const messagesIT = {
    code: "it",
    messages: {
        cache: {
            management: "Gestione cache",
            createNew: "Crea nuova cache",
            keySearchPlaceholder: "Cerca chiave (wildcard supportato: *chat*, chat*, *chat)",
            type: "Tipo cache",
            actorType: "Tipo attore",
            selectAutomation: "Seleziona automazione",
            selectChatbot: "Seleziona chatbot",
            selectUser: "Seleziona utente",
            clearFilters: "Cancella filtri",
            deleteSelected: "Elimina selezionati",
            extendSelected: "Estendi durata selezionati",
            makeSelectedNeverExpire: "Rendi selezionati senza scadenza",
            deleteAllActorCaches: "Elimina tutte le cache di questo attore",
            emptyState: "Nessuna cache trovata",
            editCache: "Modifica cache",
            key: "Chiave cache",
            keyPlaceholder: "Esempio: user_session_123",
            value: "Valore cache",
            stringValuePlaceholder: "Valore stringa",
            dataType: "Tipo di dati",
            validityDuration: "Durata validità",
            neverExpire: "Mai scadere",
            specifyDuration: "Specifica durata",
            specifyDate: "Specifica data",
            minutes: "Minuti",
            hours: "Ore",
            days: "Giorni",
            update: "Aggiorna",
            create: "Crea",
            bulkExtend: "Estensione massiva",
            bulkExtendInfo: "La durata di validità di {count} cache verrà estesa.",
            newValidityDuration: "Nuova durata validità",
            extend: "Estendi",
            keyLabel: "Chiave",
            valueLabel: "Valore",
            typeLabel: "Tipo",
            createdBy: "Creato da",
            createdAt: "Creato il",
            updatedBy: "Aggiornato da",
            expiresAt: "Scade il",
            actions: "Azioni",
            edit: "Modifica",
            extendDuration: "Estendi durata",
            makeNeverExpire: "Rendi senza scadenza",
            loadError: "Impossibile caricare l'elenco cache",
            updateSuccess: "Cache aggiornata",
            createSuccess: "Cache creata",
            saveError: "Impossibile salvare cache",
            deleteCache: "Elimina cache",
            confirmDelete: "Sì, elimina",
            deleteSuccess: "Cache eliminata",
            extendSuccess24h: "Durata cache estesa di 24 ore",
            extendError: "Impossibile estendere durata cache",
            deleteActorCaches: "Elimina cache attore",
            deleteActorCachesConfirm: "Sei sicuro di voler eliminare tutte le cache di \"{actor}\"? Questa azione non può essere annullata.",
            confirmDeleteAll: "Sì, elimina tutto",
            countDeleted: "{count} cache eliminate",
            bulkDelete: "Eliminazione massiva",
            bulkDeleteConfirm: "{count} cache verranno eliminate. Sei sicuro?",
            bulkMakeNeverExpire: "Rendi senza scadenza massivamente",
            bulkMakeNeverExpireConfirm: "La scadenza verrà rimossa da {count} cache. Sei sicuro?",
            makeNeverExpireSuccess: "Cache impostata per non scadere mai",
            makeNeverExpireError: "Impossibile impostare cache senza scadenza",
            bulkExtendError: "Impossibile estendere durate cache",
            bulkExtendSuccess: "Durata di {count} cache estesa",
            bulkMakeNeverExpireSuccess: "{count} cache impostate per non scadere mai",
            deleteCacheConfirm: "Sei sicuro di voler eliminare la cache \"{key}\"?",
            selectedCount: "{count} cache selezionate",
            valueTitle: "Valore cache: {key}",
            never: "Mai",
            automation: "Automazione",
            chatbot: "Chatbot",
            user: "Utente",
            api: "API",
            all: "Tutti",
            public: "Pubblico",
            private: "Privato"
        },
        zoho: {
            SETTING_GROUP: "Impostazioni",
            usermapping: "Mappatura utenti"
        },
        chatWindow: {
            descending: "Decrescente",
            ascending: "Crescente",
            filterTable: "Filtra",
            thereIsNoChatContent: "Nessun contenuto della chat disponibile.",
            thereIsNoChatContentDsc: "Qui puoi visualizzare il contenuto della chat e inviare messaggi.",
            interactions: "Interazioni:",
            departments: "Dipartimenti",
            channels: "Canali",
            date: "Data",
            lastChatStatus: "Ultimo stato della chat",
            all: "Tutti",
            queued: "In coda",
            open: "Aperto",
            closed: "Chiuso",
            private: "Privato",
            chatbot: "Chatbot",
            lostMissed: "Perso / Mancato",
            interaction: "Interazione",
            myActiveInbox: "La mia posta in arrivo attiva",
            activeQueueInbox: "Posta in arrivo attiva + in coda",
            chatbotActiveInbox: "Posta in arrivo attiva del chatbot",
            myDepartmentsActiveInbox: "Posta in arrivo attiva dei miei dipartimenti",
            notInteractedYesterday: "Nessuna interazione ieri",
            queueInbox: "Posta in arrivo in coda",
            whatsappActiveInbox: "Posta in arrivo attiva di WhatsApp",
            socialMediaActiveInbox: "Posta in arrivo attiva dei social media",
            missedThisMonth: "Chat perse questo mese",
            chooseAFileOrDragItHere: "Scegli un file o trascinalo qui!",
            watching: "Osservando",
            selectFilter: "Seleziona filtro",
            clearAll: "Cancella tutto",
            me: "Io",
            today: "Oggi",
            yesterday: "Ieri",
            thisWeek: "Questa settimana",
            lastWeek: "La scorsa settimana",
            last7Days: "Ultimi 7 giorni",
            last30Days: "Ultimi 30 giorni",
            thisMonth: "Questo mese",
            lastMonth: "Il mese scorso",
            last24h: "Ultime 24 ore",
            custom: "Personalizzato",
            startMessage: "Avvia messaggio",
            goToAgentReport: "Vai al rapporto dell'agente",
            agentDetail: "Dettagli agente",
            agentList: "Elenco agenti",
            selectedFilter: "Filtro selezionato",
            groupBy: "Raggruppa",
            none: "Nessun gruppo",
            agent: "Rappresentante",
            department: "Dipartimento",
            tag: "Etichetta",
            website: "Sito web",
            channel: "Canale",
            platform: "Piattaforma",
            answerStatus: "Stato della risposta",
            sortBy: "Ordina",
            lastPostAbove: "Ultimo post in alto",
            newChatsAbove: "Nuove chat in alto",
            oldChatsAbove: "Vecchie chat in alto",
            live: "Vivere",
            systemStatus: "Stato del sistema",
            refresh: "Aggiorna",
            close: "Chiudi",
            totalCustomers: "Totale clienti",
            totalAnswered: "Totale risposte",
            waitingAnswer: "In attesa di risposta",
            totalAgentInChat: "Numero totale di agenti in chat",
            onlineAgentCount: "Numero di agenti online",
            totalCustomer: "Totale cliente",
            answered: "Risposto",
            unanswered: "Senza risposta",
            noContactWasFoundMatchingTheCurrentFilters: "Nessun contatto corrispondente ai filtri attuali è stato trovato.",
            you: "Tu",
            others: "Altri",
            queue: "Coda",
            chatbotContact: "Chatbot",
            closedContact: "Chiuso",
            myInteractions: "Le mie interazioni",
            special: "Speciale",
            allInteractions: "Tutti i contatti",
            waiting: "In attesa",
            departmentToWhichItIsAffiliated: "Dipartimento a cui è affiliato",
            owner: "Proprietario",
            switchToLiveSupportMode: "Passa alla modalità supporto live",
            switchToLiveSupportModeConfirmation: "Vuoi passare alla modalità supporto live per visualizzare questo contatto?",
            hiddenChatsWarning: "Ci sono {count} chat che non puoi vedere in questo elenco",
            clickToSeeDetails: "Clicca per vedere i dettagli",
            viewDetails: "Visualizza dettagli",
            hiddenChatsDetails: "Dettagli chat nascoste",
            totalHiddenChats: "Totale chat nascoste",
            examples: "Esempi",
            reasons: {
                visitorNotFound: "Visitatore non trovato",
                noChannelAccess: "Non hai accesso a questo canale",
                ownedByOtherNotChannelOwner: "Di proprietà di un altro utente (Non sei il proprietario del canale)",
                ownedByOtherNoChannel: "Di proprietà di un altro utente (Senza canale)",
                noOwnerAdminOnly: "Chat senza proprietario (Solo gli amministratori e i proprietari del canale possono vedere)"
            }
        },
        chat: {
            inbox: "Posta in Arrivo",
            layouts: {
                chat: "Layout Chat",
                table: "Layout Tabella",
                kanban: "Layout Kanban"
            },
            filters: {
                allContacts: "Tutti i Contatti",
                myInbox: "La Mia Posta in Arrivo",
                myContacts: "I Miei Contatti",
                missed: "Persi",
                unanswered: "Senza risposta",
                unassigned: "Non Assegnati",
                chatbot: "Chatbot"
            },
            groups: {
                views: "Visualizzazioni",
                customFilters: "Filtri Personalizzati",
                team: "Squadra",
                contacts: "Contatti",
                system: "Sistema"
            },
            sidebar: {
                tabScreen: "Schermata schede",
                search: "Cerca",
                addNewFilter: "Aggiungi nuovo filtro",
                edit: "Modifica",
                showInTable: "Mostra in modalità tabella",
                showInKanban: "Mostra in modalità Kanban",
                rename: "Rinomina",
                makePublic: "Rendi pubblico",
                makePrivate: "Rendi privato",
                moveToTop: "Sposta in alto",
                moveToBottom: "Sposta in basso",
                delete: "Elimina",
                renameFilterTitle: "Rinomina filtro",
                filterNamePlaceholder: "Inserisci il nome del filtro",
                positionUpdateError: "Errore nell'aggiornamento della posizione",
                filterNameEmpty: "Il nome del filtro non può essere vuoto",
                filterNameUpdated: "Nome del filtro aggiornato",
                filterNameUpdateError: "Errore nell'aggiornamento del nome del filtro",
                filterVisibilityUpdateError: "Errore nell'aggiornamento della visibilità del filtro",
                filterMadePrivate: "Filtro impostato come privato",
                filterMadePublic: "Filtro impostato come pubblico",
                filterMovedToTop: "Filtro spostato in alto",
                filterMovedToBottom: "Filtro spostato in basso",
                filterMoveError: "Errore nello spostamento del filtro",
                onlyCreatorOrRootCanDeletePublic: "Solo il creatore o l'utente root può eliminare i filtri pubblici",
                deleteFilterTitle: "Elimina filtro",
                deleteFilterConfirm: "Sei sicuro di voler eliminare il filtro \"{name}\"?",
                deleteFilterOk: "Elimina",
                deleteFilterCancel: "Annulla",
                filterDeleted: "Filtro eliminato",
                filterDeleteError: "Errore nell'eliminazione del filtro",
                websiteAnalytics: "Analisi del sito web"
            },
            gridContactList: {
                emptyConversationsTitle: "Nessuna chat trovata",
                emptyConversationsDescription: "Non hai ancora una chat attiva. Puoi avviare una nuova chat dalla pagina del cliente.",
                markAsUnanswered: "Segna come senza risposta",
                markAsAnswered: "Segna come risposto",
                removeVIP: "Rimuovi VIP",
                markAsVIP: "Segna come VIP",
                markAsRead: "Segna come letto",
                markAsUnread: "Segna come non letto",
                closeChat: "Chiudi chat",
                markedAsAnswered: "Segnato come risposto",
                markedAsUnanswered: "Segnato come senza risposta",
                operationFailed: "Operazione fallita",
                markedAsVIP: "Segnato come VIP",
                vipRemoved: "VIP rimosso",
                markedAsUnread: "Segnato come non letto",
                markedAsRead: "Segnato come letto",
                confirmCloseChat: "Sei sicuro di voler terminare la chat?",
                chatClosed: "Chat chiusa"
            },
            tableContactList: {
                editFilter: "Modifica filtro",
                chatStatus: "Stato della Chat",
                grouping: "Raggruppamento",
                allContacts: "Tutti i contatti",
                groupNone: "Nessuno",
                groupTag: "Etichetta",
                groupDepartment: "Dipartimento",
                groupChannel: "Canale",
                groupPlatform: "Piattaforma",
                groupOwner: "Proprietario",
                groupUsers: "Partecipanti",
                groupAnswerStatus: "Stato risposta",
                statusAll: "Tutti",
                statusOpen: "Aperto",
                statusClosed: "Chiuso",
                statusUnknown: "Sconosciuto",
                copyLabel: "Copia",
                filterCreatedSuccess: "Filtro creato con successo",
                filterCreatedNameDuplicate: "Il nome \"{createName}\" era già in uso. Il filtro è stato creato come \"{filterName}\".",
                filterCreateFailed: "Impossibile creare il filtro",
                filterCreateError: "Si è verificato un errore durante la creazione del filtro.",
                platformSupsis: "Supsis",
                platformEmail: "Email",
                platformWhatsapp: "WhatsApp",
                platformWeb: "Web",
                platformInstagram: "Instagram",
                platformTelegram: "Telegram",
                platformMessenger: "Messenger",
                platformMetaLeads: "Meta Leads",
                platformTrendyol: "Trendyol",
                platformLinkedin: "LinkedIn",
                answerStatusAnswered: "Risposto",
                answerStatusUnanswered: "Senza risposta"
            },
            kanbanContactList: {
                filterHide: "Nascondi filtri",
                filterAdd: "Aggiungi filtro",
                broadcast: "Trasmissione",
                broadcastSelectPlaceholder: "Seleziona trasmissione...",
                loading: "Caricamento...",
                broadcastNotFound: "Nessuna trasmissione trovata",
                broadcastTitle: "Titolo",
                broadcastDate: "Data",
                broadcastStatus: "Stato",
                broadcastProgress: "Progresso",
                refresh: "Aggiorna",
                kanbanLoading: "Caricamento Kanban...",
                deletedUser: "Utente eliminato",
                unowned: "Senza proprietario",
                activeInChat: "Attivo (in chat)",
                newInQueue: "Nuovo (in coda)",
                agentDown: "Agente disconnesso",
                closed: "Chiuso",
                blocked: "Bloccato",
                unblocked: "Sbloccato",
                groupsLoadError: "Errore nel caricamento dei gruppi",
                dataLoadError: "Errore nel caricamento dei dati",
                broadcastsLoadError: "Errore nel caricamento delle trasmissioni",
                dataRefreshed: "Dati aggiornati",
                refreshError: "Errore durante l'aggiornamento",
                unknownContact: "Contatto sconosciuto",
                assigned: "Non assegnato",
                platformMobile: "Mobile",
                broadcastStatusCreated: "Creato",
                broadcastStatusScheduled: "Programmato",
                broadcastStatusQueued: "In coda",
                broadcastStatusRunning: "Invio in corso",
                broadcastStatusCompleted: "Completato",
                broadcastStatusFailed: "Fallito",
                broadcastStatusCancelled: "Annullato",
                metaLeadNewLead: "Nuovo lead",
                metaLeadInitialContact: "Primo contatto",
                metaLeadNeedsAssessment: "Valutazione dei bisogni",
                metaLeadProposalSent: "Proposta inviata",
                metaLeadProposalReview: "Revisione proposta",
                metaLeadNegotiation: "Negoziazione",
                metaLeadDecisionStage: "Fase decisionale",
                metaLeadClosure: "Chiusura",
                metaLeadFollowUp: "Follow-up",
                broadcastSent: "Inviato",
                broadcastDelivered: "Consegnato",
                broadcastRead: "Letto",
                broadcastFailed: "Fallito",
                broadcastEdited: "Modificato",
                broadcastDeleted: "Eliminato",
                triggerTypeApi: "API",
                triggerTypeBroadcast: "Trasmissione",
                triggerTypeAutomation: "Automazione",
                emptyGroup: "Nessun contatto in questo gruppo",
                loadMore: "Carica altro...",
                groupSelectTitle: "Seleziona campo di raggruppamento",
                searchPlaceholder: "Cerca...",
                categoryBasic: "Base",
                categoryDemographic: "Demografico",
                categoryTags: "Tag e categoria",
                categoryMeta: "Meta Leads",
                categoryBroadcast: "Trasmissione",
                categoryOther: "Altro",
                fieldAnswerStatus: "Stato risposta",
                fieldLastConversationStatus: "Stato chat",
                fieldOwner: "Proprietario",
                fieldUsers: "Partecipanti",
                fieldChannel: "Canale",
                fieldPlatform: "Piattaforma",
                fieldCountry: "Paese",
                fieldCity: "Città",
                fieldBrowser: "Browser",
                fieldPreferredLang: "Lingua",
                fieldTags: "Tag",
                fieldDepartment: "Dipartimento",
                fieldMetaLeadStatus: "Stato lead",
                fieldMetaLeadAdName: "Nome annuncio",
                fieldMetaLeadAdsetName: "Set di annunci",
                fieldMetaLeadCampaignName: "Campagna",
                fieldMetaLeadFormName: "Nome modulo",
                fieldMetaLeadPlatform: "Piattaforma Meta",
                fieldLastBroadcastStatus: "Stato trasmissione",
                fieldLastBroadcastReason: "Motivo trasmissione",
                fieldBlockedSnapshot: "Stato blocco",
                fieldLastTriggerType: "Tipo attivazione",
                fieldZohoLeadStatus: "Stato lead Zoho",
                fieldZohoLeadSource: "Fonte lead Zoho",
                broadcastTriggerSuccess: "Ha risposto al messaggio di trasmissione!",
                broadcastTriggerWaiting: "In attesa di risposta...",
                unknownUser: "Utente sconosciuto",
                unread: "Non letto",
                platformIg: "Instagram",
                platformFb: "Facebook"
            },
            gridContactListToolBar: {
                chatStatus: "Stato della Chat",
                sortBy: "Ordina per",
                all: "Tutti",
                open: "Aperto",
                closed: "Chiuso",
                allStatus: "Tutti",
                lastActivity: "Ultima Attività",
                createdAt: "Data di Creazione",
                unknown: "Sconosciuto"
            },
            chatCloseSettings: {
                selectPhone: "Seleziona telefono",
                selectPhoneDescription: "Con quale telefono vuoi chiamare {number}?",
                call: "Chiama",
                unnamedChannel: "Canale senza nome",
                typeVisitorName: "Digita il nome del visitatore...",
                webphoneCall: "Chiama con Webphone",
                hideSystemMessages: "Nascondi messaggi di sistema",
                chatbotDebugMode: "Modalità debug chatbot",
                createTask: "Crea attività",
                showProfile: "Mostra profilo",
                sendCapiEvent: "Invia evento CAPI",
                noPhoneNumber: "Nessun numero trovato da chiamare",
                noWebphoneChannel: "Nessun canale webphone trovato",
                webphoneCalling: "Chiamata a {number} con Webphone...",
                unknown: "Sconosciuto",
                channelTypeKirmiziSantral: "Centralino Rosso",
                channelTypeTelnyx: "Telnyx",
                channelTypeNetgsm: "NetGSM",
                channelTypeWebPhone: "Telefono web",
                platformWeb: "Web",
                platformWhatsapp: "WhatsApp",
                platformWhatsappBusiness: "WhatsApp Business",
                platformInstagram: "Instagram",
                platformInstagramV2: "Instagram V2",
                platformMessenger: "Messenger",
                platformTelegram: "Telegram",
                platformTrendyol: "Trendyol",
                platformEmail: "Email",
                platformSms: "SMS",
                vipCustomerTooltip: "★ Cliente VIP"
            },
            contactDetail: {
                removeVIPTooltip: "Rimuovi VIP",
                markAsVIPTooltip: "Segna come VIP (Gli utenti contrassegnati come VIP verranno sempre visualizzati in alto nelle chat).",
                customerOwnership: "Proprietà del Cliente",
                ownershipDescription: "Quando viene assegnata la proprietà del cliente, solo il proprietario e gli amministratori completi possono vederla",
                unowned: "Senza proprietario",
                assignToMe: "Assegna a Me",
                removeOwnership: "Rimuovi Proprietà",
                dragPlaceholder: "Sposta qui",
                currentConversationDepartment: "Dipartimento Conversazione Corrente",
                pastInteractionDepartments: "Dipartimenti Interazione Passati",
                createdAt: "Data di Creazione",
                updatedAt: "Data di Aggiornamento",
                zohoSync: "Sincronizzazione Zoho",
                zohoSyncQuestion: "Vuoi eseguire le operazioni di modifica del contatto anche in Zoho?",
                basicInfo: "Informazioni Contatto",
                loginInfo: "Informazioni Modulo Contatto",
                profileFields: "Campi Profilo",
                systemInfo: "Informazioni Sistema"
            },
            contactDetailItem: {
                removeOwnership: "Rimuovi Proprietà",
                assignOwnershipToMe: "Assegna Proprietà a Me",
                vipCustomer: "Cliente VIP",
                contentCopiedSuccess: "Contenuto copiato con successo!",
                invalidEmail: "Indirizzo email non valido!",
                invalidValue: "Valore non valido!"
            },
            filtersSection: {
                addFilter: "Aggiungi Filtro",
                all: "Tutti",
                open: "Aperto",
                closed: "Chiuso",
                relevance: "Rilevanza",
                lastActivityNewest: "Attività Più Recente",
                lastActivityOldest: "Attività Più Vecchia",
                noParticipant: "Nessun Partecipante",
                ownershipFilter: "Filtro di Proprietà",
                metaReferral: "Riferimento Meta",
                userStatus: "Stato Utente",
                unowned: "Senza proprietario",
                fromAds: "Da Pubblicità",
                notFromAds: "Non Da Pubblicità",
                blockedUsers: "Utenti Bloccati",
                unblockedUsers: "Utenti Non Bloccati",
                unread: "Non Letto",
                read: "Letto",
                yes: "Sì",
                no: "No",
                answered: "Risposto",
                unanswered: "Senza Risposta",
                active: "Attivo",
                lost: "Perso",
                new: "Nuovo",
                chatbot: "Chatbot",
                closedStatus: "Chiuso",
                platform: "Piattaforma",
                channel: "Canale",
                department: "Dipartimento",
                tag: "Etichetta",
                participant: "Partecipante",
                ownership: "Proprietà",
                lastActivityTime: "Ora Ultima Attività",
                fullName: "Nome Completo",
                email: "Email",
                phone: "Telefono",
                vipCustomer: "Cliente VIP",
                hasVIP: "Ha VIP",
                noVIP: "Nessun VIP",
                operatingSystem: "Sistema Operativo",
                browser: "Browser",
                ipAddress: "Indirizzo IP",
                visitingPage: "Pagina Visitata",
                adInteraction: "Interazione Pubblicitaria",
                blockedStatus: "Stato di Blocco",
                connectionTime: "Ora di Connessione",
                createdAt: "Data di Creazione",
                updatedAt: "Data di Aggiornamento",
                readStatus: "Stato di Lettura",
                missedChat: "Chat Persa",
                answerStatus: "Stato di Risposta",
                lastConversationStatus: "Stato Ultima Conversazione",
                lastTriggerState: "Stato Ultimo Trigger",
                type: "Tipo",
                name: "Nome",
                enterTriggerName: "Inserisci il nome del trigger...",
                zohoInfo: "Info Zoho",
                id: "ID",
                enterContactOrLeadId: "Inserisci ID Contatto o Lead...",
                broadcastMessage: "Messaggio Broadcast",
                today: "Oggi",
                yesterday: "Ieri",
                thisWeek: "Questa Settimana",
                lastWeek: "Settimana Scorsa",
                last7Days: "Ultimi 7 Giorni",
                last30Days: "Ultimi 30 Giorni",
                thisMonth: "Questo Mese",
                lastMonth: "Mese Scorso"
            },
            filterChip: {
                operator: "Operatore:",
                enterText: "Inserisci testo...",
                enterNumber: "Inserisci numero...",
                type: "Tipo",
                value: "Valore",
                enterValue: "Inserisci valore...",
                addFilter: "Aggiungi Filtro",
                equals: "Uguale",
                contains: "Contiene",
                startsWith: "Inizia Con",
                endsWith: "Termina Con",
                greaterThan: "Maggiore Di",
                lessThan: "Minore Di",
                greaterThanOrEqual: "Maggiore o Uguale Di",
                lessThanOrEqual: "Minore o Uguale Di",
                between: "Tra",
                custom: "Personalizzato",
                select: "Seleziona"
            },
            filterPanel: {
                backToChat: "Torna alla Vista Chat",
                publicFilter: "Filtro Pubblico",
                privateFilter: "Filtro Privato",
                editFilterName: "Modifica Nome Filtro",
                contactsFound: " contatti trovati",
                enterFilterName: "Inserisci il nome del filtro",
                filterSuggestions: "Suggerimenti Filtro",
                private: "Privato",
                public: "Pubblico",
                createFilter: "Crea Filtro",
                update: "Aggiorna",
                changeToPublic: "Cambia in Pubblico",
                changeToPrivate: "Cambia in Privato",
                delete: "Elimina",
                clearSearch: "Cancella Ricerca",
                previous: "Precedente",
                next: "Successivo",
                searchTerm: "Termine di Ricerca:",
                whichFieldToSearch: "In quale campo vuoi cercare?",
                contactId: "ID Contatto",
                conversationId: "ID Conversazione",
                noSearchAllFields: "No, cerca in tutti i campi",
                yesSearchOnlyField: "Sì, cerca solo in {field}",
                search: "Cerca",
                allFields: "Tutti i Campi",
                fullname: "Nome completo",
                email: "Email",
                whatsappNumber: "Numero WhatsApp",
                phone: "Telefono",
                contactIdField: "campo ID contatto",
                conversationIdField: "ID Conversazione",
                searchAllFieldsPlaceholder: "Inserisci cosa vuoi cercare in tutti i campi",
                searchFullnamePlaceholder: "Inserisci cosa vuoi cercare per Nome Completo",
                searchEmailPlaceholder: "Inserisci cosa vuoi cercare per Email",
                searchWhatsappPlaceholder: "Inserisci cosa vuoi cercare per WhatsApp",
                searchPhonePlaceholder: "Inserisci cosa vuoi cercare per Telefono",
                searchContactIdPlaceholder: "Inserisci l'ID Contatto che vuoi cercare",
                searchConversationIdPlaceholder: "Inserisci l'ID Conversazione che vuoi cercare",
                searchPlaceholder: "Cerca",
                edited: " (Modificato)",
                unnamedFilter: "Filtro Senza Nome",
                all: "Tutti",
                open: "Aperto",
                closed: "Chiuso",
                unknown: "Sconosciuto",
                filterUpdatedSuccess: "Filtro aggiornato con successo",
                filterUpdatedDescription: "Il filtro \"{name}\" è stato aggiornato.",
                filterUpdateFailed: "Il filtro non è stato aggiornato",
                filterUpdateError: "Si è verificato un errore durante l'aggiornamento del filtro.",
                filterSavedSuccess: "Filtro salvato con successo",
                filterSavedDescription: "Il nome \"{createName}\" era già in uso. Il filtro è stato creato come \"{filterName}\".",
                filterCreatedDescription: "Il filtro \"{filterName}\" è stato creato.",
                filterSaveFailed: "Il filtro non è stato salvato",
                filterSaveError: "Si è verificato un errore durante il salvataggio del filtro.",
                aiFilterCreatedSuccess: "Filtro IA creato con successo",
                aiFilterCreatedDescription: "Il nome \"{createName}\" era già in uso. Il filtro è stato creato come \"{filterName}\" e applicato.",
                aiFilterCreatedApplied: "Il filtro \"{filterName}\" è stato creato e applicato.",
                aiFilterCreateFailed: "Il filtro non è stato creato",
                aiFilterCreateError: "Si è verificato un errore durante la creazione del filtro IA.",
                phoneDetected: "Numero di Telefono Rilevato",
                emailDetected: "Indirizzo Email Rilevato",
                idFormatDetected: "Formato ID Rilevato",
                contactIdDetected: "ID Contatto Rilevato",
                conversationIdDetected: "ID Conversazione Rilevato",
                searchMode: "Modo di Ricerca",
                phoneDetectedMessage: "Il valore inserito sembra essere un numero di telefono. Vuoi cercare solo nel campo numero di telefono?",
                emailDetectedMessage: "Il valore inserito sembra essere un indirizzo email. Vuoi cercare solo nel campo email?",
                idFormatDetectedMessage: "Il valore inserito sembra essere un formato ID. In quale campo vuoi cercare?",
                phoneField: "campo numero di telefono",
                emailField: "campo email",
                conversationIdFieldName: "campo ID conversazione",
                idField: "campo ID",
                deleteFilter: "Elimina Filtro",
                deleteFilterConfirm: "Sei sicuro di voler eliminare il filtro \"{name}\"? Questa azione non può essere annullata.",
                cancel: "Annulla",
                filterDeletedSuccess: "Filtro eliminato con successo",
                filterDeletedDescription: "Il filtro \"{name}\" è stato eliminato.",
                filterDeleteFailed: "Il filtro non è stato eliminato",
                filterDeleteError: "Si è verificato un errore durante l'eliminazione del filtro.",
                visibilityUpdatedSuccess: "Visibilità aggiornata con successo",
                visibilityUpdatedDescription: "Il filtro è stato impostato come \"{visibility}\".",
                visibilityUpdateFailed: "La visibilità non è stata aggiornata",
                visibilityUpdateError: "Si è verificato un errore durante l'aggiornamento del filtro.",
                publicVisibility: "pubblico",
                privateVisibility: "privato"
            },
            contactList: {
                noContactsFound: "Nessun contatto trovato",
                unknownContact: "Contatto Sconosciuto",
                unknown: "Sconosciuto",
                fullName: "Nome Completo",
                platform: "Piattaforma",
                email: "Email",
                phone: "Telefono",
                tags: "Etichette",
                status: "Stato",
                lastActivity: "Ultima Attività",
                answerStatus: "Stato della Risposta",
                channel: "Canale",
                owner: "Proprietario",
                vip: "VIP",
                connectionTime: "Ora di Connessione",
                unread: "Non Letto",
                departments: "Dipartimenti",
                operatingSystem: "Sistema Operativo",
                browser: "Browser",
                countryCity: "Paese - Città",
                ipAddress: "Indirizzo IP",
                visitingPage: "Pagina Visitata",
                lastConversationDate: "Data Ultima Conversazione",
                blockedStatus: "Stato di Blocco",
                lastConversationParticipants: "Partecipanti Ultima Conversazione",
                preferredLanguage: "Lingua Preferita",
                createdAt: "Data di Creazione",
                updatedAt: "Data di Aggiornamento",
                broadcastStatus: "Stato Broadcast",
                broadcastAnswer: "Risposta Broadcast",
                zohoContactId: "ID Contatto Zoho",
                zohoLeadId: "ID Lead Zoho",
                profileFields: "Campi Profilo",
                closed: "Chiuso",
                open: "Aperto",
                unknownStatus: "Sconosciuto",
                answered: "Risposto",
                unanswered: "Senza Risposta",
                unreadStatus: "Non Letto",
                readStatus: "Letto",
                vipStatus: "VIP",
                normal: "Normale",
                blocked: "Bloccato",
                today: "Oggi",
                yesterday: "Ieri",
                enqueued: "In Coda",
                sent: "Inviato",
                delivered: "Consegnato",
                read: "Letto",
                deleted: "Eliminato",
                failed: "Fallito",
                replied: "Risposto",
                notReplied: "Non Risposto",
                jsonProperty: "Proprietà JSON",
                jsonCopiedSuccess: "Contenuto JSON copiato con successo!"
            }
        },
        form: {
            title: {
                titleSettings: "Impostazioni del titolo",
                fullNameSettings: "Impostazioni del nome completo",
                emailSettings: "Impostazioni e-mail",
                addressSettings: "Impostazioni dell'indirizzo",
                phoneSettings: "Impostazioni del telefono",
                datePickerSettings: "Impostazioni del selettore di data",
                shortTextSettings: "Impostazioni testo breve",
                longTextSettings: "Impostazioni testo lungo",
                dropDownListSettings: "Impostazioni elenco a discesa",
                singleChoiceSettings: "Impostazioni scelta singola",
                multipleSelectionSettings: "Impostazioni selezione multipla",
                numberSettings: "Impostazioni dei numeri",
                hourSettings: "Impostazioni dell'ora",
                spinnerSettings: "Impostazioni dello spinner",
                sendSettings: "Impostazioni di invio",
                starRatingSettings: "Impostazioni della valutazione a stelle",
                ratingScaleSettings: "Impostazioni della scala di valutazione",
                separationElementSettings: "Impostazioni elemento di separazione",
                fileUploadSettings: "Impostazioni caricamento file",
                imageSettings: "Impostazioni immagine"
            },
            lineColor: "Colore della linea",
            separatorColorInfo: "Seleziona o inserisci il colore del separatore (ad esempio, #RRGGBB)",
            separatorHeight: "Altezza del separatore",
            separatorHeightInfo: "Inserisci l'altezza del separatore",
            bottomSpace: "Spazio inferiore",
            bottomSpaceInfo: "Aggiungi spazio sotto il separatore",
            topSpace: "Spazio superiore",
            topSpaceInfo: "Aggiungi spazio sopra il separatore",
            sideSpace: "Spazio laterale",
            sideSpaceInfo: "Aggiungi spazio a sinistra e a destra del separatore",
            onlyImageUpload: "Puoi caricare solo un'immagine!",
            imageSizeLimit: "La dimensione della tua immagine non deve superare i 5 MB!",
            image: "Immagine",
            size: "Dimensione",
            width: "Larghezza",
            height: "Altezza",
            imageAlignment: "Allineamento dell'immagine",
            wide: "Largo",
            small: "Piccolo",
            textAlignment: "Allineamento del testo",
            chooseHorizontalAlignment: "Scegli come allineare orizzontalmente questo titolo.",
            headerSize: "Dimensione dell'intestazione",
            addSmallTextBelowHeader: "Aggiungi un testo più piccolo sotto l'intestazione",
            subHeaderText: "Testo del sottotitolo",
            subLabel1: "Sottolabel(1)",
            subLabel2: "Sottolabel(2)",
            validPhoneNumber: "Per favore inserisci un numero di telefono valido",
            masked: "Mascherato",
            copyField: "Copia campo",
            copyFieldDescription: "Crea una copia di questo campo mantenendo tutte le sue impostazioni salvate",
            enterQuestion: "Inserisci una domanda",
            notRequired: "Non richiesto",
            addDescriptionBelowField: "Aggiungi una breve descrizione sotto il campo",
            setDefault: "Imposta come predefinito",
            pleaseSelect: "Per favore seleziona",
            placeholder: "Segnaposto",
            required: "Obbligatorio",
            fieldEmptyError: "Non consentire l'invio del modulo se questo campo è vuoto",
            subLabels: "Sotto etichette",
            addressLine1: "Riga indirizzo 1",
            addressLine2: "Riga indirizzo 2",
            postalCode: "Codice postale",
            stateProvince: "Stato / Provincia",
            chooseLabelAlignment: "Scegli come allineare il testo dell'etichetta orizzontalmente",
            right: "DESTRA",
            left: "SINISTRA",
            top: "SOPRA",
            labelAlignment: "Allineamento etichetta",
            fieldLabel: "Etichetta campo",
            read: "Letto",
            itemsPerPage: "elementi/pagina",
            downloadAllDataAsPDF: "Scarica tutti i dati in formato PDF",
            downloadAllDataAsExcel: "Scarica tutti i dati in formato Excel",
            downloadSelectedDataAsPDF: "Scarica i dati selezionati in formato PDF",
            downloadSelectedDataAsExcel: "Scarica i dati selezionati in formato Excel",
            selectItemToViewDetails: "Seleziona un elemento per visualizzare i dettagli.",
            deleteFormConfirm: "Se elimini questo modulo, tutti i dati associati verranno eliminati definitivamente. Sei sicuro di voler continuare?",
            redicetFormAnswer: "INOLTRA RISPOSTE MODULO",
            redicetFormAnswerDesc: "Quando si reindirizzano le risposte del modulo al sistema dei ticket, assicurarsi di richiedere all'utente un numero di telefono o un indirizzo e-mail nel modulo. Queste informazioni sono importanti per una comunicazione più rapida ed efficace con l'utente.",
            redicetFormAnswerDesc2: "Le risposte del modulo vengono indirizzate al sistema come ticket.",
            rediectAnswersToTicket: "Reindirizza le risposte in arrivo a un biglietto.",
            errorTicketMode: "Errore nell'aggiornamento della modalità ticket:",
            formView: "Visualizza modulo",
            formEdit: "Modulo di aggiornamento",
            totalResponse: "Risposta totale",
            totalUnreadResponse: "Totale risposte non lette",
            totalReadResponse: "Risposta di lettura totale",
            totalArchivedResponse: "Totale risposta archiviata",
            singleChoice: "Scelta singola",
            _delete: "Cancellare",
            inbox: "Posta in arrivo",
            edit: "Modifica",
            forms: "Moduli",
            formsDesc: "Potete gestire i vostri moduli qui.",
            createaForm: "creare un modulo",
            allForms: "tutte le forme",
            formPublish: {
                shareFast: "CONDIVIDERE VELOCEMENTE",
                shareFastDesc: "Collegamento diretto al modulo e condivisione sui social",
                add: "ADD",
                addDesc: "Varie opzioni di incorporazione di pagine web",
                assignForm: "MODULO DI ASSEGNAZIONE",
                assignFormDesc: "Assegnate i vostri moduli ad altri",
                emails: "E-MAIL",
                emailsDesc: "Promemoria e condivisione immediata",
                prefill: "PREFILL",
                prefillDesc: "Prepagare i moduli",
                pdf: "PDF",
                pdfDesc: "Scarica il PDF compilabile",
                platforms: "PIATTAFORME",
                platformsDesc: "Opzioni di pubblicazione di terze parti",
                linkToYour: "INDIRIZZO DEL LINK DEL VOSTRO MODULO",
                linkToYourDesc: "Il vostro modulo è stato pubblicato in modo sicuro ed è pronto per essere utilizzato a questo indirizzo.",
                shareWithLink: "CONDIVIDERE CON IL LINK",
                publicForm: "Modulo pubblico",
                copyLink: "COPIA LINK",
                openInNewTab: "APRIRE IN UNA NUOVA SCHEDA",
                linkCopied: "Link copiato",
                codeCopied: "Codice copiato",
                iframe: "IFRAME",
                iframeDesc: "Aggiungere il modulo alla pagina con iFrame",
                openWindow: "FINESTRA APERTA",
                openWindowDesc: "Collegamento a un modulo pop-up",
                formAddDesc: "Copiate e incollate questo snippet nel codice e inserite il modulo nel vostro sito web."
            },
            formSettings: {
                enterNameForm: "Inserire un nome per questo modulo",
                selectStatusForm: "Selezionare lo stato del modulo",
                disabled: "Disabili",
                disableSpecifiedTime: "Disattivare in un momento specifico",
                disableFormResponse: "Disattivare quando viene raggiunto il limite di risposta del modulo",
                pageShownAfterForm: "La pagina visualizzata dopo l'invio del modulo",
                formNotFound: "Modulo non trovato.",
                errorLoadingform: "Si è verificato un errore durante il caricamento del modulo.",
                formUpdated: "Il titolo del modulo è stato aggiornato con successo.",
                formErrorUpdated: "Si è verificato un errore durante l'aggiornamento del titolo del modulo",
                formSettings: "IMPOSTAZIONI DEL MODULO",
                changeFormStateAndProperties: "Modificare lo stato e le proprietà del modulo",
                title: "Titolo",
                newFormSettings: "Impostazioni del nuovo modulo",
                formStatus: "Stato del modulo",
                activateOrDeactivate: "Attivare, disattivare o attivare in modo condizionato il vostro modulo",
                effective: "EFFICACE",
                yourFromIsVisible: "Il modulo è ora visibile e può ricevere le risposte del modulo.",
                emails: "E-MAIL",
                emailsDesc: "Inviare e-mail di autoresponder e di notifica",
                conditions: "CONDIZIONI",
                conditionsDesc: "Sezione di logica condizionale che attiva azioni in base agli input del modulo",
                thankYouPage: "PAGINA DEI RINGRAZIAMENTI",
                thankYouPageDesc: "La pagina visualizzata dopo l'invio del modulo",
                integretions: "INTEGRAZIONI",
                integretionsDesc: "Collegare il modulo ad altre applicazioni"
            },
            clickToDeleteYourLogo: "Fare clic per eliminare il logo",
            create: "Creare",
            settings: "Impostazioni",
            load: "Carico",
            insertFormField: "Inserisci campo modulo",
            addYourLogo: "Aggiungi il tuo logo",
            surveyElements: {
                surveyElements: "Elementi del sondaggio",
                dataTable: "Tabella dati",
                starRating: "Valutazione a stelle",
                evaluationScale: "Scala di valutazione"
            },
            pageElements: {
                pageElements: "Elementi della pagina",
                separationElement: "Elemento di separazione",
                partitionCollapse: "Crollo della partizione",
                pageBreak: "Fine della pagina"
            },
            basicElements: {
                basicElements: "Elementi di base",
                shortText: "Testo breve",
                longText: "Testo lungo",
                paragraph: "Paragrafo",
                dropDownList: "Elenco a discesa",
                singleChoice: "Scelta singola",
                multipleSelection: "Selezione multipla",
                number: "Numero",
                image: "Immagine",
                fileUpload: "Caricamento file",
                hour: "Ora",
                spinner: "Spinner",
                send: "Inviare"
            },
            formElements: {
                formElements: "Elementi di forma",
                title: "Titolo",
                fullName: "Nome completo",
                email: "Email",
                address: "Indirizzo",
                phone: "Telefono",
                datePicker: "Selezionatore di date",
                appointment: "Appuntamento",
                signature: "Firma",
                productList: "Elenco dei prodotti"
            },
            startWithaBlankForm: "Iniziare con un modulo vuoto",
            startFromScratch: "Iniziare da zero",
            createOrTransferaForm: "Creare o trasferire un modulo per avviare la raccolta dei dati",
            createForm: "Creare un modulo",
            trashBin: "Cestino",
            formAutomations: "Automatizzazioni moduli",
            trashBinList: {
                title: "Cestino",
                description: "I tuoi moduli eliminati sono elencati qui",
                loading: "Caricamento moduli eliminati...",
                restore: "Ripristina",
                permanentDelete: "Elimina definitivamente",
                delete: "Elimina",
                emptyTitle: "Il cestino è vuoto",
                emptyDescription: "Nessun modulo eliminato trovato",
                totalResponses: "Totale risposte",
                unread: "Non letto",
                read: "Letto",
                archived: "Archiviato",
                restoreConfirmDescription: "Sei sicuro di voler ripristinare questo modulo? Il modulo e tutti i suoi dati verranno aggiunti all'elenco dei moduli attivi.",
                deleteConfirmDescription: "Sei sicuro di voler eliminare definitivamente questo modulo? Questa azione non può essere annullata e tutti i dati associati al modulo verranno eliminati.",
                deletedToday: "Eliminato oggi",
                deletedYesterday: "Eliminato ieri",
                deletedDaysAgo: "Eliminato {count} giorni fa",
                deletedWeeksAgo: "Eliminato {weeks} settimane fa",
                deletedMonthsAgo: "Eliminato {months} mesi fa",
                restoreSuccess: "Modulo ripristinato con successo",
                restoreError: "Si è verificato un errore durante il ripristino del modulo",
                deleteSuccess: "Modulo eliminato definitivamente",
                deleteError: "Si è verificato un errore durante l'eliminazione del modulo"
            }
        },
        automation: {
            deleteAutomationsTitle: "Elimina Automazioni",
            deleteAutomationsConfirmation: "Sei sicuro di voler eliminare {count} automazioni? Questa azione non può essere annullata.",
            automationsMoveError: "Errore durante lo spostamento delle automazioni",
            noAutomationToMove: "Nessuna automazione trovata da spostare",
            deleteCategoryConfirmation: "Sei sicuro di voler eliminare la categoria \"{categoryName}\"? Le automazioni in questa categoria verranno spostate nella categoria \"{generalCategory}\".",
            automationsMovedToCategory: "{count} automazioni spostate nella categoria \"{categoryName}\"",
            automationImportedSuccessfully: "Automazione {name} importata con successo",
            automationPasteError: "Errore durante l'incollaggio dell'automazione",
            invalidAutomationExport: "Nessuna esportazione di automazione Supsis valida trovata negli appunti",
            invalidAutomationJSON: "Nessun JSON di automazione valido trovato negli appunti",
            clipboardNotSupported: "L'accesso agli appunti non è supportato da questo browser",
            automationJSONCopyError: "Errore durante la copia dell'automazione",
            automationCopiedToClipboardFallback: "Automazione copiata negli appunti come JSON (metodo alternativo)",
            automationCopiedToClipboard: "Automazione copiata negli appunti come JSON. Puoi incollarla con Ctrl+V in un altro pannello cliente.",
            automationCopyError: "Errore durante la copia dell'automazione",
            automationCopied: "Automazione copiata",
            automationMoveError: "Errore durante lo spostamento dell'automazione",
            automationMovedToCategory: "Automazione spostata nella categoria \"{categoryName}\"",
            categoryDeletedSuccessfully: "Categoria eliminata con successo",
            categoryDeleteError: "Errore durante l'eliminazione della categoria",
            automationsDeleteError: "Errore durante l'eliminazione delle automazioni",
            automationsDeletedSuccessfully: "Automazioni eliminate con successo",
            categoryUpdatedSuccessfully: "Categoria aggiornata",
            categoryUpdateError: "Errore durante l'aggiornamento della categoria",
            categorySaveError: "Errore durante il salvataggio della categoria",
            categoryCreatedSuccessfully: "Categoria creata. Puoi trascinare le automazioni in questa categoria.",
            categoryNameAlreadyExists: "Una categoria con questo nome esiste già",
            categoryNameRequired: "Il nome della categoria non può essere vuoto",
            moveAllAutomations: "Sposta Tutte le Automazioni",
            deleteAutomations: "{count} automazioni eliminate",
            selectedAutomations: "{count} automazioni selezionate",
            pasteInfoMessage: "Automazione copiata negli appunti rilevata! Crea immediatamente una nuova automazione incollandola con <strong>Ctrl+V</strong>.",
            categoryName: "Nome Categoria",
            categoryNamePlaceholder: "Inserisci il nome della categoria",
            editCategory: "Modifica Categoria",
            deleteCategory: "Elimina Categoria",
            createCategory: "Aggiungi Categoria",
            publishAutomation: "Pubblicato",
            unpublishAutomation: "Fermato",
            timerAutomation: "Programmato",
            eventAutomation: "Evento",
            deleteAutomation: "Elimina Automazione",
            changeCategory: "Cambia Categoria",
            copyAutomation: "Copia Automazione",
            copyAutomationAsJSON: "Copia come JSON",
            emptyCategoryMessage: "Puoi aggiungere automazioni alla categoria trascinandole qui",
            whenFormSubmitted: "Quando viene inviato un modulo",
            automations: "Automazioni",
            taskCreated2: "Compito creato",
            waitingTaskCreation: "In attesa della creazione del compito...",
            calendarEventCreated: "Evento creato nel calendario",
            calendarEventUpdated: "Evento aggiornato nel calendario",
            calendarEventDeleted: "Evento eliminato dal calendario",
            reservationCreated: "Prenotazione creata",
            reservationDateChanged: "Data di prenotazione modificata",
            reservationDeleted: "Prenotazione eliminata",
            chatLost: "Quando la chat è persa",
            webchatCompleted: "Quando la chat web è completata",
            instagramCompleted: "Quando la chat dal canale Instagram è completata",
            messengerCompleted: "Quando la chat dal canale Messenger è completata",
            whatsappCompleted: "Quando la chat dal canale WhatsApp è completata",
            telegramCompleted: "Quando la chat dal canale Telegram è completata",
            chatAssignedToAgent: "Quando la chat è assegnata a un agente",
            profileButtonClicked: "Quando il pulsante di automazione viene cliccato dal profilo",
            operatedTask: "Attività in esecuzione",
            tableSelection: "Selezione tabella",
            selectTable: "Seleziona tabella",
            whichTableAutomationAddRecords: "Quale tabella si desidera eseguire l'automazione quando viene aggiunto un record? Selezionare",
            whichTableAutomationUpdateRecords: "Si desidera eseguire l'automazione quando viene aggiornato un record in quale tabella? Selezionare",
            whichTableAutomationDeletedRecords: "Da quale tabella si desidera eseguire l'automazione quando un record viene cancellato? Selezionare",
            whichTableAutomationClickRecords: "In quale tabella si desidera eseguire l'automazione quando si fa clic sul pulsante di automazione di un record? Selezionare",
            selectAtLeastOneField: "Deve essere selezionato almeno un campo",
            generalCategory: "Generale",
            configureTrackFields: "Configura campi di tracciamento",
            configureMessageFilter: "Configura filtro messaggi",
            makeFreeTier: "Rendi gratuito",
            revertFreeTier: "Ripristina livello normale",
            webhook: "Webhook",
            system: "Sistema",
            freeTierTooltip: "Questa automazione è nel livello gratuito. L'utilizzo non verrà detratto dalla tua quota.",
            freeTierBadge: "Livello gratuito",
            trackFieldsLabel: "Campi da tracciare",
            trackFieldsSelectPlaceholder: "Se nessun campo è selezionato, tutti i campi verranno tracciati",
            selectFieldPlaceholder: "Seleziona campo",
            tableMustBeSelectedFirst: "La tabella deve essere selezionata prima per l'automazione",
            fieldsLoadError: "Errore nel caricamento dei campi",
            trackFieldsUpdated: "Campi di tracciamento aggiornati",
            updateError: "Errore durante l'aggiornamento",
            automationMadeFreeTier: "Automazione impostata come livello gratuito",
            makeFreeTierError: "Errore nell'impostazione del livello gratuito",
            automationRevertedToNormalTier: "Automazione ripristinata al livello normale",
            revertFreeTierError: "Errore nel ripristino al livello normale",
            wrongPassword: "Password errata!",
            configLoadError: "Errore nel caricamento della configurazione",
            messageFilterConfigUpdated: "Configurazione filtro messaggi aggiornata",
            freeTierPasswordPrompt: "Inserisci la password per rendere gratuito:",
            configurePreFilters: "Configura prefiltri",
            configureExecutionPrivacy: "Configura permesso di esecuzione",
            editDescription: "Modifica descrizione",
            permissions: {
                title: "Permessi di accesso",
                mode: "Modalità permessi",
                publicMode: "Pubblico",
                customMode: "Personalizzato",
                publicModeDesc: "Tutti gli utenti possono accedere e modificare questa automazione.",
                customModeDesc: "Solo gli utenti e i dipartimenti specificati possono accedere a questa automazione.",
                confirmPublicMode: "Passa alla modalità pubblica",
                confirmPublicModeDesc: "Dopo questa operazione, tutti gli utenti potranno accedere a questa automazione. Vuoi continuare?",
                addUser: "Aggiungi utente",
                addDepartment: "Aggiungi dipartimento",
                selectUser: "Seleziona utente",
                selectDepartment: "Seleziona dipartimento",
                add: "Aggiungi",
                targetHeader: "Utente/Dipartimento",
                matrixInfo: "Seleziona i permessi da concedere per ogni utente o dipartimento.",
                noTargetsAdded: "Nessun utente o dipartimento aggiunto. Aggiungine uno sopra per concedere i permessi.",
                confirmRemoveTarget: "Rimuovi permesso",
                confirmRemoveTargetDesc: "Sei sicuro di voler rimuovere i permessi per questo utente o dipartimento?",
                saveSuccess: "Permessi di accesso salvati con successo",
                saveError: "Si è verificato un errore durante il salvataggio dei permessi di accesso",
                unknownUser: "Utente sconosciuto",
                unknownDepartment: "Dipartimento sconosciuto",
                noReadAccess: "Non hai accesso a questa automazione.",
                usersTab: "Utenti",
                departmentsTab: "Dipartimenti",
                authorizedUsers: "Utenti autorizzati",
                otherUsers: "Altri utenti",
                authorizedDepartments: "Dipartimenti autorizzati",
                otherDepartments: "Altri dipartimenti",
                cannotChangeOwnPermission: "Non puoi modificare il tuo permesso",
                you: "Tu",
                customPermissionDefined: "Permesso personalizzato definito per questo utente",
                customPermission: "Permesso personalizzato",
                grantPermission: "Concedi permesso",
                revokePermission: "Rimuovi permesso",
                applyToOthers: "Applica ad altre automazioni",
                applyToOthersDesc: "Applica queste impostazioni di permesso alle altre automazioni che selezioni",
                applyToOthersTitle: "Applica impostazioni permessi ad altre automazioni",
                applyToOthersWarning: "Le impostazioni di permesso esistenti delle automazioni selezionate saranno sostituite con quelle di questa automazione.",
                selectAll: "Seleziona tutto",
                selectedCount: "{count} automazioni selezionate",
                applyToSelected: "Applica ai selezionati",
                noAutomationsFound: "Nessuna automazione trovata",
                searchPlaceholder: "Cerca automazione o categoria...",
                applySuccess: "Impostazioni permessi applicate a {count} automazioni con successo",
                applyFailed: "Impossibile applicare le impostazioni di permesso a {count} automazioni",
                applyError: "Errore nell'applicazione delle impostazioni di permesso",
                groups: {
                    basic: "Base",
                    flow: "Flusso",
                    meta: "Info",
                    publish: "Pubblica",
                    actions: "Azioni",
                    plan: "Piano",
                    filter: "Filtro"
                },
                scopes: {
                    read: "Visualizza",
                    readDesc: "Permesso di visualizzare l'automazione",
                    flowUpdate: "Modifica flusso",
                    flowUpdateDesc: "Permesso di aggiungere, rimuovere e modificare i blocchi dell'automazione",
                    metaUpdate: "Modifica info",
                    metaUpdateDesc: "Permesso di modificare nome, descrizione e categoria dell'automazione",
                    publish: "Pubblica",
                    publishDesc: "Permesso di pubblicare e annullare la pubblicazione dell'automazione",
                    delete: "Elimina",
                    deleteDesc: "Permesso di eliminare l'automazione",
                    duplicate: "Duplica",
                    duplicateDesc: "Permesso di duplicare l'automazione",
                    planView: "Visualizza piani",
                    planViewDesc: "Permesso di visualizzare i piani di esecuzione dell'automazione",
                    planCancel: "Annulla piano",
                    planCancelDesc: "Permesso di annullare i piani programmati",
                    reschedule: "Riprogramma",
                    rescheduleDesc: "Permesso di riprogrammare l'automazione",
                    prefilterUpdate: "Modifica filtro",
                    prefilterUpdateDesc: "Permesso di modificare la configurazione del pre-filtro"
                }
            },
            planStatus: "Stato del piano",
            scheduled: "Pianificato",
            completed: "Completato",
            cancelled: "Annullato",
            startTest: "Avvia test",
            unpublish: "Annulla pubblicazione",
            whenMessagePicked: "Quando viene selezionato un messaggio tramite l'interfaccia di chat",
            whenTaskCompleted: "Quando un'attività viene completata",
            whenTaskDeleted: "Quando un'attività viene eliminata",
            whenTaskAssigneeChanged: "Quando viene cambiato l'assegnatario di un compito",
            whenTaskPriorityChanged: "Quando la priorità di un'attività viene modificata",
            whenTaskDueDateChanged: "Quando la data di scadenza di un'attività viene modificata",
            whenTaskStatusChanged: "Quando lo stato di un'attività viene modificato",
            whenTaskArchived: "Quando un'attività viene archiviata",
            whenTagAdded: "Quando viene aggiunto un tag all'attività",
            whenTagRemovedTask: "Quando un tag viene rimosso da un'attività",
            whenTagChecklist: "Quando viene completata una lista di controllo dell'attività",
            whenReminderActivated: "Quando viene attivato un promemoria",
            whenTicketCreated: "Quando viene creato un biglietto",
            whenTicketStageChanged: "Quando viene modificata la fase di un ticket",
            whenTicketAssigneeChanged: "Quando viene cambiato l'assegnatario di un biglietto",
            whenTicketClosed: "Quando un ticket viene chiuso",
            whenTicketUpdated: "Quando un ticket viene aggiornato",
            autoPlanAndTaskHistory: "Piano di automazione e cronologia attività",
            automation: "Automazione",
            botScenario: "Scenario bot",
            nameSurname: "NomeCognome",
            phone164: "*Inserire nel formato E164. Ad esempio: 905396667744",
            whichWpChannels: "Quali canali Whatsapp aggiungere?",
            findContact: "Trova un contatto",
            findContacts: "Trova contatti",
            offsetDesc: "Salta i primi N contatti. Il valore predefinito è '0'. Utilizzare questo valore per scorrere i contatti",
            limitDesc: "Numero massimo di contatti da restituire dopo l'offset. Il valore predefinito è '10'. Usare questo valore per impaginare",
            contact: "Contatto",
            selectAction: "Seleziona azione",
            addMethod: "Metodo di aggiunta",
            selectField: "Seleziona campo",
            schedulerRunningPlanEx: "Esempio di piano di esecuzione dello scheduler",
            schedulerPlanner: "Pianificatore di pianificazione",
            taskCreated: "Attività creata?",
            taskStatus: "Stato dell'attività",
            terminateReason: "Motivo di terminazione",
            taskDuration: "Durata dell'attività",
            taskWakeUpCount: "Conteggio risvegli dell'attività",
            completedAt: "Completato",
            cancelledAt: "Annullato",
            nextRunAt: "Prossima esecuzione",
            configSchedulerAuto: "Configura il timer per l'automazione",
            saveChanges: "Salva le modifiche",
            catchAllWebhooks: "Cattura tutti i webhook da questo URL",
            webhookDataExPreview: "Anteprima del campione di dati del webhook (verrà mostrato dopo l'invio della richiesta)",
            webhookUrlCopied: "URL del webhook copiato negli appunti",
            selectAnBlock: "Seleziona un blocco",
            dataFormats: "Formati dei dati",
            whenRecordCreated: "Quando viene creato un record",
            whenRecordUpdated: "Quando un record viene aggiornato",
            whenRecordDelete: "Quando un record viene eliminato",
            whenRecordAutomation: "Quando viene fatto clic sul pulsante di automazione di un record",
            whenWebhookTriggered: "Quando viene attivato un webhook",
            whenChatCreated: "Quando viene creata una chat",
            whenChatClosed: "Quando una chat viene chiusa",
            whenChatRated: "Quando una chat viene valutata",
            whenNewContactCreated: "Quando viene creato un nuovo contatto",
            whenContactUpdate: "Quando viene aggiornato un contatto",
            whenContactPropUpdate: "Quando viene aggiornata una proprietà del contatto",
            whenNewTagAdded: "Quando viene aggiunto un nuovo tag",
            whenTagRemoved: "Quando un tag viene rimosso",
            whenNewEmailReceived: "Quando viene ricevuta una nuova e-mail",
            whenNewTaskCreated: "Quando viene creata una nuova attività",
            whenNewMetaleadCreated: "Quando viene creato un nuovo meta-lead",
            whenNewAgentCreated: "Quando viene creato un nuovo agente",
            whenAgentOnline: "Quando un agente va online",
            whenAgentOffline: "Quando un agente va offline",
            whenAgentStatusChanged: "Quando lo stato di un agente cambia",
            whenAgentLogin: "Quando un agente effettua l'accesso",
            whenNewInvoiceCreated: "Quando viene creata una nuova fattura",
            whenNewWpReceived: "Quando viene ricevuto un nuovo messaggio whatsapp",
            whenNewReservationCreated: "Quando viene creata una nuova prenotazione",
            whenNewChatbotReceived: "Quando viene ricevuto un nuovo messaggio chatbot",
            chatWebhookAutomation: "Catturare un webhook ed eseguire un'automazione",
            automationName: "Nome automazione",
            supsisObject: "Oggetto Supsis",
            selectModule: "Modello di selezione",
            bodyType: "Tipo di corpo",
            selectBodyType: "Seleziona il tipo di corpo",
            selectMethod: "Seleziona metodo",
            trigger: "Trigger",
            published: "Pubblicato",
            createdAt: "Creato a",
            action: "Azione",
            type: "Tipo",
            view: "Vista",
            createTimerAutomation: "Creare automazione basata su eventi",
            createEventBasedAutomation: "Creare l'automazione Webhook",
            createWebhookAutomation: "Creare l'automazione Webhook",
            automationsCouldNotBeDeleted: "Non è stato possibile eliminare le automazioni",
            timerAutomationCreatedSuccessfully: "Automazione timer creata con successo",
            eventAutomationCreatedSuccessfully: "Automazione evento creata con successo",
            webhookAutomationCreatedSuccessfully: "Automazione webhook creata con successo",
            automationsCouldNotBeFetched: "Non è stato possibile rilevare le automazioni",
            automationPublishedStateUpdatedSuccessfully: "Automazione Stato pubblicato aggiornato con successo",
            automazioni: "Automazioni",
            allAutomations: "Tutte le automazioni",
            scheduledAutomations: "Automazioni pianificate",
            eventBasedAutomations: "Automazioni basate su eventi",
            buttonAutomations: "Automazioni su pulsanti",
            webhookAutomations: "Automazioni webhook",
            analytics: "Analitica",
            insights: "Approfondimenti",
            trash: "Cestino",
            sandboxPage: {
                title: "Scenari di automazione eliminati",
                description: "Le automazioni non ripristinate verranno eliminate definitivamente dal sistema entro 30 giorni",
                emptyState: "Nessuna automazione eliminata nel cestino",
                unnamedAutomation: "Automazione senza titolo",
                restore: "Ripristina",
                timerAutomation: "Automazione timer",
                eventAutomation: "Automazione evento",
                webhook: "Webhook",
                buttonAutomation: "Automazione pulsante",
                tableButtonAutomation: "Automazione pulsante tabella",
                chatbotAutomation: "Automazione chatbot",
                unknown: "Sconosciuto",
                user: "Utente",
                restoreConfirmTitle: "Sei sicuro di voler ripristinare questa automazione?",
                restoreConfirmContent: "L'automazione {name} verrà ripristinata.",
                restoreSuccess: "Automazione ripristinata",
                restoreFailed: "Ripristino fallito",
                loadError: "Errore nel caricamento delle automazioni eliminate"
            },
            insightsPage: {
                title: "Statistiche automazione",
                selectAutomation: "Seleziona automazione",
                dateRange: "Intervallo di date",
                datePlaceholderStart: "Inizio",
                datePlaceholderEnd: "Fine",
                lastWeek: "Ultima settimana",
                lastMonth: "Ultimo mese",
                last3Months: "Ultimi 3 mesi",
                statusFilter: "Filtro stato",
                statusScheduled: "Pianificato",
                statusRunning: "In esecuzione",
                statusWaitingReply: "In attesa di risposta",
                statusDone: "Completato",
                statusFailed: "Fallito",
                statusCancelled: "Annullato",
                clearFilters: "Cancella filtri",
                refreshData: "Aggiorna dati",
                activeFilters: "Filtri attivi:",
                totalTasks: "Totale attività",
                executedTasks: "Attività eseguite",
                successRate: "Tasso di successo",
                successfulTasks: "Attività completate",
                avgDuration: "Durata media",
                avgWorkDuration: "Durata media di lavoro",
                activeTasks: "Attività attive",
                runningNow: "In esecuzione ora",
                dailyTaskExecution: "Esecuzione attività giornaliere",
                statusDistribution: "Distribuzione stato",
                durationDistribution: "Distribuzione durata",
                terminateReasons: "Motivi di terminazione",
                automationPerformance: "Prestazioni automazione",
                view: "Visualizza",
                automationName: "Nome automazione",
                executionCount: "Numero di esecuzioni",
                actions: "Azioni",
                totalTasksLegend: "Totale attività",
                successfulLegend: "Completato",
                failedLegend: "Fallito",
                taskCount: "Numero di attività",
                ms: "ms",
                sec: "sec",
                min: "min",
                hour: "h",
                automationsLoadError: "Errore nel caricamento delle automazioni",
                insightsLoadError: "Errore nel caricamento delle statistiche"
            },
            settingsWidget: {
                viewActivityLogs: "Visualizza log attività",
                activityLogsTitle: "Log attività",
                activityLogsEmpty: "Nessun record di attività ancora",
                activityLogsLoadError: "Errore nel caricamento dei log attività",
                exportedToClipboard: "Automazione esportata negli appunti",
                settings: "Impostazioni"
            },
            blocks: {
                ASSIGN_OWNER: "Assegna Proprietà",
                autoForwardToOwnerForce: "Inoltro automatico al proprietario (anche con chatbot attivo)",
                SHOW_WIDGET: "Mostra Widget",
                REPLY_TRENDYOL_QUESTION: "Rispondi alla domanda Trendyol",
                START_POINT: "PUNTO DI PARTENZA",
                AI_ASSISTANT: "ASSISTENTE AI",
                BOT_RESPONSE: "RISPOSTA DEL BOT",
                AI_BOT_RESPONSE: "AI RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "CLASSIFICAZIONE AI",
                AI_MENU_FLOW: "MENU AI",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "COMMENTO AI INSTAGRAM",
                PLATFORM_FLOW: "PIATTAFORMA",
                DEFAULT_FALLBACK: "FALLBACK PREDEFINITO",
                DEFAULT_TIMEOUT: "TIMEOUT PREDEFINITO",
                AI_FUNCTIONS: "FUNZIONI AI",
                FILTER: "FILTRO",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "INPUT DELL'ALLEGATO",
                USER_INPUT: "INPUT DELL'UTENTE",
                GO_TO_STEP: "VAI AL PASSO",
                WEBHOOK: "WEBHOOK",
                SET_ATTRIBUTE: "IMPOSTA ATTRIBUTO",
                QUESTION: "DOMANDA",
                CLOSE_CHAT: "CHIUDERE LA CHAT",
                CREATE_TICKET: "CREA TICKET",
                TRANSFER_CHAT: "TRASFERISCI CHAT",
                TRANSFER_TO_CHATBOT: "INOLTRA AL CHATBOT",
                TAG_CHAT: "AGGIUNGI TAG",
                REMOVE_TAG: "RIMUOVI TAG",
                SET_DEPARTMENT: "IMPOSTA REPARTO",
                SEND_TRANSCRIPT: "INVIA TRASCRIZIONE",
                SEND_SMS: "INVIA SMS",
                SEND_MAIL: "INVIA EMAIL",
                CREATE_EVENT: "CREA EVENTO",
                CREATE_RESERVATION: "CREA PRENOTAZIONE",
                RESERVATION_OPEN_URL: "Url di apertura della prenotazione",
                RESERVATION_SELECT_DAY: "Seleziona il giorno della prenotazione",
                RESERVATION_EVENT_LIST: "Visitatore dell'elenco prenotazioni",
                RESERVATION_SELECT_TIME: "Selezionare l'ora della prenotazione",
                CREATE_TASK: "CREA ATTIVITÀ",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY MOSTRA PRODOTTI",
                SHOPIFY_PRODUCT_AVAILABILITY: "DISPONIBILITÀ DEI PRODOTTI SHOPIFY",
                SHOPIFY_ORDER_STATUS: "STATO DELL'ORDINE DI SHOPIFY",
                AKINON_SHOW_PRODUCTS: "AKINON MOSTRA PRODOTTI",
                AKINON_FIND_PRODUCT: "AKINON TROVA PRODOTTO",
                AKINON_ORDER_STATUS: "STATO DELL'ORDINE DI AKINON",
                AKINON_SELECT_ORDER: "AKINON SELEZIONA ORDINE",
                AKINON_SELECT_SIZE: "AKINON SELEZIONA LA TAGLIA",
                AKINON_FIND_NEAREST_STOCK: "MOSTRA LO STOCK DEL NEGOZIO",
                AKINON_FIND_NEAREST_STORES: "MOSTRA I NEGOZI PIÙ VICINI",
                AKINON_SHOW_DISCOUNT_CODES: "MOSTRA I CODICI SCONTO",
                SUPPRESSION_ADD: "BLOCCA IL CONTATTO",
                SUPPRESSION_REMOVE: "SBLOCCA CONTATTO",
                IDEASOFT_SELECT_ORDER: "SELEZIONA ORDINE",
                IDEASOFT_ORDER_STATUS: "OTTIENI LO STATO DELL'ORDINE",
                IDEASOFT_GET_MEMBER_INFO: "RIEMPIRE INFORMAZIONI SUI MEMBRI",
                TICKET_UPDATE: "AGGIORNAMENTO DEI BIGLIETTI",
                TSOFT_SELECT_ORDER: "SELEZIONA ORDINE",
                TSOFT_ORDER_STATUS: "OTTIENI LO STATO DELL'ORDINE",
                TICIMAX_V2_SELECT_ORDER: "SELEZIONA ORDINE",
                TICIMAX_V2_ORDER_STATUS: "OTTIENI LO STATO DELL'ORDINE",
                IKAS_GET_MEMBER_INFO: "Ottieni dettagli membro",
                IKAS_SELECT_ORDER: "Seleziona ordine",
                IKAS_ORDER_STATUS: "Recupera stato ordine",
                GET_LOCATION: "OTTENERE LA POSIZIONE",
                FALLBACK: "CASO D'EMERGENZA",
                TIMEOUT: "TIMEOUT",
                SUCCESSO: "SUCCESSO",
                FALLIMENTO: "FALLITO",
                PROBEL_SELECT_BRANCH: "Seleziona filiale",
                PROBEL_SELECT_CLINIC: "Selezionare il policlinico",
                PROBEL_SELECT_DAY: "Selezionare il giorno dell'appuntamento",
                PROBEL_SELECT_HOUR: "Selezionare l'ora dell'appuntamento",
                PROBEL_MAKE_APPOINTMENT: "Fissa un appuntamento",
                PROBEL_CANCEL_APPOINTMENT: "Cancellazione appuntamento",
                PROBEL_GET_PATIENT_TOKEN: "Ottieni il token del paziente",
                PROBEL_FILL_INFO: "Ottenere informazioni MERNIS",
                PROBEL_SELECT_APPOINTMENT: "Seleziona appuntamento",
                SEND_WP_BUSINESS_MESSAGE: "INVIA MESSAGGIO WHATSAPP",
                MESSENGER_SEND_MESSAGE: "INVIA MESSAGGIO MESSENGER",
                INSTAGRAM_SEND_MESSAGE: "INVIA MESSAGGIO INSTAGRAM",
                INSTAGRAM_COMMENT_REPLY: "RISPOSTA AL COMMENTO",
                INSTAGRAM_COMMENT_DELETE: "CANCELLA COMMENTO",
                INSTAGRAM_COMMENT_SHOW: "MOSTRA COMMENTO",
                INSTAGRAM_COMMENT_HIDE: "NASCONDI COMMENTO",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RISPONDI COME PRIVATO",
                LOOP: "Loop",
                LOOP_NEXT: "Loop Next Item",
                LOOP_BREAK: "Interruzione del ciclo",
                LOOP_CONTINUE: "Continua il ciclo successivo",
                LOOP_FINISH: "Termina il ciclo",
                SLEEP: "Dormi",
                NOOP: "Noop",
                CATCH_WEBHOOK: "Cattura Webhook",
                TERMINATE_AUTOMATION: "Termina automazione",
                CREATE_CONTACT: "Crea contatto",
                UPDATE_CONTACT: "Aggiorna contatto",
                FIND_CONTACTS: "Trova contatti",
                FIND_CONTACT: "Trova contatto",
                FIND_CHATS: "Trova chat",
                FIND_CHAT: "Trova chat",
                WAIT_FOR: "Attendere",
                STRING_FORMAT: "Formato stringa",
                NUMBER_FORMAT: "Formato numero",
                DATE_FORMAT: "Formato data",
                RECORDS_FROM_CSV: "Record da CSV",
                MESSAGE_RECEIVED: "Messaggio ricevuto",
                ASK_AI: "Intelligenza Artificiale",
                TABLE_CREATE_RECORD: "Crea record",
                TABLE_DELETE_RECORD: "Elimina record",
                TABLE_UPDATE_RECORD: "Aggiorna record",
                TABLE_FIND_RECORD: "Trova record",
                TABLE_FIND_RECORDS: "Elenco record",
                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Trova record (per telefono)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Aggiungi file al record",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Carica immagine nel campo personalizzato",
                ZOHO_CREATE_RECORD: "Zoho Crea record",
                GET_SUPSIS_RECORD_BY_ID: "Ottieni record",
                META_SEND_CAPI_EVENT: "Invia evento CAPI",
                GOOGLE_DRIVE_UPLOAD_FILE: "Carica file",
                GOOGLE_DRIVE_DOWNLOAD_FILE: "Scarica file",
                GOOGLE_DRIVE_GET_FILE_INFO: "Ottieni informazioni file",
                GOOGLE_DRIVE_DELETE_FILE: "Elimina file",
                ADD_TO_SEGMENT: "Aggiungi al segmento",
                REMOVE_FROM_SEGMENT: "Rimuovi dal segmento",
                FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
                INSERT_TO_SYSTEM_PROMPT: "INSERT TO SYSTEM PROMPT",
                AI_CALL: "AI CALL",
                TAVILY_WEB_SEARCH: "WEB SEARCH (TAVILY)",
                RUN_JAVASCRIPT: "RUN JAVASCRIPT",
                SEND_JSON_RESPONSE: "RESPOND TO WEBHOOK",
                UPDATE_TASK: "UPDATE TASK",
                CACHE_WRITE: "CACHE WRITE",
                CACHE_READ: "CACHE READ",
                CACHE_EXTEND: "CACHE EXTEND",
                CACHE_DELETE: "CACHE DELETE",
                YOUTUBE_REPLY_COMMENT: "Reply Comment",
                YOUTUBE_UPDATE_COMMENT_STATUS: "Aggiorna stato commento",
                YOUTUBE_SET_MODERATION_STATUS: "Set Moderation Status",
                GOOGLE_BUSINESS_REPLY_REVIEW: "Rispondi alla recensione",
                GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "Aggiorna stato recensione",
                GOOGLE_PLAY_REPLY_REVIEW: "Rispondi alla recensione",
                GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "Aggiorna stato recensione",
                APP_STORE_REPLY_REVIEW: "Rispondi alla recensione",
                APP_STORE_UPDATE_REVIEW_STATUS: "Aggiorna stato recensione",
                APP_STORE_DELETE_REVIEW_RESPONSE: "Elimina risposta alla recensione",
                SUCCESS: "RIUSCITO",
                FAILURE: "FALLITO",
                OPENROUTER_RESPONSE: "Risposta OpenRouter AI",
                OPENAI_RESPONSE: "Genera con OpenAI",
                GOOGLE_AI_RESPONSE: "Genera con Google AI",
                ANTHROPIC_RESPONSE: "Genera con Anthropic",
                MISTRAL_RESPONSE: "Genera con Mistral",
                AZURE_RESPONSE: "Genera con Azure",
                BEDROCK_RESPONSE: "Genera con AWS Bedrock",
                COHERE_RESPONSE: "Genera con Cohere",
                XAI_RESPONSE: "Genera con xAI",
                DEEPINFRA_RESPONSE: "Genera con DeepInfra",
                TOGETHER_RESPONSE: "Genera con Together",
                FIREWORKS_RESPONSE: "Genera con Fireworks",
                SILICONFLOW_RESPONSE: "Genera con SiliconFlow",
                PARASAIL_RESPONSE: "Genera con Parasail",
                NEBIUS_RESPONSE: "Genera con Nebius",
                ALIBABA_RESPONSE: "Genera con Alibaba",
                XIAOMI_RESPONSE: "Genera con Xiaomi",
                SAMBANOVA_RESPONSE: "Genera con SambaNova",
                MOONSHOT_RESPONSE: "Genera con Moonshot",
                MINIMAX_RESPONSE: "Genera con MiniMax",
                NVIDIA_RESPONSE: "Genera con NVIDIA",
                OPENAI_WEB_SEARCH: "WEB SEARCH (OPENAI)",
                OPEN_AI: "OPEN_AI",
                PLATTFORM_FLOW: "PLATTFORM",
                PUNTO_INICIO: "PUNTO DE INICIO"
            },
            newAutomation: "New Automation",
            totalAutomations: "Total {count} automations",
            totalAutomationsWithHidden: "Total {total} automations ({visible} visible)",
            whenVoiceAgentCallStarted: "Quando una chiamata dell'agente vocale viene avviata",
            whenVoiceAgentCallEnded: "Quando una chiamata dell'agente vocale termina",
            whenVoiceAgentCallAnalyzed: "Quando una chiamata dell'agente vocale viene analizzata",
            createAnEventAutomation: "Crea un'automazione evento",
            automationPublishedStateCouldNotBeUpdated: "Impossibile aggiornare lo stato di pubblicazione dell'automazione",
            enablePreFilters: "Enable Pre-Filters",
            preFilterDescription: "I pre-filtri consentono di determinare quando l'automazione deve essere eseguita. Se attivati, l'automazione si attiverà solo per gli eventi che corrispondono alle condizioni definite.",
            preFilters: "Pre-Filters",
            executionRules: "Execution Rules",
            preFilterInfo: "Con i pre-filtri puoi determinare quando l'automazione deve essere eseguita. L'automazione si attiverà solo per gli eventi che corrispondono alle condizioni definite.",
            preFiltersSaved: "Pre-filters saved successfully",
            preFiltersSaveError: "Errore nel salvataggio dei pre-filtri",
            preFiltersConfiguration: "Pre-Filter Configuration",
            executionPrivacyTitle: "Execution Permission",
            executionPrivacyDescription: "Quali utenti o dipartimenti possono eseguire questa automazione? Se lasciato vuoto, tutti gli utenti possono eseguirla.",
            executionPrivacyPublic: "Tutti gli utenti possono eseguire questa automazione",
            executionPrivacyConfiguration: "Execution Permission Configuration",
            executionPrivacySaved: "Execution permission saved successfully",
            executionPrivacySaveError: "Si è verificato un errore durante il salvataggio del permesso di esecuzione",
            addDescription: "Aggiungi descrizione...",
            descriptionPlaceholder: "Inserisci la descrizione dell'automazione...",
            descriptionSaved: "Descrizione salvata con successo",
            descriptionSaveError: "Si è verificato un errore durante il salvataggio della descrizione",
            makePublicExecution: "Make Public",
            makePublicExecutionConfirmTitle: "Sei sicuro di voler rendere pubblica questa automazione?",
            makePublicExecutionConfirmContent: "Dopo questa operazione, tutti i rappresentanti potranno eseguire questa automazione.",
            madePublicExecution: "L'automazione è stata resa pubblica",
            openrouterResponse: "Risposta OpenRouter AI",
            selectProvider: "Seleziona provider",
            modelName: "Model",
            modelHint: "E.g.: google/gemini-2.0-flash-001, openai/gpt-4o",
            systemInstructions: "System Instructions (Optional)",
            systemInstructionsPlaceholder: "Indica all'IA come comportarsi...",
            promptPlaceholder: "Scrivi la tua domanda per l'IA...",
            advancedSettings: "Advanced Settings",
            temperatureHint: "Lower values produce more consistent responses, higher values produce more creative responses (0-2)",
            maxTokens: "Max Tokens",
            maxTokensHint: "Numero massimo di token da generare",
            maxTokensPlaceholder: "Default: Model limit",
            selectChannel: "Seleziona canale (opzionale)",
            autoSelectChannel: "Auto select",
            archivingDate: "Archiving Date",
            automationPublishedStateUpdatedSupdatedSuccessfully: "Stato di pubblicazione dell'automazione aggiornato con successo",
            automationsCouldNouldNotBeFetched: "Impossibile recuperare le automazioni",
            cancelado: "Annullato",
            webhookAutomationCutomationCreatedSuccessfully: "Automazione webhook creata con successo"
        },
        modules: {
            kanbanSettings: {
                title: "Impostazioni",
                column: "Impostazioni della colonna",
                selectField: "Seleziona un campo",
                selectFieldPlaceholder: "Seleziona un campo",
                card: "Impostazioni della scheda",
                selectFields: "Seleziona i campi da visualizzare nella scheda",
                cancel: "Annulla",
                save: "Salva",
                kanban: "Impostazioni Kanban"
            },
            createFailed: "Creazione del modulo fallita",
            createSuccess: "Modulo creato con successo",
            moduleDeletedSuccessfully: "Modulo eliminato con successo",
            deleteModuleTitle: "Elimina Modulo",
            deleteModuleContent: "Sei sicuro di voler eliminare questo modulo?",
            modules: "Moduli",
            relations: "Relazioni",
            newRelation: "Nuova Relazione",
            editRelation: "Modifica Relazione",
            modulesSettings: "Impostazioni dei Moduli",
            displayName: "Nome Visualizzato",
            description: "Descrizione",
            table: "Tabella",
            menuApiSettings: "Impostazioni Menu e API",
            icon: "Icona",
            save: "Salva",
            exampleIcon: "Esempio: extension, home",
            newModule: "Nuovo Modulo",
            moduleName: "Nome Modulo",
            apiName: "Nome API",
            type: "Tipo",
            apiAccess: "Accesso API",
            actions: "Azioni",
            module: "Modulo",
            relation: "Relazione",
            moduleRelationName: "Modulo/Relazione",
            moduleRelationTable: "Tabella Modulo/Relazione",
            showInMainMenu: "Mostra nel Menu Principale",
            apiEnabled: "API Abilitata",
            settings: "Impostazioni",
            createModule: "Crea Modulo",
            relationType: "Tipo di Relazione",
            relationTypeTableToTable: "Tabella a Tabella",
            relationTypeTableToStandart: "Tabella a Modulo Standard",
            relationTypeStandartToTable: "Modulo Standard a Tabella",
            fromColumn: "Da",
            toColumn: "A",
            apiDoc: "Documentazione API",
            standartModule: "Modulo Standard",
            customTable: "Tabella Personalizzata",
            localField: "Campo Locale",
            showingRemoteFieldInList: "Mostra Campo Remoto in Lista",
            relationSettings: "Impostazioni Relazione",
            remoteField: "Campo Remoto",
            localFieldType: "Tipo di Campo Locale",
            standart: "Standard",
            custom: "Personalizzato",
            contact: "Contatto",
            viewRecord: "Visualizza Record",
            recordDetail: "Dettagli del record",
            recordNotFound: "Record o informazioni della tabella non trovate",
            relatedLists: "Liste correlate",
            recordViewer: "Visualizzatore di record",
            updateSuccess: "Modulo aggiornato con successo",
            updateFailed: "Aggiornamento modulo fallito",
            editModule: "Modifica modulo",
            priority_high: "Alta",
            priority_highest: "Molto alta",
            priority_low: "Bassa",
            priority_lowest: "Molto bassa",
            priority_medium: "Media"
        },
        tables: {
            enterWidgetName: "Inserisci il nome del widget",
            widgetName: "Nome del Widget",
            renameWidget: "Rinomina Widget",
            assistantCapabilities: "Capacità dell'Assistente",
            addNewFieldsToTable: "Può aggiungere nuovi campi alla tabella",
            editExistingFields: "Può modificare i campi esistenti",
            deleteUnnecessaryFields: "Può eliminare i campi non necessari",
            filterRecords: "Può filtrare i record",
            groupRecords: "Può raggruppare i record",
            hideFieldsCapability: "Può nascondere i campi",
            createConditionalFormatting: "Può creare formattazione condizionale",
            createCalculationFormulas: "Può creare formule di calcolo",
            createSampleRecords: "Può creare record di esempio",
            examplePrompt: "Esempio: Aggiungi i campi Nome, Cognome, Email e Telefono per le informazioni del cliente a questa tabella...",
            supsisAssistantTables: "Supsis Assistant: Tabelle",
            supsisAssistantWritePrompt: "Descrivi cosa vuoi che faccia il Supsis Assistant",
            supsisAssistantExamplePrompt: "Crea una tabella per tracciare le riunioni. Includi campi come argomento della riunione, data, partecipanti, persona responsabile, decisioni prese e azioni di follow-up.",
            sendSupsisAssistant: "Invia al Supsis Assistant",
            examplePromptsTitle: "Richieste Esempio:",
            examplePrompts: {
                addCustomerInfoFields: "Aggiungi i campi Nome, Cognome, Email e Telefono per le informazioni del cliente a questa tabella.",
                addOrderFields: "Aggiungi i campi Nome Prodotto, Quantità, Prezzo Unitario, Importo Totale e Data Ordine alla tabella degli ordini.",
                addBirthDateField: "Aggiungi un campo Data di Nascita a questa tabella e imposta il formato della data su GG/MM/AAAA.",
                updateStatusField: "Aggiorna il campo Stato, rendilo un menu a discesa con le opzioni: In attesa, In elaborazione, Completato, Annullato.",
                replaceAddressFields: "Elimina il campo Indirizzo e aggiungi al suo posto Indirizzo Riga 1, Indirizzo Riga 2, Quartiere, Città e CAP.",
                alignTextFields: "Allinea tutti i campi di testo al centro e limita la lunghezza massima del testo a 100 caratteri.",
                addAutoIncrementID: "Aggiungi un campo ID a incremento automatico con il prefisso PRD- per il prodotto.",
                addTotalAmountFormula: "Aggiungi il campo Importo Totale come formula che calcola il prodotto tra quantità e prezzo unitario.",
                createActiveCustomersFilter: "Crea un filtro per visualizzare solo i clienti attivi.",
                filterRecentUsers: "Filtra gli utenti registrati negli ultimi 30 giorni.",
                groupByStatus: "Raggruppa i record in base alla colonna Stato.",
                hideAllExceptDeliveryAndOrderNo: "Nascondi tutti i campi tranne Data di Consegna e Numero Ordine.",
                colorCodeOrders: "Colore rosso per gli ordini in ritardo, giallo per quelli da consegnare oggi e verde per quelli completati.",
                highlightHighPaymentRecords: "Evidenzia in viola i record con un pagamento superiore a 1000 TL.",
                groupAndHighlightUnpaidOrders: "Raggruppa per data dell’ordine e evidenzia in rosso quelli non pagati.",
                createSampleRecords: "Crea 10 record di esempio in questa tabella.",
                addSampleRecordsForAliAndAhmet: "Aggiungi 5 record di esempio con i nomi cliente Ali e Ahmet.",
                createRandomSampleOrders: "Crea 20 ordini di esempio con stati assegnati in modo casuale.",
                hrCandidateTracking: "Voglio creare un software di tracciamento dei candidati (ATS) per i nostri processi HR. Includi tutto ciò che un ATS dovrebbe avere. Usa nomi di campo in turco.",
                crmModuleCreation: "Crea tutti i moduli necessari per la gestione delle relazioni con i clienti (CRM). Includi informazioni sui clienti, registrazioni delle riunioni e gestione delle opportunità.",
                realEstatePortfolioManagement: "Voglio impostare un sistema di gestione del portafoglio immobiliare. Dovrebbe gestire i dettagli delle proprietà, le richieste dei clienti e il tracciamento delle vendite.",
                schoolManagementSystem: "Voglio gestire il tracciamento degli studenti, degli insegnanti e degli orari delle lezioni per un sistema di gestione scolastica. Usa nomi di campo in turco.",
                projectManagementSystem: "Voglio creare un sistema di gestione dei progetti. Includi compiti, membri del team, tracciamento del tempo e funzionalità di reporting.",
                inventoryAndWarehouseManagement: "Voglio costruire un sistema per la gestione delle scorte e dei magazzini. Dovrebbe gestire le entrate/uscite dei prodotti, i livelli di scorta e il tracciamento dei fornitori.",
                serviceAndMaintenanceTracking: "Voglio un sistema di tracciamento dei servizi e della manutenzione. Dovrebbe gestire i dispositivi dei clienti, la cronologia della manutenzione e le assegnazioni dei tecnici.",
                restaurantManagementSystem: "Voglio impostare un sistema di gestione del ristorante. Includi tracciamento dei tavoli, gestione degli ordini, display della cucina e operazioni di fatturazione."
            },
            createAppWithSupsisAssistant: "Crea App con Supsis Assistant",
            noWidgets: "Nessun widget aggiunto",
            widgetLoadError: "Errore nel caricamento del widget",
            createDashboardSupsisAssistant: "Crea Dashboard con Supsis Assistant",
            youtubeDesc: "Inserisci video YouTube nel tuo pannello",
            iframeDesc: "Inserisci contenuti web esterni nel tuo pannello",
            countdownDesc: "Aggiungi un contatore per monitorare i tempi importanti",
            countdown: "Contatore",
            textDesc: "Aggiungi contenuto testo personalizzato al tuo pannello",
            numbersDesc: "Ottieni un rapido riepilogo di tutte le colonne numeriche",
            numbers: "Numeri",
            addWidget: "Aggiungi Widget",
            graphDesc: "Crea un widget grafico per visualizzare i dati nelle tue tabelle",
            graph: "Grafico",
            suggested: "Suggerito",
            tables: "Tavoli",
            company: "Azienda",
            individual: "Individuale",
            creationDate: "Data di creazione",
            today: "Oggi",
            month: "Mese",
            week: "Settimana",
            day: "Giorno",
            table: "Tabella",
            kanban: "Kanban",
            calendar: "Calendario",
            colorBy: "Colore Per",
            startDateField: "Campo Data Inizio",
            endDateField: "Campo Data Fine (Opzionale)",
            eventCardFields: "Campi Scheda Evento",
            selectColorField: "Seleziona Campo Colore",
            selectStartDateField: "Seleziona Campo Data Inizio",
            selectEndDateField: "Seleziona Campo Data Fine",
            cancel: "Annulla",
            save: "Salva",
            kanbanNotAvailable: "Vista Kanban Non Disponibile",
            needDropdownField: "Per utilizzare la vista Kanban, è necessario almeno un campo a discesa statico nella tabella. È possibile aggiungere un nuovo campo o modificarne uno esistente dalle impostazioni della tabella.",
            notAvailable: "Vista Calendario Non Disponibile",
            needDateField: "È necessario almeno un campo data nella tabella per utilizzare la vista calendario. È possibile aggiungere un nuovo campo o modificarne uno esistente dalle impostazioni della tabella.",
            switchToTable: "Passa alla Vista Tabella",
            operator: "Operatore",
            conditionalColor: "Colore condizionale",
            groupField: "Campo di gruppo",
            selectDirection: "Seleziona direzione",
            showEmptyGroups: "Mostra gruppi vuoti",
            clearGrouping: "Cancella raggruppamento",
            sortDirection: "Direzione di ordinamento",
            applyGrouping: "Applica raggruppamento",
            downloadSelectedRecords: "Scarica record selezionati",
            downloadSelected: "Scarica selezionati",
            downloadSelectedWithCount: "Scarica selezionati ({count})",
            downloadThisPage: "Scarica questa pagina",
            downloadAll: "Scarica tutto",
            downloadRecords: "Scarica record",
            downloadRecordsSettings: "Scarica record - Impostazioni",
            recordLimitExceededTooltip: "Limite record raggiunto. È necessario aggiornare il piano per importare record.",
            zebraMode: "Modalità Zebra",
            viewName: "Nome della vista",
            enterViewName: "Inserire il nome della vista",
            enterDesc: "Inserire la descrizione",
            viewNameRequired: "Nome vista richiesto",
            runWebhookAutomation: "Esegui automazione Webhook",
            downloadAllRecords: "Scarica tutti i record",
            deleteRecords: "Elimina i record",
            editRecords: "Aggiorna i record",
            duplicateRecords: "Record duplicati",
            selected: "Selezionato",
            sureDeleteRecords: "Sei sicuro di voler cancellare i record?",
            selectedRecordSucs: "I record selezionati sono stati cancellati con successo",
            errorDeletingRecords: "Si è verificato un errore durante l'eliminazione dei record",
            sureCopyRecords: "Sei sicuro di voler copiare i record?",
            copyRecords: "Copia dei record",
            recordsCopiedSucs: "I record selezionati sono stati copiati con successo",
            recordsCopiedError: "Si è verificato un errore durante la copia dei record selezionati",
            viewSucsCreated: "La vista è stata creata con successo",
            editMultipleRecords: "Modifica di più record",
            importRecords: "Importazione di record",
            importHasStarted: "L'importazione è iniziata. Potrebbe richiedere alcuni minuti, a seconda delle dimensioni dei dati. Attendere...",
            anErrorImport: "Si è verificato un errore durante l'importazione",
            recordCreated: "Crea record",
            recordUpdated: "Aggiorna record",
            recordDeleted: "Elimina record",
            noAutomationDefined: "Nessuna automazione ancora definita",
            nameTheAutomationAdd: "Nome dell'automazione che verrà eseguita quando un record viene aggiunto a questa tabella:",
            nameTheAutomationUpdate: "Nome dell'automazione che verrà eseguita quando un record di questa tabella viene aggiornato:",
            nameTheAutomationDelete: "Nome dell'automazione che verrà eseguita quando un record viene cancellato da questa tabella:",
            editField: "Campo di modifica",
            sort: "Ordinamento",
            sortAscending: "Ordina A-Z",
            sortDescending: "Ordina Z-A",
            clearSort: "Rimuovi ordinamento",
            markAsIdentifierField: "Segna come campo identificativo",
            runAI: "Esegui IA",
            ascendente: "Ascendente",
            discendente: "Discendente",
            createField: "Crea campo",
            insertBefore: "Inserisci prima",
            insertAfter: "Inserisci dopo",
            goToRelatedAuto: "Vai all'automazione correlata",
            permission: "Autorizzazione",
            lockField: "Blocca campo",
            hideField: "Nascondi campo",
            deleteField: "Elimina campo",
            watchVideo: "Guarda video",
            uploadError: "Errore di caricamento",
            updateError: "Errore di aggiornamento",
            invalidValue: "Valore non valido. Utilizzare il formato corretto",
            errorUpdatingRecord: "Si è verificato un errore durante l'aggiornamento del record",
            errorCreatingView: "Si è verificato un errore durante la creazione della vista",
            datetimeOptions: "Opzioni di data e ora",
            numberOptions: "Opzioni numero",
            currencyOptions: "Opzioni di valuta",
            dropdownOptions: "Opzioni a discesa",
            automationButtonOptions: "Opzioni del pulsante di automazione",
            defaultLabel: "Etichetta predefinita",
            disableWhenClicked: "Disabilita quando si fa clic",
            fieldSucsCreate: "Campo creato con successo",
            fieldCreatingFailed: "Si è verificato un errore durante la creazione del campo",
            fieldSucsUpdate: "Campo aggiornato con successo",
            fieldUpdatingFailed: "Si è verificato un errore durante l'aggiornamento del campo",
            showAll: "Mostra tutto",
            hideAll: "Nascondi tutto",
            searchFields: "Campi di ricerca",
            firstRowHeader: "La prima riga contiene l'intestazione",
            seperatorCharacter: "Carattere separatore",
            comma: "Virgola",
            semicolan: "Punto e virgola",
            tableFieldOrFileColumns: "Mappatura campi tabella / colonne file",
            exampleResultPreview: "Anteprima del risultato",
            newView: "Nuova vista",
            createViewaFiltering: "Creare viste per continuare a filtrare, ordinare e nascondere i campi senza modificare la tabella master",
            pleaseUpdateSelected: "Selezionare il campo che si desidera aggiornare per i record selezionati",
            pleaseSelectedNewValue: "Inserire il nuovo valore per il campo selezionato",
            selectedMenuItem: "Voce di menu selezionata:",
            deleteTable: "Elimina tabella",
            sureDeleteTable: "Sei sicuro di voler cancellare questa tabella?",
            deleteTableSucs: "La tabella è stata eliminata con successo",
            deleteTableError: "Errore nell'eliminazione della tabella:",
            editTable: "Modifica tabella",
            createNewField: "Creare un nuovo campo",
            tabelle: "Tabelle",
            tableName: "Nome tabella",
            description: "Descrizione",
            createTable: "Crea tabella",
            createNewTable: "Crea nuova tabella",
            allTables: "Tutte le tabelle",
            myTables: "Le mie tabelle",
            myFavorites: "I miei preferiti",
            errorCreatingTable: "Errore nella creazione della tabella:",
            customerTable: "Tabella clienti",
            customerTableDesc: "Tabella clienti predefinita",
            leadTracking: "Lead Tracking",
            leadTrackingDesc: "Tabella di tracciamento dei lead",
            todoList: "Elenco di cose da fare",
            todoListDesc: "Elenco per il monitoraggio dei compiti",
            approvalReq: "Richiesta di approvazione",
            approvalReqDesc: "Gestione delle richieste di approvazione",
            eventSchedule: "Calendario eventi",
            eventScheduleDesc: "Pianificazione dei prossimi eventi",
            inventoryList: "Elenco di inventari",
            inventoryListDesc: "Tiene traccia delle scorte di prodotti",
            bookingForm: "Modulo di prenotazione",
            bookingFormDesc: "Tracciamento delle prenotazioni",
            bugTracker: "Bug Tracker",
            bugTrackerDesc: "Traccia i bug del software",
            employeeDirectory: "Elenco dei dipendenti",
            employeeDirectoryDesc: "Contiene informazioni sui dipendenti",
            errorPullTable: "Errore nell'estrazione dei dati della tabella",
            newRecordSucs: "Nuovo record creato con successo",
            failedNewRecord: "Impossibile creare un nuovo record:",
            newRecordCreateError: "Si è verificato un errore durante la creazione di un nuovo record",
            recordCount: "Conteggio dei record",
            increaseLimit: "Limite di incremento",
            newRecord: "Nuovo record",
            imports: "Importazione",
            exports: "Esportazione",
            download: "Download",
            automateYourData: "Automatizza i tuoi dati",
            recordUpdatedSucs: "Record aggiornato con successo",
            failedToUpdateRecord: "Aggiornamento del record non riuscito",
            recordUpdatingError: "Errore nell'aggiornamento del record",
            mainTable: "Tabella principale",
            filter: "Filtro",
            hideFields: "Nascondi campi",
            saveAsView: "Salva come vista",
            search: "Ricerca",
            create: "Crea",
            sinistra: "Sinistra",
            centro: "Medio",
            destra: "Destra",
            selectTimezone: "Seleziona il fuso orario",
            createFieldSucs: "Campo creato con successo",
            failedCreateField: "Impossibile creare il campo:",
            createFieldError: "Si è verificato un errore durante la creazione del campo",
            addCondition: "Aggiungi condizione",
            applyFilter: "Applica filtro",
            fieldType: "Tipo di campo",
            alignment: "Allineamento",
            blankTable: "Tabella vuota",
            templates: "Modelli",
            timezone: "Fuso orario",
            timeFormat: "Formato dell'ora",
            includeTime: "Tempo incluso",
            decimalFormat: "Formato decimale",
            currencySymbol: "Simbolo di valuta",
            mode: "Modalità",
            statica: "Statica",
            dinamico: "Dinamico",
            multipleSelection: "Selezione multipla",
            addOption: "Aggiungi opzione",
            text: "Testo",
            longText: "Testo lungo",
            number: "Numero",
            currency: "Valuta",
            datetime: "Data e ora",
            dropdown: "Elenco a discesa",
            checkbox: "Casella di controllo",
            email: "Email",
            phone: "Telefono",
            file: "File",
            immagine: "Immagine",
            video: "Video",
            audio: "Audio",
            colore: "Colore",
            automationButton: "Pulsante di automazione",
            trashBin: "Cestino",
            pasteInfoDetected: "È stata rilevata una tabella copiata negli appunti! Incolla con Ctrl+V per creare una nuova tabella.",
            addCategory: "Aggiungi categoria",
            editCategory: "Modifica categoria",
            deleteCategory: "Elimina categoria",
            moveAllTables: "Sposta tutte le tabelle",
            dragTablesToCategory: "Trascina le tabelle qui per aggiungerle a questa categoria",
            deleteProtectionActive: "Protezione eliminazione attiva",
            copyTable: "Copia tabella",
            copyAsJSON: "Copia come JSON",
            changeCategory: "Cambia categoria",
            turnOffDeleteProtection: "Disattiva protezione eliminazione",
            turnOnDeleteProtection: "Attiva protezione eliminazione",
            privacySettings: "Impostazioni privacy",
            categoryName: "Nome categoria",
            categoryNamePlaceholder: "Inserisci il nome della categoria",
            categoryUpdate: "Aggiorna",
            categoryCreate: "Crea",
            categoryNameRequired: "Il nome della categoria non può essere vuoto",
            categoryAlreadyExists: "Esiste già una categoria con questo nome",
            categoryCreated: "Categoria creata. Puoi trascinare le tabelle in questa categoria.",
            categorySaveError: "Errore nel salvataggio della categoria",
            categoryUpdated: "Categoria aggiornata",
            categoryUpdateError: "Errore nell'aggiornamento della categoria",
            deleteCategoryConfirm: "Elimina categoria",
            deleteCategoryConfirmContent: "Sei sicuro di voler eliminare \"{name}\"? Le tabelle in questa categoria verranno spostate in \"Generale\".",
            categoryDeleted: "Categoria eliminata",
            categoryDeleteError: "Errore nell'eliminazione della categoria",
            tableMovedToCategory: "Tabella spostata nella categoria \"{name}\"",
            tableMoveError: "Errore nello spostamento della tabella",
            tableProtectedWarning: "Questa tabella è protetta dall'eliminazione. Rimuovi prima la protezione per eliminare.",
            deleteProtectionEnabled: "Protezione eliminazione attivata",
            deleteProtectionDisabled: "Protezione eliminazione disattivata",
            protectionUpdateError: "Errore nell'aggiornamento dello stato di protezione",
            tableCopied: "Tabella copiata",
            tableCopyError: "Errore nella copia della tabella",
            tableJsonCopied: "Tabella copiata negli appunti come JSON. Puoi incollare con Ctrl+V in un altro pannello cliente.",
            tableJsonCopiedFallback: "Tabella copiata negli appunti come JSON (metodo alternativo)",
            tableJsonCopyError: "Errore nella copia della tabella come JSON",
            clipboardNotSupported: "L'accesso agli appunti non è supportato in questo browser",
            noValidTableJson: "Nessun JSON di tabella valido trovato negli appunti",
            noValidSupsisExport: "Nessun export tabella Supsis valido trovato negli appunti",
            tableImported: "Tabella \"{name}\" importata con successo",
            tablePasteError: "Errore nell'incollaggio della tabella",
            noTablesToMove: "Nessuna tabella da spostare",
            tablesMovedToCategory: "{count} tabelle spostate nella categoria \"{name}\"",
            tablesMoveError: "Errore nello spostamento delle tabelle",
            noPermissionEditPrivacy: "Non hai il permesso di modificare le impostazioni di privacy di questa tabella",
            sandboxTitle: "Scenari tabelle eliminate",
            sandboxDesc: "Le tabelle eliminate vengono eliminate definitivamente automaticamente dopo 30 giorni nel cestino",
            sandboxEmpty: "Nessuna tabella eliminata nel cestino",
            unnamedTable: "Tabella senza nome",
            restore: "Ripristina",
            permanentlyDelete: "Elimina definitivamente",
            unknown: "Sconosciuto",
            user: "Utente",
            restoreTableConfirm: "Sei sicuro di voler ripristinare questa tabella?",
            restoreTableContent: "La tabella {name} verrà ripristinata.",
            tableRestored: "Tabella ripristinata",
            restoreFailed: "Ripristino fallito",
            permanentlyDeleteConfirm: "Sei sicuro di voler eliminare definitivamente questa tabella?",
            permanentlyDeleteContent: "La tabella {name} verrà eliminata definitivamente. Questa azione non può essere annullata.",
            yesPermanentlyDelete: "Sì, elimina definitivamente",
            tablePermanentlyDeleted: "Tabella eliminata definitivamente",
            permanentDeleteFailed: "Eliminazione definitiva fallita",
            deletedTablesLoadError: "Errore nel caricamento delle tabelle eliminate",
            otherTables: "Other Tables",
            noTablesFound: "No tables found",
            renameView: "Rinomina vista",
            enterNewViewName: "Inserisci il nome della nuova vista",
            viewRenamedSuccess: "Vista rinominata con successo.",
            viewRenameError: "Si è verificato un errore durante la rinomina della vista.",
            deleteView: "Elimina vista",
            confirmDeleteView: "Sei sicuro di voler eliminare questa vista?",
            viewDuplicatedSuccess: "Vista duplicata con successo.",
            viewDuplicateError: "Si è verificato un errore durante la duplicazione della vista.",
            duplicateView: "Duplica vista",
            confirmDuplicateView: "Sei sicuro di voler duplicare questa vista?",
            viewDeletedSuccess: "Vista eliminata con successo.",
            viewDeleteError: "Si è verificato un errore durante l'eliminazione della vista.",
            ascending: "Crescente",
            descending: "Decrescente",
            errorProcessingFile: "Si è verificato un errore durante l'elaborazione del file",
            left: "Sinistra",
            center: "Centro",
            right: "Destra",
            statics: "Statico",
            dynamic: "Dinamico",
            image: "Immagine",
            color: "Colore",
            upload: "Carica",
            permissions: {
                title: "Impostazioni privacy tabella",
                mode: "Modalità permessi",
                publicMode: "Pubblico",
                customMode: "Personalizzato",
                publicModeDesc: "In questa modalità, tutti gli utenti hanno accesso completo alla tabella.",
                customModeDesc: "In questa modalità, solo alcuni utenti e dipartimenti hanno accesso alla tabella.",
                confirmPublicMode: "Passa alla modalità pubblica",
                confirmPublicModeDesc: "Se passi alla modalità pubblica, tutte le autorizzazioni personalizzate saranno eliminate. Vuoi continuare?",
                addUser: "Aggiungi utente",
                addDepartment: "Aggiungi dipartimento",
                selectUser: "Seleziona utente",
                selectDepartment: "Seleziona dipartimento",
                add: "Aggiungi",
                matrixInfo: "Puoi gestire le autorizzazioni per utenti e dipartimenti dalla matrice sottostante. Le caselle selezionate indicano autorizzato.",
                targetHeader: "Utente / Dipartimento",
                noTargetsAdded: "Nessun utente o dipartimento aggiunto ancora",
                confirmRemoveTarget: "Rimuovi destinatario",
                confirmRemoveTargetDesc: "Sei sicuro di voler rimuovere questo utente/dipartimento dalle autorizzazioni?",
                saveSuccess: "Impostazioni permessi salvate con successo",
                saveError: "Errore nel salvataggio delle impostazioni di autorizzazione",
                unknownUser: "Utente sconosciuto",
                unknownDepartment: "Dipartimento sconosciuto",
                noPermission: "Non hai l'autorizzazione per eseguire questa azione",
                groups: {
                    basic: "Permessi base",
                    record: "Permessi record",
                    view: "Permessi vista",
                    page: "Permessi pagina",
                    field: "Permessi campo",
                    widget: "Permessi widget",
                    importExport: "Importa/Esporta"
                },
                scopes: {
                    tableRead: "Visualizza",
                    tableReadDesc: "Visualizza tabella",
                    tableMetaEdit: "Modifica tabella",
                    tableMetaEditDesc: "Modifica nome tabella, categoria e descrizione",
                    recordCreate: "Crea record",
                    recordCreateDesc: "Crea un nuovo record",
                    recordUpdate: "Aggiorna record",
                    recordUpdateDesc: "Aggiorna record esistenti",
                    recordDelete: "Elimina record",
                    recordDeleteDesc: "Elimina record",
                    viewCreate: "Crea vista",
                    viewCreateDesc: "Crea una nuova vista",
                    viewUpdate: "Aggiorna vista",
                    viewUpdateDesc: "Aggiorna viste esistenti",
                    viewDelete: "Elimina vista",
                    viewDeleteDesc: "Elimina viste",
                    pageRead: "Visualizza pagina",
                    pageReadDesc: "Visualizza pagine speciali",
                    pageCreate: "Crea pagina",
                    pageCreateDesc: "Crea una nuova pagina",
                    pageUpdate: "Aggiorna pagina",
                    pageUpdateDesc: "Aggiorna pagine esistenti",
                    pageDelete: "Elimina pagina",
                    pageDeleteDesc: "Elimina pagine",
                    fieldCreate: "Crea campo",
                    fieldCreateDesc: "Crea un nuovo campo",
                    fieldUpdate: "Aggiorna campo",
                    fieldUpdateDesc: "Aggiorna campi esistenti",
                    fieldDelete: "Elimina campo",
                    fieldDeleteDesc: "Elimina campi",
                    widgetCreate: "Crea widget",
                    widgetCreateDesc: "Crea un nuovo widget",
                    widgetUpdate: "Aggiorna widget",
                    widgetUpdateDesc: "Aggiorna widget esistenti",
                    widgetDelete: "Elimina widget",
                    widgetDeleteDesc: "Elimina widget",
                    bulkImport: "Importazione massiva",
                    bulkImportDesc: "Importazione massiva record",
                    export: "Esporta",
                    exportDesc: "Esporta record"
                }
            },
            calendarSettings: "Impostazioni calendario",
            colour: "Colore",
            createFailed: "Creazione modulo non riuscita",
            createSuccess: "Modulo creato con successo",
            dynamisch: "Dinamico",
            failCreateField: "Creazione campo fallita:",
            failToUpdateRecord: "Aggiornamento record fallito",
            izquierda: "Sinistra",
            priority_high: "Alta",
            priority_highest: "Molto alta",
            priority_low: "Bassa",
            priority_lowest: "Molto bassa",
            priority_medium: "Media",
            rechts: "Destra",
            semicolon: "Punto e virgola",
            separatorCharacter: "Carattere separatore"
        },
        plans: {
            manageWithChatbot: "Gestisci con Chatbot",
            manageInbox: "Gestisci inbox",
            commentManage: "Gestisci commenti",
            privateReplyMessage: "Risposta privata ai commenti",
            mentionTicket: "Converti menzioni in ticket",
            week: "Settimana",
            readyContents: "Contenuti pronti",
            webhookIntegration: "Integrazione webhook",
            businessChannel: "Canale Business di WhatsApp",
            confirmationFeature: "Funzione di conferma",
            specialReporting: "Reporting speciale",
            aiAssistant: "Assistente IA",
            flexibleBilling: "Fatturazione flessibile",
            automaticReservation: "Prenotazione automatica",
            taskManagement: "Gestione attività",
            calendarIntegration: "Integrazione del calendario",
            activeChatbot: "Chatbot attivo",
            smsIntegration: "Integrazione SMS",
            mailIntegration: "Integrazione email",
            startChatWithVisitor: "Avvia chat con visitatore",
            whatsappManaging: "Gestione di Whatsapp",
            automaticChatbotButton: "Pulsante/Chatbot automatico",
            personalizedBroadcasts: "Trasmissioni personalizzate",
            chatWithNonContacts: "Chat con non contatti",
            broadcastMessaging: "Messaggistica di trasmissione",
            perBroadcast: "Per Broadcast",
            extraPricePerMessage: "Costo aggiuntivo per messaggio",
            smartTrigger: "Trigger intelligente",
            telegramIntegration: "Integrazione di Telegram",
            instagramIntegration: "Integrazione di Instagram",
            ticketFeature: "Funzione del biglietto",
            storage: "Archiviazione",
            onePanelManagement: "Gestione in un unico pannello",
            isolatedDatabaseConnection: "Connessione isolata al database",
            removeLogo: "Rimuovi il logo Supsis",
            chatBaloonCustomization: "Personalizzazione del palloncino della chat",
            chatAndNotifications: "Chat e Notifiche",
            unlimited: "Illimitato",
            specialCustomerSupport: "Supporto clienti speciale",
            softwareSupport: "Supporto software",
            standardSupport: "Supporto standard",
            teamChatIntegration: "Integrazione chat di gruppo",
            fileAndVoiceShare: "Condivisione file e voce",
            instantVisitor: "Tracciamento visitatori istantaneo",
            detailedReporting: "Segnalazione dettagliata",
            normalreporting: "Segnalazione normale",
            noExtraCosts: "Nessun costo extra",
            accessibleToAllAgents: "Accessibile a tutti gli agenti",
            dataSecurity: "Sicurezza dei dati",
            autoTranslate: "Traduzione automatica",
            chatbotVersionHistory: "Cronologia delle versioni del chatbot",
            chatbotStory: "Storia del chatbot",
            freeAgent: "Agente gratuito",
            stableAgentCount: "Numero di agenti stabili",
            stableChannelCount: "Stable Channel Count",
            chipPlans: "Piani convenienti",
            generalPlan: "Piano generale",
            specialPlan: "Piano speciale",
            currentPlan: "Piano attuale",
            selected: "Selezionato",
            popular: "Popolare",
            trialPkg: "Pacchetto di prova",
            support: "Supporto 24/7",
            flexiblePricing: "Prezzi flessibili",
            rightToCancel: "Diritto di annullare in qualsiasi momento",
            unlimitedCBScenario: "Scenari di chatbot illimitati",
            freeFirstScenario: "Primo scenario gratuito",
            unlimitedLearn: "Formazione illimitata per chatbot",
            allPlatformIntegration: "Integrazione con tutte le piattaforme",
            detailedReports: "Rapporti dettagliati",
            aiSupport: "Supporto IA",
            creativeAI: "Assistente chat IA veloce e realistico",
            unlimitedSession: "Sessioni illimitate contemporaneamente",
            assistantFromWebsite: "Creazione di assistente dal sito web",
            assistantFromDoc: "Creazione di chatbot dal documento",
            mobileApp: "Applicazione mobile",
            commentManagement: "Gestisci commenti"
        },
        messenger: {
            channel: "Canale Messenger",
            manageChannel: "Gestisci canale",
            channelDetail: "Dettaglio canale",
            integrationTitle: "Integrazione Messenger",
            deleteDesc: "Sei sicuro di voler eliminare il canale Messenger?",
            channels: "Canali Messenger",
            connectMessenger: "Collegati a Messenger",
            detail: "dettaglio",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            commentsettings: "Gestione dei commenti",
            commentSettingsTitle: "Gestione dei commenti di Messenger",
            commentSettingsDesc: "Gestisci i tuoi commenti su Messenger",
            adoptimization: "Ad Optimization"
        },
        instagram: {
            channel: "Canale Instagram",
            detail: "dettaglio",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            commentsettings: "Gestione dei commenti",
            commentSettingsTitle: "Gestione dei commenti di Instagram",
            commentSettingsDesc: "Gestisci i tuoi commenti su Instagram",
            commentSettingsTicket: "Garantisce che i commenti in arrivo siano registrati nel sistema come ticket.",
            commentSettingsChatbot: "Seleziona a quale scenario di chatbot devono essere indirizzati i commenti in arrivo.",
            leads: "Leads",
            forms: "Forms",
            showAllInstagramChannels: "Mostra tutti i canali Instagram",
            brand: "Marca",
            questions: "Domande",
            showAllLinkedinChannels: "Show All Linkedin Channels",
            showAllTelegramChannels: "Show All Telegram Channels",
            adoptimization: "Ad Optimization"
        },
        calendar: {
            calendari: "Calendari",
            calendarsDesc: "Evita i conflitti di orario",
            generalAvailability: "Disponibilità generale",
            generalAvailabilityDesc: "Specificare gli orari in cui si è regolarmente disponibili per gli appuntamenti",
            appointDuration: "Durata dell'appuntamento",
            appointDurationDesc: "Quanto deve durare ogni appuntamento?",
            customDuration: "Durata personalizzata",
            descriptionDesc: "Aggiungere una nota che descriva il servizio. La nota aggiunta apparirà sulla pagina di prenotazione e nelle e-mail di conferma.",
            resForm: "Modulo di prenotazione",
            resFormDesc: "Personalizzate il modulo che gli utenti utilizzeranno per prenotare un appuntamento",
            addField: "Aggiungi campo",
            addAnItem: "Aggiungi un elemento",
            saveItem: "Salva elemento",
            planningTimeframe: "Pianificazione temporale",
            planningTimeframeDesc: "Limita l'arco di tempo in cui è possibile fissare un appuntamento",
            availableAtMoment: "Disponibile ora",
            startAndEndDate: "Date di inizio e fine",
            maxNumberAppoint: "Numero massimo di giorni dopo i quali è possibile fissare un appuntamento",
            howLongMinAppoint: "Quanto tempo prima l'appuntamento può essere prenotato",
            planningIntervalStartEnd: "Date di inizio e fine dell'intervallo di pianificazione",
            startTime: "Ora di inizio",
            done: "Fatto",
            receivedAppointInterval: "Intervallo di appuntamenti ricevuti",
            receivedAppointIntervalDesc: "Gestione degli appuntamenti ricevuti da visualizzare nel calendario",
            interimTime: "Tempo intermedio",
            interimTimeDesc: "Aggiunge tempo tra gli intervalli di riunione",
            dayMaxRes: "Numero massimo di prenotazioni al giorno",
            dayMaxResDesc: "Limita il numero di appuntamenti prenotati che possono essere accettati in un solo giorno",
            customise: "Imposta personalizzato",
            noAvatar: "Nessun Avatar",
            organizationName: "Nome dell'organizzazione",
            enterFullAdress: "Inserire l'indirizzo completo",
            noCoverPhoto: "Nessuna foto di copertina",
            enterAboutInfo: "Inserisci informazioni su",
            service: "Servizio",
            deleteService: "Elimina servizio",
            enterGoogleMapsUrl: "Inserire l'URL di Google Maps",
            enterLatitude: "Inserire la latitudine",
            enterLongitude: "Inserire la longitudine",
            enterNumber: "Inserire il numero di telefono",
            uploadAvatar: "Carica avatar",
            teamMemberDeleteError: "Errore nell'eliminazione del membro del team:",
            setupBookingWebsite: "Configurazione del sito web di prenotazione",
            bookingLandingPageBuilder: "Costruttore della pagina di prenotazione",
            coverPhoto: "Foto di copertina",
            enterOrganisationName: "Inserire il nome dell'organizzazione",
            about: "Informazioni su",
            services: "Servizi",
            deleteServices: "Elimina servizio",
            selectReservationPlan: "Seleziona piano di prenotazione",
            addNewService: "Aggiungi un nuovo servizio",
            addNewMember: "Aggiungi un nuovo membro",
            fullAddress: "Indirizzo completo",
            latitude: "Latitudine",
            longitude: "Longitudine",
            contactDetails: "Dettagli del contatto",
            emailAddress: "Indirizzo e-mail",
            enterEmail: "Inserire l'indirizzo e-mail",
            websiteURL: "URL del sito web",
            enterWebsiteURL: "Inserire l'URL del sito web",
            reservationPolicy: "Politica di prenotazione",
            enterResPolicy: "Inserire la politica di prenotazione",
            workingHours: "Orario di lavoro",
            selectEndHour: "Selezionare l'ora di fine",
            addNewHour: "Aggiungi una nuova ora",
            updateMemberInfo: "Aggiorna le informazioni sul membro",
            errorRecevingData: "Errore nel recupero dei dati:",
            anonymService: "Servizio anonimo",
            unknownPlan: "Piano sconosciuto",
            errorCreatingMockPage: "Errore nella creazione della pagina mock:",
            failedToCreateBookingPage: "Impossibile creare la pagina di prenotazione",
            fileSizeToolLarge: "Dimensione del file troppo grande",
            errorLoadingTheLogo: "Errore nel caricamento del logo:",
            failedToLoadLogo: "Errore nel caricamento del logo",
            errorUpdating: "Errore nell'aggiornamento:",
            failedToUpdate: "Aggiornamento fallito",
            newMember: "Nuovo membro",
            errorLoadingAvatar: "Errore nel caricamento dell'avatar:",
            avatarFailedToLoad: "Errore nel caricamento dell'avatar",
            teamMemberSuccessfullyDeleted: "Membro del team cancellato con successo",
            teamMemberNotDelete: "Non è stato possibile eliminare un membro del team",
            yesDelete: "Sì, eliminare",
            sureResDelete: "Sei sicuro di voler cancellare questa prenotazione?",
            resDetails: "Dettagli della prenotazione",
            infoPersonMakingRes: "Informazioni della persona che effettua la prenotazione",
            appointmentProgram: "Programma dell'appuntamento",
            goToAppointSettings: "Vai alle impostazioni del programma di appuntamenti",
            resPlanCreateSuccess: "Piano di prenotazione creato con successo",
            pleaseEnterTitle: "Inserire il titolo",
            sureContinueSaving: "Sei sicuro di voler continuare senza salvare?",
            appointProgram: "PROGRAMMA DI PRENOTAZIONE",
            everyMonth: "Ogni mese",
            firstEveryMonth: "Primo di ogni mese",
            dayOf: "Giorno",
            notRepeat: "Non si ripete",
            daily: "Tutti i giorni",
            weekly: "Una volta alla settimana",
            monthly: "Una volta al mese",
            annually: "Una volta all'anno",
            custom: "Speciale",
            eventSaved: "Evento salvato",
            createAppoint: "Termin erstellen",
            calendarSetting: "Kalendereinstellungen",
            notAuthezord: "Non autorizzato a eseguire questa azione",
            notAuthorizedToPerformOperation: "Non sei autorizzato a eseguire questa operazione.",
            reservationWebPage: "Pagina web di prenotazione",
            reservationBuilder: "Sito web di prenotazione",
            reservationPrograms: "Programmi di prenotazione",
            automations: "Automazioni",
            addReservationProgram: "Aggiungi programma di prenotazione",
            resPlanError: "Errore nella ricezione dei programmi di prenotazione:",
            resDeleteSure: "Sei sicuro di voler eliminare questo programma di prenotazione?",
            resDeleteSuccess: "Il programma di prenotazione è stato eliminato con successo",
            resDeleteError: "Errore nell'eliminazione del programma di prenotazione:",
            unkownUser: "Utente sconosciuto",
            eventNotFound: "Evento non trovato",
            reservations: "Prenotazioni",
            events: "Eventi",
            upcoming: "In arrivo",
            past: "Il passato",
            setting: "Impostazioni",
            delete: "Elimina",
            cancel: "Annulla",
            save: "Salva",
            close: "Chiudi",
            deleteRepeatEvent: "Elimina evento ricorrente",
            thisEvent: "Questo evento",
            thisAndOtherEvent: "Questo e altri eventi",
            allEvent: "Tutti gli eventi",
            ok: "OK",
            googleCalendarLink: "Aggiungi a Google Calendar",
            yahooCalendarLink: "Aggiungi a Yahoo Calendar",
            subject: "Oggetto",
            visitor: "Visitatore",
            allDay: "Tutto il giorno",
            title: "Titolo",
            deleteEvent: "Elimina evento",
            deleteEvents: "Elimina eventi",
            deleteEventsSure: "Sei sicuro di voler eliminare gli eventi da questo calendario?",
            deleteEventConfirm: "Sei sicuro di voler eliminare questo evento?",
            notEmptyTitle: "Il titolo non può essere vuoto!",
            tasks: "Attività",
            googleConnect: "Integrazione Google",
            googleDisconnect: "Disconnetti integrazione Google",
            sure: "Sei sicuro?",
            disconnectGoogleSure: "Sei sicuro di voler disconnettere Google?",
            yes: "Sì",
            no: "No",
            customRepeat: "Ripetizione personalizzata",
            recurrenceFrequency: "Frequenza di ripetizione",
            repeatDays: "Ripeti nei giorni:",
            never: "Mai",
            thisDate: "In questa data:",
            recurrenceCount: "Numero di ripetizioni:",
            end: "Fine",
            event: "Evento",
            calendars: "Calendari",
            newCalendar: "Crea nuovo calendario",
            changeColor: "Cambia colore",
            addCalendar: "Aggiungi calendario",
            nameCalendar: "Nome del calendario",
            description: "Descrizione",
            change: "Modifica",
            deleteCalendar: "Elimina calendario",
            deleteCalendarSure: "Sei sicuro di voler eliminare questo calendario?",
            notEmptyCalendarName: "Il nome del calendario non può essere vuoto",
            myEvents: "I miei eventi",
            everyoneEvents: "Tutti gli eventi",
            haveEvent: "eventi dell'agente",
            goCalendar: "Vai al calendario",
            goReservation: "Crea una prenotazione",
            agents: "Agenti",
            today: "Oggi",
            month: "Mese",
            week: "Settimana",
            day: "Giorno",
            list: "Lista",
            planingIntervalStartEnd: "Date di inizio e fine dell'intervallo di pianificazione",
            customize: "Set Custom",
            enterOrganizationName: "Inserisci il nome dell'organizzazione",
            weely: "Haftada bir",
            annualy: "Annualmente",
            appointmentDuration: "Durata appuntamento",
            appointmentSchedule: "Programma appuntamento",
            goToAppointmentSettings: "Zu den Einstellungen des Terminprogramms",
            infoPersonMakingReservation: "Informazioni sulla persona che effettua la prenotazione",
            reservationDetails: "Buchungsdetails",
            sureReservationDelete: "Sei sicuro di voler eliminare questa prenotazione?",
            teamMemberNotDeleted: "Impossibile eliminare il membro del team"
        },
        ticimax: {
            segment: "Segmento",
            settings_group: "Gruppo di impostazioni",
            waitDayFromLastSend: "Giorno di attesa dall'ultimo messaggio inviato",
            automationRuleName: "Nome della regola di automazione",
            time: "Ora",
            year: "Anno",
            month: "Mese",
            dayOfMonth: "Giorno del mese",
            day: "Giorno",
            bySecond: "Per secondo",
            byMinute: "Per minuto",
            byHour: "Per ora",
            byWeekNo: "Per numero di settimana",
            byYearDay: "Per giorno dell'anno",
            byMonthDay: "Per giorno del mese",
            byMonth: "Per mese",
            december: "Dicembre",
            november: "Novembre",
            october: "Ottobre",
            september: "Settembre",
            august: "Agosto",
            july: "Luglio",
            june: "Giugno",
            may: "Maggio",
            april: "Aprile",
            march: "Marzo",
            february: "Febbraio",
            january: "Gennaio",
            byWeekDay: "Per giorno della settimana",
            interval: "Intervallo",
            seconds: "Secondi",
            minutes: "Minuti",
            hourly: "Ogni ora",
            daily: "Giornaliero",
            weekly: "Settimanale",
            monthly: "Mensile",
            yearly: "Annuale",
            frequency: "Frequenza",
            attributes: {
                vip: "VIP",
                segment: "Segmento",
                province: "Provincia",
                country: "Paese",
                phone: "Telefono",
                email: "E-mail",
                fullname: "Nome completo",
                couponPercent: "% del coupon",
                lastOrderDate: "Ultimo ordine",
                firstOrderDate: "Primo ordine",
                county: "Contea",
                lastSource: "Ultima fonte",
                firstSource: "Prima fonte",
                lastPaymentType: "Ultimo metodo di pagamento",
                firstPaymentType: "Primo metodo di pagamento",
                maxOrderAmount: "Importo massimo dell'ordine",
                minOrderAmount: "Importo minimo dell'ordine",
                totalOrderAmount: "Importo totale dell'ordine",
                totalOrderCount: "Numero totale degli ordini",
                usedCouponAmount: "Importo del coupon utilizzato",
                usedCouponCount: "Numero di coupon utilizzati",
                tookDayFromLastOrder: "Giorni dall'ultimo ordine",
                isCouponUser: "È un utente del coupon?"
            },
            createAutomation: "Crea automazione",
            previous: "Precedente",
            createAutomationDesc: "Crea e gestisci l'automazione dei messaggi",
            newTicimaxChannel: "Nuovo canale Ticimax",
            connextToTicimaxXml: "Collegati al servizio XML di Ticimax",
            connectTicimax: "Collegati a Ticimax",
            examplePreview: "Anteprima dell'esempio",
            completeAutomationRule: "Regola di automazione completa",
            configureMessage: "Configura il messaggio",
            automationTimer: "Timer di automazione",
            findTargetMembers: "Trova i membri target",
            createAutomationRule: "Crea regola di automazione",
            action: "Azione",
            status: "Stato",
            triggeredUserCount: "Numero di utenti attivati",
            nextScheduled: "Successivo programmato",
            timerRule: "Regola del timer",
            automationRules: "Regole di automazione",
            apply: "Applica",
            searchAMember: "Cerca un membro",
            segmentedMembersDesc: "Elenca e automatizza i membri segmentati",
            manageVisibilityDesc: "Gestisci la visibilità del canale",
            xmlOrderListURL: "URL dell'elenco ordini XML",
            manageIntegrationDesc: "Gestisci la tua integrazione Ticimax",
            detail: "Dettaglio",
            ticimaxChannelsTitle: "Canali Ticimax",
            ticimaxDetail: "Dettaglio Ticimax",
            settingsGroup: "Impostazioni",
            visibility: "Visibilità",
            members: "Membri",
            automation: "Automazione",
            integrationChannel: "Canale di integrazione",
            channelUpdated: "Canale aggiornato correttamente",
            channelUpdateFailed: "Aggiornamento del canale non riuscito"
        },
        notification: {
            taskArchive: "Notifica inviata quando un compito viene archiviato.",
            taskComplet: "Notifica inviata quando una task viene completata.",
            adjustNow: "Regola impostazioni",
            chatAssignedMe: "Quando una chat mi viene assegnata.",
            ticketAssignedMe: "Quando un ticket mi viene assegnato.",
            myChatClosed: "Quando una chat che possiedo viene chiusa.",
            contactOwner: "Quando cambia il proprietario della chat, quando viene assegnata o rimossa la proprietà.",
            tagActionsToVisitor: "Quando un'etichetta viene aggiunta o rimossa da un visitatore.",
            ticketCreated: "Quando un visitatore o un chatbot crea un ticket.",
            notesActions: "Quando una nota viene aggiunta o rimossa da un cliente.",
            visitorProfileUpdated: "Quando il profilo di un visitatore viene aggiornato.",
            chatStartedByAnyPlatform: "Quando una chat viene avviata da qualsiasi canale.",
            userActions: "Quando un utente viene creato, aggiornato o eliminato.",
            departmentActions: "Quando un dipartimento viene creato, aggiornato o eliminato.",
            settingsActions: "Quando le impostazioni vengono create, aggiornate o eliminate.",
            integrationsActions: "Quando un canale di integrazione viene creato, aggiornato o eliminato.",
            loginFormActions: "Quando il modulo di accesso viene aggiornato o attivato.",
            bannedWordActions: "Quando una parola vietata viene creata, aggiornata o eliminata.",
            emailActions: "Quando un'email viene creata, aggiornata o eliminata.",
            preparedContentActions: "Quando un contenuto preparato viene creato, aggiornato o eliminato.",
            roleActions: "Quando un ruolo viene creato, aggiornato o eliminato.",
            tagActions: "Quando un'etichetta viene creata, aggiornata o eliminata.",
            welcomeMessageActions: "Quando un messaggio di benvenuto viene creato, aggiornato o eliminato.",
            webhookActions: "Quando un webhook viene creato, aggiornato o eliminato.",
            billingEvents: "Quando una fattura viene creata o il suo stato viene aggiornato.",
            systemStatus: "Quando lo stato del sistema di supporto dal vivo viene aggiornato.",
            reservationMessageCrud: "Quando una prenotazione viene creata, aggiornata o eliminata.",
            ipAddressWhiteListEvents: "Quando un indirizzo IP autorizzato viene aggiunto, aggiornato o eliminato.",
            taskAssignedMe: "Quando un compito mi viene assegnato.",
            workflowCreated: "Quando un flusso di lavoro viene creato.",
            workflowDeleted: "Quando un flusso di lavoro viene eliminato.",
            createdTask: "Quando un compito viene creato.",
            deletedTask: "Quando un compito viene eliminato.",
            chatbotStoryCrud: "Quando una storia del chatbot viene creata, aggiornata o eliminata.",
            chatbotForwardAgent: "Il chatbot inoltra una chat a un agente.",
            userSegmentCrud: "Quando un segmento utente viene creato, aggiornato o eliminato.",
            chatbotCreditLow: "Quando il credito del chatbot è basso.",
            wpCreditLow: "Quando il credito di WhatsApp scende sotto 100 TL.",
            wpCustomerGroupCrud: "Quando un gruppo clienti WhatsApp viene creato, aggiornato o eliminato.",
            wpBroadcastMessageStatus: "Quando l'invio di un messaggio di broadcast WhatsApp inizia, viene completato o annullato.",
            wpTemplateMesssageCrud: "Quando un messaggio modello WhatsApp viene creato, aggiornato o eliminato.",
            whatsappQrChannelStatusUpdated: "Quando lo stato di connessione del canale WhatsApp QR viene aggiornato.",
            activityTypeLabels: {
                "chat-assign": "Quando una chat mi viene assegnata",
                "ticket-assign": "Quando un ticket mi viene assegnato",
                "task-assign": "Quando un'attività mi viene assegnata",
                "task-complet": "Quando un'attività è completata",
                "chat-close-own": "Quando una chat di mia proprietà viene chiusa",
                "tag-actions-to-visitor": "Tag aggiunti o rimossi da un contatto",
                "create-ticket": "Ticket creato da un visitatore o chatbot. Inoltre, quando viene inviato un messaggio offline dalla finestra di chat",
                "note-actions-to-visitor": "Note aggiunte o rimosse da un contatto",
                "visitor-profile-updates": "Aggiornamenti del profilo visitatore",
                "chat-start": "Chat avviata su qualsiasi piattaforma da un contatto o agente",
                "user-crud": "Utente creato, aggiornato o eliminato",
                "department-crud": "Dipartimento creato, aggiornato o eliminato",
                "settings-crud": "Impostazioni create, aggiornate o eliminate",
                "integration-channel-crud": "Canale di integrazione creato, aggiornato o eliminato",
                "login-form-crud": "Modulo di accesso aggiornato, attivato o disattivato",
                "banned-word-crud": "Parola vietata creata, aggiornata o eliminata",
                "email-account-crud": "Account email creato o eliminato",
                "prepared-content-crud": "Contenuto preparato creato o eliminato",
                "role-crud": "Ruolo creato, aggiornato o eliminato",
                "tag-crud": "Tag creato, aggiornato o eliminato",
                "welcome-message-crud": "Messaggio di benvenuto creato, aggiornato o eliminato",
                "webhook-crud": "Webhook creato, aggiornato o eliminato",
                "automation-created": "Automazione creata",
                "automation-deleted": "Automazione eliminata",
                "automation-published": "Automazione pubblicata",
                "automation-unpublished": "Automazione non pubblicata",
                "automation-updated": "Automazione aggiornata",
                "billing-events": "Eventi di fatturazione",
                "task-workflow-crud": "Flusso di lavoro attività creato, aggiornato o eliminato",
                "task-crud": "Attività creata, aggiornata o eliminata",
                "system-status": "Modifiche dello stato del sistema online o offline",
                "chatbot-story-crud": "Storia chatbot creata, aggiornata o eliminata",
                "chatbot-forward-chat": "Chatbot inoltra una chat a un agente",
                "chatbot-user-segment-crud": "Segmento utente creato, aggiornato o eliminato",
                "chatbot-credit-low": "Quando il credito del chatbot è basso",
                "whatsapp-credit-low": "Quando il credito WhatsApp è basso",
                "whatsapp-customer-group-crud": "Quando un gruppo clienti WhatsApp viene creato, aggiornato o eliminato",
                "whatsapp-broadcast-message-crud": "Quando un messaggio broadcast WhatsApp viene inviato, completato o annullato",
                "whatsapp-template-message-crud": "Quando un messaggio modello WhatsApp viene creato, aggiornato o eliminato",
                "form-created": "Modulo creato",
                "form-updated": "Modulo aggiornato",
                "form-deleted": "Modulo eliminato",
                "form-restored": "Modulo ripristinato",
                "form-downloaded": "Modulo scaricato",
                "user-role-changed": "Ruolo utente modificato",
                "user-password-changed": "Password utente modificata",
                "user-email-changed": "Indirizzo email utente modificato",
                "user-name-changed": "Nome utente modificato",
                "user-phone-changed": "Telefono utente modificato",
                "user-disabled": "Utente disabilitato/abilitato",
                "role-updated": "Ruolo aggiornato",
                "task-workflow-updated": "Flusso di lavoro attività aggiornato",
                "task-workflow-pipeline-stage-added": "Fase pipeline flusso di lavoro attività aggiunta",
                "task-workflow-pipeline-stage-updated": "Fase pipeline flusso di lavoro attività aggiornata",
                "task-workflow-pipeline-stage-deleted": "Fase pipeline flusso di lavoro attività eliminata",
                "drive-folder-created": "Cartella Drive creata",
                "drive-folder-deleted": "Cartella Drive eliminata",
                "drive-folder-renamed": "Cartella Drive rinominata",
                "drive-file-added": "File aggiunto a Drive",
                "drive-file-deleted": "File eliminato da Drive",
                "task-module-rules-enabled": "Regole modulo attività abilitate",
                "task-module-rules-disabled": "Regole modulo attività disabilitate",
                "task-module-rules-rule-added": "Regola aggiunta al flusso di lavoro attività",
                "task-module-rules-rule-deleted": "Regola eliminata dal flusso di lavoro attività",
                "task-module-rules-rule-updated": "Regola aggiornata nel flusso di lavoro attività",
                "task-module-rules-rule-enabled": "Regola abilitata nel flusso di lavoro attività",
                "task-module-rules-rule-disabled": "Regola disabilitata nel flusso di lavoro attività",
                "contact-module-rules-enabled": "Regole modulo contatti abilitate",
                "contact-module-rules-disabled": "Regole modulo contatti disabilitate",
                "contact-module-rules-rule-added": "Regola aggiunta al modulo contatti",
                "contact-module-rules-rule-updated": "Regola aggiornata nel modulo contatti",
                "contact-module-rules-rule-deleted": "Regola eliminata dal modulo contatti",
                "contact-module-rules-rule-enabled": "Regola abilitata nel modulo contatti",
                "contact-module-rules-rule-disabled": "Regola disabilitata nel modulo contatti",
                "developer-token-changed": "Token sviluppatore aggiornato",
                "table-created": "Tabella creata",
                "table-field-added": "Campo aggiunto alla tabella",
                "table-field-updated": "Campo aggiornato nella tabella",
                "table-field-deleted": "Campo eliminato dalla tabella",
                "table-view-added": "Vista aggiunta alla tabella",
                "table-view-updated": "Vista aggiornata nella tabella",
                "table-view-deleted": "Vista eliminata dalla tabella",
                "table-page-added": "Pagina aggiunta alla tabella",
                "table-page-updated": "Pagina aggiornata nella tabella",
                "table-page-deleted": "Pagina eliminata dalla tabella",
                "table-widget-added": "Widget aggiunto alla pagina della tabella",
                "table-widget-updated": "Widget aggiornato nella pagina della tabella",
                "table-widget-deleted": "Widget eliminato dalla pagina della tabella",
                "table-privacy-changed": "Impostazioni privacy tabella aggiornate",
                "web-app-created": "Applicazione web creata",
                "web-app-updated": "Applicazione web aggiornata",
                "web-app-deleted": "Applicazione web eliminata",
                "web-tab-created": "Scheda web creata",
                "web-tab-updated": "Scheda web aggiornata",
                "web-tab-deleted": "Scheda web eliminata",
                "module-created": "Modulo creato",
                "module-updated": "Modulo aggiornato",
                "module-deleted": "Modulo eliminato",
                "relation-created": "Relazione creata",
                "relation-updated": "Relazione aggiornata",
                "voice-agent-created": "Agente vocale creato",
                "voice-agent-updated": "Agente vocale aggiornato",
                "voice-agent-deleted": "Agente vocale eliminato",
                "voice-agent-phone-number-inbound-agent-changed": "Agente chiamata in entrata numero di telefono modificato",
                "voice-agent-phone-number-outbound-agent-changed": "Agente chiamata in uscita numero di telefono modificato",
                "voice-agent-batch-call-created": "Chiamata batch creata",
                "voice-agent-knowledge-base-created": "Base di conoscenza creata",
                "voice-agent-knowledge-base-deleted": "Base di conoscenza eliminata",
                "table-data-downloaded": "Dati tabella scaricati",
                "table-data-imported": "Dati bulk importati nella tabella",
                "table-data-batch-updated": "Dati tabella aggiornati in batch",
                "table-data-batch-deleted": "Dati tabella eliminati in batch",
                "contact-batch-updated": "Contatti aggiornati in batch",
                "chat-data-downloaded": "Cronologia chat scaricata",
                "automation-restored": "Quando l'automazione viene ripristinata dal cestino",
                "waba-supsis-partner-remove": "Quando il partner Whatsapp Business API V2 viene rimosso",
                "waba-supsis-account-deleted": "Quando l'account Whatsapp Business API V2 viene eliminato",
                "waba-supsis-account-violation": "Quando viene rilevata una violazione dell'account Whatsapp Business API V2",
                "waba-supsis-ad-account-linked": "Quando l'account pubblicitario Whatsapp Business API V2 viene collegato",
                "waba-supsis-auth-intl-price-eligibility-update": "Quando viene aggiornata l'idoneità ai prezzi internazionali Whatsapp Business API V2",
                "waba-supsis-disabled-update": "Quando viene effettuato l'aggiornamento di disabilitazione Whatsapp Business API V2",
                "waba-supsis-mm-lite-terms-signed": "Quando vengono firmati i termini MM Lite Whatsapp Business API V2",
                "waba-supsis-partner-app-installed": "Quando l'app partner Whatsapp Business API V2 viene installata",
                "waba-supsis-partner-app-uninstalled": "Quando l'app partner Whatsapp Business API V2 viene disinstallata",
                "waba-supsis-partner-client-certification-status-update": "Quando viene aggiornato lo stato di certificazione cliente partner Whatsapp Business API V2",
                "waba-supsis-business-primary-location-country-update": "Quando viene aggiornato il paese della sede principale Whatsapp Business API V2",
                "waba-supsis-volume-based-pricing-tier-update": "Quando viene aggiornato il livello di pricing basato sul volume Whatsapp Business API V2",
                "waba-supsis-message-template-components-update": "Quando vengono aggiornati i componenti del modello messaggio Whatsapp Business API V2",
                "waba-supsis-message-template-status-update": "Quando viene aggiornato lo stato del modello messaggio Whatsapp Business API V2",
                waba_supsis_partner_remove: "Partner Whatsapp Business API V2 rimosso",
                waba_supsis_account_deleted: "Account Whatsapp Business API V2 eliminato",
                waba_supsis_account_violation: "Violazione account Whatsapp Business API V2 rilevata",
                waba_supsis_ad_account_linked: "Account pubblicitario Whatsapp Business API V2 collegato",
                waba_supsis_auth_intl_price_eligibility_update: "Aggiornamento idoneità prezzi internazionali Whatsapp Business API V2",
                waba_supsis_disabled_update: "Aggiornamento disabilitazione Whatsapp Business API V2",
                waba_supsis_mm_lite_terms_signed: "Termini MM Lite Whatsapp Business API V2 firmati",
                waba_supsis_partner_added: "Partner Whatsapp Business API V2 aggiunto",
                waba_supsis_partner_app_installed: "App partner Whatsapp Business API V2 installata",
                waba_supsis_partner_app_uninstalled: "App partner Whatsapp Business API V2 disinstallata",
                waba_supsis_partner_client_certification_status_update: "Stato certificazione cliente partner Whatsapp Business API V2 aggiornato",
                waba_supsis_business_primary_location_country_update: "Paese sede principale Whatsapp Business API V2 aggiornato",
                waba_supsis_volume_based_pricing_tier_update: "Livello pricing basato sul volume Whatsapp Business API V2 aggiornato",
                waba_supsis_message_template_components_update: "Componenti modello messaggio Whatsapp Business API V2 aggiornati",
                waba_supsis_message_template_status_update: "Stato modello messaggio Whatsapp Business API V2 aggiornato",
                waba_supsis_template_category_update: "Categoria modello Whatsapp Business API V2 aggiornata",
                waba_supsis_PARTNER_REMOVE: "Partner Whatsapp Business API V2 rimosso",
                waba_supsis_ACCOUNT_DELETED: "Account Whatsapp Business API V2 eliminato",
                "task-workflow-restored": "Quando il flusso di lavoro viene ripristinato dal cestino",
                "task-workflow-permanently-deleted": "Quando il flusso di lavoro viene eliminato definitivamente dal cestino",
                "table-deleted": "Quando la tabella viene eliminata",
                "table-restored": "Quando la tabella viene ripristinata dal cestino",
                "table-permanently-deleted": "Quando la tabella viene eliminata definitivamente dal cestino"
            },
            crmActions: "Azioni CRM",
            mobileApp: "App Mobile",
            webPanel: "Pannello Web",
            notifications: "Notifiche",
            whatsappActions: "Azioni Whatsapp",
            chatbotActions: "Azioni del chatbot",
            companyActions: "Azioni dell'azienda",
            basicActions: "Azioni di base",
            notificationSettingsDesc: "Scegli quali notifiche desideri ricevere e dove desideri riceverle.",
            noNotificationDesc2: "Qui vedrai tutte le notifiche relative alle offerte di lavoro, ai candidati e ai pool di talenti che stai seguendo. Puoi personalizzare le notifiche regolando le impostazioni.",
            noNotificationTitle2: "Ancora nessuna notifica.",
            noNotificationTitle1: "Nessuna notifica. Goditi il silenzio.",
            adjustSettings: "Regola impostazioni",
            showAll: "Mostra tutto",
            showOnlyUnread: "Mostra solo non letti",
            mailWasSent: "L'email è stata inviata.",
            mailAdressRemoved: "Indirizzo email rimosso.",
            chatbotPublished: "La versione <b>{version}</b> del chatbot è stata pubblicata da <b>{user}</b>.",
            chatbotDeleted: "Il chatbot <b>{chatbot}</b> è stato eliminato da <b>{user}</b>.",
            settingsUpdatedWoDetail: "Le impostazioni sono state aggiornate da <b>{user}</b>.",
            noActivityDesc: "Attualmente non ci sono attività nel sistema. Devono verificarsi alcuni eventi",
            noActivityTitle: "Ancora nessuna attività",
            actionType: "Tipo di azione",
            dateBetween: "Data compresa tra",
            selectActor: "Seleziona Utente",
            activities: "Attività",
            chatbotCreated: "Il chatbot di nome <b>{chatbot}</b> è stato creato da <b>{user}</b>.",
            taskAddedTags: "<b>{user}</b> ha aggiunto questi tag al compito (<b>{taskTitle}</b>): <b>{tags}</b>",
            taskStageChanged: "Lo stadio del compito <b>{task}</b> è stato cambiato da <b>{oldStage}</b> a <b>{newStage}</b> da <b>{user}</b>.",
            taskCreated: "Il compito <b>{task}</b> è stato creato da <b>{user}</b>.",
            contactPropRemoved: "La proprietà del visitatore <b>{prop}</b> è stata rimossa da <b>{user}</b>.",
            contactPropAdded: "La proprietà del visitatore <b>{prop}</b> è stata aggiunta da <b>{user}</b>.",
            userRemoved: "L'utente <b>{oldUser}</b> è stato rimosso da <b>{user}</b>.",
            loginFormUpdated: "Il modulo di accesso del visitatore è stato aggiornato da <b>{user}</b>.",
            loginFormDeactivated: "Il modulo di accesso dell'utente è stato disattivato da <b>{user}</b>.",
            loginFormActivated: "Il modulo di accesso dell'utente è stato attivato da <b>{user}</b>.",
            invoiceRefunded: "Il processo di rimborso è stato effettuato da <b>{user}</b>.",
            paymentMethodAdded: "Un nuovo metodo di pagamento è stato aggiunto da <b>{user}</b>.",
            invoicePaymentFailed: "Il pagamento della fattura non è stato accettato da <b>{user}</b>.",
            invoicePaymentReceived: "Il pagamento della fattura è stato accettato da <b>{user}</b>.",
            planStarted: "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> (<b>{altTitle}</b>).",
            planStartedAgent: "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{details} Rappresentante</b>).",
            planStartedChatbot: "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sessione</b>).",
            planStartedWhatsapp: "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canali Whatsapp</b>).",
            planStartedWhatsappApi: "<b>{user}</b> L'utente ha avviato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canali Business Whatsapp</b>).",
            PlanCanceled: "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> (<b>{altTitle}</b>).",
            planCanceledAgent: "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{details} Rappresentante</b>).",
            planCanceledChatbot: "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sessione</b>).",
            planCanceledWhatsapp: "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} Canali Whatsapp</b>).",
            planCanceledWhatsappApi: "<b>{user}</b> L'utente ha annullato l'abbonamento per <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} Canali Business Whatsapp</b>).",
            invoiceCreated: "La fattura è stata creata da <b>{user}</b>.",
            billingAddressUpdated: "Le informazioni sull'indirizzo sono state aggiornate da <b>{user}</b>.",
            taskWorkflowDeleted: "Il workflow <b>{workflow}</b> è stato eliminato da <b>{user}</b>.",
            whatsappBroadcastFailed: "Invio del messaggio broadcast dal titolo <b>{title}</b> fallito.",
            whatsappBroadcastCancelled: "L'invio del messaggio broadcast dal titolo <b>{title}</b> è stato annullato.",
            whatsappBroadcastCompleted: "Un messaggio broadcast dal titolo <b>{title}</b> è stato inviato con successo a <b>{numbers}</b> destinatari.",
            whatsappBroadcastCreated: "Un messaggio broadcast dal titolo <b>{title}</b> è stato inviato a <b>{numbers}</b> destinatari da <b>{user}</b>.",
            ticketAssigned: "Un ticket è stato assegnato a <b>{user2}</b> da <b>{user1}</b>.",
            userLoggedIn: "<b>{user}</b> ha effettuato l'accesso a SUPSIS.",
            chatJoined: "<b>{agent}</b> si è unito alla chat con <b>{visitor}</b>.",
            chatForwarded: "La chat con <b>{visitor}</b> è stata inoltrata a <b>{agent}</b> da <b>{user}</b>.",
            chatAssigned: "La chat con <b>{visitor}</b> è stata assegnata a <b>{agent}</b> dal sistema.",
            customerGroupUpdated: "Il gruppo <b>{group}</b> è stato aggiornato da <b>{user}</b>.",
            customerGroupRemoved: "Il gruppo <b>{group}</b> è stato rimosso da <b>{user}</b>.",
            chatOwnerUpdated: "<b>{agent}</b> ha riassegnato <b>{visitor}</b> da <b>{oldOwner}</b> a <b>{newOwner}</b>.",
            customerOwnershipRemoved: "<b>{actor}</b> ha rimosso la proprietà di <b>{visitor}</b> da <b>{oldOwner}</b>, lasciandolo senza proprietario.",
            customerOwnershipAssigned: "<b>{actor}</b> ha assegnato la proprietà di <b>{visitor}</b> da senza proprietario a <b>{newOwner}</b>.",
            customerOwnershipReassigned: "<b>{actor}</b> ha riassegnato la proprietà di <b>{visitor}</b> da <b>{oldOwner}</b> a <b>{newOwner}</b>.",
            customerGroupAdded: "Il gruppo <b>{group}</b> è stato creato da <b>{user}</b>.",
            contentRemoved: "Il contenuto pronto <b>{content}</b> è stato rimosso da <b>{user}</b>.",
            contentAdded: "Il contenuto pronto <b>{content}</b> è stato aggiunto da <b>{user}</b>.",
            channelVisibilityChanged: "La visibilità del canale di integrazione <b>{channel}</b> è stata cambiata da <b>{user}</b>.",
            taskDeleted: "Il compito <b>{task}</b> è stato eliminato da <b>{user}</b>.",
            taskCompleted: "<b>{task}</b> compito è stato completato da <b>{user}</b>.",
            taskArchived: "<b>{user}</b> ha archiviato il compito <b>{task}</b>.",
            userRemovedToDepartment: "L'utente <b>{user2}</b> è stato rimosso dal dipartimento <b>{department}</b> da <b>{user1}</b>.",
            userAddedToDepartment: "L'utente <b>{user2}</b> è stato aggiunto al dipartimento <b>{department}</b> da <b>{user1}</b>.",
            mailAddressAdded: "Indirizzo email <b>{email}</b> aggiunto da <b>{user}</b>",
            settingUpdate: "Aggiornato da <b>{user}</b>:",
            taskWFlowCreated: "Flusso di lavoro delle attività <b>{Wflow}</b> creato da <b>{user}</b>.",
            bannedWordRemoved: "La parola vietata <b>{bWord}</b> è stata rimossa da <b>{user}</b>.",
            bannedWordCreated: "La parola vietata <b>{bWord}</b> è stata creata da <b>{user}</b>.",
            taskPriorityUpdated: "<b>{user}</b> ha cambiato la priorità del compito <b>{taskTitle}</b> da <b>{oldPriority}</b> a <b>{newPriority}</b>",
            welcomeMessageRemoved: "Il messaggio di benvenuto <b>{welcome}</b> è stato rimosso da <b>{user}</b>.",
            welcomeMessageAdded: "Messaggio di benvenuto <b>{welcome}</b> creato da <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> rimosso da <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> aggiunto da <b>{user}</b>.",
            roleRemoved: "Ruolo <b>{role}</b> rimosso da <b>{user}</b>.",
            roleAdded: "Ruolo <b>{role}</b> aggiunto da <b>{user}</b>.",
            departmentRemoved: "Dipartimento <b>{department}</b> rimosso da <b>{user}</b>.",
            departmentAdded: "Dipartimento <b>{department}</b> aggiunto da <b>{user}</b>.",
            triggerUpdated: "Un trigger aggiornato da <b>{user}</b>.",
            triggerRemoved: "Un trigger rimosso da <b>{user}</b>.",
            triggerAdded: "Un nuovo trigger creato da <b>{user}</b>.",
            webhookRemoved: "Webhook di <b>{user1}</b> rimosso da <b>{user2}</b>",
            webhookAdded: "Webhook aggiunto da <b>{user1}</b>, aggiunto da <b>{user2}</b>.",
            chatClosed: "La chat con <b>{visitor}</b> è stata chiusa da <b>{agent}</b>.",
            chatOpenedByAgent: "<b>{agent}</b> ha avviato una chat <b>{platform}</b> con <b>{visitor}</b>.",
            chatOpenedByVisitor: "Una chat <b>{platform}</b> è stata avviata da <b>{visitor}</b>.",
            channelRemoved: "Il canale <b>{channel}</b> è stato rimosso da <b>{agent}</b>.",
            userAdded: "<b>{agent}</b> ha creato un rappresentante di nome <b>{newAgent}</b>.",
            visitorUnblocked: "Il visitatore <b>{visitor}</b> sbloccato dall'utente <b>{agent}</b>.",
            visitorBlocked: "Il visitatore <b>{visitor}</b> bloccato da <b>{agent}</b>.",
            userStatusChanged: "L'utente <b>{name}</b> ha cambiato stato da <b>{oldStatus}</b> a <b>{newStatus}</b>.",
            channelCreated: "Il canale <b>{channel}</b> è stato creato da <b>{name}</b>.",
            reservationCreatedPlan: "<b>{name}</b> utente ha pianificato l'appuntamento chiamato <b>{title}</b> per il <b>{date}</b>.",
            reservationUpdatedPlan: "<b>{name}</b> utente ha aggiornato l'appuntamento chiamato <b>{title}</b>.",
            reservationDeletedPlan: "<b>{name}</b> utente ha eliminato l'appuntamento chiamato <b>{title}</b>.",
            reservationCreated: "Una prenotazione è stata creata per l'utente <b>{name}</b> e il visitatore <b>{visitor}</b> in data <b>{date}</b>.",
            reservationDeleted: "L'appuntamento pianificato tra l'utente <b>{name}</b> e il visitatore <b>{visitor}</b> in data <b>{date}</b> è stato cancellato.",
            taskStatusChanged: "Quando cambia lo stato dell'attività",
            taskWorkflowCrud: "Il workflow del compito viene creato, aggiornato o eliminato",
            taskCrud: "Il compito viene creato, aggiornato o eliminato",
            autoRebalanceEvents: "Quando un ribilanciamento automatico viene completato, fallisce o disabilitato.",
            automationActions: "Azioni automazione",
            automationCreated: "{user} created an automation named {automation}.",
            automationDeleted: "{user} deleted an automation named {automation}.",
            automationRestored: "{user} ha ripristinato dal cestino l'automazione \"{automation}\".",
            automationPublished: "{user} published an automation named {automation}.",
            automationUnpublished: "{user} unpublished an automation named {automation}.",
            automationUpdated: "{user} updated an automation named {automation}.",
            automationCreatedNotification: "Quando un'automazione viene creata.",
            automationDeletedNotification: "Quando un'automazione viene eliminata.",
            automationRestoredNotification: "Quando un'automazione viene ripristinata dal cestino.",
            automationPublishedNotification: "Quando un'automazione viene pubblicata.",
            automationUnpublishedNotification: "Quando un'automazione viene annullata la pubblicazione.",
            automationUpdatedNotification: "Quando un'automazione viene aggiornata.",
            formDeleted: "{user} ha eliminato il modulo \"{formName}\" (ID: {formId}).",
            formDeletedPermanent: "{user} ha eliminato definitivamente il modulo \"{formName}\" (ID: {formId}).",
            formRestored: "{user} ha ripristinato dal cestino il modulo \"{formName}\" (ID: {formId}).",
            formCreated: "{user} ha creato il modulo \"{formName}\".",
            formUpdated: "{user} ha aggiornato il modulo \"{formName}\".",
            formDownloaded: "{user} ha scaricato i dati del modulo \"{formName}\" (ID: {formId}).",
            userRoleChanged: "{actor} ha modificato il ruolo di \"{userName}\" da \"{oldRoleName}\" a \"{newRoleName}\".",
            userPasswordChanged: "{actor} ha modificato la password di \"{userName}\".",
            userEmailChanged: "{actor} ha modificato l'email di \"{userName}\" da \"{oldEmail}\" a \"{newEmail}\".",
            userNameChanged: "{actor} ha modificato il nome di \"{userName}\" da \"{oldName}\" a \"{newName}\".",
            userPhoneChanged: "{actor} ha modificato il telefono di \"{userName}\" da \"{oldPhone}\" a \"{newPhone}\".",
            userDisabled: "{actor} ha disattivato l'utente \"{userName}\".",
            userEnabled: "{actor} ha attivato l'utente \"{userName}\".",
            roleUpdated: "{actor} ha aggiornato il ruolo \"{roleName}\".",
            taskWorkflowUpdated: "{actor} ha aggiornato il flusso di lavoro \"{workflowTitle}\".",
            taskWorkflowPipelineStageAdded: "{actor} ha aggiunto la fase \"{stageName}\" al flusso di lavoro \"{workflowTitle}\".",
            taskWorkflowPipelineStageUpdated: "{actor} ha aggiornato la fase \"{stageName}\" nel flusso di lavoro \"{workflowTitle}\".",
            taskWorkflowPipelineStageDeleted: "{actor} ha eliminato la fase \"{stageName}\" dal flusso di lavoro \"{workflowTitle}\".",
            driveFolderCreated: "{actor} ha creato la cartella \"{folderName}\".",
            driveFolderDeleted: "{actor} ha eliminato la cartella \"{folderName}\".",
            driveFolderRenamed: "{actor} ha rinominato la cartella \"{oldName}\" in \"{newName}\".",
            driveFileAdded: "{actor} ha aggiunto il file \"{fileName}\".",
            driveFileDeleted: "{actor} ha eliminato il file \"{fileName}\".",
            taskModuleRulesEnabled: "{actor} ha abilitato le regole del modulo attività per il flusso di lavoro \"{workflowTitle}\".",
            taskModuleRulesDisabled: "{actor} ha disabilitato le regole del modulo attività per il flusso di lavoro \"{workflowTitle}\".",
            taskModuleRulesRuleAdded: "{actor} ha aggiunto la regola \"{ruleName}\" al flusso di lavoro \"{workflowTitle}\".",
            taskModuleRulesRuleDeleted: "{actor} ha eliminato la regola \"{ruleName}\" dal flusso di lavoro \"{workflowTitle}\".",
            taskModuleRulesRuleUpdated: "{actor} ha aggiornato la regola \"{ruleName}\" nel flusso di lavoro \"{workflowTitle}\".",
            taskModuleRulesRuleEnabled: "{actor} ha abilitato la regola \"{ruleName}\" nel flusso di lavoro \"{workflowTitle}\".",
            taskModuleRulesRuleDisabled: "{actor} ha disabilitato la regola \"{ruleName}\" nel flusso di lavoro \"{workflowTitle}\".",
            contactModuleRulesEnabled: "{actor} ha abilitato le regole del modulo contatti.",
            contactModuleRulesDisabled: "{actor} ha disabilitato le regole del modulo contatti.",
            contactModuleRulesRuleAdded: "{actor} ha aggiunto la regola \"{ruleName}\" al modulo contatti.",
            contactModuleRulesRuleUpdated: "{actor} ha aggiornato la regola \"{ruleName}\" nel modulo contatti.",
            contactModuleRulesRuleDeleted: "{actor} ha eliminato la regola \"{ruleName}\" dal modulo contatti.",
            contactModuleRulesRuleEnabled: "{actor} ha abilitato la regola \"{ruleName}\" nel modulo contatti.",
            contactModuleRulesRuleDisabled: "{actor} ha disabilitato la regola \"{ruleName}\" nel modulo contatti.",
            developerTokenChanged: "{actor} ha aggiornato il token di accesso sviluppatore.",
            tableCreated: "{actor} ha creato la tabella \"{tableName}\".",
            tableDeleted: "{actor} ha eliminato la tabella \"{tableName}\".",
            tableRestored: "{actor} ha ripristinato dal cestino la tabella \"{tableName}\".",
            tablePermanentlyDeleted: "{actor} ha eliminato definitivamente dal cestino la tabella \"{tableName}\".",
            tableFieldAdded: "{actor} ha aggiunto il campo \"{fieldName}\" alla tabella \"{tableName}\".",
            tableFieldUpdated: "{actor} ha aggiornato il campo \"{fieldName}\" nella tabella \"{tableName}\".",
            tableFieldDeleted: "{actor} ha eliminato il campo \"{fieldName}\" dalla tabella \"{tableName}\".",
            tableViewAdded: "{actor} ha aggiunto la vista \"{viewName}\" alla tabella \"{tableName}\".",
            tableViewUpdated: "{actor} ha aggiornato la vista \"{viewName}\" nella tabella \"{tableName}\".",
            tableViewDeleted: "{actor} ha eliminato la vista \"{viewName}\" dalla tabella \"{tableName}\".",
            tablePageAdded: "{actor} ha aggiunto la pagina \"{pageName}\" alla tabella \"{tableName}\".",
            tablePageUpdated: "{actor} ha aggiornato la pagina \"{pageName}\" nella tabella \"{tableName}\".",
            tablePageDeleted: "{actor} ha eliminato la pagina \"{pageName}\" dalla tabella \"{tableName}\".",
            tableWidgetAdded: "{actor} ha aggiunto il widget \"{widgetTitle}\" ({widgetType}) alla pagina \"{pageName}\" della tabella \"{tableName}\".",
            tableWidgetUpdated: "{actor} ha aggiornato il widget \"{widgetTitle}\" ({widgetType}) nella pagina \"{pageName}\" della tabella \"{tableName}\".",
            tableWidgetDeleted: "{actor} ha eliminato il widget \"{widgetTitle}\" ({widgetType}) dalla pagina \"{pageName}\" della tabella \"{tableName}\".",
            tablePermissionChanged: "{actor} ha aggiornato le impostazioni di privacy della tabella \"{tableName}\".",
            tableDataDownloaded: "{actor} ha scaricato {recordCount} record dalla tabella \"{tableName}\".",
            tableDataImported: "{actor} ha importato {successCount}/{recordCount} record nella tabella \"{tableName}\".",
            tableDataBatchUpdated: "{actor} ha aggiornato in batch il campo \"{fieldName}\" di {recordCount} record nella tabella \"{tableName}\".",
            tableDataBatchDeleted: "{actor} ha eliminato in batch {recordCount} record dalla tabella \"{tableName}\".",
            contactDataDownloaded: "{actor} ha scaricato i dati di {contactCount} contatti.",
            contactBatchUpdated: "{actor} ha eseguito l'operazione batch {action} per {contactCount} contatti.",
            chatDataDownloaded: "{actor} ha scaricato la cronologia di {chatCount} chat.",
            chatDataDownloadedWithVisitor: "{actor} ha scaricato la cronologia chat con \"{visitorName}\".",
            visitorTagAdded: "{actor} ha aggiunto il tag {tagNames} a {visitorName}.",
            visitorTagRemoved: "{actor} ha rimosso il tag {tagNames} da {visitorName}.",
            unknownVisitor: "Contatto sconosciuto",
            tagsLabel: "Tag",
            webAppCreated: "{actor} ha creato l'applicazione web \"{appName}\" ({appSlug}).",
            webAppUpdated: "{actor} ha aggiornato l'applicazione web \"{appName}\" ({appSlug}).",
            webAppDeleted: "{actor} ha eliminato l'applicazione web \"{appName}\" ({appSlug}).",
            webTabCreated: "{actor} ha aggiunto la scheda web \"{tabName}\" in {placement}.",
            webTabUpdated: "{actor} ha aggiornato la scheda web \"{tabName}\".",
            webTabDeleted: "{actor} ha eliminato la scheda web \"{tabName}\" ({placement}).",
            moduleCreated: "{actor} ha creato \"{moduleName}\" {moduleType}.",
            moduleUpdated: "{actor} ha aggiornato \"{moduleName}\" {moduleType}.",
            moduleDeleted: "{actor} ha eliminato \"{moduleName}\" {moduleType}.",
            relationCreated: "{actor} ha creato la relazione \"{relationName}\".",
            relationUpdated: "{actor} ha aggiornato la relazione \"{relationName}\".",
            voiceAgentCreated: "{actor} ha creato l'agente vocale \"{agentName}\" ({agentId}).",
            voiceAgentUpdated: "{actor} ha aggiornato l'agente vocale \"{agentName}\" ({agentId}).",
            voiceAgentDeleted: "{actor} ha eliminato l'agente vocale \"{agentName}\" ({agentId}).",
            voiceAgentPhoneNumberInboundAgentChanged: "{actor} ha modificato l'agente per le chiamate in entrata del numero {phoneNumber} in \"{agentName}\".",
            voiceAgentPhoneNumberOutboundAgentChanged: "{actor} ha modificato l'agente per le chiamate in uscita del numero {phoneNumber} in \"{agentName}\".",
            voiceAgentBatchCallCreated: "{actor} ha creato la chiamata batch \"{batchCallName}\" ({taskCount} destinatari).",
            voiceAgentKnowledgeBaseCreated: "{actor} ha creato la knowledge base \"{knowledgeBaseName}\".",
            voiceAgentKnowledgeBaseDeleted: "{actor} ha eliminato la knowledge base \"{knowledgeBaseName}\".",
            webTabCreatedNotification: "Quando viene creata una scheda web.",
            webTabUpdatedNotification: "Quando viene aggiornata una scheda web.",
            webTabDeletedNotification: "Quando viene eliminata una scheda web.",
            moduleCreatedNotification: "Quando viene creato un modulo o una relazione.",
            moduleUpdatedNotification: "Quando viene aggiornato un modulo o una relazione.",
            moduleDeletedNotification: "Quando viene eliminato un modulo o una relazione.",
            relationCreatedNotification: "Quando viene creata una relazione.",
            relationUpdatedNotification: "Quando viene aggiornata una relazione.",
            voiceAgentCreatedNotification: "Quando viene creato un agente vocale.",
            voiceAgentUpdatedNotification: "Quando viene aggiornato un agente vocale.",
            voiceAgentDeletedNotification: "Quando viene eliminato un agente vocale.",
            voiceAgentPhoneNumberInboundAgentChangedNotification: "Quando viene modificato l'agente per le chiamate in entrata del numero.",
            voiceAgentPhoneNumberOutboundAgentChangedNotification: "Quando viene modificato l'agente per le chiamate in uscita del numero.",
            voiceAgentBatchCallCreatedNotification: "Quando viene creata una chiamata batch.",
            voiceAgentKnowledgeBaseCreatedNotification: "Quando viene creata una knowledge base.",
            voiceAgentKnowledgeBaseDeletedNotification: "Quando viene eliminata una knowledge base.",
            formDeletedNotification: "Quando un modulo viene eliminato.",
            formRestoredNotification: "Quando un modulo viene ripristinato dal cestino.",
            formCreatedNotification: "Quando un modulo viene creato.",
            formUpdatedNotification: "Quando un modulo viene aggiornato.",
            formDownloadedNotification: "Quando i dati del modulo vengono scaricati.",
            userRoleChangedNotification: "Quando il ruolo utente viene modificato.",
            userPasswordChangedNotification: "Quando la password utente viene modificata.",
            userEmailChangedNotification: "Quando l'indirizzo email utente viene modificato.",
            userNameChangedNotification: "Quando il nome utente viene modificato.",
            userPhoneChangedNotification: "Quando il numero di telefono utente viene modificato.",
            userDisabledNotification: "Quando l'utente viene disabilitato o abilitato.",
            roleUpdatedNotification: "Quando il ruolo viene aggiornato.",
            taskWorkflowUpdatedNotification: "Quando il flusso di lavoro viene aggiornato.",
            taskWorkflowPermanentlyDeletedNotification: "Quando il flusso di lavoro viene eliminato definitivamente dal cestino.",
            taskWorkflowPipelineStageAddedNotification: "Quando viene aggiunta una nuova fase al flusso di lavoro.",
            taskWorkflowPipelineStageUpdatedNotification: "Quando una fase del flusso di lavoro viene aggiornata.",
            taskWorkflowPipelineStageDeletedNotification: "Quando una fase viene eliminata dal flusso di lavoro.",
            driveFolderCreatedNotification: "Quando viene creata una cartella Drive.",
            driveFolderDeletedNotification: "Quando viene eliminata una cartella Drive.",
            driveFolderRenamedNotification: "Quando una cartella Drive viene rinominata.",
            driveFileAddedNotification: "Quando un file viene aggiunto a Drive.",
            driveFileDeletedNotification: "Quando un file viene eliminato da Drive.",
            taskModuleRulesEnabledNotification: "Quando le regole del modulo attività vengono abilitate.",
            taskModuleRulesDisabledNotification: "Quando le regole del modulo attività vengono disabilitate.",
            taskModuleRulesRuleAddedNotification: "Quando viene aggiunta una nuova regola al flusso di lavoro.",
            taskModuleRulesRuleDeletedNotification: "Quando una regola viene eliminata dal flusso di lavoro.",
            taskModuleRulesRuleUpdatedNotification: "Quando una regola del flusso di lavoro viene aggiornata.",
            taskModuleRulesRuleEnabledNotification: "Quando una regola del flusso di lavoro viene abilitata.",
            taskModuleRulesRuleDisabledNotification: "Quando una regola del flusso di lavoro viene disabilitata.",
            contactModuleRulesEnabledNotification: "Quando le regole del modulo contatti vengono abilitate.",
            contactModuleRulesDisabledNotification: "Quando le regole del modulo contatti vengono disabilitate.",
            contactModuleRulesRuleAddedNotification: "Quando viene aggiunta una nuova regola al modulo contatti.",
            contactModuleRulesRuleUpdatedNotification: "Quando una regola del modulo contatti viene aggiornata.",
            contactModuleRulesRuleDeletedNotification: "Quando una regola viene eliminata dal modulo contatti.",
            contactModuleRulesRuleEnabledNotification: "Quando una regola del modulo contatti viene abilitata.",
            contactModuleRulesRuleDisabledNotification: "Quando una regola del modulo contatti viene disabilitata.",
            developerTokenChangedNotification: "Quando il token di accesso sviluppatore viene aggiornato.",
            tableCreatedNotification: "Quando viene creata una nuova tabella.",
            tableDeletedNotification: "Quando una tabella viene eliminata.",
            tableRestoredNotification: "Quando una tabella viene ripristinata dal cestino.",
            tablePermanentlyDeletedNotification: "Quando una tabella viene eliminata definitivamente dal cestino.",
            tableFieldAddedNotification: "Quando un nuovo campo viene aggiunto alla tabella.",
            tableFieldUpdatedNotification: "Quando un campo della tabella viene aggiornato.",
            tableFieldDeletedNotification: "Quando un campo viene eliminato dalla tabella.",
            tableViewActionsNotification: "Quando una vista della tabella viene aggiunta, aggiornata o eliminata.",
            tablePageActionsNotification: "Quando una pagina della tabella viene aggiunta, aggiornata o eliminata.",
            tableWidgetActionsNotification: "Quando un widget viene aggiunto, aggiornato o eliminato dalla pagina della tabella.",
            tablePermissionChangedNotification: "Quando le impostazioni di privacy della tabella vengono aggiornate.",
            tableDataDownloadedNotification: "Quando i dati della tabella vengono scaricati.",
            tableDataImportedNotification: "Quando i record vengono importati in blocco nella tabella.",
            tableDataBatchUpdatedNotification: "Quando viene eseguito un aggiornamento batch sulla tabella.",
            tableDataBatchDeletedNotification: "Quando i record vengono eliminati in blocco dalla tabella.",
            contactBatchUpdatedNotification: "Quando i contatti vengono aggiornati in blocco.",
            chatDataDownloadedNotification: "Quando la cronologia chat viene scaricata.",
            webAppCreatedNotification: "Quando viene creata un'applicazione web.",
            webAppUpdatedNotification: "Quando un'applicazione web viene aggiornata.",
            webAppDeletedNotification: "Quando un'applicazione web viene eliminata.",
            formActions: "Quando un modulo viene creato, aggiornato o eliminato.",
            userInfoActions: "Quando cambiano informazioni utente come ruolo, password, email, nome, telefono o stato.",
            driveActions: "Operazioni su cartelle e file Drive.",
            developerActions: "Quando il token di accesso sviluppatore viene aggiornato.",
            contactModuleRulesActions: "Quando le regole del modulo contatti vengono abilitate/disabilitate, o una regola viene aggiunta, aggiornata o eliminata.",
            tableActions: "Quando una tabella viene creata, o un campo viene aggiunto, aggiornato o eliminato.",
            wabaSupsisPartnerRemove: "Quando il partner Whatsapp Business API V2 viene rimosso.",
            wabaSupsisAccountDeleted: "Quando l'account Whatsapp Business API V2 viene eliminato.",
            wabaSupsisAccountViolation: "Quando viene rilevata una violazione dell'account Whatsapp Business API V2.",
            wabaSupsisAdAccountLinked: "Quando l'account pubblicitario viene collegato a Whatsapp Business API V2.",
            wabaSupsisAuthIntlPriceEligibilityUpdate: "Quando viene aggiornata l'idoneità al prezzo internazionale Whatsapp Business API V2.",
            wabaSupsisDisabledUpdate: "Quando viene effettuato l'aggiornamento di disabilitazione Whatsapp Business API V2.",
            wabaSupsisMmLiteTermsSigned: "Quando vengono firmati i termini MM Lite Whatsapp Business API V2.",
            wabaSupsisPartnerAdded: "Quando il partner Whatsapp Business API V2 viene aggiunto.",
            wabaSupsisPartnerAppInstalled: "Quando l'app partner Whatsapp Business API V2 viene installata.",
            wabaSupsisPartnerAppUninstalled: "Quando l'app partner Whatsapp Business API V2 viene disinstallata.",
            wabaSupsisPartnerClientCertificationStatusUpdate: "Quando lo stato di certificazione cliente partner Whatsapp Business API V2 viene aggiornato.",
            wabaSupsisBusinessPrimaryLocationCountryUpdate: "Quando il paese della sede principale Whatsapp Business API V2 viene aggiornato.",
            wabaSupsisVolumeBasedPricingTierUpdate: "Quando il livello di prezzo a volume Whatsapp Business API V2 viene aggiornato.",
            wabaSupsisMessageTemplateComponentsUpdate: "Quando i componenti del modello messaggio Whatsapp Business API V2 vengono aggiornati.",
            wabaSupsisMessageTemplateStatusUpdate: "Quando lo stato del modello messaggio Whatsapp Business API V2 viene aggiornato.",
            wabaSupsisTemplateCategoryUpdate: "Quando la categoria del modello Whatsapp Business API V2 viene aggiornata.",
            chatbotRestored: "Il chatbot <b>{chatbot}</b> è stato ripristinato dal cestino da <b>{user}</b>.",
            taskWorkflowRestored: "Il flusso di lavoro <b>{workflow}</b> è stato ripristinato dal cestino da <b>{user}</b>.",
            taskWorkflowPermanentlyDeleted: "Il flusso di lavoro <b>{workflow}</b> è stato eliminato definitivamente dal cestino da <b>{user}</b>.",
            userLoggenIn: "<b>{user}</b> ha effettuato l'accesso a SUPSIS.",
            channelForwardConfigUpdated: "{actor} ha aggiornato la configurazione di inoltro del canale \"{channelName}\" {channelType}.",
            channelZohoConfigUpdated: "{actor} ha aggiornato la configurazione di integrazione Zoho del canale \"{channelName}\" {channelType}.",
            webhookUpdated: "{actor} ha aggiornato il webhook \"{webhookName}\" ({webhookUrl})."
        },
        search: {
            prefix: {
                jump: "Git",
                new: "Nuovo",
                visitor: "Persona",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automazione",
                table: "Tavolo",
                module: "Modulo",
                message: "Messaggio"
            },
            calendar: "Calendario",
            soundSettings: "Notifiche audio",
            allNotificationSettings: "Impostazioni di notifica",
            allAuditLogs: "Registri di controllo",
            allNotifications: "Tutte le notifiche",
            allActivities: "Tutte le attività",
            workFlow: "Flusso di lavoro",
            editTask: "Modifica attività",
            tasks: "Compiti",
            todo: "Cose da fare",
            tapTo: "Premere ⇥ per le operazioni '{prefix}'",
            newUsers: "Nuovo ⇥ Utente",
            newTags: "Nuovo ⇥ Etichetta",
            newRole: "Nuovo ⇥ Ruolo",
            newTrigger: "Nuovo ⇥ Trigger",
            newDepartment: "Nuovo ⇥ Dipartimento",
            newTicket: "Nuovo ⇥ Biglietto",
            jumpSettings: "Vai ⇥ Impostazioni",
            jumpIntegrations: "Vai ⇥ Integrazioni",
            jumpTeam: "Vai ⇥ Team",
            jumpUsers: "Vai ⇥ Utenti",
            jumpReport: "Vai ⇥ Report",
            timingSettings: "Impostazioni di temporizzazione",
            exampleVisitorMail: "Visitatore@mail.com",
            languageAndRegion: "Lingua e regione",
            theme: "Tema",
            appearance: "Aspetto",
            color: "Colore",
            background: "Sfondo",
            smart: "Intelligente",
            teamChat: "Chat di squadra",
            chatbot: "ChatBot",
            chatbotTraining: "Formazione Chatbot",
            chatbotUserSegments: "Segmenti utente del chatbot",
            chatbotIntegration: "Integrazione chatbot",
            chatbotEntities: "Entità chatbot",
            chatbotIntegrationWebHook: "Integrazione WebHook chatbot",
            chatbotArchive: "Archivio chatbot",
            chatbotTemplatesAI: "Modelli di intelligenza artificiale per chatbot",
            chatbotTemplates: "Modelli di chatbot",
            chatbotReportsOverall: "Rapporti complessivi del chatbot",
            chatbotReportsAllChats: "Rapporti chatbot di tutte le chat",
            chatbotReportsRatingDistribution: "Distribuzione delle valutazioni dei rapporti chatbot",
            chatbotReportsPaidChats: "Rapporti chatbot delle chat a pagamento",
            chatbotReportsBusiestPeriod: "Periodo di maggiore affluenza del chatbot",
            chatbotTemplatesAllMessages: "Modelli di chatbot per tutti i messaggi",
            chatbotTemplatesAverage: "Media dei modelli di chatbot",
            chatbotTemplatesPopularity: "Popolarità dei modelli di chatbot",
            chatbotTemplatesAllUser: "Modelli di chatbot di tutti gli utenti",
            ticket: "Richieste di assistenza",
            archivi: "Archivio",
            tag: "Tag",
            offlineSupportRequests: "Richieste di assistenza offline",
            ruoli: "Ruoli",
            utenti: "Utenti",
            soggetti: "Dipartimenti",
            contenuti: "Contenuti istantanei",
            welcomeMessages: "Messaggi di benvenuto",
            catalog: "Catalogo",
            bannedWords: "Parole vietate",
            bannedVisitors: "Visitatori vietati",
            applicazione: "Applicazione",
            mail: "Mailer",
            visitatori: "Visitatori",
            integrazioniWebhook: "Integrazione Webhook",
            billing: "Fattura",
            reportNew: "Nuovo report",
            integrazioni: "Integrazioni",
            chatbotStory: "Storie di chatbot",
            searchPlaceHolder: "Cerca, vai o aggiungi...",
            searchAreaTitle: "Ricerca Supsis",
            searchAreaDesc1: "È possibile cercare qualsiasi cosa. Solo",
            searchAreaDesc2: "o",
            searchAreaDesc3: "Digita o cerca qualsiasi cosa.",
            navigateBtn: "Naviga",
            selectBtn: "Seleziona",
            cancelBtn: "Annulla",
            integration: {
                shouldByInstaPack: "Dovreste acquistare un pacchetto Instagram per creare un canale Instagram. È possibile raggiungere immediatamente i pacchetti a prezzi accessibili.",
                createInstaLimitMax: "Hai raggiunto il limite di creazione di un canale Instagram. Massimo.",
                createInstaContinue: "È possibile creare un canale Instagram. Per continuare, aggiorna il tuo pacchetto o elimina alcuni dei tuoi canali Instagram.",
                privatePolicy: "Politica privata.",
                termsAndCondition: "Termini e condizioni.",
                readAndAgree: "Ho letto e accetto.",
                shouldByMessengerPack: "È necessario acquistare un pacchetto Messenger per creare un canale Messenger. È possibile raggiungere immediatamente i pacchetti a prezzi convenienti.",
                createMessengerLimitMax: "Hai raggiunto il limite di creazione di un canale Messenger. Massimo.",
                createMessengerContinue: "È possibile creare un canale Messenger. Per continuare, aggiornare il pacchetto o eliminare alcuni dei canali Messenger.",
                selectMessengerAccount: "Selezionare l'account Messenger.",
                forwardLiveAgents: "👉 Forward Live Agents",
                allDepartments: "Tutti i reparti",
                deleteAll: "Cancella tutti",
                wpBusinessAPI: "Integrazioni - Canali API Whatsapp Business",
                wpV1: "Integrazioni - Canali Whatsapp multipli",
                instagram: "Integrazioni - Instagram",
                instagramContactList: "Integrazioni - Elenco contatti Instagram",
                mail: "Integrazioni - Mail",
                whatsapp: "Integrazioni - Whatsapp",
                whatsappContactList: "Integrazioni - Elenco contatti Whatsapp",
                wpBCRichieste: "Integrazioni - Richieste di messaggi in massa Whatsapp",
                wpBCCustomerGroups: "Integrazioni - Gruppi di clienti Whatsapp",
                wpBCTemplates: "Integrazioni - Modelli di messaggi Whatsapp Bulk",
                chatbot: "Integrazioni - ChatBot",
                wpBCRequests: "Integrations - Whatsapp Broadcast Requests",
                allSections: "Tutte le sezioni",
                createInstaInstaLimitMax: "Hai raggiunto il limite massimo per la creazione di un canale Instagram.",
                createMessengerMessengerLimitMax: "Hai raggiunto il limite massimo per la creazione di un canale Messenger.",
                directClientsForward: "👉 Inoltra agli agenti diretti",
                shouldByByMessengerPack: "È necessario acquistare un pacchetto Messenger per creare un canale Messenger. Puoi accedere subito ai pacchetti a prezzi convenienti.",
                messenger: "Integrazioni - Messenger",
                telegram: "Integrazioni - Telegram",
                whatsappV3: "Integrazioni - WhatsApp V3",
                waba: "Integrazioni - WhatsApp Business API V2",
                metaLeads: "Integrazioni - Meta Leads",
                linkedin: "Integrazioni - LinkedIn",
                youtubeComments: "Integrazioni - Commenti YouTube",
                googleBusinessReviews: "Integrazioni - Recensioni Google Business",
                googlePlayReviews: "Integrazioni - Recensioni Google Play",
                appstoreReviews: "Integrazioni - Recensioni App Store",
                googleDrive: "Integrazioni - Google Drive",
                openai: "Integrazioni - OpenAI",
                openrouter: "Integrazioni - OpenRouter AI",
                ideasoft: "Integrazioni - Ideasoft",
                bitrix24: "Integrazioni - Bitrix24",
                zoho: "Integrazioni - Zoho CRM",
                ticimax: "Integrazioni - Ticimax",
                ticimaxV2: "Integrazioni - Ticimax V2",
                teamgram: "Integrazioni - TeamGram",
                holidayplus: "Integrazioni - HolidayPlus",
                trendyol: "Integrazioni - Trendyol",
                tSoft: "Integrazioni - T-Soft",
                ikas: "Integrazioni - Ikas",
                postacell: "Integrazioni - PostaCell SMS",
                telnyx: "Integrazioni - Telnyx",
                netgsm: "Integrazioni - NetGSM",
                webtabs: "Integrazioni - Web Tabs",
                webapps: "Integrazioni - Web Apps",
                instagramV2: "Integrazioni - Instagram V2",
                voiceAgent: "Integrazioni - Agente Vocale IA",
            },
            settings: {
                settings: "Impostazioni",
                features: "Impostazioni - Caratteristiche",
                languageAndRegion: "Impostazioni - Lingua e regione",
                bubbleSettings: "Impostazioni - Impostazioni della bolla",
                bubbleActions: "Impostazioni - Azioni bolla",
                themeSettings: "Impostazioni - Impostazioni del tema",
                visitorLoginForm: "Impostazioni - Modulo di accesso per i visitatori",
                visitorAttribute: "Impostazioni - Attributi del visitatore",
                autoAssign: "Impostazioni - Assegnazione automatica",
                talkSettings: "Impostazioni - Impostazioni della conversazione",
                chatTimingSettings: "Impostazioni - Impostazioni orario chat",
                availability: "Impostazioni - Disponibilità",
                websiteIntegration: "Impostazioni - Integrazione del sito web",
                developer: "Impostazioni - Sviluppatore",
                wallet: "Impostazioni - Portafoglio",
                accessControl: "Impostazioni - Controllo accessi",
                sessions: "Impostazioni - Gestione sessioni",
                contactModuleRules: "Impostazioni - Regole modulo contatti",
                taskModuleRules: "Impostazioni - Regole modulo attività",
                notifications: "Impostazioni - Notifiche",
                billing: "Impostazioni - Fatturazione",
                company: "Impostazioni - Informazioni azienda",
                companyUsers: "Impostazioni - Utenti",
                departments: "Impostazioni - Dipartimenti",
                roles: "Impostazioni - Ruoli",
                systemMessages: "Impostazioni - Messaggi di sistema",
                templates: "Impostazioni - Contenuti pronti",
                forbiddenInputs: "Impostazioni - Parole vietate",
                timingsSettings: "Impostazioni - Impostazioni tempi",
                autoAssignSettings: "Impostazioni - Assegnazione automatica",
                availabilitySettings: "Impostazioni - Disponibilità",
            },
            chatbotTemplatesAvarage: "Chatbot Templates Avarage",
            archives: "Archives",
            tags: "Tags",
            roles: "Roles",
            users: "Users",
            subjects: "Subjects",
            contents: "Contents",
            application: "Application",
            mails: "Mails",
            visitors: "Visitors",
            integrationsWebhook: "Integrations Webhook",
            integrations: "Integrations",
            audioSettings: "Impostazioni audio",
            chatbotArchiv: "Chatbot-Archiv",
            content: "Contenuto istantaneo",
            departments: "Abteilungen",
            emails: "Email",
            fondo: "Fondo",
            forbiddenWords: "Parole vietate",
            integraciones: "Integraciones",
            integrationOperations: "Operazioni di integrazione",
            intelligent: "Intelligent",
            invoices: "Fatture",
            kalender: "Kalender",
            mailMessages: "Messaggi email",
            navigation: "Navigazione",
            newReport: "Nuovo report",
            newSection: "Nuova sezione",
            topics: "Argomenti",
            webhookIntegration: "Integrazione webhook",
            workflow: "Flusso di lavoro",
            profile: "Profilo",
            chatbotBlockMarket: "Chatbot Mercato blocchi",
            chatbotSandbox: "Chatbot Sandbox",
            allAutomations: "Tutte le automazioni",
            scheduledAutomations: "Automazioni programmate",
            eventBasedAutomations: "Automazioni basate su eventi",
            buttonAutomations: "Automazioni pulsante",
            webhookAutomations: "Automazioni webhook",
            automationInsights: "Statistiche automazione",
            automationSandbox: "Sandbox automazione",
            mailInbox: "Posta in arrivo",
            mailTemplates: "Modelli di posta",
            mailBroadcast: "Invio massivo",
            mailCustomerGroups: "Gruppi clienti",
            reservation: "Prenotazione",
            reservationLandingPage: "Pagina di prenotazione",
            reservationPrograms: "Programmi di prenotazione",
            reservationAutomations: "Automazioni prenotazione",
            calendarEvents: "Eventi del calendario",
            calendarReservations: "Prenotazioni del calendario",
        },
        mail: {
            errorStatus: "Stato errore",
            mailSendErrorTitle: "Email non consegnate",
            mailSendErrorDescription: "Totale email non consegnate",
            fixGrammarTitle: "Correzione grammaticale",
            expandTextTitle: "Espansione del testo",
            summaryTitle: "Riepilogo",
            changeToneTitle: "Modifica del tono",
            translationTitle: "Traduzione",
            replyTitle: "Risposta",
            customRequestTitle: "Risposta alla richiesta personalizzata",
            viewMode: "Modalità di visualizzazione",
            singleView: "Vista singola",
            splitView: "Vista divisa",
            folders: "Cartelle",
            sendError: "Si è verificato un errore durante l'invio dell'email. Si prega di riprovare più tardi.",
            visitorCreationError: "Errore nella creazione del visitatore. Si prega di riprovare più tardi.",
            onlyImageAllowed: "Sono consentiti solo file immagine.",
            imageFileTooLarge: "Il file immagine è troppo grande. La dimensione massima è di 10MB.",
            imageUploaded: "Immagine caricata con successo.",
            imageUploadError: "Si è verificato un errore durante il caricamento dell'immagine.",
            mailAiAssistant: {
                aiCreateSummarized: "Crea Riassunto AI",
                aiSentimentAnalysis: "Analisi del Sentimento AI",
                contentRequired: "Il contenuto dell'email è necessario per utilizzare questa funzionalità",
                grammarFixed: "La grammatica è stata corretta",
                aiError: "L'assistente AI ha riscontrato un errore",
                contentExpanded: "Il contenuto dell'email è stato ampliato",
                emailSummarized: "L'email è stata riassunta",
                toneChanged: "Tono cambiato in {tone}",
                emailTranslated: "Email tradotta in {language}",
                replyGenerated: "Risposta automatica generata",
                contentUpdated: "Il contenuto è stato aggiornato",
                contentRebuilt: "Il contenuto è stato ricostruito",
                contentRebuildFailed: "Impossibile ricostruire il contenuto",
                customRequestEmpty: "Si prega di inserire una richiesta",
                customRequestApplied: "Il contenuto della richiesta personalizzata è stato applicato",
                loadingText: "AI in funzione",
                loadingDescription: "Il testo è in fase di analisi, si prega di attendere...",
                aiTitle: "Assistente AI per Email",
                aiDescription: "Strumenti AI per migliorare, modificare e analizzare la tua email",
                emptyContentTitle: "Nessun Contenuto Email Trovato",
                emptyContentDescription: "Il contenuto dell'email è necessario per utilizzare le funzionalità AI.",
                limitedAccessDescription: "Solo funzionalità limitate disponibili in assenza di contenuto email.",
                resultEmotions: "Emozioni Rilevate",
                analysisDescription: "Spiegazione dell'Analisi",
                recommendationsList: "Suggerimenti per il Miglioramento",
                mailSummarize: "Riassunto Email",
                aiResponse: "Generato dall'AI",
                rebuild: "Ricostruisci",
                applyText: "Applica Testo",
                specialRequest: "Richiesta Personalizzata",
                specialRequestPlaceholder: "Inserisci qui le tue istruzioni personalizzate...",
                sendRequest: "Invia Richiesta",
                fixGrammarTitle: "Correggi Grammatica",
                fixGrammardescription: "Corregge automaticamente errori ortografici e grammaticali",
                expandTextTitle: "Espandi Testo",
                expandTextDescription: "Rende il tuo testo più completo e dettagliato",
                changeToneTitle: "Cambia Tono",
                changeToneDescription: "Trasforma il tono e lo stile del testo nel tipo desiderato",
                changeTone_ProfessionalTitle: "Professionale",
                changeTone_ProfessionalDescription: "Tono formale e professionale per ambienti di lavoro",
                changeTone_FriendlyTitle: "Amichevole",
                changeTone_FriendlyDescription: "Approccio caldo e sincero",
                changeTone_CasualTitle: "Informale",
                changeTone_CasualDescription: "Tono conversazionale rilassato e quotidiano",
                changeTone_FormalTitle: "Formale",
                changeTone_FormalDescription: "Stile altamente formale e aziendale",
                changeTone_ConfidentTitle: "Sicuro",
                changeTone_ConfidentDescription: "Stile espressivo forte e impressionante",
                translateTitle: "Traduci",
                translateDescription: "Traduce il tuo testo in diverse lingue",
                generateReplyTitle: "Genera Risposta",
                generateReplyDescription: "Genera automaticamente una risposta adeguata all'email ricevuta",
                customPromptTitle: "Richiesta Personalizzata",
                customPromptDescription: "Genera contenuto email basato sulle tue istruzioni personalizzate"
            },
            searchEmail: "Cerca Email...",
            emailAttachments: "Allegati ({count})",
            signatureMessage: "La tua firma email è presente. Vuoi includerla nel contenuto dell'email?",
            emailSubject: "Oggetto Email",
            takeItBack: "Annulla",
            fastForward: "Ripristina",
            addEmoji: "Aggiungi Emoji",
            addLink: "Aggiungi Link",
            bold: "Grassetto",
            italic: "Corsivo",
            underline: "Sottolineato",
            fontFamily: "Carattere",
            textColor: "Colore del Testo",
            stringFormats: "Formati di Testo",
            alignLeft: "Allinea a Sinistra",
            alignRight: "Allinea a Destra",
            alignCenter: "Centra",
            normalText: "Testo Normale",
            participantList: "{first}, {second}, {third} +{remaining} altri",
            noMailFound: "Nessuna email trovata",
            selectedMail: "{count} email selezionata",
            recipientEmailAddress: "Indirizzo email del destinatario",
            CCreceivers: "Destinatari CC",
            BCCreceivers: "Destinatari BCC",
            emptyStateMessage: "Seleziona un'email o componine una nuova",
            FromName: "Nome del Mittente",
            broadcastCreatedSuccess: "Trasmissione creata con successo",
            confirmArchive: "Sei sicuro di voler archiviare questa trasmissione?",
            archive: "Archivia",
            cancel: "Annulla",
            archiveSuccess: "Trasmissione archiviata con successo",
            archiveError: "Errore durante l'archiviazione della trasmissione",
            empty: "Vuoto",
            summerDiscounts: "Sconti estivi",
            opportunities: "Opportunità",
            newMailTemplateCreated: "Crea nuovo modello e-mail",
            dateRange: "Intervallo di date",
            templateName: "Nome del modello",
            category: "Categoria",
            templateUpdateSucs: "Il modello è stato aggiornato con successo",
            templateUpdateError: "Si è verificato un errore durante l'aggiornamento del modello",
            marketing: "Marketing",
            operational: "Operativo",
            custom: "Speciale",
            pleaseEnterTemplateName: "Inserire il nome del modello",
            pleaseEnterTemplateSubject: "Inserire l'oggetto del modello",
            pleaseSelectTemplateCategories: "Selezionare la categoria del modello",
            representMails: "Mail di rappresentanza",
            otherRepresentMails: "È possibile tenere traccia delle e-mail in entrata e in uscita da e verso gli indirizzi e-mail di altri rappresentanti",
            signatureAutoAdd: "Lo stato di aggiunta automatica della firma è stato modificato con successo",
            autoAdd: "Aggiunta automatica",
            forwardEmailAddSucs: "Indirizzo e-mail di inoltro aggiunto con successo",
            errorAddingForwardEmail: "Si è verificato un errore durante l'aggiunta di un indirizzo e-mail di inoltro",
            mailAddForward: "Aggiunta manuale (inoltro completato)",
            mailAddForwarding: "Aggiunta manuale (ho completato l'inoltro)",
            broadcast: "Pubblicazioni",
            templates: "Modelli",
            newMailArrived: "È arrivata nuova posta",
            mailSentSucs: "Posta inviata con successo",
            representativeMails: "Posta rappresentativa",
            composeNewEmail: "Comporre una nuova e-mail",
            couldNotUserMail: "Impossibile inviare la posta perché non c'è posta dell'utente",
            mailAddressReq: "Indirizzo di posta richiesto",
            emailAddressInvalid: "Indirizzo di posta non valido",
            departmentIsNotValid: "Reparto non valido",
            mailSendNotValid: "Indirizzo di posta non valido",
            routingSteps: "Passi di instradamento",
            owner: "Proprietario",
            whereHeDirected: "Dove ha diretto",
            forwardingEmailAddress: "Indirizzo email di inoltro",
            deleteMailDesc: "Questa azione non può essere annullata.",
            deleteMailTitle: "Sei sicuro di voler eliminare questo indirizzo email?",
            gmailForwardMail: "Inoltro email Gmail",
            senderMailAddressDesc: "Si prega di inserire l'indirizzo email del mittente",
            verified: "Verificato",
            notForwarded: "Non inoltrato",
            notVerified: "Non verificato",
            default: "Predefinito",
            isVerified: "Verificato",
            forwarding: "Inoltro",
            mailAdress: "Indirizzo email",
            addSenderAddress: "Aggiungi indirizzo mittente",
            outlookForward: "Inoltra Microsoft (Outlook/Exchange)",
            gmailForward: "Inoltra Google (Gmail)",
            senderMail: "Mail del mittente",
            mailDetail: "Dettaglio della mail",
            mailNotFound: "Mail non trovata",
            mailSelecting: "Selezione mail",
            newMail: "Nuova e-mail",
            myMails: "Le mie email",
            inbox: "Posta in arrivo",
            sent: "Inviato",
            departmentMails: "Email del dipartimento",
            newTemplate: "Nuovo Modello",
            unread: "Non letto",
            unreply: "Unanswered",
            ply: "Rispondi",
            attachments: "Allegati alla mail",
            To: "A",
            From: "Da",
            placeHolders: "Segnaposto",
            attacheFiles: "Allega file",
            replyAll: "Rispondi a tutti",
            forward: "Inoltra",
            deleteThread: "Elimina conversazione",
            markAsRead: "Segna come letto",
            markAsAllRead: "Segna tutto come letto",
            emailEditor: "Editor email",
            integrateYourMail: "Integra la tua email",
            connect: "Collegare",
            departmentMail: "Email del dipartimento",
            createMailAddress: "Crea un indirizzo email",
            createNewMail: "Crea una nuova email",
            reply: "Reply",
            canNotUserMail: "Impossibile inviare l'email perché non è presente un account email utente",
            createNewEmail: "Crea nuova email",
            ly: "Risposta",
            operativ: "Operativo"
        },
        visitor: {
            ownership: "Proprietà",
            visitors: "Visitatori",
            bannedVisitors: "Visitatori Banditi",
            tags: "Tag",
            profileFields: "Campi Profilo",
            downloadAll: "Scarica tutto",
            saveAsCustomerGroup: "Salva come gruppo di clienti",
            saveSearchFavorite: "Salva la ricerca tra i preferiti",
            editOrDeleteFavorite: "Modifica o elimina preferito",
            mail: "Posta",
            visitorDetail: "Dettagli del visitatore",
            selectedUser: "{selectedUser} di {totalUsers} utenti selezionati",
            uncheck: "Deseleziona tutto",
            checkAll: "Seleziona tutto",
            matchedUsers: "{checkedCount} utenti corrispondenti",
            more: "Di più",
            exportUsers: "Esporta utenti selezionati",
            exportAllUsers: "Esporta tutti gli utenti",
            addSegment: "Aggiungi segmento",
            deleteCheckedUser: "Elimina utenti selezionati",
            deleteAllUser: "Elimina tutti gli utenti",
            matchedFilter: "Corrispondi a tutti i filtri",
            visitor: "Visitatore",
            deleteUser: "Elimina utente",
            userData: "Dati utente",
            lastSession: "Ultima sessione",
            notUserData: "Nessun dato utente trovato",
            segments: "Segmenti",
            addTag: "Aggiungi tag",
            userChats: "Chat utente",
            seeAll: "Vedi tutti",
            confirm: "Conferma",
            manageSegments: "Gestisci segmenti",
            search: "Ricerca",
            manageTags: "Gestisci tag",
            allAttributes: "Vedi tutti gli attributi",
            noData: "Nessun dato",
            noEmail: "Nessuna email",
            noIpAddress: "Indirizzo IP non trovato.",
            noWpNumber: "Numero non trovato.",
            filterName: "nome del filtro...",
            matchedContacts: "{chechkedCount} contatti corrispondenti",
            channelContacts: "Contatti del canale",
            searchInAllFields: "Cerca in tutti i campi",
            searchInName: "Cerca nel nome",
            importContacts: "Importa contatti",
            addNewContact: "Aggiungi nuovo contatto",
            importContactsTitle: "Importa contatti",
            addSingleContactTitle: "Aggiungi singolo contatto",
            downloadRecordsSettings: "Scarica record - Impostazioni",
            excelExport: "Esporta in Excel",
            exportTotalRecords: "Totale {total} record",
            exportCancel: "Annulla",
            whatsappContacts: "Contatti WhatsApp",
            instagramContacts: "Contatti Instagram",
            messengerContacts: "Contatti Messenger",
            linkedinContacts: "Contatti LinkedIn",
            telegramContacts: "Contatti Telegram",
            metaLeadsContacts: "Contatti MetaLeads",
            searchPlaceholderAll: "Scrivi qui per cercare in tutti i campi",
            searchPlaceholderFullname: "Scrivi qui per cercare per nome",
            searchPlaceholderEmail: "Scrivi qui per cercare per email",
            searchPlaceholderPhone: "Scrivi qui per cercare per telefono",
            searchPlaceholderWhatsapp: "Scrivi qui per cercare per WhatsApp",
            searchPlaceholderDefault: "Cerca",
            searchFieldAll: "Tutti i campi",
            searchFieldName: "Nome",
            searchFieldEmail: "Email",
            searchFieldPhone: "Numero di telefono",
            searchFieldWhatsapp: "Numero WhatsApp",
            searchModePhoneDetected: "Numero di telefono rilevato",
            searchModeEmailDetected: "Indirizzo email rilevato",
            searchModeNotPhone: "Non è un numero di telefono",
            searchModeNotEmail: "Non è un'email",
            searchMode: "Modalità di ricerca",
            searchModePhoneMessage: "\"{query}\" è stato rilevato come numero di telefono. Sei attualmente nel campo {field}. Vuoi cercare nel campo numero di telefono?",
            searchModeEmailMessage: "\"{query}\" è stato rilevato come indirizzo email. Sei attualmente nel campo {field}. Vuoi cercare nel campo email?",
            searchModeNotPhoneMessage: "\"{query}\" non è in formato numero di telefono. Vuoi cercare in tutti i campi o nel campo nome?",
            searchModeNotEmailMessage: "\"{query}\" non è in formato email. Vuoi cercare in tutti i campi o nel campo nome?",
            unknownTag: "Sconosciuto",
            noRecordsToDownload: "Nessun record da scaricare",
            excelCreatedSuccess: "File Excel creato con successo",
            exportCancelled: "Esportazione annullata",
            excelCreateError: "Si è verificato un errore durante la creazione del file Excel",
            yes: "Sì",
            no: "No",
            unowned: "Non assegnato",
            whatsappGroupCreatedSuccess: "Gruppo clienti WhatsApp creato con successo.",
            whatsappGroupCreateError: "Si è verificato un errore durante la creazione del gruppo clienti WhatsApp.",
            mailGroupCreatedSuccess: "Gruppo clienti mail creato con successo.",
            mailGroupCreateError: "Si è verificato un errore durante la creazione del gruppo clienti mail.",
            messageHistory: "Cronologia messaggi",
            pastConversations: "Conversazioni passate",
            defaultUser: "Utente",
            blockManagement: "Gestione del blocco",
            vipCustomer: "Cliente VIP",
            startChat: "Avvia chat",
            createEvent: "Crea evento",
            createTask: "Crea attività",
            selectTask: "Seleziona attività",
            webphoneCall: "Chiama con Webphone",
            capiEventSend: "Invia evento CAPI",
            defaultName: "Visitatore",
            notAvailable: "N/D",
            relatedList: "Lista correlata",
            adReferrals: "Referral pubblicitari",
            calls: "Chiamate",
            generalInfo: "Informazioni generali",
            callHistory: "Cronologia chiamate",
            webTab: "Scheda Web",
            widgetUrlError: "Impossibile creare l'URL del widget",
            deleteSuccess: "Visitatore eliminato con successo.",
            taskStatusUpdateSuccess: "Stato dell'attività aggiornato con successo",
            taskStatusUpdateError: "Errore durante l'aggiornamento dello stato dell'attività",
            copyToClipboard: "Copiato negli appunti",
            noPhoneNumber: "Nessun numero di telefono da chiamare",
            webphoneCalling: "Chiamata a {phoneNumber} con Webphone...",
            filterResultMax5000: "Il risultato del filtro è limitato a un massimo di 5000 contatti",
            onlyContactsPhoneNumber: "Solo i contatti con numero di telefono saranno trasferiti al gruppo",
            enterGroupName: "Inserisci il nome del gruppo",
            showInColumns: "Mostra nelle colonne",
            sendMailSucs: "Email inviata con successo",
            equal: "Uguale",
            notEqual: "Diverso da",
            contains: "Contiene",
            notContains: "Non contiene",
            startsWith: "Inizia con",
            endWith: "Termina con",
            deletedCheckedUser: "Elimina utenti selezionati",
            userMails: "Email utenti"
        },
        chatbotv2: {
            Ticket_Actions: "Azioni Ticket",
            Task_Actions: "Azioni Compito",
            Contact_Actions: "Azioni Contatto",
            Calendar_Actions: "Azioni Calendario",
            "T-Soft_Actions": "Azioni T-Soft",
            "Ticimax-V2_Actions": "Azioni Ticimax",
            TSOFT_SELECT_ORDER: "SELEZIONA ORDINE",
            TSOFT_ORDER_STATUS: "OTTIENI LO STATO DELL'ORDINE",
            TICIMAX_V2_SELECT_ORDER: "SELEZIONA ORDINE",
            TICIMAX_V2_ORDER_STATUS: "OTTIENI LO STATO DELL'ORDINE",
            Ikas_Actions: "Azioni Ikas",
            IKAS_GET_MEMBER_INFO: "Ottieni dettagli membro",
            IKAS_SELECT_ORDER: "Seleziona ordine",
            IKAS_ORDER_STATUS: "Ottieni stato dell'ordine",
            IDEASOFT_PRODUCT_SEARCH: "Ricerca prodotto",
            privateMessageDescription: "I messaggi privati possono essere visualizzati solo dagli agenti e rimangono nascosti ai visitatori.",
            AI_RANDOM_TEXT: "Testo casuale IA",
            AI_IMAGE: "Immagine IA",
            PRIVATE_MESSAGE: "Messaggio Privato",
            aiPrompt: "Prompt AI",
            variants: "Varianti",
            Zoho_Actions: "Azioni Zoho",
            File_Actions: "Azioni file",
            Google_Drive_Actions: "Azioni Google Drive",
            Artificial_Intelligence: "Intelligenza Artificiale",
            Table_Actions: "Azioni tabella",
            Cache_Actions: "Azioni cache",
            Data_Formatters: "Formattatori di dati",
            Loop_Actions: "Azioni di ciclo",
            importSuccess: "Modello importato con successo",
            importFailed: "Errore durante l'importazione del modello",
            creatingBlank: "ChatBOT vuoto in fase di creazione...",
            untitledChatbot: "ChatBOT senza titolo",
            errorCreating: "Errore durante la creazione del ChatBOT",
            typeAutomationTitle: "Digita il titolo dell'automazione",
            typeStoryTitle: "Scrivi un titolo di storia",
            setUpYourChatbot: "Imposta il tuo chatbot",
            setUpYourChatbotDesc: "Addestra il tuo chatbot con i dati, usa i nostri modelli pronti all'uso o parti da zero",
            blankBot: "Bot vuoto",
            blankBotDesc: "Crea un chatbot vuoto che puoi addestrare e personalizzare in seguito",
            aiBotDesc: "Crea un chatbot AI basato su RAG. Aggiungi una base di conoscenza e scegli il tuo modello LLM.",
            recommended: "Consigliato",
            websiteDesc: "Esamina i contenuti del vostro sito web per ottenere risposte alle domande più frequenti degli utenti",
            yourNeedEnterYourOpenAi: "È necessario inserire la propria chiave API OpenAI per creare un chatbot automatizzato attraverso il crawling del proprio sito web",
            createOpenAiKey: "Creare la chiave Api",
            aiKnowledge: "Conoscenza dell'intelligenza artificiale",
            modalUsage: "Uso modale",
            usedContentSources: "Fonti di contenuto utilizzate",
            websites: "Siti web",
            articles: "Articoli",
            faq: "FAQ",
            file: "File",
            functions: "Funzioni",
            impostazioni: "Impostazioni",
            disableAi: "Disabilita l'intelligenza artificiale",
            enableAi: "Abilita l'intelligenza artificiale",
            lastEdited: "Ultima modifica",
            state: "Stato",
            frequentlyAskedQuestions: "Domande frequenti (FAQ)",
            faqIsCreated: "FAQ create",
            selectKnowEnabled: "Abilitazione delle basi di conoscenza selezionate...",
            selectKnowDisabled: "Le basi di conoscenza selezionate sono disabilitate...",
            selectKnowNotEnabled: "Le basi di conoscenza selezionate non sono abilitate...",
            selectKnowNotDisabled: "Le basi di conoscenza selezionate non sono disabilitate",
            risposta: "Risposta",
            addFile: "Aggiungi file",
            fileCancellato: "File cancellato",
            fileDeletedFailed: "Si è verificato un problema nell'eliminazione dei file",
            noFileAdded: "Nessun file aggiunto",
            aiFunctions: "Funzioni AI",
            addFunction: "Aggiungi funzione",
            aiFunctionCreateHint: "Non utilizzare caratteri turchi quando si creano funzioni IA. Utilizzare solo lettere inglesi, numeri e underscore nei nomi delle funzioni.",
            builtInFunctionsTitle: "Funzioni integrate",
            builtInFunctionsDesc: "Queste sono funzioni predefinite che possono essere utilizzate dall'intelligenza artificiale.",
            builtInFunctionsOptionButtonsTitle: "L'IA può inviare messaggi con pulsanti",
            builtInFunctionsOptionButtonsDesc: "Consente all'IA di mostrare pulsanti cliccabili all'utente. Quando attivo, l'IA può offrire pulsanti di opzione all'utente.",
            builtInFunctionsCloseConversationTitle: "L'IA può terminare la conversazione",
            builtInFunctionsCloseConversationDesc: "Consente all'IA di terminare la conversazione quando appropriato. Quando attivo, l'IA può chiudere la chat.",
            builtInFunctionsTransferChatTitle: "L'IA può trasferire al supporto live",
            builtInFunctionsTransferChatDesc: "Consente all'IA di trasferire la conversazione al supporto live quando necessario. Quando attivo, l'IA può trasferire la conversazione a un agente umano.",
            parameterCount: "Conteggio parametri",
            auto: "Auto",
            usedByAI: "Utilizzato dall'IA",
            usedByAi: "Utilizzato dall'IA",
            notUsed: "Non utilizzato",
            saveAndClose: "Salva e chiudi",
            contentPreview: "Anteprima del contenuto",
            addContent: "Aggiungi contenuto",
            populerUserQuestion: "Esamina il contenuto del sito web per ottenere risposte alle domande più frequenti degli utenti",
            enterUrlAddress: "Inserire un indirizzo URL",
            sharingYourUrl: "Condividendo il vostro URL, confermate di avere i diritti necessari per condividerne il contenuto",
            pageSelected: "Pagine selezionate",
            trainChatbot: "Addestra il chatbot",
            thereAreOnePages: "C'è 1 pagina all'interno",
            categoryDesc: "Categoria. Scegliere quale utilizzare per addestrare il modello di intelligenza artificiale.",
            scarpOrAddContent: "Scartare o aggiungere contenuti, che AI Assist può utilizzare per rispondere alle domande dei clienti.",
            noContentAdded: "Nessun contenuto aggiunto",
            howItWorks: "Come funziona",
            editEntries: "Modifica voci",
            newEntries: "Nuovi inserimenti",
            chatbotManagement: "Gestione dei chatbot",
            chatbotScenarioList: "Chatbot Schenerio Lista",
            exportDiagramToClipboard: "Esportazione del diagramma negli appunti",
            selectedStory: "{count} storia selezionata",
            Meta_Actions: "Meta Actions",
            suppressionRemoved: "Soppressione rimossa",
            suppressionAdded: "Soppressione aggiunta",
            didntSuppression: "Non hai fatto alcuna soppressione.",
            whatsappIntegrationTitle: "Integrazione di WhatsApp V1 e WhatsApp V2",
            whatsappApiIntegrationTitle: "Integrazione dell'API di WhatsApp Business",
            ReadyTemplateBadge: "Modello pronto",
            readyTemplates: "Modelli pronti",
            regex: "Regex",
            regexDescription: "Cattura tutto con regex",
            chatbotLogo: "Logo del ChatBot",
            chatbotName: "Nome del ChatBot",
            allSecnario: "Elenco degli scenari di Chatbot",
            ChatbotScenarioList: "Elenco degli scenari di Chatbot",
            Scenario: "Scenari",
            filters: {
                equal: "uguale",
                not_equal: "non uguale",
                contain: "contiene",
                not_contain: "non contiene",
                starts_with: "inizia con",
                ends_with: "finisce con",
                empty: "vuoto",
                non_empty: "non vuoto",
                longer_than: "più lungo di",
                shorter_than: "più corto di",
                less_than: "minore di",
                less_or_equal: "minore o uguale a",
                greater_than: "maggiore di",
                greater_or_equal: "maggiore o uguale a"
            },
            planRequired: "{integratable} è disponibile solo con il piano.",
            noDefaultStoryTitle: "Nessuna storia predefinita",
            noDefaultStory: "Non hai una storia predefinita.\n Vuoi impostare questa storia come predefinita?",
            noMessage: "Nessun messaggio",
            loading: "Caricamento...",
            loadMore: "Carica altro",
            hostname: "Nome host",
            allTemplates: "Tutti i modelli",
            allAITemplates: "Tutti i modelli di IA",
            templatesFromTheIndustry: "Modelli dell'industria",
            basicTemplate: "Modello di base",
            proTemplate: "Modello avanzato",
            goToStory: "Vai alla storia",
            noResultFound: "Nessun risultato trovato",
            checkYourFilterCombination: "Controlla la combinazione del filtro",
            clearYourSearch: "Cancella la tua ricerca",
            andTryAgain: "e riprova",
            withBot: "& Bot",
            userWithBot: "Utente & Bot",
            chatDetail: "Dettaglio chat",
            allUserDetail: "Tutti i dettagli degli utenti",
            sessionData: "Dati di sessione",
            supsisChatWidget: "Supsis Chat Widget",
            integratedWith: "Integrato con: ",
            integration: "Integrazione",
            Users: "Utenti",
            user_id: "ID utente",
            botStory: "Storia del bot",
            categories: "Categorie",
            worksWith: "Funziona con",
            importBot: "Importa bot",
            keyFeatures: "Caratteristiche principali",
            importing: "Importazione",
            comingSoon: "Prossimamente",
            pickStory: "Scegli una storia",
            conversationId: "ID conversazione",
            integrateStoryWithSupsisWidget: "Integra la storia con Supsis Widget",
            integrateStoryWithWhatsapp: "Integra la storia con WhatsApp",
            integrateStoryWithInstagram: "Integra la storia con Instagram",
            selectIntegratingStory: "Seleziona la storia da integrare",
            install: "Installa",
            attr: {
                weekday: "Weekday",
                channelId: "Channel",
                email: "E-mail",
                phone: "Telefono",
                language: "Lingua",
                timezone: "Fuso orario",
                gender: "Genere",
                country: "Paese",
                referrer: "Referente",
                url: "Indirizzo di visita",
                ip: "IP",
                last_seen: "Ultima visita",
                name: "Nome",
                user_id: "ID utente",
                department: "Dipartimento",
                message: "Messaggio",
                akinon_brand: "Nome del marchio",
                akinon_order_id: "ID ordine",
                akinon_product_id: "ID prodotto",
                akinon_user_id: "ID utente",
                akinon_user_name: "Nome utente",
                akinon_user_email: "E-mail utente",
                akinon_invoice_url: "URL fattura",
                akinon_order_status: "Stato ordine",
                akinon_order_price: "Prezzo ordine",
                akinon_shipper_name: "Nome spedizioniere",
                akinon_product_size: "Dimensione prodotto",
                akinon_sku: "SKU",
                akinon_product_url: "URL prodotto",
                akinon_product_title: "Titolo prodotto",
                akinon_product_image: "Immagine prodotto",
                akinon_product_stock: "Stock prodotto",
                akinon_order_date: "Data ordine",
                akinon_track_number: "Numero di tracciamento",
                akinon_track_url: "URL di tracciamento",
                akinon_latitude: "Latitudine (Posizione)",
                akinon_longitude: "Longitudine (Posizione)",
                last_meta_post_id: "Ultimo ID post meta",
                last_meta_post_caption: "Ultima didascalia post meta",
                last_meta_post_type: "Ultimo tipo post meta",
                ideasoft_user_id: "Member Id",
                ideasoft_invoice_url: "URL fattura",
                ideasoft_order_id: "Numero ordine",
                ideasoft_order_status: "Order Status",
                ideasoft_order_price: "Order Price",
                ideasoft_shipper_name: "Shipper Name",
                ideasoft_product_size: "Product Size",
                ideasoft_sku: "Sku",
                ideasoft_product_url: "Product Url",
                ideasoft_product_title: "Product Title",
                ideasoft_product_image: "Product Image",
                ideasoft_product_stock: "Product Stock",
                ideasoft_order_date: "Order Date",
                ideasoft_track_number: "Track Number",
                ideasoft_track_url: "Track Url",
                offline_mode: "Modalità offline",
                available_agents: "Agenti disponibili",
                probel_sube_kodu: "Codice filiale",
                probel_brans_adi: "Nome del ramo",
                probel_brans_kodu: "Codice ramo",
                probel_doktor_adi: "Nome del dottore",
                probel_doktor_kodu: "Codice dottore",
                probel_poliklinik_adi: "Nome del poliambulatorio",
                probel_poliklinik_kodu: "Codice poliambulatorio",
                probel_randevu_tarihi: "Data dell'appuntamento",
                probel_date: "Data dell'appuntamento",
                probel_randevu_saati: "Ora dell'appuntamento",
                probel_randevu_id: "ID dell'appuntamento",
                probel_hasta_token: "Token del paziente",
                probel_kimlik_tipi: "Tipo di identità",
                probel_kimlik_no: "Numero di identità",
                probel_hasta_adi: "Nome del paziente",
                probel_hasta_soyadi: "Cognome del paziente",
                probel_hasta_cinsiyet: "Genere",
                probel_hasta_dogum_tarihi: "Data di nascita",
                probel_hasta_telefon: "Telefono",
                platform: "Piattaforma",
                hour: "Ora",
                segments: "Segments",
                ticket: "biglietto",
                tags: "Tag",
                metaReferrals: "Meta referral",
                owner: "Owner",
                trendyol_question: "Product Question",
                trendyol_question_id: "Product Question ID",
                trendyol_product_id: "Product ID",
                trendyol_product: "Product Data",
                id: "ID",
                conversationId: "Conversation ID",
                idleUserTime: "Ultima azione utente (secondi)",
                ai_class_result: "Risultato classificazione IA",
                meta_comment_id: "Meta Comment ID",
                meta_comment: "Meta Comment",
                meta_post_id: "Meta Post ID",
                visitor_trigger_type: "Tipo trigger visitatore",
                visitor_trigger_name: "Nome trigger visitatore",
                b2cargo_companyCode: "Company Code",
                b2cargo_takipNo: "Tracking Number",
                b2cargo_takipseri: "Tracking Serial",
                b2cargo_evrakdurum: "Order Status",
                b2cargo_teslimtar: "Delivery Date",
                b2cargo_gonderen: "Sender Name",
                b2cargo_aliciAdi: "Receiver Name",
                b2cargo_cikisIl: "Province of Departure",
                b2cargo_varisIl: "Province of Arrival",
                b2cargo_teslim: "Product Status",
                b2cargo_urun: "Product Type",
                b2cargo_atfTarih: "Product ATF Date",
                b2cargo_palet: "Product Palette",
                b2cargo_koli: "Product Parcel",
                b2cargo_kg: "Product WEIGHT",
                b2cargo_desi: "Product DESI",
                b2cargo_zimmetno: "Debit No",
                b2cargo_varissube: "Arrival Branch",
                b2cargo_atfDurum: "ATF State",
                holiday_plus_room_id: "Room ID",
                holiday_plus_room_title: "Room Title",
                holiday_plus_room_description: "Room Description",
                holiday_plus_room_size: "Room Size",
                holiday_plus_room_price: "Room Price",
                holiday_plus_room_price_offer: "Room Price Offer",
                holiday_plus_room_discount_price: "Room Discount Price",
                holiday_plus_selected_hotel_id: "Selected Hotel ID",
                holiday_plus_checkin: "Check In",
                holiday_plus_checkout: "Check Out",
                holiday_plus_child_count: "Child Count",
                holiday_plus_adult_count: "Adult Count",
                holiday_plus_child_dates: "Child Dates",
                reservation_time: "Orario prenotazione",
                reservation_day: "Giorno prenotazione"
            },
            storyList: "Elenco delle storie",
            douYouWannaDeleteItem: "Vuoi eliminare questo elemento?",
            douYouWannaDeleteWithChildren: "Vuoi eliminare questo elemento e i suoi figli?",
            stories: "Storie",
            templates: "Modelli",
            aitemplates: "Modelli di IA",
            integrations: "Integrazioni",
            all: "Tutti",
            installed: "Installato",
            installationOK: "Installazione OK",
            uninstall: "Disinstalla",
            remainingMessageDesc: "Hai messaggi rimanenti : ",
            openAISiteRoutingDescStart: "Per ottenere un Apikey",
            openAISiteRoutingDescEnd: " è possibile fare clic sul collegamento.",
            integrationOK: "Integrazione OK",
            chatWidget: "Supsis Widget di chat",
            artificialIntelligence: "AI",
            integratePlatform: "Chatbot {integretable} può essere integrato con",
            integrateOpenAIWithChatbot: "Integra Chat GPT-4 con Chatbot",
            integrateChatBotWithChatGPT3: "Integrazione di ChatBot con Chat GPT-4",
            integrateStoryWithTelegram: "Integra la storia con Telegram",
            webhooks: "Webhooks",
            archive: "Archivio",
            reports: "Rapporti",
            uncheckAll: "Deseleziona tutto",
            userSegments: "Segmenti utente",
            sandbox: "Cestino",
            sandboxPage: {
                title: "Scenari Chatbot Eliminati",
                description: "I tuoi scenari eliminati verranno rimossi automaticamente dopo 30 giorni nel cestino",
                emptyState: "Nessuno scenario eliminato nel cestino",
                unnamedScenario: "Scenario senza titolo",
                restore: "Ripristina",
                permanentlyDelete: "Elimina definitivamente",
                unknown: "Sconosciuto",
                user: "Utente",
                restoreConfirmTitle: "Sei sicuro di voler ripristinare questo scenario?",
                restoreConfirmContent: "Lo scenario {story} verrà ripristinato.",
                restoreSuccess: "Scenario ripristinato con successo",
                restoreError: "Ripristino fallito",
                permanentDeleteConfirmTitle: "Sei sicuro di voler eliminare definitivamente questo scenario?",
                permanentDeleteConfirmContent: "Questa azione non può essere annullata. Lo scenario verrà eliminato definitivamente.",
                permanentDeleteSuccess: "Scenario eliminato definitivamente",
                permanentDeleteError: "Operazione di eliminazione fallita",
                loadError: "Errore nel caricamento degli scenari eliminati"
            },
            customBlocks: "Blocchi personalizzati",
            blockMarket: "Mercato dei blocchi",
            browseBlockMarket: "Sfoglia mercato blocchi",
            searchBlocks: "Cerca blocchi...",
            unknownBlock: "Blocco sconosciuto",
            aiModelsComparison: "Confronto modelli IA",
            aiModelsChangeModel: "Cambia modello",
            aiModelsRecommended: "Consigliato",
            aiModelsEconomic: "Economico",
            aiModelsCodex: "Codex",
            comingSoonVectorIntro: "Con OpenAI Vector Storage puoi addestrare il tuo chatbot con i tuoi contenuti personalizzati.",
            comingSoonStep1Title: "Carica i tuoi file",
            comingSoonStep1Desc: "Aggiungi file PDF, Word, Excel, di testo o altri documenti al sistema.",
            comingSoonStep2Title: "Elaborazione automatica",
            comingSoonStep2Desc: "I tuoi file vengono analizzati da OpenAI e convertiti in formato vettoriale.",
            comingSoonStep3Title: "Risposte intelligenti",
            comingSoonStep3Desc: "Il tuo chatbot fornisce risposte accurate e significative basate sui contenuti che hai caricato.",
            comingSoonTip: "Suggerimento: Man mano che aggiungi contenuti, la base di conoscenza del tuo chatbot si espande e può fornire risposte più complete.",
            comingSoonGotIt: "Capito",
            imageProcessingSettings: {
                title: "Impostazioni elaborazione immagini",
                description: "Determina come verranno elaborate le immagini inviate al chatbot.",
                processingMode: "Modalità elaborazione",
                processWithBlock: "Elabora con blocco",
                processWithBlockDesc: "Instrada le immagini al flusso di blocchi locale",
                processWithAI: "Elabora con IA",
                processWithAIDesc: "Elabora le immagini con intelligenza artificiale",
                fallbackBlock: "Blocco di fallback",
                fallbackBlockDesc: "Blocco a cui reindirizzare in caso di errore durante l'elaborazione delle immagini",
                fallbackBlockPlaceholder: "Seleziona blocco di fallback",
                directJumpBlock: "Blocco salto diretto",
                directJumpBlockDesc: "Instrada tutte le immagini direttamente a questo blocco",
                directJumpBlockPlaceholder: "Seleziona blocco salto diretto (opzionale)",
                aiProcessingMode: "Modalità elaborazione IA",
                processIndividual: "Elabora uno per uno",
                processIndividualDesc: "Invia ogni immagine all'IA separatamente",
                processParallel: "Elabora in parallelo",
                processParallelDesc: "Raccogli le immagini entro un certo tempo e inviale insieme",
                bufferTime: "Durata buffer (secondi)",
                bufferTimeDesc: "Tempo di attesa per raccogliere le immagini",
                saveSuccess: "Impostazioni elaborazione immagini aggiornate con successo",
                saveError: "Errore durante il salvataggio delle impostazioni"
            },
            addSegment: "Aggiungi segmento",
            addToSegment: "Aggiungi al segmento",
            removeFromSegment: "Rimuovi dal segmento",
            plansVTippyContent: "La fatturazione per questo pacchetto verrà effettuata all'inizio di ogni mese e, nel caso in cui desideriate annullare, il vostro utilizzo verrà addebitato fino all'inizio del mese e il vostro pacchetto scadrà.<br><br>Il prezzo del pacchetto è escluso dall'IVA.<br><br>Le modifiche al pacchetto vengono riflesse nella fattura il giorno successivo.",
            segmentName: "Nome del segmento",
            sameSegment: "C'è un segmento con lo stesso nome!",
            usersInSegment: "Utenti nel segmento",
            noUsersAdded: "Nessun utente aggiunto",
            updateSegment: "Aggiorna segmento",
            newSegment: "Nuovo segmento",
            selectAll: "Seleziona tutto",
            queriesSelected: "query selezionate",
            noBlocksFound: "Nessun blocco trovato",
            userQuery: "Query utente",
            date: "Data",
            unmatched: "Non corrispondente",
            goToChat: "Vai alla chat",
            selectStory: "Seleziona storia",
            selectBlock: "Seleziona blocco",
            training: "Formazione",
            trainingAlert: "Per implementare le modifiche apportate alla pagina di addestramento del bot, è necessario pubblicare la nuova versione dello scenario da voi modificato.",
            unmatchedPhrases: "Frasi non corrispondenti",
            ignored: "Ignorato",
            story: "Storia",
            timePeriod: "Periodo di tempo",
            wholeTimeSpan: "Tutto il periodo",
            selectAStory: "Seleziona una storia",
            searchUserQuery: "Cerca query utente",
            time: {
                today: "Oggi",
                yesterday: "Ieri",
                last7: "Ultimi 7 giorni",
                last30: "Ultimi 30 giorni",
                "this-month": "Questo mese",
                "last-month": "Ultimo mese",
                "last-3-month": "Ultimi 3 mesi",
                "this-year": "Quest'anno",
                "last-year": "L'anno scorso",
                custom: "Personalizzato"
            },
            emailProvider: "Provider di posta elettronica",
            triggerFromAnywhere: "Attiva da qualsiasi parte",
            editWebhook: "Modifica Webhook",
            newWebhook: "Nuovo Webhook",
            webhookTitle: "Webhook connesso",
            webhookUrl: "URL Webhook",
            webhookToken: "Token Webhook",
            webhookUsername: "Nome utente Webhook",
            webhookPassword: "Password Webhook",
            allIntegrations: "Tutte le integrazioni",
            integrateYourCBwithChatWidget: "Integra il chatbot con il Chat Widget.",
            integrateYourCBwithChatGpt3: "Chatbot può essere integrato con GPT-4. Chiave API GPT-4 richiesta.",
            integrateYourCBwithWebHook: "Passa facilmente le informazioni sulla chat tra ChatBot e i tuoi servizi web.",
            integrateYourCBwithIntegratable: "ChatBot e {integratable} Trasmetti facilmente le informazioni sulla chat tra",
            addWebhook: "Aggiungi Webhook",
            editBlock: "Modifica blocco",
            moveBlock: "Sposta blocco",
            copyBlock: "Copia blocco",
            chatbot: "Chatbot",
            addFilter: "Aggiungi filtro",
            addFilterGroup: "Aggiungi gruppo di filtri",
            clearFilter: "filtro trasparente",
            in: "in",
            and: "e",
            or: "o",
            allStories: "Tutte le storie",
            addBot: "Aggiungi bot",
            testBot: "Test bot",
            publish: "Pubblica",
            editName: "Modifica nome",
            search: "Ricerca",
            typeMoreThan3Char: "Digita più di 3 caratteri ",
            expand: "Espandi",
            expandAll: "Espandi tutto",
            noMatchingItem: "Nessun elemento corrispondente",
            hint: "Suggerimento",
            select: "Seleziona",
            navigate: "Naviga",
            dismiss: "Ignora",
            choseAttribute: "Scegli attributo",
            selectReply: "Seleziona risposta",
            preview: "Anteprima",
            draft: "Bozza",
            lastUpdate: "Ultimo aggiornamento",
            published: "Pubblicato",
            newStory: "Nuova storia",
            updateStory: "Aggiorna storia",
            storyDescription: "Descrizione della storia",
            storyTitle: "Titolo della storia",
            deleteSingleBlock: "Elimina blocco",
            deleteWithChildren: "Elimina con figli",
            startTestFromHere: "Inizia il test da qui",
            copyBlockId: "Copia ID blocco",
            gotoLiveLink: "Vai al link dal vivo",
            copyBlockIdSuccessfull: "ID blocco copiato con successo",
            collapse: "Riduci",
            collapseAll: "Riduci tutto",
            snDelay: "{delay} ritardo sec",
            blockUpdated: "Blocco aggiornato",
            addPayload: "Aggiungi payload",
            previewModeCaution: "Sei in modalità anteprima. I cambiamenti apportati qui non verranno salvati. Per salvare, vai alla modalità modifica.",
            enterText: "Inserisci testo",
            trackpad: "Trackpad",
            navigation: "Navigazione",
            navigationDesc: "Seleziona questa opzione se vuoi che il chatbot risponda alle domande di navigazione come 'Torna indietro', 'Vai avanti', 'Vai alla home page' ecc.",
            botSetting: "Impostazioni bot",
            botSettingDesc: "Seleziona questa opzione se vuoi che il chatbot risponda alle domande di navigazione come 'Torna indietro', 'Vai avanti', 'Vai alla home page' ecc.",
            languageSettingsDesc: "Seleziona la lingua in cui vuoi che il chatbot risponda alle domande.",
            mouse: "Mouse",
            Interactions: "Interazioni",
            Actions: "Azioni",
            Supsis_Actions: "Supsis Azioni",
            Shopify_Actions: "Shopify Azioni",
            Akinon_Actions: "Akinon Azioni",
            IdeaSoft_Actions: "Ideasoft Actions",
            START_POINT: "PUNTO DI PARTENZA",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "RISPOSTA BOT",
            AI_BOT_RESPONSE: "RISPOSTA DI INTELLIGENZA ARTIFICIALE (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Blocchi modello",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "DEFAULT FALLBACK",
            FILTER: "FILTRO",
            addNewFilter: "Aggiungi nuovo filtro",
            FLOW: "FLUSSO",
            ATTACHMENT_INPUT: "INPUT ALLEGATO",
            USER_INPUT: "INPUT UTENTE",
            GO_TO_STEP: "VAI AL PASSO",
            WEBHOOK: "WEBHOOK",
            SET_ATTRIBUTE: "IMPOSTA ATTRIBUTO",
            QUESTION: "DOMANDA",
            CLOSE_CHAT: "CHIUDI CHAT",
            CREATE_TICKET: "CREA TICKET",
            TRANSFER_CHAT: "TRASFERISCI CHAT",
            TRANSFER_TO_CHATBOT: "FORWARD TO CHATBOT",
            TAG_CHAT: "ADD TAG",
            REMOVE_TAG: "REMOVE TAG",
            SET_DEPARTMENT: "IMPOSTA DIPARTIMENTO",
            SEND_TRANSCRIPT: "INVIA TRASCRIZIONE",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "INVIA EMAIL",
            CREATE_EVENT: "CREATE EVENT",
            CREATE_RESERVATION: "CREATE RESERVATION",
            RESERVATION_OPEN_URL: "Reservation Open Url",
            RESERVATION_SELECT_DAY: "Seleziona giorno prenotazione",
            RESERVATION_SELECT_TIME: "Seleziona orario prenotazione",
            RESERVATION_EVENT_LIST: "Reservation list visitor",
            CREATE_TASK: "CREATE TASK",
            SHOPIFY_SHOW_PRODUCTS: "SHOPIFY MOSTRA IL PRODOTTO",
            SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY STATO STOCK DEL PRODOTTO",
            SHOPIFY_ORDER_STATUS: "STATO ORDINE NEGOZIO",
            AKINON_SHOW_PRODUCTS: "MOSTRA DEL PRODOTTO AKINON",
            AKINON_FIND_PRODUCT: "TROVA IL PRODOTTO AKINON",
            AKINON_ORDER_STATUS: "STATO DELL'ORDINE AKINON",
            AKINON_SELECT_ORDER: "AKINON SELEZIONA ORDINE",
            AKINON_SELECT_SIZE: "AKINON SELEZIONA TAGLIA",
            AKINON_FIND_NEAREST_STOCK: "TROVA IL NEGOZIO PIÙ VICINO AKINON",
            AKINON_FIND_NEAREST_STORES: "TROVA I NEGOZI PIÙ VICINI AKINON",
            AKINON_SHOW_DISCOUNT_CODES: "MOSTRA CODICI SCONTO AKINON",
            IDEASOFT_SELECT_ORDER: "SELECT ORDER",
            IDEASOFT_ORDER_STATUS: "GET ORDER STATUS",
            IDEASOFT_GET_MEMBER_INFO: "FILL MEMBER INFO",
            SEND_WP_BUSINESS_MESSAGE: "INVIA MESSAGGIO WHATSAPP",
            MESSENGER_SEND_MESSAGE: "INVIA MESSAGGIO MESSENGER",
            INSTAGRAM_COMMENT_REPLY: "RISPONDI AL COMMENTO",
            INSTAGRAM_COMMENT_DELETE: "ELIMINA COMMENTO",
            INSTAGRAM_COMMENT_SHOW: "MOSTRA COMMENTO",
            INSTAGRAM_COMMENT_HIDE: "NASCONDI COMMENTO",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "RISPONDERE IN PRIVATO",
            followingAttributesFilled: "I seguenti attributi sono stati compilati",
            GET_LOCATION: "OTTIENI LA POSIZIONE",
            FALLBACK: "FALLBACK",
            SUCCESS: "SUCCESSO",
            FAILURE: "FALLIMENTO",
            Probel_Actions: "Probel Azioni",
            PROBEL_SELECT_BRANCH: "Seleziona Filiale",
            PROBEL_SELECT_CLINIC: "Scegli Clinica",
            PROBEL_SELECT_DAY: "Selezionare Giorno dell'appuntamento",
            PROBEL_SELECT_HOUR: "Seleziona Ora appuntamento",
            PROBEL_MAKE_APPOINTMENT: "Fai un appuntamento",
            PROBEL_CANCEL_APPOINTMENT: "Annulla appuntamento",
            PROBEL_GET_PATIENT_TOKEN: "Ottieni token paziente",
            PROBEL_FILL_INFO: "MERNIS Fill Info",
            PROBEL_SELECT_APPOINTMENT: "Seleziona appuntamento",
            message: "Messaggio",
            condition: "Condizione",
            score: "Punteggio",
            equal: "uguale",
            not_equal: "non uguale",
            contain: "contiene",
            not_contain: "non contiene",
            starts_with: "inizia con",
            ends_with: "finisce con",
            empty: "vuoto",
            longer_than: "più lungo",
            shorter_than: "più corto",
            less_than: "minore di",
            less_than_equal: "minore o uguale a",
            greater_than: "maggiore di",
            greater_than_equal: "maggiore o uguale a",
            value: "Valore",
            failures: "Fallimenti",
            email: "E-mail",
            name: "Nome",
            username: "Nome utente",
            source: "Fonte",
            language: "Lingua",
            timezone: "Fuso orario",
            region: "Regione",
            country: "Paese",
            referrer: "Referente",
            url: "URL",
            ip: "IP",
            city: "Città",
            lastSeen: "Ultima visita",
            userId: "ID utente",
            selectStep: "Seleziona Passo",
            keywords: "Parole chiave",
            userSays: "Utente dice",
            addKeyword: "Aggiungi parola chiave",
            addUserMessage: "Aggiungi messaggio utente",
            set: "Imposta",
            to: "a",
            gender: "Genere",
            go_to_failure: "Vai al passo di fallimento",
            go_to_success: "Vai al passo di successo",
            untilFilled: "Fino a quando non è riempito",
            time1: "1 volta",
            time2: "2 volte",
            time3: "3 volte",
            time4: "4 volte",
            time5: "5 volte",
            any: "Qualsiasi",
            anytext: "Any Text",
            anytextDescription: "Matches only words + spaces",
            alphanumeric: "Alfanumerico",
            integer: "Intero",
            no: "No",
            number: "Numero",
            phone: "Telefono",
            yes: "Sì",
            yesNo: "Si - No",
            anyDescription: "Corrisponde a tutto ciò che non è nullo.",
            alphanumericDescription: "Corrisponde a qualsiasi carattere alfanumerico.",
            integerDescription: "Corrisponde a qualsiasi numero intero.",
            noDescription: "Corrisponde a no, nope, nah, non,",
            numberDescription: "Corrisponde a qualsiasi numero.",
            phoneDescription: "Corrisponde a qualsiasi numero di telefono.",
            yesDescription: "Corrisponde ai sinonimi di sì.",
            yesNoDescription: "Corrisponde ai sinonimi di sì e no.",
            emailDescription: "Corrisponde a qualsiasi indirizzo email.",
            urlDescription: "Corrisponde a qualsiasi URL.",
            temperature: "Temperatura",
            askWhenInvalid: "Chiedi quando non valido",
            applyFilter: "Applica filtro",
            notificationMessageStartSuccess: "Blok ",
            notificationMessageEndSuccess: " Aggiunto",
            notificationMessageStartError: "Si è verificato un errore, blocco ",
            notificationMessageEndError: " non aggiunto",
            blockChangedWannaUpdate: "Il blocco è stato modificato, vuoi aggiornare?",
            TEXT: "Testo",
            IMAGE: "Immagine",
            GALLERY: "Galleria",
            BUTTON: "Pulsante",
            RANDOM_TEXT: "Testo casuale",
            QUICK_REPLY: "Risposta rapida",
            FILE: "File",
            responses: "Risposte",
            flow: "Flusso",
            active: "Attivo",
            passive: "Passivo",
            chooseAttributeType: "Seleziona tipo di attributo",
            imageAttachment: "Aggiungi immagine",
            audioAttachment: "Aggiungi audio",
            videoAttachment: "Aggiungi video",
            documentAttachment: "Aggiungi documento",
            anyAttachment: "Aggiungi allegato",
            typeAttributeValue: "Inserisci valore attributo",
            typeSearchValue: "Inserisci valore di ricerca",
            male: "Maschio",
            addAttribute: "Aggiungi attributo",
            addAttributeDescription: "Gli attributi sono utilizzati per memorizzare le informazioni dell'utente. Ad esempio, se si desidera memorizzare il nome dell'utente, è possibile creare un attributo con il nome 'nome' e il valore 'nome utente'.",
            USER_DATA: "Dati utente",
            CUSTOM_ATTRIBUTES: "Attributi personalizzati",
            enterBotResponseHere: "Inserisci qui la risposta del bot",
            enterPrivateBotResponseHere: "Inserisci il messaggio privato che il bot invierà ...",
            addCard: "Aggiungi carta",
            addButton: "Aggiungi pulsante",
            typeCardTitle: "Titolo della carta",
            typeCardDescription: "Descrizione della carta",
            dragAndDropBrowse: "Trascina e rilascia / Sfoglia",
            dragAndDropBrowseFile: "Trascina e rilascia / Sfoglia file",
            button: "Pulsante",
            enterYourMessage: "Inserisci il tuo messaggio",
            imageView: "Visualizzazione immagine",
            imageUploading: "Caricamento immagine...",
            fileUploading: "Caricamento file...",
            clickToChooseNewImage: "Fai clic per scegliere una nuova immagine",
            clickToChooseNewFile: "Fai clic per scegliere un nuovo file",
            removeTheExistingOne: "Rimuovi quello esistente",
            validateResponseWithEntity: "Convalida la risposta con l'entità",
            actionOnFailureInput: "Azione in caso di input non valido",
            askNextQuestion: "Chiedi la prossima domanda",
            goToSuccessBlock: "Vai al blocco di successo",
            goToFailureBlock: "Vai al blocco di fallimento",
            saveResposeToAttribute: "Salva la risposta nell'attributo",
            selectReplyType: "Seleziona tipo di risposta",
            questionVariants: "Varianti di domande",
            systemEntities: "Entità di sistema",
            delay: "Ritardo",
            retrySectionTextPart: " e riprova dopo ",
            retrySectionText: "Riprova se l'utente ha fornito una risposta non valida",
            addNextQuestion: "Aggiungi la prossima domanda",
            typeBlockTitle: "Inserisci il titolo del blocco",
            versionHistory: "Cronologia delle versioni",
            restore: "Ripristina",
            versionName: "Nome della versione",
            restoreModalText: "Sei sicuro di voler ripristinare questa versione? Tutte le modifiche apportate alla versione corrente verranno perse.",
            restoreVersion: "Ripristina versione",
            newVersion: "Nuova versione",
            synonymMustBeUnique: "Il sinonimo deve essere univoco",
            save: "Salva",
            entries: "Voci",
            youHaveNoEntries: "Non hai voci",
            inputsCantBeEmpty: "Le voci non possono essere vuote",
            entryNamesMustBeUnique: "I nomi delle voci devono essere univoci",
            entityNameCantBeEmpty: "Il nome dell'entità non può essere vuoto",
            entityNameMustBeUnique: "Il nome dell'entità deve essere univoco",
            synonyms: "Sinonimi",
            title: "Titolo",
            entryName: "Nome della voce",
            entities: "Entità",
            entityhasbeenUpdatedSuccessfully: "L'entità è stata aggiornata con successo",
            emptyError: "Non può essere vuoto",
            allChats: "Tutte le chat",
            paidChats: "Chat a pagamento",
            busiestPeriod: "Periodo più trafficato",
            ratingDistribution: "Distribuzione del rating",
            allMessages: "Tutti i messaggi",
            avarageMessages: "Messaggi medi",
            popularity: "Popolarità",
            allUsers: "Tutti gli utenti",
            interactionName: "Nome interazione",
            numberOfMessage: "Numero di messaggi",
            ofAllUsersMessage: "% Messaggio da tutti gli utenti",
            totalData: "Dati totali",
            avgData: "Dati medi",
            exportToCsv: "Esporta in CSV",
            exportToExcel: "Esporta in Excel",
            inMaintenance: "In manutenzione",
            ADD_TO_SEGMENT: "Aggiungi al segmento",
            REMOVE_FROM_SEGMENT: "Rimuovi dal segmento",
            users: "Utenti",
            webhookName: "Nome webhook",
            webHookUrl: "URL webhook",
            webHookToken: "Token webhook",
            delete: "Elimina",
            basicAuth: "Autenticazione di base",
            requiredFieldsCannotBeLeftBlank: "I campi obbligatori non possono essere lasciati vuoti",
            yourVerificationToken: "Il tuo token di verifica",
            yourWebHookName: "Nome webhook",
            yourWebHookUrl: "URL webhook",
            enterKey: "Inserisci chiave",
            password: "Password",
            headerValue: "Valore",
            saveSuccessfully: "Salva con successo",
            urlTypeError: "Si prega di compilare correttamente il campo (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "Chiave API richiesta per OpenAI Chat GPT-4.",
                apiKeyDesc: "La chiave API è necessaria per l'integrazione di Chatbot + Chat GPT-4. Si prega di ottenere la chiave API o utilizzare la chiave API sottostante per la prova. Puoi utilizzare solo 20 messaggi a scopo di prova.",
                getApiKey: "Ottieni la chiave API",
                typeApiKey: "Inserisci la chiave API",
                ownApiKey: "Ottieni la chiave API OpenAI",
                trialApiKey: "Chiave API di prova (limitata a 20 post)",
                useOurTrial: "Usa la nostra prova gratuita",
                twentyMessages: "Puoi provare e utilizzare 20 messaggi gratuitamente.",
                enableChatGpt3: "Attiva la chat GPT-4"
            },
            YouTube_Actions: "YouTube Actions",
            Google_Business_Actions: "Google Business Actions",
            Google_Play_Actions: "Google Play Actions",
            App_Store_Actions: "App Store Actions",
            META_SEND_CAPI_EVENT: "INVIA EVENTO CAPI",
            META_SEND_CAPI_EVENTDesc: "Invia eventi di conversione per l'ottimizzazione pubblicitaria tramite Meta Conversions API (CAPI). Aiuta a migliorare le prestazioni delle tue pubblicità su Instagram e Messenger.",
            CUSTOM_BLOCK: "Custom Block",
            CUSTOM_BLOCKDesc: "Execute custom JavaScript code with configurable parameters. Extend your chatbot by using blocks shared from the marketplace.",
            exampleOutput: "Example Output",
            outputSchema: "Output Schema (JSON)",
            FEEDBACK_AI_ASSISTANTDesc: "Supsis AI Artificial Intelligence Assistant is an intelligent solution that optimizes customer service and business processes. It provides 24/7 service by automatically responding to customer inquiries, offers multilingual support, and integrates with platforms like WhatsApp, Instagram, and Facebook. It facilitates sales, marketing, and appointment scheduling processes while offering personalized experiences to increase customer satisfaction. This assistant, which enhances efficiency and cost savings, provides businesses with a modern and effective customer service solution through fast and accurate information flow.",
            INSERT_TO_SYSTEM_PROMPTDesc: "The Insert to System Prompt block allows the chatbot to insert a message into the system prompt. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position. The message is inserted into the system prompt at the specified position.",
            API_REQUESTDesc: "This block defines the structure and parameters used to send a request to an API. The API Request URL specifies the address where the data will be sent, while the method (GET, POST, etc.) determines the type of request. Headers include authentication and content type information, Body Type defines the format of the data being sent, and the Body section contains the main data to be sent to the API. Finally, the Example Response shows an example of the expected response from the API. This block facilitates API integrations and automates data exchange.",
            BOT_RESPONSEDesc: "The Bot’s Response block enhances interaction by responding to the user with different content types such as text, images, and files. This block is used to send plain text messages (Text), randomly selected text variants (Random Text), images (Image), or files (File). It also provides button responses to offer options to the user: Gallery presents interactive displays with images and descriptions; Button offers options and is persistent across all platforms; Quick Reply allows the user to make quick selections and disappears after selection. Gallery supports unlimited buttons on the website platform, while only one card can be sent on WhatsApp. On Instagram and Messenger, each gallery card is sent as a separate message. Quick Reply offers more than 3 buttons on Instagram and Messenger, and the buttons appear above the message box.",
            TAVILY_WEB_SEARCHDesc: "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            AI_BOT_RESPONSEDesc: "This system enables AI to generate personalized responses based on user inputs and predefined instructions; it provides accurate and comprehensive answers using pre-prepared templates while recording user feedback to improve future responses.",
            AI_CLASSIFICATIONDesc: "The AI Classification Block analyzes user messages and categorizes them into predefined categories, automatically triggering relevant actions. Automatic classification ensures correct routing based on message content, while flexible category management allows adding or editing categories. Classified data is filtered to take the most appropriate actions based on user requests. Additionally, Instagram messages and comments can be classified through this block, enabling automated responses or actions.",
            DEFAULT_TIMEOUTDesc: "The default timeout is triggered at the start of the scenario and takes precedence if it is shorter than the local timeout duration; to use only the local timeout, the default must be deleted. The timeout duration cannot exceed the session duration, and multiple timeouts can be used in conjunction with user inputs. This structure, triggered when no response is received from the user, is suitable for sending reminder messages or restarting specific flows.",
            FILTERDesc: "The Supsis AI platform allows chatbots to filter user data based on customized attributes, user information (name, email, phone, language, time zone, gender, etc.), and visitor profile information (country, IP, referrer, visit address, etc.). Filtering operations enable the creation of complex conditions using 'and' and 'or' operators; for example, providing live support during working hours or offering special responses based on specific countries, phone numbers, or visit addresses. These features analyze user behavior, enabling the chatbot to provide more personalized, fast, and effective responses, thereby increasing customer satisfaction and optimizing chatbot efficiency.",
            ATTACHMENT_INPUTDesc: "The File Input block allows the chatbot to securely store and generate a downloadable URL for files received from users; this URL can be shared via channels like email or WhatsApp. The user can only send files in a defined file input; otherwise, the system redirects to the local or default 'Otherwise' flow. Images, audio, video, documents, or other attachments are supported, and the system automatically initiates the relevant process for each file type, redirecting the file to relevant units if necessary.",
            USER_INPUTDesc: "The User Input block allows the chatbot to process, validate, and save data received from users, triggering relevant actions. Global keywords are valid everywhere, while local keywords work in specific steps. Inputs can be validated using regex and saved to the user profile. The confidence level determines how the chatbot responds to inputs. With the 'Go to Block' and 'Send Message' buttons, users can be directed to specific steps or interact with the chatbot. This structure enables the chatbot to manage user interactions more efficiently.",
            GO_TO_STEPDesc: "The Go to Step Action is a mechanism that directs chatbot users to predefined steps. Dynamic routing ensures users are directed to the correct flow based on their queries or triggered actions. Block name editing ensures the flow is understandable and connections are easily managed. Users can edit block names from the block or within the block. The 'Go to Step' action is particularly useful for organizing transitions in complex chatbot flows. The Go to Block button type works similarly, directing users who click the defined button to a predefined block. The Go To selection determines the block the button will direct to, optimizing the user experience.",
            WEBHOOKDesc: "The Webhook Action facilitates data sharing between the chatbot and external systems. It directs the user flow based on successful and failed scenarios. In a successful scenario, the user flow continues when data is successfully sent; in a failed scenario, an error message is displayed, and the user is redirected. Webhook integration enables interaction with external systems and data exchange. Webhooks enhance the chatbot's flexibility and enrich the flow. For integration, adjustments must be made according to the system's API documentation.",
            SET_ATTRIBUTEDesc: "The Set Attribute block allows data received from users to be saved to their profile card, classifying data as static, dynamic, or special. Static data saves fixed values, dynamic data saves information that changes based on user inputs, and special data saves randomly generated values (e.g., random numbers or OTP). User and visitor profile information is collected and stored during user interactions, making it available for future interactions. This block is useful for managing user data and providing more personalized and accurate responses.",
            ASSIGN_OWNERDesc: "The Assign Owner Block is used to assign an ongoing chat to a selected representative through the chatbot. The assignment algorithm determines the most suitable representative based on the number of contacts they have and specific date ranges. Additionally, assignments can be made only to online representatives, and certain representatives can be excluded from the assignment pool. This process is synchronized with Zoho CRM, saving the assigned representative's data to the CRM system, thereby managing customer support processes more efficiently.",
            QUESTIONDesc: "The Question block allows the chatbot to ask users questions and validate and process their responses. When the user provides the correct answer, the successful scenario is triggered, and the flow continues. If the user provides an incorrect answer, the failed scenario is activated, giving the user another chance to respond. Additionally, user responses are validated using validation parameters, and correct data is saved to the profile card. For example, email addresses are validated, and correctly formatted information is saved to the profile card. In case of incorrect responses, the user is given the opportunity to correct them. This feature makes the chatbot's interaction with users more personalized and accurate.",
            TRANSFER_TO_CHATBOTDesc: "The Transfer to Chatbot block directs the user to a predefined different chatbot flow, offering a personalized experience. Users can transition from one flow to another and are directed to the correct scenario based on their needs. Scenario selection uses filtering and tagging processes to ensure users are directed to the correct flow based on their specific attributes. This feature provides flexible and dynamic responses to user requests.",
            TAG_CHATDesc: "The Add Tag block adds tags to profiles based on user interactions, enabling segmentation and chatbot filtering. User inputs are analyzed to direct them to the correct department, followed by representative transfer. Tags are used to optimize customer support and sales processes.",
            REMOVE_TAGDesc: "The Remove Tag block removes unnecessary or outdated tags from user profiles, ensuring chatbot analyses remain current and accurate. Tags are automatically cleaned, making segmentation and data management more efficient.",
            SET_DEPARTMENTDesc: "The Set Department block automatically or manually directs users to the correct department based on their needs. The appropriate department is determined based on user selections or system data, tags are added for segmentation, and representative transfer is performed if necessary.",
            SEND_TRANSCRIPTDesc: "The Send Transcript block automatically sends a record of the chat with the user to a specified email address, contributing to support and analysis processes. The transcript can be sent to the email address in the user profile card or a manually entered address.",
            SEND_SMSDesc: "The Send SMS block enables the sending of automated and personalized messages using Supsis's integration with Postacell or another SMS provider. The SMS content is dynamically generated using the phone number in the user's profile card and system data. For integration and additional information, contact live support or info@supsis.com.",
            SEND_MAILDesc: "The Send Mail block enables automated email sending using information collected through the chatbot. Personalized email content can be created based on attributes in the user's profile card. The email subject and content can be dynamically customized, and automatic notifications can be sent to both users and relevant teams for support requests. Supsis's email module integrates with existing mail infrastructures, simplifying the process.",
            CREATE_EVENTDesc: "The Create Event block automatically adds events to users' calendars through the chatbot. The event title, description, and duration are determined using data from the user's profile information, and event owners and additional representatives can be assigned. Automatic notifications inform participants, and event details can be managed through calendar integrations (Google Calendar, Microsoft Teams), speeding up the process and optimizing time management.",
            CREATE_RESERVATIONDesc: "The Create Reservation block automatically initiates a reservation process using attributes from the user's profile card or manually entered form data. Information from the user's profile, such as email addresses, can be used for calendar events, and event details can be retrieved from these attributes. This block organizes information received through the reservation form by interacting with other blocks and initiates the reservation process, making it faster and more personalized.",
            RESERVATION_OPEN_URLDesc: "The View Reservation Screen block lists available appointments for the user through a predefined reservation calendar. The user can view available appointments on the calendar through this screen. Additionally, predefined duration options (e.g., 5 minutes, 15 minutes, 30 minutes) can be selected for the appointment duration. This feature only works on website chatbots and offers users convenient reservation options.",
            RESERVATION_SELECT_DAYDesc: "The Select Reservation Day block offers users a selection of weekly reservation days, and the selected reservation day is saved in the system. Relevant information is automatically retrieved from the user's profile card attributes, and the reservation day is determined. This block offers users options through buttons, directing them to the appropriate reservation day. This process is personalized with user-specific information and integrated with the event calendar.",
            RESERVATION_EVENT_LISTDesc: "The Customer Reservation List quickly and efficiently presents reservation data associated with users' email information. This process is performed using a specific customer's email address, and all reservations linked to that email address are listed for the user.",
            RESERVATION_SELECT_TIMEDesc: "The Select Reservation Time block offers users available times for the selected reservation day. The user selects a suitable time from the available options for the previously selected day. This block lists available times for the day based on data received from the Select Reservation Day block and offers options to the user. The selected reservation time is saved in the system and integrated appropriately using the user's profile information and attributes.",
            CREATE_TASKDesc: "The Create Task block automatically or manually adds tasks to the Task Management Module based on user requests. The task title, description, urgency level, workflow, and pipeline (column) are determined and assigned to relevant representatives. Tasks personalized with information from the user's profile card are notified to relevant individuals through system and email notifications. Google Calendar and Microsoft Teams integrations make the process easy to track. For example, when a customer requests additional information, the chatbot automatically creates a task in the 'Awaiting Contact' column of the sales process and notifies the relevant representative.",
            GET_LOCATIONDesc: "The Get Location Module allows the chatbot to collect geographic location information from users. When requesting location information from the user, a special message is displayed, and the location's latitude and longitude are saved to the profile card. The user can share their location manually by entering an address or selecting it on the map. This feature is particularly useful in e-commerce, logistics, and delivery sectors, personalizing the user experience. For example, an e-commerce chatbot can use this module to collect a delivery address from the user and complete the process.",
            SUPPRESSION_ADDDesc: "The Suppression block blocks a user on a specified platform (WhatsApp, Web Visitor, Instagram, Messenger). The value of the user to be blocked can be automatically retrieved from attributes or entered manually. Blocking can be applied to inbound (message reception), outbound (message sending), or both. For example, to block a user causing discomfort on WhatsApp, 'WhatsApp' is selected as the platform, the user's phone number is specified, and both inbound and outbound blocking are activated.",
            SUPPRESSION_REMOVEDesc: "The Remove Suppression block unblocks a previously blocked user on a specified platform (WhatsApp, Web, Instagram, etc.) using the value used for blocking (e.g., phone number, user ID). The value for unblocking can be automatically retrieved from the profile card attributes. This allows the unblocking process to be performed quickly and automatically.",
            SEND_WP_BUSINESS_MESSAGEDesc: "The Send WhatsApp Message block enables sending personalized messages to users using the WhatsApp Business API. When this action is triggered, a message is sent through the WhatsApp channel using a predefined template. The message content can be personalized using attributes from the profile card and manual inputs. The number to be sent can be entered manually or automatically retrieved from user information. Templates are approved formats in the WhatsApp Business API, and existing templates can be selected or new ones created. Variables within the template can be used to create personalized messages. Additionally, media files (JPEG, PNG, etc.) can be added to messages. This block enables automated message sending for scenarios like campaign messages, support requests, or special notifications.",
            MESSENGER_SEND_MESSAGEDesc: "This block allows the CHATBOT to send messages via Messenger. The CHATBOT can send messages containing text, images, or other media types to a specific recipient.",
            INSTAGRAM_SEND_MESSAGEDesc: "This block allows the CHATBOT to send direct messages via the Instagram platform. The CHATBOT can send messages containing text or media to a specific user.",
            INSTAGRAM_COMMENT_REPLYDesc: "This block is used to reply to a comment on an Instagram post. The CHATBOT can interact by replying to a specific comment.",
            INSTAGRAM_COMMENT_DELETEDesc: "This block is used to delete a comment on an Instagram post. The CHATBOT can remove unwanted or inappropriate comments.",
            INSTAGRAM_COMMENT_SHOWDesc: "This block is used to view a comment on an Instagram post. The CHATBOT can review a specific comment and see other users' opinions.",
            INSTAGRAM_COMMENT_HIDEDesc: "This block is used to hide a comment on an Instagram post. The CHATBOT can make a specific comment invisible, preventing followers from seeing it.",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATEDesc: "This block is used to reply to a comment on an Instagram post with a private message (DM). The CHATBOT can send a private response to the commenter, establishing a more personal communication.",
            TABLE_CREATE_RECORDDesc: "This block adds a new record to a specific table. Using information received from the user or other attributes in the system, a new record is created and added to the relevant table. Adding a new record is used for processes such as creating new customer information or product records.",
            TABLE_DELETE_RECORDDesc: "This block deletes a record from the data table. When the user wants to remove a record that is no longer valid or contains errors, this block is triggered. The deleted record is completely removed from the table and cannot be recovered. For example, this process is used to delete a customer's record or an invalid order.",
            TABLE_UPDATE_RECORDDesc: "This block updates the content of a record in the table. When the user wants to change information in an existing record, this block can be used. For example, this process is used to update a customer's address or product price. This operation only changes the specified record and does not affect other records in the table.",
            TABLE_FIND_RECORDDesc: "This block allows finding a specific record in the data table. When the user wants to search for specific data (e.g., a username or product ID) recorded in the table, this block is used. The search process allows users to quickly access a specific record.",
            TABLE_FIND_RECORDSDesc: "This block displays existing records in the table to the user. When the user wants to see all records in the table or filtered records based on specific criteria, this block is used. The listing process can include operations such as sorting and filtering data.",
            ADD_TO_SEGMENTDesc: "The Add to Segment Action allows adding users to defined segments after they go through specific steps. This action helps analyze user behavior by dividing it into segments and creating custom reports. Users are added to appropriate segments through the segment selection bar, and new segments can be created from the chatbot menu. For example, when a VIP customer makes a special campaign query, the Add to Segment action adds the user to the VIP segment. Segment reports can be reviewed through reporting, providing detailed data on which segments users are added to and their requests.",
            REMOVE_FROM_SEGMENTDesc: "The Remove from Segment Action is used to remove users from specific segments. This action updates segments, enabling more accurate analysis of users on a segment basis. Users are automatically removed from the relevant segment after selecting the segment to be removed through the segment selection bar. Segment updates and analyses of removed users can be performed through reporting, allowing clearer tracking of segment changes and user behavior.",
            files: "Files",
            settings: "Settings",
            answered: "Answered",
            answer: "Answer",
            fileDeleted: "File eliminati",
            Messaging_Actions: "Azioni messaggistica",
            exportDiagram: "Export Diagram",
            exportDiagramDescription: "Seleziona i componenti da esportare. I dati saranno copiati negli appunti e potranno essere importati in un altro scenario.",
            diagram: "Diagram",
            diagramExportDesc: "Chatbot flow diagram (required)",
            aiSettings: "AI Settings",
            aiSettingsExportDesc: "AI model settings, prompt and parameters",
            aiFunctionsExportDesc: "Seleziona le funzioni IA da esportare",
            knowledgeBase: "Base di conoscenza",
            knowledgeBaseExportDesc: "Seleziona i tipi di base di conoscenza da esportare",
            webPages: "Pagine web",
            noKnowledgeBase: "Nessuna base di conoscenza da esportare",
            exportToClipboard: "Copia negli appunti",
            exportSuccess: "Scenario successfully copied to clipboard",
            exportError: "Si è verificato un errore durante l'esportazione",
            exportDataFetchError: "Errore nel recupero dei dati da esportare",
            model: "Model",
            topP: "Top P",
            toolChoice: "Tool Choice",
            prompt: "Prompt",
            B2Cargo_Actions: "B2Cargo Actions",
            Holiday_Plus_Actions: "Holiday+ Actions",
            HOLIDAY_PLUS_GET_ROOMS: "LIST ROOMS",
            HOLIDAY_PLUS_GET_HOTELS: "LIST HOTELS",
            ZOHO_CREATE_RECORD: "Zoho Create Record",
            B2CARGO_LOGIN_USER: "Accesso utente",
            B2CARGO_PRODUCT_STATUS: "Stato prodotto",
            createNewBlock: "Crea nuovo blocco",
            marketplace: "Marketplace",
            myBlocks: "My Blocks",
            importedBlocks: "Imported Blocks",
            pendingApproval: "Pending Approval",
            utility: "Utility",
            dataTransform: "Data Transform",
            custom: "Custom",
            mostUsed: "Most Used",
            topRated: "Top Rated",
            newest: "Newest",
            uses: "uses",
            import: "Import",
            imported: "Imported",
            pending: "Pending",
            approved: "Approved",
            rejected: "Rejected",
            unlist: "Unlist",
            confirmDeleteBlock: "Sei sicuro di voler eliminare questo blocco?",
            noBlocksCreated: "No blocks created yet",
            enterChangelog: "Enter changelog (optional)",
            publishBlock: "Publish Block",
            blockPublished: "Block published successfully",
            blockUnlisted: "Block unlisted successfully",
            blockDeleted: "Blocco eliminato con successo",
            cannotDeleteActiveBlock: "Cannot delete block with active usage",
            noImportedBlocks: "No imported blocks",
            confirmRemoveImport: "Sei sicuro di voler rimuovere questa importazione?",
            remove: "Remove",
            importRemoved: "Importazione rimossa con successo",
            creator: "Creator",
            viewDetails: "View Details",
            approve: "Approve",
            reject: "Reject",
            noPendingBlocks: "No pending blocks",
            enterRejectionReason: "Enter rejection reason",
            rejectBlock: "Reject Block",
            blockApproved: "Block approved successfully",
            blockRejected: "Block rejected",
            blockImported: "Block imported successfully",
            parameters: "Parameters",
            noParameters: "No parameters required",
            ratings: "Ratings",
            writeReview: "Scrivi la tua recensione...",
            selectOrTypeCategory: "Seleziona o digita categoria",
            changelogPlaceholder: "Enter changelog (optional)",
            category: "Category",
            description: "Description",
            tags: "Tags",
            submitRating: "Submit Rating",
            noRatings: "No ratings yet",
            latest: "Latest",
            pinned: "Pinned",
            createBlock: "Crea blocco",
            basicInfo: "Basic Info",
            blockName: "Block Name",
            enterBlockName: "Enter block name",
            enterDescription: "Enter description",
            icon: "Icon",
            addTags: "Add tags",
            javascriptCode: "JavaScript Code",
            addParameter: "Add Parameter",
            parameterName: "Parameter name (variable)",
            parameterLabel: "Display label",
            parameterDescription: "Description (help text)",
            defaultValue: "Default value",
            allowAutoUpdate: "Auto-update output schema on execution",
            visibility: "Visibility",
            allowedSiteIds: "Allowed Site IDs",
            enterSiteIds: "Enter site IDs",
            saveDraft: "Save Draft",
            fillRequired: "Compila i campi obbligatori",
            blockCreated: "Blocco creato",
            selectCustomBlock: "Seleziona blocco personalizzato",
            selectCustomBlockDesc: "Choose a custom block from your imported blocks",
            outputPreview: "Output Preview",
            blockNotFound: "Block not found",
            pleaseSelectRating: "Seleziona una valutazione",
            ratingSubmitted: "Rating submitted",
            plans: "Piani",
            chatBotPlans: "Piani Chat Bot",
            FEEDBACK_AI_ASSISTANT: "FEEDBACK AI ASSISTANT",
            INSERT_TO_SYSTEM_PROMPT: "INSERT TO SYSTEM PROMPT",
            API_REQUEST: "API REQUEST",
            AI_CALL: "AI CALL",
            TAVILY_WEB_SEARCH: "WEB SEARCH",
            OPENAI_WEB_SEARCH: "WEB ARAMA (OPENAI)",
            RUN_JAVASCRIPT: "RUN JAVASCRIPT",
            DEFAULT_TIMEOUT: "DEFAULT TIMEOUT",
            AI_FUNCTIONS: "AI FUNCTIONS",
            ASSIGN_OWNER: "Sahip Ata",
            CACHE_WRITE: "CACHE WRITE",
            CACHE_READ: "CACHE READ",
            CACHE_EXTEND: "CACHE EXTEND",
            CACHE_DELETE: "CACHE DELETE",
            YOUTUBE_REPLY_COMMENT: "YOUTUBE REPLY COMMENT",
            YOUTUBE_UPDATE_COMMENT_STATUS: "YOUTUBE UPDATE COMMENT STATUS",
            YOUTUBE_SET_MODERATION_STATUS: "YOUTUBE SET MODERATION STATUS",
            GOOGLE_BUSINESS_REPLY_REVIEW: "GOOGLE BUSINESS REPLY REVIEW",
            GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "GOOGLE BUSINESS UPDATE REVIEW STATUS",
            GOOGLE_PLAY_REPLY_REVIEW: "GOOGLE PLAY REPLY REVIEW",
            GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "GOOGLE PLAY UPDATE REVIEW STATUS",
            APP_STORE_REPLY_REVIEW: "APP STORE REPLY REVIEW",
            APP_STORE_UPDATE_REVIEW_STATUS: "APP STORE UPDATE REVIEW STATUS",
            APP_STORE_DELETE_REVIEW_RESPONSE: "APP STORE DELETE REVIEW RESPONSE",
            TIMEOUT: "TIMEOUT",
            SUPPRESSION_ADD: "BLOCK CONTACT",
            SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
            INSTAGRAM_SEND_MESSAGE: "Instagram Send Message",
            TABLE_CREATE_RECORD: "Crea record",
            TABLE_DELETE_RECORD: "Elimina record",
            TABLE_UPDATE_RECORD: "Aggiorna record",
            TABLE_FIND_RECORD: "Find Record",
            TABLE_FIND_RECORDS: "Find Records",
            OPENAI_WEB_SEARCHDesc: "Web search allows retrieving information from various websites through AI-powered systems. When a search query is entered, the most relevant results are scanned based on the specified search depth, providing information tailored to the user's needs. Raw content, images, and image descriptions can also be included for a more comprehensive information transfer. Additionally, the obtained data can be summarized or presented in its raw form. Users can filter search results by including specific domains, ensuring access to information from the most reliable sources. Thus, AI-powered web searches optimize the process of obtaining fast and accurate information.",
            TICKET_UPDATE: "AGGIORNA TICKET",
            b2cargo_login_user: "Login User",
            b2cargo_product_status: "Product Status",
            cardInfos: "Informazioni carta",
            ficheros: "Ficheros",
            setUpUpYourChatbot: "Configura il tuo chatbot",
            setUpUpYourChatbotDesc: "Addestra il tuo chatbot con i dati, usa i nostri modelli pronti o parti da zero.",
            yourNeedEnterEnterYourOpenAi: "Devi inserire la tua chiave API OpenAI per creare un chatbot tramite crawling del tuo sito."
        },
        coupon: {
            code: "codice",
            discount: "sconto",
            endDate: "Data di fine",
            name: "Nome",
            email: "E-mail",
            phone: "Telefono",
            add: "Aggiungi",
            coupons: "Coupon",
            couponDeleted: "Coupon eliminato",
            limit: "Limite",
            visitorBan: "Il visitatore è stato bloccato.",
            visitorUnBlock: "Il blocco è stato rimosso."
        },
        instagramTitle: "Fai clic sul pulsante in basso per abilitare le funzionalità di Instagram.",
        instegramFunctionActive: "Funzione Instagram attiva",
        ChatBOT: "ChatBOT",
        WhatsappContacts: "Contatti Whatsapp",
        InstagramContacts: "Contatti Instagram",
        MessengerContacts: "Contatti Messenger",
        volumeUp: "Volume su",
        minimize: "Minimizza",
        maximize: "Massimizza",
        auditLogs: {
            auditLogsTitle: "Log di audit",
            auditLogsSub: "I log di audit ti consentono di tracciare gli eventi che sono avvenuti nella tua azienda negli ultimi 30 giorni.",
            actor: "Attore",
            actorSelect: "Seleziona attore",
            actorSystem: "System (Supsis Ai)",
            actorChatbot: "Chatbot",
            actorApi: "API",
            actorVisitor: "Qualsiasi visitatore",
            actorAgent: "Qualsiasi agente",
            adminUserSuffix: "(Utente admin)",
            activityType: {
                blocked: "Bloccato",
                unblocked: "Sbloccato",
                "chat-opened": "Chat aperta",
                "chat-closed": "Chat chiusa",
                "chat-rating": "Chat valutata",
                "chat-assigned-to-user": "Chat assegnata all'utente",
                "chat-forwarded-to-user": "Chat inoltrata all'utente",
                "contact-owner-updated": "Proprietario contatto aggiornato",
                "user-joined-to-chat": "Utente unito alla chat",
                "ticket-assigned-to-user": "Ticket assegnato all'utente",
                online: "Online",
                offline: "Offline",
                "page-changed": "Pagina modificata",
                "create-ticket": "Ticket creato",
                "video-calling-started": "Videochiamata avviata",
                "video-calling-closed": "Videochiamata chiusa",
                "voice-calling-started": "Chiamata vocale avviata",
                "voice-calling-closed": "Chiamata vocale chiusa",
                "visitor-tag-added": "Tag visitatore aggiunto",
                "visitor-tag-removed": "Tag visitatore rimosso",
                "note-created": "Nota creata",
                "note-updated": "Nota aggiornata",
                "visitor-profile-updated": "Profilo visitatore aggiornato",
                "user-added": "Utente aggiunto",
                "user-removed": "Utente rimosso",
                "user-status-changed": "Stato utente modificato",
                "user-logged-in": "Utente connesso",
                "user-added-to-department": "Utente aggiunto al dipartimento",
                "user-removed-from-depart": "Utente rimosso dal dipartimento",
                "user-role-changed": "Ruolo utente modificato",
                "user-password-changed": "Password utente modificata",
                "user-email-changed": "Email utente modificata",
                "user-name-changed": "Nome utente modificato",
                "user-phone-changed": "Telefono utente modificato",
                "user-disabled": "Utente disabilitato",
                "user-enabled": "Utente abilitato",
                "settings-updated": "Impostazioni aggiornate",
                "whatsapp-broadcast-created": "Broadcast WhatsApp creato",
                "whatsapp-broadcast-completed": "Broadcast WhatsApp completato",
                "whatsapp-broadcast-canceled": "Broadcast WhatsApp annullato",
                "whatsapp-broadcast-failed": "Broadcast WhatsApp fallito",
                "whatsapp-v1-bot-state-changed": "Stato bot WhatsApp v1 modificato",
                "whatsapp-v2-bot-state-changed": "Stato bot WhatsApp v2 modificato",
                "channel-created": "Canale creato",
                "channel-removed": "Canale rimosso",
                "channel-visibility-changed": "Visibilità canale modificata",
                "channel-zoho-config-updated": "Configurazione canale Zoho aggiornata",
                "channel-forward-config-updated": "Config inoltro canale aggiornata",
                "login-form-activated": "Modulo di accesso attivato",
                "login-form-deactivated": "Modulo di accesso disattivato",
                "login-form-updated": "Modulo di accesso aggiornato",
                "chatbot-created": "Chatbot creato",
                "chatbot-deleted": "Chatbot eliminato",
                "chatbot-restored": "Chatbot ripristinato dal cestino",
                "chatbot-published": "Chatbot pubblicato",
                "chatbot-webhook-added": "Webhook chatbot aggiunto",
                "chatbot-webhook-removed": "Webhook chatbot rimosso",
                "banned-word-added": "Parola vietata aggiunta",
                "banned-word-removed": "Parola vietata rimossa",
                "mail-address-added": "Indirizzo email aggiunto",
                "mail-address-removed": "Indirizzo email rimosso",
                "mail-was-sent": "Email inviata",
                "content-added": "Contenuto aggiunto",
                "content-removed": "Contenuto rimosso",
                "role-added": "Ruolo aggiunto",
                "role-removed": "Ruolo rimosso",
                "role-updated": "Ruolo aggiornato",
                "department-added": "Dipartimento aggiunto",
                "department-removed": "Dipartimento rimosso",
                "tags-added": "Tag aggiunti",
                "tags-removed": "Tag rimossi",
                "trigger-added": "Trigger aggiunto",
                "trigger-removed": "Trigger rimosso",
                "trigger-updated": "Trigger aggiornato",
                "welcome-message-added": "Messaggio di benvenuto aggiunto",
                "welcome-message-removed": "Messaggio di benvenuto rimosso",
                "customer-group-added": "Gruppo clienti aggiunto",
                "customer-group-removed": "Gruppo clienti rimosso",
                "customer-group-updated": "Gruppo clienti aggiornato",
                "webhook-added": "Webhook aggiunto",
                "webhook-removed": "Webhook rimosso",
                "webhook-updated": "Webhook aggiornato",
                "contact-prop-added": "Proprietà contatto aggiunta",
                "contact-prop-removed": "Proprietà contatto rimossa",
                "invoice-created": "Fattura creata",
                "invoice-updated": "Fattura aggiornata",
                "invoice-payment-received": "Pagamento fattura ricevuto",
                "invoice-payment-failed": "Pagamento fattura fallito",
                "invoice-refunded": "Fattura rimborsata",
                "invoice-deleted": "Fattura eliminata",
                "payment-method-added": "Metodo di pagamento aggiunto",
                "billing-address-updated": "Indirizzo di fatturazione aggiornato",
                "plan-started": "Piano avviato",
                "plan-canceled": "Piano annullato",
                "task-workflow-created": "Flusso attività creato",
                "task-workflow-deleted": "Flusso attività eliminato",
                "task-workflow-restored": "Flusso attività ripristinato dal cestino",
                "task-workflow-permanently-deleted": "Flusso attività eliminato definitivamente",
                "task-workflow-updated": "Flusso attività aggiornato",
                "task-workflow-pipeline-stage-added": "Fase pipeline flusso attività aggiunta",
                "task-workflow-pipeline-stage-updated": "Fase pipeline flusso attività aggiornata",
                "task-workflow-pipeline-stage-deleted": "Fase pipeline flusso attività eliminata",
                "task-created": "Attività creata",
                "task-deleted": "Attività eliminata",
                "task-stage-changed": "Fase attività modificata",
                "task-workflow-changed": "Flusso attività modificato",
                "task-assigned-to-user": "Attività assegnata all'utente",
                "task-update-priority": "Priorità attività aggiornata",
                "task-added-tags": "Tag aggiunti all'attività",
                "task-removed-tags": "Tag rimossi dall'attività",
                "task-update-title": "Titolo attività aggiornato",
                "task-update-description": "Descrizione attività aggiornata",
                "task-update-start-date": "Data inizio attività aggiornata",
                "task-update-end-date": "Data fine attività aggiornata",
                "task-update-owner": "Proprietario attività aggiornato",
                "task-added-followers": "Follower aggiunti all'attività",
                "task-removed-followers": "Follower rimossi dall'attività",
                "task-added-collaborators": "Collaboratori aggiunti all'attività",
                "task-update-checklist": "Checklist attività aggiornata",
                "task-added-subtask": "Sottoattività aggiunta all'attività",
                "task-removed-subtask": "Sottoattività rimossa dall'attività",
                "task-added-attachment": "Allegato aggiunto all'attività",
                "task-comment-added": "Commento aggiunto all'attività",
                "task-comment-updated": "Commento attività aggiornato",
                "task-comment-deleted": "Commento attività eliminato",
                "task-completed": "Attività completata",
                "task-archived": "Attività archiviata",
                "task-restored": "Attività ripristinata dal cestino",
                "task-unarchived": "Attività ripristinata dall'archivio",
                "chatbot-credit-low": "Credito chatbot basso",
                "chatbot-credit-done": "Credito chatbot esaurito",
                "system-status": "Stato sistema",
                "whatsapp-credit-low": "Credito WhatsApp basso",
                "reservation-created-plan": "Piano prenotazione creato",
                "reservation-updated-plan": "Piano prenotazione aggiornato",
                "reservation-deleted-plan": "Piano prenotazione eliminato",
                "reservation-created": "Prenotazione creata",
                "reservation-updated": "Prenotazione aggiornata",
                "reservation-deleted": "Prenotazione eliminata",
                "white-list-added": "Whitelist aggiunta",
                "white-list-removed": "Whitelist rimossa",
                "site-suspended": "Sito sospeso",
                "site-dead": "Sito disabilitato",
                "site-enabled": "Sito abilitato",
                custom: "Attività personalizzata",
                "auto-rebalance-success": "Ribilanciamento automatico completato",
                "auto-rebalance-failed": "Ribilanciamento automatico fallito",
                "auto-rebalance-disabled": "Ribilanciamento automatico disabilitato",
                "automation-created": "Automazione creata",
                "automation-deleted": "Automazione eliminata",
                "automation-restored": "Automazione ripristinata dal cestino",
                "automation-published": "Automazione pubblicata",
                "automation-unpublished": "Automazione annullata pubblicazione",
                "automation-updated": "Automazione aggiornata",
                "form-created": "Modulo creato",
                "form-updated": "Modulo aggiornato",
                "form-deleted": "Modulo eliminato",
                "form-restored": "Modulo ripristinato dal cestino",
                "form-downloaded": "Dati modulo scaricati",
                "table-created": "Tabella creata",
                "table-deleted": "Tabella eliminata",
                "table-restored": "Tabella ripristinata dal cestino",
                "table-permanently-deleted": "Tabella eliminata definitivamente",
                "table-field-added": "Campo tabella aggiunto",
                "table-field-updated": "Campo tabella aggiornato",
                "table-field-deleted": "Campo tabella eliminato",
                "table-view-added": "Vista tabella aggiunta",
                "table-view-updated": "Vista tabella aggiornata",
                "table-view-deleted": "Vista tabella eliminata",
                "table-page-added": "Pagina tabella aggiunta",
                "table-page-updated": "Pagina tabella aggiornata",
                "table-page-deleted": "Pagina tabella eliminata",
                "table-widget-added": "Widget tabella aggiunto",
                "table-widget-updated": "Widget tabella aggiornato",
                "table-widget-deleted": "Widget tabella eliminato",
                "table-permission-changed": "Permessi tabella modificati",
                "table-data-downloaded": "Dati tabella scaricati",
                "table-data-imported": "Dati tabella importati",
                "table-data-batch-updated": "Dati tabella aggiornati in batch",
                "table-data-batch-deleted": "Dati tabella eliminati in batch",
                "contact-data-downloaded": "Dati contatti scaricati",
                "contact-batch-updated": "Contatti aggiornati in batch",
                "chat-data-downloaded": "Cronologia chat scaricata",
                "voice-agent-created": "Agente vocale creato",
                "voice-agent-updated": "Agente vocale aggiornato",
                "voice-agent-deleted": "Agente vocale eliminato",
                "voice-agent-phone-number-inbound-agent-changed": "Agente chiamate in entrata modificato",
                "voice-agent-phone-number-outbound-agent-changed": "Agente chiamate in uscita modificato",
                "voice-agent-batch-call-created": "Chiamata batch agente vocale creata",
                "voice-agent-knowledge-base-created": "Base conoscenza agente vocale creata",
                "voice-agent-knowledge-base-updated": "Base conoscenza agente vocale aggiornata",
                "drive-folder-created": "Cartella Drive creata",
                "drive-folder-deleted": "Cartella Drive eliminata",
                "drive-folder-renamed": "Cartella Drive rinominata",
                "drive-file-added": "File Drive aggiunto",
                "drive-file-deleted": "File Drive eliminato",
                "task-module-rules-rule-added": "Regola modulo attività aggiunta",
                "task-module-rules-rule-updated": "Regola modulo attività aggiornata",
                "task-module-rules-rule-deleted": "Regola modulo attività eliminata",
                "task-module-rules-rule-enabled": "Regola modulo attività abilitata",
                "task-module-rules-rule-disabled": "Regola modulo attività disabilitata",
                "task-module-rules-enabled": "Regole modulo attività abilitate",
                "task-module-rules-disabled": "Regole modulo attività disabilitate",
                "contact-module-rules-rule-added": "Regola modulo contatto aggiunta",
                "contact-module-rules-rule-updated": "Regola modulo contatto aggiornata",
                "contact-module-rules-rule-deleted": "Regola modulo contatto eliminata",
                "contact-module-rules-rule-enabled": "Regola modulo contatto abilitata",
                "contact-module-rules-rule-disabled": "Regola modulo contatto disabilitata",
                "contact-module-rules-enabled": "Regole modulo contatto abilitate",
                "contact-module-rules-disabled": "Regole modulo contatto disabilitate",
                "module-created": "Modulo creato",
                "module-updated": "Modulo aggiornato",
                "module-deleted": "Modulo eliminato",
                "relation-created": "Relazione creata",
                "relation-updated": "Relazione aggiornata",
                "relation-deleted": "Relazione eliminata",
                "web-app-created": "App web creata",
                "web-app-updated": "App web aggiornata",
                "web-app-deleted": "App web eliminata",
                "web-tab-created": "Scheda web creata",
                "web-tab-updated": "Scheda web aggiornata",
                "web-tab-deleted": "Scheda web eliminata",
                "developer-token-created": "Token sviluppatore creato",
                "developer-token-changed": "Token sviluppatore modificato"
            },
            activityTypeSelect: "Seleziona tipo di attività",
            dateRange: "Intervallo di date",
            startDate: "Data di inizio",
            endDate: "Data di fine",
            reset: "Reimposta",
            filter: "Filtra",
            activeFilters: "Filtri attivi:",
            auditLogsTable: "Log di audit",
            noActivityYet: "Nessuna attività ancora",
            ipAddress: "Indirizzo IP",
            tablePagination: {
                goto: "Vai",
                pagePer: " / pagina",
                total: "Totale",
                prev5: "5 pagine precedenti",
                next5: "5 pagine successive",
                cut: "Taglia",
                copy: "Copia",
                insertRowAbove: "Inserisci riga sopra",
                insertRowBelow: "Inserisci riga sotto",
                removeRow: "rimuovi riga(e)",
                emptyRow: "svuota riga(e)",
                emptyColumn: "svuota colonna(e)",
                emptyCell: "Svuota cella",
                leftFixedColumnTo: "Fissa colonna a sinistra",
                cancelLeftFixedColumnTo: "Annulla fissa colonna a sinistra",
                rightFixedColumnTo: "Fissa colonna a destra",
                cancelRightFixedColumnTo: "Annulla fissa colonna a destra"
            }
        },
        task: {
            taskID: "ID attività",
            completeTask: "Completa attività",
            closedTasks: "Attività chiuse",
            moveToArchive: "Sposta in archivio",
            changeWorkflow: "Sposta in un Altro Flusso di Lavoro",
            selectWorkflow: "Seleziona flusso di lavoro",
            taskNumber: "Compito #",
            priority_lowest: "Minima",
            priority_low: "Bassa",
            priority_medium: "Media",
            priority_high: "Alta",
            priority_highest: "Massima",
            workflowActions: "Azioni del flusso di lavoro",
            workflowTitle: "Titolo del flusso di lavoro",
            deleteTask: "Elimina attività",
            archivingDate: "Data di archiviazione",
            selectOption: "Selezionare un'opzione",
            notAuthorisedCreateTask: "Non siete autorizzati a creare un'attività",
            notAuthorisedCreateTaskDesc: "Non siete autorizzati a eseguire questa attività",
            goToMessage: "Vai al messaggio",
            goToChat: "Vai alla chat",
            showVisitor: "Mostra visitatore",
            closeTheTask: "Chiudi l'attività",
            sureAddCompletedList: "Sei sicuro di voler aggiungere l'attività all'elenco dei completati?",
            success: "Successo",
            successDesc: "Nuovo campo aggiunto con successo",
            moveAndDeleteTask: "Sposta ed elimina le attività",
            justDelete: "Solo eliminazione",
            selectColumnMoveTask: "Selezionare la colonna in cui si desidera spostare le attività",
            todos: "Cose da fare",
            inProgress: "In corso",
            approval: "Approvato",
            addAComment: "Aggiungi un commento...",
            deleteComment: "Sei sicuro di voler eliminare il commento?",
            edited: "Modificato",
            comments: "Commenti",
            addComment: "Aggiungi commento",
            workflow: "Flusso di lavoro",
            workflowDetail: "Dettagli del flusso di lavoro",
            workflowPerm: "Permessi del flusso di lavoro",
            perm: "Permessi",
            detail: "Dettagli",
            userPerm: "Permessi utente",
            deleteCard: "Elimina scheda",
            createCard: "Crea scheda",
            editCard: "Modifica scheda",
            dragCard: "Trascina scheda",
            allWorkflow: "Tutti i flussi di lavoro",
            createworkflow: "Crea flusso di lavoro",
            editDragActive: "Modifica attiva",
            editSortOrder: "Modifica ordine",
            deleteWorkflow: "Sei sicuro di voler eliminare questo flusso di lavoro?",
            permEditTask: "Non hai il permesso di modificare questa attività",
            permEditTaskDes: "Contatta il tuo amministratore per ottenere i permessi di modifica.",
            createTaskError: "Non hai il permesso di creare attività",
            createTaskErrorDesc: "Contatta il tuo amministratore per ottenere i permessi per creare attività.",
            moveTaskError: "Non hai il permesso di cambiare lo stato dell'attività",
            moveTaskErrorDesc: "Contatta il tuo amministratore per ottenere i permessi per cambiare lo stato dell'attività.",
            deleteTaskError: "Non hai il permesso di eliminare attività",
            deleteTaskErrorDesc: "Contatta il tuo amministratore per ottenere i permessi per eliminare attività.",
            permissionError: "Non hai il permesso di creare attività",
            permissionErrorDesc: "Si prega di contattare l'amministratore per ottenere i permessi di creazione delle attività",
            whatsappContactProfileTitle: "Profilo di {name} / {number}",
            createTaskVisitor: "Crea attività (Visitatore)",
            editWorkflow: "Modifica Workflow",
            visitor: "Profilo del visitatore",
            createTaskMessage: "Crea Compito (Messaggio)",
            createStage: "Crea Stage",
            stagesAndStatuses: "Fasi e stati",
            workflowCreateDesc: "Descrizione del flusso di lavoro",
            subTasks: "Sottoattività",
            followers: "Seguaci",
            collaborators: "Collaboratori",
            addRelations: "Aggiungi relazioni",
            relations: "Relazioni",
            main: "Principale",
            name: "Nome",
            completedOfCheck: "{completed} di {total} compiti completati",
            workflowUpdateMs: "Workflow aggiornato con successo",
            taskUpdateMs: "Attività aggiornata con successo",
            workflowCreatedMs: "Workflow creato con successo",
            workflowCreateError: "Impossibile creare il flusso di lavoro",
            taskCreatedMs: "Attività creata con successo",
            settingsDesc3: "Inoltre, il modulo attività di Supsis consente di creare il proprio flusso di lavoro con automazione personalizzabile, consentendo di gestire le attività in modo più efficace e migliorare la collaborazione all'interno del team.",
            settingsDesc4: "In questo modo, puoi monitorare ogni singola tua attività in dettaglio, assegnare compiti ai membri del team e gestire complessivamente i tuoi processi aziendali in modo più efficiente. Il modulo attività di Supsis fornisce una soluzione completa per la gestione delle attività e il coordinamento del team.",
            settingsDesc2: "Il modulo attività di Supsis non lascia nessuna attività trascurata. Puoi filtrare le attività in base a qualsiasi parametro, monitorare i carichi di lavoro per ogni fase del flusso di lavoro e organizzare il tuo calendario per allinearti ai tuoi orari.",
            settingsDesc1: "Il modulo Attività ti consente di organizzare il lavoro collaborativo, delegare compiti e monitorare il progresso del tuo team. Puoi personalizzare le tue attività in base alle tue esigenze selezionando qualsiasi visualizzazione e creare i tuoi flussi di lavoro personalizzati con automazioni.",
            taskModuleSettingsTitle: "Impostazioni del modulo attività",
            high: "Alta",
            medium: "Media",
            low: "Bassa",
            priority: "Priorità",
            addExistsSubtask: "Aggiungi sottoattività esistente",
            addSubtask: "Aggiungi sottoattività",
            add: "Aggiungi",
            newCheckList: "Nuova checklist",
            subtaskTitle: "Titolo della sotto-attività",
            view: "Visualizza",
            attachFiles: "Allega file",
            createTaskDesc: "Descrizione del compito",
            createWorkflow: "Crea un flusso di lavoro",
            editTask: "Modifica attività",
            createTask: "Crea attività",
            deleteColumnCont: "Sei sicuro di voler eliminare questa colonna?",
            changeStage: "Cambia Stage",
            filterBar: {
                searchTasksPlaceholder: "Cerca nelle attività...",
                otherUsers: "Altri utenti",
                searchUserPlaceholder: "Cerca utente...",
                filter: "Filtra",
                clearFilters: "Cancella filtri",
                apply: "Applica",
                prioritySelection: "Selezione priorità attività",
                priorityDescription: "Puoi filtrare le attività per livello di priorità. Seleziona i livelli di priorità che desideri filtrare.",
                aboutPriorityLevels: "Informazioni sui livelli di priorità",
                priorityInfoText: "I livelli di priorità indicano l'importanza delle attività. Le attività ad alta priorità mostrano il lavoro su cui il tuo team dovrebbe concentrarsi per primo, mentre le attività a bassa priorità indicano lavoro meno urgente.",
                userSelection: "Selezione utente",
                assigneesDescription: "Puoi filtrare per utenti assegnati alle attività. Seleziona gli utenti per vedere solo le attività assegnate a loro.",
                unassigned: "Non assegnato",
                ownerSelection: "Selezione proprietario attività",
                ownerDescription: "Puoi filtrare per proprietari delle attività. Seleziona gli utenti per vedere solo le attività che possiedono.",
                searchOwnerPlaceholder: "Cerca proprietario attività...",
                followersSelection: "Selezione follower attività",
                followersDescription: "Puoi filtrare per follower delle attività. Seleziona gli utenti per vedere solo le attività che seguono.",
                searchFollowerPlaceholder: "Cerca follower...",
                creatorSelection: "Selezione creatore attività",
                creatorDescription: "Puoi filtrare per chi ha creato l'attività o il sistema. Seleziona utenti o tipi di sistema per filtrare le attività.",
                createdBySystem: "Creato dal sistema",
                createdByUsers: "Creato dagli utenti",
                searchCreatorPlaceholder: "Cerca utente...",
                filterByCreatedDate: "Filtra per data di creazione",
                today: "Oggi",
                thisWeek: "Questa settimana",
                thisMonth: "Questo mese",
                startDate: "Data di inizio",
                endDate: "Data di fine",
                aboutDateFilter: "Informazioni sul filtro data",
                filterByStartDate: "Filtra per data di inizio",
                filterByEndDate: "Filtra per data di fine",
                overdueTasks: "Attività scadute",
                showOverdueTasks: "Mostra attività scadute",
                importantInfo: "Informazione importante",
                filterByUpdateDate: "Filtra per data di aggiornamento",
                taskTags: "Tag attività",
                searchTagPlaceholder: "Cerca tag...",
                tagsLoading: "Caricamento tag...",
                noTagsMatchingSearch: "Nessun tag corrisponde ai criteri di ricerca.",
                noTagsCreated: "Nessun tag creato ancora.",
                aboutTags: "Informazioni sui tag",
                pipelineSelection: "Selezione stato pipeline",
                searchPipelinePlaceholder: "Cerca pipeline...",
                order: "Ordine",
                pipelinesLoading: "Caricamento pipeline...",
                noPipelinesMatchingSearch: "Nessuna pipeline corrisponde ai criteri di ricerca.",
                noPipelinesCreated: "Nessuna pipeline creata ancora.",
                aboutPipelines: "Informazioni sulle pipeline",
                selected: "selezionato",
                closeTask: "Chiudi attività",
                tabPriorities: "Priorità",
                tabOwners: "Proprietario attività",
                tabFollowers: "Follower attività",
                tabCreatedBy: "Creatore",
                tabCreatedDate: "Data di creazione",
                tabUpdateDate: "Data di aggiornamento",
                tabStartDate: "Data di inizio",
                tabEndDate: "Data di fine",
                tabTags: "Tag",
                tabOverdue: "Attività scadute",
                tabStatus: "Stato",
                tabSortBy: "Ordina per",
                sortBySelection: "Selezione ordinamento",
                sortByDescription: "Scegli l'ordine in cui le attività vengono elencate. Le attività più recenti appaiono per prime.",
                sortByCreatedAt: "Per data di creazione",
                sortByCreatedAtDescription: "Le attività sono ordinate dalla più recente alla più vecchia per data di creazione.",
                sortByUpdatedAt: "Per data di aggiornamento",
                sortByUpdatedAtDescription: "Le attività sono ordinate dall'ultima aggiornata alla più vecchia.",
                sortByEndDate: "Per data di scadenza",
                sortByEndDateDescription: "Le attività sono ordinate per data di scadenza dalla più vicina alla più lontana.",
                aboutSortBy: "Informazioni sull'ordinamento",
                sortByInfoText: "Senza ordinamento selezionato, la vista Kanban usa l'ordine trascina e rilascia, la vista elenco usa la data di creazione.",
                priorityLowest: "Priorità più bassa",
                priorityLow: "Priorità bassa",
                priorityMedium: "Priorità media",
                priorityHigh: "Priorità alta",
                priorityHighest: "Priorità più alta",
                createdByApi: "Attività create da API",
                createdByChatbot: "Attività create da Chatbot",
                createdByAutomation: "Attività create da Automazione",
                dateRangeCreatedDescription: "Imposta le date di inizio e fine per filtrare le attività create nell'intervallo di date selezionato. Questo filtro filtra le attività per data di creazione (createdAt).",
                dateInfoCreatedText: "Il filtro data limita i risultati per data di creazione delle attività. In questo modo puoi facilmente trovare attività create in un periodo di tempo specifico.",
                dateRangeStartDescription: "Imposta la data di inizio per filtrare le attività create nell'intervallo di date selezionato. Questo filtro filtra le attività per data di inizio (startDate).",
                dateInfoStartText: "Il filtro data limita i risultati per data di inizio delle attività. In questo modo puoi facilmente trovare attività che inizieranno in un periodo di tempo specifico.",
                dateRangeEndDescription: "Imposta la data di fine per filtrare le attività create nell'intervallo di date selezionato. Questo filtro filtra le attività per data di fine (endDate).",
                dateInfoEndText: "Il filtro data limita i risultati per data di fine delle attività. In questo modo puoi facilmente trovare attività che termineranno in un periodo di tempo specifico.",
                dateRangeUpdateDescription: "Imposta le date di inizio e fine per filtrare le attività aggiornate nell'intervallo di date selezionato. Questo filtro filtra le attività per data di aggiornamento (updatedAt).",
                dateInfoUpdateText: "Il filtro data limita i risultati per ultima data di aggiornamento delle attività. In questo modo puoi facilmente trovare attività aggiornate in un periodo di tempo specifico.",
                overdueDescription: "Puoi filtrare le attività la cui data di scadenza è passata e sono ancora incomplete. Quando questo filtro è attivo, verranno visualizzate solo le attività scadute.",
                overdueDetail: "Le attività la cui data di scadenza è passata e sono ancora incomplete verranno visualizzate quando questo filtro è attivo. Queste attività sono generalmente quelle che il tuo team deve affrontare il prima possibile.",
                overdueInfoText: "Le attività scadute sono attività la cui data di scadenza è passata ma non sono ancora completate. Queste attività indicano lavoro importante a cui il tuo team deve prestare attenzione.",
                tagsDescription: "Puoi filtrare le attività per i loro tag. Verranno visualizzate le attività con i tag che selezioni.",
                tagsInfoText: "I tag ti aiutano a categorizzare le attività e trovarle più facilmente. Se selezioni più tag, verranno visualizzate le attività con uno qualsiasi dei tag selezionati.",
                pipelineDescription: "Puoi filtrare le attività per stato della pipeline. Selezionando le pipeline desiderate, puoi vedere solo le attività in quelle fasi.",
                pipelinesInfoText: "Le pipeline mostrano in quale fase si trovano le attività. Se selezioni più pipeline, verranno visualizzate le attività in una qualsiasi delle pipeline selezionate."
            },
            assignees: "Assegnatari",
            owner: "Proprietario",
            stage: "Fase",
            writeSomething: "Scrivi qualcosa",
            selectAssginee: "Seleziona assegnatario",
            assignee: "Assegnatario",
            enterNewTaskDesc: "Inserisci la descrizione del nuovo compito",
            enterNewTaskTitle: "Inserisci il titolo del nuovo compito",
            task: "Compito",
            deleteTaskCont: "Sei sicuro di voler eliminare questi compiti?",
            deleteWorkFlowCont: "Sei sicuro di voler eliminare questo flusso di lavoro?",
            completed: "Completato",
            todo: "Da fare",
            kanbanBoard: "Bacheca Kanban",
            listView: "Visualizzazione elenco",
            taskNotifications: "Notifiche attività",
            reports: "Rapporti",
            workflowSettings: "Impostazioni flusso di lavoro",
            trashBin: "Cestino",
            taskReports: {
                title: "Report attività",
                selectWorkflow: "Seleziona flusso di lavoro",
                filters: "Filtri",
                clear: "Cancella",
                dateRange: "Intervallo dati:",
                dateRangePlaceholder: "Inizio - Fine",
                assignees: "Assegnatari:",
                selectUser: "Seleziona utente",
                unassigned: "Non assegnato",
                priority: "Priorità:",
                selectPriority: "Seleziona priorità",
                emptyTitle: "Seleziona flusso di lavoro per visualizzare i report",
                emptyDescription: "Seleziona un flusso di lavoro dall'alto per visualizzare i report delle attività.",
                loadingTitle: "Preparazione report",
                loadingSubtitle: "Analisi dei dati delle attività...",
                tasksClosed: "attività chiuse",
                tasksUpdated: "attività aggiornate",
                tasksCreated: "attività create",
                upcomingDeadlines: "Scadenze imminenti",
                statusOverview: "Panoramica stato",
                statusOverviewSubtitle: "Visualizza lo stato dei tuoi ticket in un colpo d'occhio.",
                totalTickets: "Totale ticket",
                priorityDistribution: "Distribuzione priorità",
                teamWorkload: "Carico di lavoro del team",
                tooltipTasks: "{name}: {count} attività ({percentage}%)",
                errorTitle: "Errore nel caricamento del report",
                retry: "Riprova",
                last7Days: "Ultimi 7 giorni",
                dateRangeIn: "tra {start} - {end}",
                upcomingCount: "{count} elementi hanno scadenze imminenti (prossimi 7 giorni)",
                upcomingCountZero: "0 elementi hanno scadenze imminenti (prossimi 7 giorni)",
                upcomingInRange: "{count} elementi hanno scadenze ({start} - {end})",
                upcomingInRangeZero: "0 elementi hanno scadenze ({start} - {end})",
                invalidWorkflowId: "Formato ID flusso di lavoro non valido: {id}",
                loadSuccess: "Dati del report caricati con successo.",
                unknownError: "Si è verificato un errore sconosciuto",
                error: "Errore"
            },
            taskNotification: {
                title: "Impostazioni notifiche attività",
                description: "Puoi gestire le impostazioni delle notifiche delle attività da qui."
            },
            workflowSandbox: {
                title: "Flussi di lavoro eliminati",
                description: "I flussi di lavoro non utilizzati per 30 giorni vengono eliminati automaticamente dal sistema",
                emptyState: "Nessun flusso di lavoro eliminato nel cestino",
                unnamedWorkflow: "Flusso di lavoro senza nome",
                restore: "Ripristina",
                permanentlyDelete: "Elimina definitivamente",
                unknown: "Sconosciuto",
                user: "Utente",
                restoreConfirmTitle: "Sei sicuro di voler ripristinare questo flusso di lavoro?",
                restoreConfirmContent: "Il flusso di lavoro {title} verrà ripristinato.",
                restoreSuccess: "Flusso di lavoro ripristinato con successo",
                restoreFailed: "Ripristino fallito",
                deleteConfirmTitle: "Sei sicuro di voler eliminare definitivamente questo flusso di lavoro?",
                deleteConfirmContent: "Il flusso di lavoro {title} verrà eliminato definitivamente. Questa azione non può essere annullata.",
                deleteOkText: "Sì, elimina definitivamente",
                cancel: "Annulla",
                deleteSuccess: "Flusso di lavoro eliminato definitivamente",
                deleteFailed: "Eliminazione definitiva fallita",
                loadError: "Errore nel caricamento dei flussi di lavoro eliminati"
            },
            notAuthorizedCreateTask: "Non sei autorizzato a creare un'attività",
            notAuthorizedCreateTaskDesc: "Non sei autorizzato a eseguire questa attività.",
            taskDesc: "Descrizione attività",
            title: "Titolo",
            archiveAndTrash: "Archivio e cestino",
            trash: "Cestino",
            loading: "Caricamento...",
            startDate: "Data di inizio",
            endDate: "Data di fine",
            clearFilter: "Cancella filtro",
            noArchivedTasks: "Nessuna attività archiviata trovata",
            noDeletedTasks: "Nessuna attività trovata nel cestino",
            total: "Totale",
            error: "Errore",
            moveToBoard: "Sposta in bacheca",
            unarchive: "Ripristina dall'archivio",
            taskMovedToBoard: "Attività spostata nella bacheca",
            taskMoveError: "Errore durante lo spostamento dell'attività nella bacheca",
            taskDeleted: "Attività eliminata",
            taskDeleteError: "Errore durante l'eliminazione dell'attività",
            taskUnarchived: "Attività ripristinata dall'archivio",
            taskUnarchiveError: "Errore durante il ripristino dell'attività dall'archivio",
            aprobado: "Approvato",
            kanbanSettings: {
                cancel: "Annulla",
                card: "Impostazioni scheda",
                column: "Impostazioni colonna",
                kanban: "Impostazioni Kanban",
                save: "Salva",
                selectField: "Seleziona campo",
                selectFieldPlaceholder: "Seleziona campo",
                selectFields: "Seleziona i campi da mostrare nella scheda",
                title: "Impostazioni"
            }
        },
        permissionErrors: {
            userCreate: "Non hai il permesso di aggiungere utenti. Si prega di consultare l'amministratore.",
            userRead: "Non hai il permesso di visualizzare gli utenti. Si prega di consultare l'amministratore.",
            userUpdate: "Non hai il permesso di aggiornare gli utenti. Si prega di consultare l'amministratore.",
            userDelete: "Non hai il permesso di eliminare gli utenti. Si prega di consultare l'amministratore.",
            visitorBlock: "Non hai il permesso di bloccare i visitatori. Si prega di consultare l'amministratore.",
            visitorUnblock: "Non hai il permesso di sbloccare i visitatori. Si prega di consultare l'amministratore.",
            visitorDetailRead: "Non hai il permesso di visualizzare i dettagli dei visitatori. Si prega di consultare l'amministratore.",
            visitorListRead: "Non hai il permesso di visualizzare l'elenco dei visitatori. Si prega di consultare l'amministratore.",
            visitorDelete: "Non hai il permesso di eliminare i visitatori. Si prega di consultare l'amministratore.",
            visitorExcel: "Non hai il permesso di ottenere l'output Excel. Si prega di consultare l'amministratore.",
            visitorUpdate: "Non hai il permesso di aggiornare i visitatori. Si prega di consultare l'amministratore.",
            bannedVisitorRead: "Non hai il permesso di visualizzare l'elenco dei visitatori bannati. Si prega di consultare l'amministratore.",
            bannedWordCreate: "Non hai il permesso di aggiungere parole bannate. Si prega di consultare l'amministratore.",
            bannedWordRead: "Non hai il permesso di visualizzare le parole bannate. Si prega di consultare l'amministratore.",
            bannedWordDelete: "Non hai il permesso di eliminare le parole bannate. Si prega di consultare l'amministratore.",
            chatRead: "Non hai il permesso di visualizzare le chat. Si prega di consultare l'amministratore.",
            chatUpdate: "Non hai il permesso di modificare le chat. Si prega di consultare l'amministratore.",
            archiveRead: "Non hai il permesso di visualizzare gli archivi. Si prega di consultare l'amministratore.",
            roleCreate: "Non hai il permesso di aggiungere ruoli. Si prega di consultare l'amministratore.",
            roleRead: "Non hai il permesso di visualizzare i ruoli. Si prega di consultare l'amministratore.",
            roleUpdate: "Non hai il permesso di aggiornare i ruoli. Si prega di consultare l'amministratore.",
            roleDelete: "Non hai il permesso di eliminare i ruoli. Si prega di consultare l'amministratore.",
            departmentCreate: "Non hai il permesso di aggiungere dipartimenti. Si prega di consultare l'amministratore.",
            departmentRead: "Non hai il permesso di visualizzare i dipartimenti. Si prega di consultare l'amministratore.",
            departmentUpdate: "Non hai il permesso di aggiornare i dipartimenti. Si prega di consultare l'amministratore.",
            departmentDelete: "Non hai il permesso di eliminare i dipartimenti. Si prega di consultare l'amministratore.",
            preparedContentCreate: "Non hai il permesso di creare contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentRead: "Non hai il permesso di visualizzare i contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentUpdate: "Non hai il permesso di aggiornare i contenuti preparati. Si prega di consultare l'amministratore.",
            preparedContentDelete: "Non hai il permesso di eliminare i contenuti preparati. Si prega di consultare l'amministratore.",
            welcomeCreate: "Non hai il permesso di creare messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeRead: "Non hai il permesso di visualizzare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeUpdate: "Non hai il permesso di aggiornare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            welcomeDelete: "Non hai il permesso di eliminare i messaggi di benvenuto. Si prega di consultare l'amministratore.",
            settingCreate: "Non hai il permesso di creare impostazioni. Si prega di contattare l'amministratore.",
            settingRead: "Non hai il permesso di visualizzare le impostazioni. Si prega di contattare l'amministratore.",
            settingUpdate: "Non hai il permesso di aggiornare le impostazioni. Si prega di contattare l'amministratore.",
            settingDelete: "Non hai il permesso di eliminare le impostazioni. Si prega di contattare l'amministratore.",
            reportCreate: "Non hai il permesso di creare rapporti. Si prega di contattare l'amministratore.",
            reportRead: "Non hai il permesso di visualizzare i rapporti. Si prega di contattare l'amministratore.",
            reportUpdate: "Non hai il permesso di aggiornare i rapporti. Si prega di contattare l'amministratore.",
            reportDelete: "Non hai il permesso di eliminare i rapporti. Si prega di contattare l'amministratore.",
            offlineSupportRequestCreate: "Non hai il permesso di creare richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestRead: "Non hai il permesso di visualizzare le richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestUpdate: "Non hai il permesso di rispondere alle richieste di supporto offline. Si prega di contattare l'amministratore.",
            offlineSupportRequestDelete: "Non hai il permesso di eliminare le richieste di supporto offline. Si prega di contattare l'amministratore.",
            catalogCreate: "Non hai il permesso di creare cataloghi. Si prega di contattare l'amministratore.",
            catalogRead: "Non hai il permesso di visualizzare il catalogo. Si prega di contattare l'amministratore.",
            catalogUpdate: "Non hai il permesso di aggiornare il catalogo. Si prega di contattare l'amministratore.",
            catalogDelete: "Non hai il permesso di eliminare il catalogo. Si prega di contattare l'amministratore.",
            chatbotStoryCreate: "Non hai il permesso di creare storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryRead: "Non hai il permesso di visualizzare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryUpdate: "Non hai il permesso di aggiornare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotStoryDelete: "Non hai il permesso di eliminare le storie del chatbot. Si prega di contattare l'amministratore.",
            chatbotTemplateRead: "Non hai il permesso di visualizzare i modelli del chatbot. Si prega di contattare l'amministratore.",
            chatbotTemplateAiRead: "Non hai il permesso di visualizzare i modelli di IA del chatbot. Si prega di contattare l'amministratore.",
            chatbotIntegrationsRead: "Non hai il permesso di visualizzare le integrazioni del chatbot. Si prega di contattare l'amministratore.",
            chatbotArchiveRead: "Non hai il permesso di visualizzare l'archivio del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesRead: "Non hai il permesso di visualizzare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesCreate: "Non hai il permesso di creare entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesUpdate: "Non hai il permesso di aggiornare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotEntitiesDelete: "Non hai il permesso di eliminare le entità del chatbot. Si prega di contattare l'amministratore.",
            chatbotReportRead: "Non hai il permesso di visualizzare i report del chatbot. Contatta il tuo amministratore.",
            chatbotTrainRead: "Non hai il permesso di visualizzare la formazione del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentCreate: "Non hai il permesso di creare segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentRead: "Non hai il permesso di visualizzare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentUpdate: "Non hai il permesso di aggiornare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            chatbotSegmentDelete: "Non hai il permesso di eliminare i segmenti utente del chatbot. Contatta il tuo amministratore.",
            integrationsRead: "Non hai il permesso di visualizzare la pagina delle integrazioni. Contatta il tuo amministratore.",
            whatsappIntegrationRead: "Non hai il permesso di visualizzare la pagina di integrazione di WhatsApp. Contatta il tuo amministratore.",
            instagramIntegrationRead: "Non hai il permesso di visualizzare la pagina di integrazione di Instagram. Contatta il tuo amministratore.",
            telegramIntegrationRead: "Non hai il permesso di visualizzare la pagina di integrazione di Telegram. Contatta il tuo amministratore.",
            integrationCreate: "Non hai il permesso di attivare le integrazioni. Contatta il tuo amministratore.",
            triggerCreate: "Non hai il permesso di creare trigger. Contatta il tuo amministratore.",
            triggerRead: "Non hai il permesso di visualizzare i trigger. Contatta il tuo amministratore.",
            triggerUpdate: "Non hai il permesso di aggiornare i trigger. Contatta il tuo amministratore.",
            triggerDelete: "Non hai il permesso di eliminare i trigger. Contatta il tuo amministratore.",
            billingRead: "Non hai il permesso di visualizzare le fatture. Si prega di contattare l'amministratore.",
            taskCreate: "Non hai il permesso di creare attività. Si prega di contattare l'amministratore.",
            taskRead: "Non hai il permesso di visualizzare le attività. Si prega di contattare l'amministratore.",
            taskUpdate: "Non hai il permesso di aggiornare le attività. Si prega di contattare l'amministratore.",
            taskDelete: "Non hai il permesso di eliminare le attività. Si prega di contattare l'amministratore.",
            calendarCreate: "Non hai il permesso di creare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarRead: "Non hai il permesso di visualizzare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarUpdate: "Non hai il permesso di aggiornare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            calendarDelete: "Non hai il permesso di eliminare calendari/prenotazioni. Si prega di contattare l'amministratore.",
            mailCreate: "Non hai il permesso di creare e-mail. Si prega di contattare l'amministratore.",
            mailRead: "Non hai il permesso di visualizzare le e-mail. Si prega di contattare l'amministratore.",
            mailUpdate: "Non hai il permesso di aggiornare le e-mail. Si prega di contattare l'amministratore.",
            mailDelete: "Non hai il permesso di eliminare le e-mail. Si prega di contattare l'amministratore."
        },
        message: {
            artificialIntelligence: "Intelligenza artificiale",
            appBreadcrumb: {
                tasks: "Attività",
                broadcastLabel: "Messaggio broadcast",
                walletBalanceTooltip: "Saldo del tuo portafoglio: {amount}₺",
                broadcastStatusCreated: "Creato",
                broadcastStatusScheduled: "Programmato",
                broadcastStatusQueued: "In coda",
                broadcastStatusRunning: "Invio in corso",
                broadcastStatus: "Stato",
                broadcastProgress: "Progresso"
            },
            confirmDeleteRedStationIntegration: "Sei sicuro di voler eliminare questo canale Centralino Rosso?",
            enterRedStationIntegration: "Inserisci le tue credenziali API Centralino Rosso",
            redStationIntegration: "Integrazione Centralino Rosso",
            copyChannelID: "Copia ID Canale",
            redStationChannels: "Canali Centralino Rosso",
            bannedUserError: "Si è verificato un errore durante l'aggiunta del ban.",
            bannedUserSuccess: "Ban aggiunto con successo.",
            selectAtLeastOneOption: "Per favore seleziona almeno un'opzione.",
            enterValidValue: "Per favore inserisci un valore valido.",
            enterValidIpAddress: "Per favore inserisci un indirizzo IP valido.",
            enterValidVisitorId: "Per favore inserisci un ID visitatore valido.",
            enterValidWhatsappNumber: "Per favore inserisci un numero WhatsApp valido.",
            invalidEmailAddress: "Per favore inserisci un indirizzo email valido.",
            bannedUser: "Bannato",
            unbannedUser: "Non Bannato",
            banModalDescription: "Inserisci piattaforma e valore per bannare l'utente.",
            exampleNumber: "Numero di esempio: 905551111111",
            clearSelectedFiltersTooltip: "Pulisce i valori dei filtri selezionati nella pagina",
            minutesText: "{count} minuti",
            secondsText: "{count} secondi",
            downloadCooldownWarning: "Per favore attendi {time} per creare una nuova richiesta di download.",
            excelExportReceiveQuestion: "Come vorresti ricevere il file Excel?",
            sendToMe: "Invia a Me",
            sendToSomeoneElse: "Invia a Qualcun Altro",
            enterEmailAddress: "Inserisci indirizzo email",
            exportRequestSuccess: "La tua richiesta è stata creata, te la invieremo via email il prima possibile",
            maxDateRangeWarning: "L'intervallo di date selezionato può essere al massimo di 45 giorni",
            ticketOnlyMail: "Questa richiesta può essere risposta solo via e-mail. I messaggi inviati tramite WhatsApp non possono essere inoltrati.",
            cardInfoUpdateError: "Si è verificato un errore durante l'aggiornamento delle informazioni della carta",
            billingInfoSavedSuccessfully: "Le tue informazioni di fatturazione sono state salvate con successo",
            billingInfoSaveError: "Errore durante il salvataggio delle informazioni di fatturazione:",
            paymentInfoSavedSuccessfully: "Le tue informazioni di pagamento sono state salvate con successo",
            annualDiscount: "Ottieni uno sconto del 20% sugli acquisti annuali",
            annualDiscountDescription: "Puoi risparmiare significativamente scegliendo un abbonamento annuale.",
            payOnlyForUsedFeatures: "Paga solo per ciò che usi",
            payOnlyForUsedFeaturesDescription: "Paga solo per le funzionalità che utilizzi, non pagare per più.",
            cancelAnytime: "Annulla in qualsiasi momento",
            cancelAnytimeDescription: "Non sono necessari contratti a lungo termine, puoi annullare quando vuoi.",
            noPermissionDescription: "Non hai il permesso di eseguire questa azione.",
            creditCardRequired: "Informazioni Carta di Credito Richieste",
            creditCardRequiredDescription: "Hai abbonamenti a pagamento. Puoi continuare inserendo le informazioni della tua carta di credito o annullando i tuoi abbonamenti.",
            creditCardRequiredDescription2: "Devi inserire le informazioni della carta di credito perché hai abbonamenti a pagamento nel tuo account.",
            subscriptionManagement: "Gestione Abbonamenti",
            addCreditCard: "Aggiungi Informazioni Carta di Credito",
            transferOwnership: "Trasferisci Proprietà e Reindirizza",
            errorLoadingAgents: "Si è verificato un errore durante il caricamento degli agenti",
            pleaseFillRequiredFields: "Si prega di compilare i campi obbligatori",
            callStartedSuccessfully: "Chiamata avviata con successo",
            errorStartingCall: "Si è verificato un errore durante l'avvio della chiamata",
            errorLoadingData: "Si è verificato un errore durante il caricamento dei dati",
            errorLoadingDataPhoneNumbers: "Si è verificato un errore durante il caricamento dei numeri di telefono",
            noVariablesFound: "Nessuna variabile trovata nel prompt. Le variabili devono essere nel formato <code v-pre>{{ nome_variabile }}</code>.",
            aiVoiceAgentSpecialVariables: "Valori delle Variabili Speciali",
            addAiVoiceAgentChannel: "Aggiungi Canale",
            multiLanguageSupport: "Supporto multilingue",
            customerService247: "Servizio clienti 24/7",
            autoCallAnswer: "Risposta automatica alle chiamate",
            aiVoiceAgentChannelRequired: "Canale Agente Vocale IA Richiesto",
            aiVoiceAgentChannelRequiredDescription: "È necessario aggiungere un canale Agente Vocale IA per utilizzare questa funzionalità.",
            aiVoiceAgentChannelRequiredDescription2: "L'Agente Vocale IA è un assistente basato sull'intelligenza artificiale che può effettuare chiamate telefoniche con i tuoi clienti.",
            startCall: "Avvia Chiamata",
            selectContactFieldPlaceholder: "Seleziona informazioni di contatto",
            aiVoiceAgentVariableValuePlaceholder: "Inserisci valore",
            aiVoiceAgentVariables: "Informazioni sulle Variabili dell'Agente",
            aiVoiceAgentVariableManual: "Manuale",
            aiVoiceAgentVariableContact: "Informazioni di Contatto",
            toNumberHelpText: "Deve essere in formato E.164. Esempio: +905321234567",
            toNumber: "Numero da Chiamare",
            selectAiVoiceAgentHelpText: "Se non selezionato, verrà utilizzato l'agente in uscita predefinito del numero",
            selectAiVoiceAgent: "Seleziona agente (opzionale)",
            aiVoiceAgent: "Agente",
            selectFromNumber: "Seleziona numero chiamante",
            fromNumber: "Numero Chiamante",
            startAiCall: "Avvia Chiamata con Agente Vocale IA",
            aiCall: "Effettua Chiamata con Agente Vocale IA",
            groupByNone: "Nessun raggruppamento applicato",
            groupByAgent: "Raggruppa contatti per gli agenti della loro ultima sessione",
            groupByDepartment: "Raggruppa contatti per il dipartimento selezionato nella loro ultima sessione",
            groupByChannel: "Raggruppa contatti per il canale da cui provengono",
            groupByPlatform: "Raggruppa contatti per la piattaforma da cui provengono",
            groupByWebsite: "Raggruppa contatti per il sito web da cui provengono",
            groupByTag: "Raggruppa contatti per i loro tag",
            groupByAnswerStatus: "Raggruppa contatti per il loro stato di risposta della loro ultima sessione",
            groupByOwner: "Raggruppa contatti per i loro proprietari",
            changeGroupBy: "Cambia Modalità di Raggruppamento",
            changeSortMode: "Cambia Modalità di Ordinamento",
            selectIcon: "Seleziona Icona",
            iconPickerTitle: "Selettore di Icone",
            searchIconPlaceholder: "Cerca icona...",
            profileFieldsDescriptionChat: "Clicca per personalizzare i tuoi campi profilo",
            createCommentSuccess: "Commento creato con successo",
            createCommentError: "Si è verificato un errore durante la creazione del commento",
            updateCommentSuccess: "Commento aggiornato con successo",
            updateCommentError: "Si è verificato un errore durante l'aggiornamento del commento",
            deleteCommentSuccess: "Commento eliminato con successo",
            deleteCommentError: "Si è verificato un errore durante l'eliminazione del commento",
            formSubmission: "Invio del modulo",
            selectForm: "Seleziona modulo",
            updateOwnerUsers: "Aggiorna proprietari",
            updateOwnerUsersDesc: "Vuoi aggiornare i proprietari di questo utente? Puoi trasferirli a un altro utente o lasciarli senza proprietario.",
            deposit: "Dépôt",
            creditUsage: "Utilisation du crédit",
            businessMarketing: "Marketing",
            businessUtility: "Utilité",
            businessAuthentication: "Authentification",
            businessService: "Service",
            incomingSessionMessage: "Messaggio in entrata",
            outgoingSessionMessage: "Messaggio in uscita",
            freeTierConversation: "Conversation gratuite (FTC)",
            chatStart: "Démarrer le chat",
            wpMessage: "Messaggio di massa Whatsapp QR",
            pin: "Fissare",
            rename: "Rinomina",
            browserSpeechRecognitionNotSupported: "Il tuo browser non supporta il riconoscimento vocale. Si consiglia di utilizzare il browser Chrome.",
            spaceKeyReleaseToSave: "Sarà salvato quando rilasci il tasto spazio",
            spaceKeyHint: "Puoi parlare tenendo premuto il tasto spazio",
            listeningInProgress: "Ascoltando...",
            speakNow: "Parla ora...",
            toggleAllPermissions: "Attiva/Disattiva tutti i permessi del ruolo",
            rolePermissions: "Permessi del ruolo",
            roleSaved: "Ruolo salvato",
            creatingRole: "Creazione del ruolo...",
            savingRole: "Salvataggio del ruolo...",
            editRole: "Modifica ruolo",
            newRoleCreate: "Crea un nuovo ruolo",
            descriptionEmail: "Aggiunge automaticamente l'indirizzo email del visitatore nella chat alla casella del messaggio e consente di inviarlo",
            exampleEmail: "Esempio: @email ciao",
            nameDescription: "Aggiunge automaticamente il nome del visitatore nella chat alla casella del messaggio e consente di inviarlo",
            exampleName: "Esempio: @name ciao",
            pmDescription: "Consente di inviare un messaggio privato. Solo gli altri rappresentanti del servizio clienti possono vedere questi messaggi, i visitatori non possono.",
            examplePm: "Esempio: pm: Questo messaggio è privato",
            chatShortcuts: "Scorciatoie Chat",
            showSystemStatus: "Mostra Stato Sistema",
            endChatWizard: "Procedura guidata di terminazione della chat",
            terminationError: "Errore di terminazione",
            profileFieldsUpdateError: "Si è verificato un errore durante l'aggiornamento dei campi del profilo",
            profileFieldsUpdated: "Campi del profilo aggiornati",
            aiSuggestionError: "Le suggerimenti IA non possono essere recuperati",
            profileFieldsDescription: "Puoi compilare i campi del profilo personalizzati per questa persona per fornire più informazioni al tuo team.",
            categoryTags: "Puoi aggiungere etichette a questa persona per classificarla rapidamente.",
            manageTags: "Gestione etichette",
            enterNote: "Inserisci nota",
            noteDescription: "Puoi aggiungere note su questa persona. Queste note saranno visibili anche dopo la conversazione.",
            suggestedProfileFields: "Campi del profilo suggeriti:",
            suggestedTags: "Tag suggeriti",
            suggestedNote: "Nota suggerita:",
            applyAll: "Applica tutto",
            aiSuggestionTitle: "Suggerimenti di intelligenza artificiale",
            aiSuggestion: "Supsis Asistan Suggerimenti",
            searchItem: "Cerca elemento",
            makeSelection: "Fai una Selezione",
            channel: "Canale",
            taskClosingDate: "Data di Chiusura Attività",
            deleteOperation: "Operazione di Eliminazione",
            confirmDeleteTask: "Sei sicuro di voler eliminare questa attività?",
            taskDeletedSuccess: "Attività eliminata con successo",
            taskDeleteError: "Errore durante l'eliminazione dell'attività",
            selectColumns: "Seleziona le Colonne che Vuoi Vedere nella Tabella",
            linkedinChannels: "Canali LinkedIn",
            updateLinkedinChannelDesc: "Aggiorna il tuo canale LinkedIn",
            deleteLinkedinChannel: "Elimina Canale LinkedIn",
            confirmDeleteLinkedinChannel: "Sei sicuro di voler eliminare questo canale LinkedIn?",
            contactIdPlaceholder: "ID contatto",
            contactId: "ID contatto",
            enterOwnerId: "Inserisci ID proprietario",
            selectOwner: "Seleziona proprietario",
            dynamic: "Dinamico",
            owner: "Proprietario",
            addCollaborator: "Aggiungi collaboratore",
            dynamicValue: "Valore dinamico",
            selectCollaborator: "Seleziona collaboratore",
            collaborator: "Collaboratore",
            collaborators: "Collaboratori",
            addFollower: "Aggiungi follower",
            selectFollower: "Seleziona follower",
            followers: "Follower",
            follower: "Follower",
            addAssignee: "Aggiungi assegnatario",
            selectUser: "Seleziona utente",
            assignees: "Assegnatari",
            assignee: "Assegnatario",
            pipelineStage: "Fase pipeline",
            selectPipelineStage: "Seleziona fase pipeline",
            title: "Titolo",
            taskTitle: "Titolo attività",
            description: "Descrizione",
            taskDescription: "Descrizione attività",
            selectPriority: "Seleziona priorità",
            workflow: "Flusso di lavoro",
            selectWorkflow: "Seleziona flusso di lavoro",
            packagePurchase: "Acquisto pacchetto",
            upcomingInvoice: "Fattura in arrivo",
            invoiceUpdated: "Fattura aggiornata",
            invoiceMarkedInvalid: "Fattura contrassegnata come non valida.",
            invoiceUpdateError: "Errore aggiornamento fattura",
            invoiceMarkInvalidError: "Si è verificato un errore durante il contrassegno della fattura come non valida.",
            refunded: "Rimborsato",
            paid: "Pagato",
            pending: "In attesa",
            unpaid: "Non pagato",
            paymentFailed: "Pagamento fallito",
            paymentProcessError: "Si è verificato un errore durante il processo di pagamento.",
            paymentSuccessful: "Pagamento riuscito",
            paymentProcessSuccessful: "Il processo di pagamento è stato completato con successo.",
            invoiceRefund: "Rimborso fattura",
            invoiceRefundedSuccessfully: "La fattura è stata rimborsata con successo.",
            invoicePaymentError: "Errore pagamento fattura",
            invoicePaymentProcessError: "Si è verificato un errore durante il processo di pagamento della fattura.",
            invoicePaid: "Fattura pagata",
            invoiceMarkedAsPaid: "La fattura è stata contrassegnata come pagata con successo.",
            invoicePriceUpdateError: "Si è verificato un errore durante l'aggiornamento del prezzo della fattura.",
            invoicePriceUpdatedSuccessfully: "Il prezzo della fattura è stato aggiornato con successo.",
            invoicePdf: "Fattura PDF",
            viewInvoice: "Visualizza fattura",
            makePayment: "Effettua pagamento",
            autoForwardToOwnerForceDescription: "In tutti i casi, i contatti posseduti vengono automaticamente inoltrati al loro proprietario. Non vengono né mantenuti in coda né trasferiti al chatbot. Anche se questa impostazione è disattivata, se il chatbot non è attivo nel sistema, verranno comunque inoltrati al loro proprietario.",
            autoForwardToOwnerForce: "Inoltro automatico al proprietario (anche con chatbot attivo)",
            cancelPlanTitle: "Annulla il piano",
            cancelPlanDescription: "Dopo aver annullato il piano, il pacchetto potrà essere utilizzato fino alla fine del periodo di validità.",
            voteSuccess: "Voto salvato con successo",
            voteSuccessDescription: "È stata ricevuta la richiesta di aggiungere l'integrazione {integrationName} a Supsis.",
            companyName: "Nome dell'azienda",
            company: "Azienda",
            languageTitle1: "Lingua predefinita del pannello",
            languageTitle2: "Lingua predefinita della messaggistica",
            languageTitle3: "Regione e fuso orario",
            languageTitle4: "Impostazione automatica della lingua del cliente",
            languageTitle5: "Selezione della lingua di messaggistica del cliente in WebChat",
            languageDesc1: "Imposta la lingua del pannello Supsis AI",
            languageDesc2: "Puoi cambiare la lingua di messaggistica predefinita da qui.",
            languageDesc3: "Imposta la regione e il fuso orario",
            languageDesc4: "Consente il rilevamento automatico della lingua di messaggistica del cliente con supporto AI.",
            languageDesc5: "Attiva la funzione che consente al cliente di selezionare la propria lingua parlata nel canale WebChat.",
            featuresTitle1: "Selezione del dipartimento",
            featuresTitle2: "Mostra il numero di clienti in attesa",
            featuresTitle3: "Restrizione delle parole vietate",
            featuresTitle4: "Consentire ai clienti di creare ticket",
            featuresTitle5: "Chiamata vocale",
            featuresTitle6: "Videochiamata",
            featuresTitle7: "Invio di messaggi vocali (Agente)",
            featuresTitle8: "Invio di messaggi vocali (Cliente)",
            featuresTitle9: "Trasferimento automatico delle chiamate",
            featuresTitle10: "Mostra la chat tra i rappresentanti",
            featuresTitle11: "Invio di file (Agente)",
            featuresTitle12: "Invio di file tramite WebChat (Cliente)",
            featuresTitle13: "Consentire l'invio di messaggi prima che si colleghi il rappresentante",
            featuresTitle14: "Nascondere i messaggi di sistema dai rappresentanti",
            featuresTitle15: "Consentire al cliente di eliminare le informazioni personali",
            featuresTitle16: "Notifica di cliente online",
            featuresTitle17: "Traduzione automatica",
            featuresTitle18: "Accesso automatico del visitatore",
            featuresTitle19: "Condivisione della posizione tramite WebChat (Cliente)",
            featuresTitle20: "Condivisione della posizione (Rappresentante)",
            featuresTitle21: "Copilota AI della chat",
            featuresTitle22: "Mantenere in attesa le conversazioni senza proprietario",
            featuresTitle23: "Nascondere le informazioni di contatto",
            featuresDesc1: "Reindirizzamento obbligatorio ai dipartimenti in base agli argomenti selezionati dal cliente.",
            featuresDesc2: "Mostra ai clienti la loro posizione in coda quando i rappresentanti sono occupati.",
            featuresDesc3: "Impedisce ai rappresentanti di inviare parole vietate definite nel sistema ai clienti quando la restrizione delle parole vietate è attiva.",
            featuresDesc4: "Attiva l'opzione per creare un ticket nella finestra di WebChat.",
            featuresDesc5: "Attiva la funzione di chiamata vocale nella finestra di WebChat.",
            featuresDesc6: "Attiva la funzione di videochiamata nella finestra di WebChat.",
            featuresDesc7: "Consente ai rappresentanti di inviare messaggi vocali.",
            featuresDesc8: "Consente ai clienti di inviare messaggi vocali nel canale WebChat.",
            featuresDesc9: "Assegna automaticamente le chiamate in attesa ai rappresentanti disponibili.",
            featuresDesc10: "Mostra il pannello di conversazione tra i rappresentanti.",
            featuresDesc11: "Consente ai rappresentanti di inviare file.",
            featuresDesc12: "Consente ai clienti di inviare file nel canale WebChat.",
            featuresDesc13: "Consente ai clienti di inviare messaggi prima che un rappresentante si colleghi.",
            featuresDesc14: "Nasconde i messaggi di sistema dai rappresentanti, impedendo ai clienti di vederli.",
            featuresDesc15: "Attiva la possibilità per i clienti di eliminare le proprie informazioni personali con un solo clic nella finestra di WebChat.",
            featuresDesc16: "Notifica i rappresentanti con un messaggio di sistema quando un cliente esce o torna nel canale WebChat.",
            featuresDesc17: "Traduce automaticamente i messaggi dei clienti nella lingua del rappresentante.",
            featuresDesc18: "Inizia la conversazione non appena il visitatore fa clic sulla finestra.",
            featuresDesc19: "Attiva la possibilità per i clienti di condividere la propria posizione nel canale WebChat.",
            featuresDesc20: "Attiva la possibilità per i rappresentanti di condividere la propria posizione.",
            featuresDesc21: "Attiva l'uso dell'assistenza AI per i rappresentanti per correggere errori di battitura, cambiare il tono dei messaggi e generare risposte supportate dall'AI.",
            featuresDesc22: "Attiva questa funzione per mantenere in attesa le persone senza proprietario.",
            featuresDesc23: "Impedisce ai rappresentanti di vedere i numeri di telefono e gli indirizzi email dei clienti.",
            featuresTitle24: "Procedura guidata fine sessione",
            featuresDesc24: "Mostra la procedura guidata di chiusura sessione agli agenti prima di chiudere la conversazione",
            privacyPolicyAndTerms: "Informativa sulla privacy / Termini di servizio",
            privacyPolicyTitle: "Informativa sulla privacy per i sistemi di supporto e chatbot Supsis",
            privacyPolicyDescription: "Questa informativa sulla privacy descrive come Softcand Servizi Software S.r.l. (“Softcand”, “noi”, “nostro” o “nostra”) raccoglie, utilizza e divulga informazioni sugli utenti (“tu” o “tuo”) dell'applicazione web Supsis (“Supsis”). Questa informativa sulla privacy si applica alle informazioni che raccogliamo quando utilizzi Supsis; queste informazioni sono valide quando vengono consultate tramite il nostro sito web, le nostre applicazioni mobili o altre piattaforme in cui è pubblicata l'informativa sulla privacy.",
            informationWeCollect: "Informazioni che raccogliamo",
            weCollectFollowingInformation: "Raccogliamo le seguenti informazioni",
            customerAccountInformation: "Informazioni sull'account cliente",
            customerAccountData: "Quando crei un account Supsis, raccogliamo i seguenti dati: nome, cognome, numero di telefono e indirizzo email.",
            userInformation: "Informazioni sull'utente",
            userProvidedInformation: "Informazioni fornite dagli utenti dell'applicazione, inclusi nome, cognome e indirizzo email.",
            dataDeletionProcess: "Processo di eliminazione dei dati",
            dataDeletionProcedures: "Seguiamo queste procedure per l'eliminazione dei dati",
            automaticDeletion: "Eliminazione automatica",
            automaticDeletionInfo: "Gli account dei clienti vengono eliminati automaticamente quando vengono chiusi o dopo sei mesi di inattività.",
            directRequest: "Richiesta diretta",
            directRequestInfo: "I clienti possono richiedere l'eliminazione di tutti i propri dati contattandoci direttamente.",
            websiteVisitorDataDeletion: "Eliminazione dei dati dei visitatori del sito web",
            websiteVisitorDataDeletionInfo: "I visitatori del sito web possono eliminare i propri dati, inclusi la cronologia delle chat, i messaggi e i file, direttamente tramite l'interfaccia di chat web.",
            howToContactUs: "Come contattarci",
            contactChannels: "Puoi contattarci tramite i seguenti canali",
            dataProcessingAndSharing: "Elaborazione e condivisione dei dati",
            handleCustomerData: "Trattiamo i dati dei clienti nel seguente modo",
            noThirdPartySharing: "Nessuna condivisione con terzi",
            noThirdPartySharingInfo: "Supsis non condivide i dati dei clienti con terzi, organizzazioni o individui.",
            promotionalEmails: "Email promozionali",
            promotionalEmailsInfo: "Possiamo inviare email promozionali ai clienti; possono scegliere di disiscriversi da queste email.",
            visitorAndConversationData: "Dati dei visitatori e delle conversazioni",
            noSharingVisitorData: "Non condividiamo né utilizziamo le informazioni sui visitatori e le chat dei clienti.",
            thirdPartyServices: "Servizi di terzi",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Calendar",
            googleCalendarInfo: "Supsis utilizza Google Calendar per attivare funzionalità relative al calendario all'interno dell'applicazione. I dati sincronizzati dai calendari non vengono condivisi con nessuno e sono visibili solo all'utente. Quando Google OAuth scade, tutti gli eventi sincronizzati di Supsis e Google Calendar vengono eliminati automaticamente.",
            googleAccountPublicProfile: "Profilo pubblico dell'account Google",
            googleAccountPublicProfileInfo: "Supsis raccoglie informazioni sul nome e sull'indirizzo email per verificare e autenticare gli utenti durante il login. Queste informazioni non vengono memorizzate dopo la verifica.",
            changesToPrivacyPolicy: "Modifiche a questa informativa sulla privacy",
            privacyPolicyUpdateInfo: "Possiamo aggiornare questa informativa sulla privacy di tanto in tanto. Se apportiamo modifiche sostanziali, ti informeremo tramite il nostro sito web o altri canali di comunicazione.",
            privacyPolicyContactInfo: "Se hai domande su questa informativa sulla privacy, contattaci all'indirizzo m@softcand.com.",
            termsOfServiceTitle: "Termini di servizio per i sistemi di supporto e chatbot Supsis",
            lastUpdated: "Ultimo aggiornamento",
            inEffect: "In vigore",
            importantTerms: "Importante: Questi termini di servizio, che includono anche la nostra informativa sulla privacy, costituiscono un contratto vincolante tra la persona designata durante il processo di registrazione come utente del servizio (“tu”) e Softcand Servizi Software S.p.A. (che opera sotto il nome di Supsis o Supsis Live Support o Supsis Live Support e sistemi di chatbot) (“noi”) e regolano il tuo utilizzo dei nostri siti web situati su supsis.com (pagina di destinazione del prodotto), softcand.com (sito web dell'azienda) o supsis.live (applicazione del prodotto) o beta.supsis.live (versione beta dell'applicazione del prodotto). Per questo motivo, questi termini sono importanti e devi assicurarti di leggerli attentamente e di contattarci per qualsiasi domanda prima di utilizzare il servizio.",
            termsDescription: "Questi termini di servizio regolano il tuo utilizzo dei nostri siti web situati su supsis.com (pagina di destinazione del prodotto), softcand.com (sito web dell'azienda) o supsis.live (applicazione del prodotto) o beta.supsis.live (versione beta dell'applicazione del prodotto).",
            applicationOfTerms: "Applicazione dei termini",
            termsApplyToAllUsers: "Questi termini si applicano a tutti gli utenti del servizio, indipendentemente dal fatto che tu utilizzi il servizio a tuo nome o a nome di un'altra persona o organizzazione.",
            termsUpdateNotice: "Possiamo aggiornare o modificare i termini in qualsiasi momento a nostra discrezione. Se modifichiamo i termini, ti informeremo avvisandoti tramite la nostra piattaforma web e via email.",
            termsDisagreementNotice: "Devi accettare di essere vincolato dai termini aggiornati facendo clic sulla tua accettazione nell'avviso che ti viene presentato prima di continuare a utilizzare il servizio.",
            consumerRightsNotice: "Se sei classificato come 'consumatore' ai sensi della legislazione applicabile, potresti avere diritti legali ai sensi di questa legislazione locale che vietano l'applicazione di tutte o parte di alcune delle limitazioni e delle esclusioni stabilite in questi termini nei tuoi confronti, e in tal caso, tali parti non si applicheranno a te.",
            theService: "Il servizio",
            serviceGrant: "Ti concediamo un diritto non esclusivo, mondiale, non trasferibile e revocabile di utilizzare il servizio in conformità con questi termini.",
            serviceAccess: "Puoi accedere e utilizzare il servizio (inclusa qualsiasi copia accidentale che si verifica nell'ambito di questo utilizzo) in conformità con questi termini.",
            serviceAgentAppointment: "Quando accedi al servizio e colleghi un account di social media al servizio, ci nomini come tuo agente in relazione a tale account per eseguire azioni per tuo conto, secondo le tue istruzioni (ad esempio, rispondere a un messaggio diretto su Instagram o su un'altra piattaforma) durante la fornitura del servizio.",
            additionalAccountsAppointment: "Quando colleghi account aggiuntivi al servizio, ci nomini anche come tuo agente in relazione a tali account per svolgere attività nell'ambito dell'agenzia.",
            accountControl: "Garantisci di controllare ogni account e di essere autorizzato a nominarci come tuo agente con l'autorità di svolgere attività nell'ambito dell'agenzia per tuo conto per ogni account.",
            serviceAffiliation: "Riconosci e accetti che il servizio non è affiliato né autorizzato da Instagram, Facebook, Twitter o qualsiasi altro servizio di social media per il quale forniamo il servizio e che qualsiasi accesso a ciascuna piattaforma (incluso tramite il servizio) è regolato dai termini di utilizzo della piattaforma applicabile.",
            serviceLinks: "Il servizio contiene collegamenti ad altri siti web, nonché contenuti aggiunti da persone diverse da noi. Non sosteniamo, sponsorizziamo né approviamo alcun contenuto generato dagli utenti o qualsiasi contenuto disponibile su un sito web collegato.",
            contentMonitoring: "Non abbiamo alcun obbligo di monitorare, modificare o rimuovere contenuti caricati o pubblicati dai nostri utenti nel servizio e successivamente pubblicati su un account su una delle piattaforme.",
            serviceControl: "Riconosci e accetti che: (1) manteniamo il controllo sul servizio e possiamo modificare, integrare o interrompere il funzionamento del servizio in qualsiasi momento a nostra esclusiva discrezione (ti informeremo ragionevolmente di qualsiasi modifica che influisca in modo significativo sulla funzionalità del servizio); (2) il servizio potrebbe non essere disponibile di volta in volta (incluso per motivi di manutenzione) e, per quanto possibile, ti informeremo di eventuali tempi di inattività pianificati; e (3) possiamo rifiutare di pubblicare il contenuto che aggiungi al servizio che riteniamo, agendo ragionevolmente, non conforme alla sezione 3 di questi termini.",
            yourRightsAndObligations: "I tuoi diritti e obblighi",
            contentAdditionRestriction: "Non devi aggiungere contenuti al servizio: (1) a meno che tu non possieda tutti i diritti, le licenze e i consensi necessari per farlo; (2) che potrebbero portare te o noi a violare qualsiasi legge o regolamento o qualsiasi altra regola, codice o obbligo legalmente vincolante; (3) che siano o che noi, agendo ragionevolmente, consideriamo spam, osceni, inappropriati, diffamatori, denigratori, indecenti, sovversivi, offensivi, pornografici, minacciosi, abusivi, incitanti all'odio, illegali, discriminatori, blasfemi, che violano la fiducia o che violano qualsiasi legge sulla privacy; (4) che potrebbero screditarci o screditare il servizio; o (5) che violano i diritti di proprietà intellettuale o altri diritti di chiunque.",
            restrictionsOnServiceUse: "Non devi: (1) tentare di duplicare o riprodurre, o modificare, cambiare o preparare opere derivate dal servizio, dal contenuto che pubblichiamo in relazione al servizio o da qualsiasi altro materiale che non possiedi o per il quale non hai una licenza pertinente; (2) distribuire virus o altri codici dannosi; (3) utilizzare il servizio per pubblicare informazioni ingannevoli o fraudolente; (4) accedere all'account di un'altra persona nel nostro servizio senza il suo permesso; (5) modificare, disabilitare, interferire o eludere qualsiasi aspetto del servizio o testare o decompilare il servizio per trovare limitazioni, vulnerabilità o eludere le capacità di filtraggio; o (6) fare qualsiasi cosa che possa influenzare l'accesso o l'integrità del servizio.",
            payments: "Pagamenti",
            paymentAcknowledgment: "Riconosci e accetti che:",
            paymentMethodDebit: "Addebiteremo il tuo metodo di pagamento designato alla data di fatturazione specificata (il giorno in cui termina il tuo periodo di prova) ogni mese, anno o altro periodo di fatturazione (se applicabile) in anticipo per il successivo periodo di fatturazione, a meno che tu non annulli il servizio prima di tale data; e",
            cancellationPolicy: "Se annulli il servizio, continuerai ad avere accesso al servizio fino alla tua prossima data di fatturazione, e qualsiasi rimborso di qualsiasi importo pagato per il periodo di fatturazione attuale è a nostra discrezione (cioè i pagamenti non sono rimborsabili, a meno che non sia a nostra discrezione).",
            intellectualProperty: "Proprietà intellettuale",
            contentDefinition: "In questi termini, 'Contenuto' include materiali in forma di testo, audio, grafica, immagini e video, o qualsiasi combinazione di materiali, in qualsiasi forma.",
            intellectualPropertyRightsTransfer: "Niente in questi termini costituisce un trasferimento di diritti di proprietà intellettuale. Riconosci e accetti che, tra te e noi, possediamo tutti i diritti di proprietà intellettuale nel servizio (cioè possediamo i diritti sulle applicazioni che ti mettiamo a disposizione; non possediamo diritti di proprietà intellettuale sul tuo contenuto; vedi sotto al 5(3)).",
            userContentRights: "Riconosciamo che, tra te e noi, possiedi o hai una licenza su tutti i diritti di proprietà intellettuale nel contenuto che fornisci al servizio o che ci fornisci in altro modo al fine di fornire il servizio.",
            grantLicense: "Ci concedi un diritto e una licenza perpetui, non esclusivi, esenti da diritti d'autore, irrevocabili, globali e trasferibili di utilizzare, in qualsiasi modo (incluso pubblicare su un account su una piattaforma come da te indicato): (a) il contenuto che aggiungi al servizio; e (b) il contenuto del profilo su piattaforme di social media associate al tuo account (incluso, senza limitazione, riproduzione, modifica o adattamento e comunicazione pubblica di tale contenuto) ai fini di fornirti il servizio.",
            subLicense: "Possiamo concedere in sublicenza la licenza di cui al paragrafo 5(4) a fornitori di servizi di terze parti che ci assistono nella fornitura del servizio.",
            moralRights: "In alcuni paesi in cui il servizio è operato, la legislazione locale riconosce che gli autori di contenuti possono avere 'diritti morali' in relazione ai contenuti. Esempi di diritti morali possono includere il diritto di essere attribuito come autore dei contenuti, il diritto di opporsi a una falsa attribuzione della paternità dei contenuti e il diritto di opporsi a trattamenti degradanti dei contenuti in determinate circostanze.",
            licenseSurvival: "La licenza di cui al paragrafo 5(4) rimarrà in vigore anche dopo la cessazione di questi termini.",
            rightsRepresentation: "Dichiari e garantisci di avere tutti i diritti necessari per concedere le licenze e gli altri impegni stabiliti in questo paragrafo 5.",
            warranties: "Garanzie",
            warrantiesAcknowledgment: "Dichiari e garantisci a noi che:",
            accountOwnership: "Tutti gli account, su qualsiasi piattaforma, aggiunti al servizio sono di tua proprietà o sotto il tuo controllo;",
            serviceUsageAgreement: "Utilizzerai il servizio in conformità con questi termini; e",
            legalCapacity: "Hai la capacità legale e l'autorità di stipulare questi termini.",
            liability: "Responsabilità",
            liabilityForLoss: "Sei responsabile per qualsiasi perdita o danno causato se violi i tuoi obblighi ai sensi di questi termini o se non eserciti la dovuta diligenza nell'utilizzo del servizio. La tua responsabilità sarà ridotta nella misura in cui noi causiamo o contribuiamo a tale perdita o danno attraverso la nostra violazione di questi termini o la nostra negligenza nella fornitura del servizio.",
            indemnification: "Ci indennizzi per qualsiasi perdita o danno che subiamo a causa della tua violazione di questi termini (comprese le garanzie che ci fornisci ai sensi di questi termini), o di qualsiasi comportamento intenzionale, atto illegale o negligenza nel tuo utilizzo o abuso del servizio.",
            exclusionOfLiability: "Nella massima misura consentita dalla legge, e soggetta alle disposizioni 7(5) e 7(6) di questi termini, escludiamo qualsiasi responsabilità per tutte le richieste, spese, perdite, danni e costi presentati contro di te o sostenuti da te direttamente o indirettamente derivanti da o in relazione al tuo utilizzo del servizio o alla tua incapacità di utilizzare il servizio, inclusi perdite economiche, perdita di dati, interruzione dell'attività o qualsiasi danno consequenziale o incidentale.",
            totalLiabilityLimit: "Nella massima misura consentita dalla legge, e soggetta alle disposizioni 7(5) e 7(6) di questi termini, la nostra responsabilità totale nei tuoi confronti per violazione del contratto ai sensi di questi termini, per illecito (comprese le negligenze) o per qualsiasi altro motivo è limitata a un importo pari al totale delle somme pagate o da pagare da parte tua per il servizio per il mese precedente al giorno in cui è sorta la nostra responsabilità.",
            exclusionOfTerms: "Nella massima misura consentita dalla legge, e soggetta alle disposizioni 7(6) e 7(7) di questi termini, escludiamo tutte le condizioni, dichiarazioni, garanzie, condizioni, assicurazioni o obblighi (espliciti o impliciti) che non sono espressamente stabiliti in questi termini.",
            statutoryObligations: "In alcune giurisdizioni, la legislazione può richiedere che determinate garanzie, condizioni, assicurazioni o obblighi relativi al servizio siano impliciti in questi termini o imposti alla nostra fornitura del servizio ('obbligazioni statutarie'). Inoltre, la legislazione può vietare o rendere nulle altre condizioni che hanno l'effetto di escludere, limitare o modificare le condizioni imposte, o l'esercizio di diritti e rimedi legali, o il recupero di risarcimenti, che altrimenti sarebbero disponibili per te se violassimo una condizione imposta ('divieto statutario').",
            statuteProhibition: "Se la legislazione menzionata nel paragrafo 7(6) si applica a questi termini come accettati da te, o al servizio come fornito a te, nulla in questi termini è destinato a essere o a funzionare come un divieto statutario. In particolare, nessuna parte di questi termini è destinata a limitare la nostra responsabilità dove tale parte costituirebbe un divieto statutario.",
            termination: "Cessazione",
            terminationAutomatic: "Questi termini si interrompono automaticamente se, per qualsiasi motivo, smettiamo di operare il servizio.",
            terminationNotice: "Possiamo anche terminare o sospendere immediatamente il tuo accesso al servizio, avvisandoti, se riteniamo ragionevolmente che tu abbia violato questi termini in qualsiasi modo.",
            cancelService: "Puoi annullare il servizio in qualsiasi momento informandoci, e puoi continuare ad accedere al servizio fino alla fine del tuo attuale periodo di fatturazione.",
            terminationRights: "Tutti i diritti concessi a te in base a questi termini cessano con la cessazione.",
            assignmentRestriction: "Non devi cedere, concedere in sublicenza o altrimenti disporre dei tuoi diritti ai sensi di questi termini.",
            invalidProvision: "Se una disposizione di questi termini è invalida o inapplicabile, deve essere letta o separata nella misura necessaria senza influire sulla validità o sull'applicabilità delle disposizioni rimanenti.",
            expenseResponsibility: "Ogni parte deve, a proprie spese, fare tutto ciò che è ragionevolmente necessario per dare pieno effetto a questo accordo e agli eventi previsti dallo stesso.",
            governingLaw: "Questi termini sono regolati dalle leggi della Turchia e ogni parte si sottopone alla giurisdizione dei tribunali della Turchia.",
            privacyPolicyTab: "Informativa sulla privacy",
            termsAndConditionsTab: "Termini e condizioni",
            placeholders: "Segnaposto",
            deleteConfirmationMessage: "Sei sicuro di voler eliminare questo filtro?",
            deleteSuccess: "Filtro eliminato con successo",
            filterSavedSuccessfully: "Il filtro è stato salvato con successo",
            filterCreatedMessage: "Il filtro che hai appena creato, {filterName}, è ora disponibile qui e può essere utilizzato in qualsiasi momento.",
            copyImage: "Copia immagine",
            copyText: "Copia testo",
            translateVisitorMessage: "Traduci messaggio",
            replyMessage: "Rispondi",
            downloading: "Download del file in corso...",
            downloadSuccess: "File scaricato con successo",
            downloadFailed: "Download del file non riuscito",
            filterName: "Nome del filtro",
            enterFilterName: "Inserisci il nome del filtro",
            selectVisibility: "Seleziona la visibilità",
            public: "Pubblico",
            private: "Privato",
            includeExistingFilters: "Includi i filtri esistenti",
            includeSearchTerm: "Includi il termine di ricerca",
            includeSortOrder: "Includi l'ordine di ordinamento",
            includeGroupingSelection: "Includi la selezione di raggruppamento",
            saveFilter: "Salva il filtro",
            ban: "Bandire",
            forwardToDepartmentAndAssign: "Inoltra al dipartimento e assegna",
            storageSpace: "Spazio di archiviazione",
            completed: "Completato",
            failed: "Fallito",
            cancelled: "Annullato",
            running: "In esecuzione",
            paused: "In pausa",
            queued: "In coda",
            scheduled: "Pianificato",
            metaLead: "Meta Lead",
            agent: "Agente",
            invoice: "Fattura",
            whatsapp: "WhatsApp",
            reservation: "Prenotazione",
            chatbot: "Chatbot",
            webhook: "Webhook",
            table: "Tabella",
            ticket: "Biglietto",
            calendar: "Calendario",
            tag: "Etichetta",
            low: "Basso",
            lowest: "Il più basso",
            medium: "Medio",
            high: "Alto",
            highest: "Il più alto",
            priority: "Priorità",
            createDepartment: "Crea dipartimento",
            goToLink: "Vai al Link",
            emailAddressYouProvide: "Esiste già un account con l’indirizzo email fornito.",
            channelPrivacyPolicyNotMet: "La politica di privacy del canale non è rispettata",
            userIsNotInDepartment: "L'utente non è in questo reparto",
            currentDepartment: "Reparto attuale",
            validDepartment: "Reparto valido",
            youCanForwardToThisDepartment: "Puoi inoltrare la conversazione a questo reparto",
            goToSettings: "Vai alle impostazioni",
            changeDepartmentAndForward: "Cambiare reparto e inoltrare",
            selectDepartmentToForwardAgent: "Selezionare il reparto a cui si desidera inoltrare la conversazione per l'agente chiamato {selectAgentName}.",
            selectDepartmentToForward: "Si prega di selezionare il dipartimento al quale si desidera reindirizzare",
            packageConfirmationMessage: "Sei sicuro di voler acquistare il pacchetto? Il pacchetto che acquisti è soggetto a costi in tempo reale. Puoi continuare a usarlo per un anno dopo la cancellazione. Il prezzo di questo prodotto è escluso IVA al 20%.",
            packagePurchaseConfirmation: "Sei sicuro di voler acquistare il pacchetto? I pacchetti mensili verranno addebitati all'inizio di ogni mese. L'uso del pacchetto terminerà dopo la data di cancellazione. Il prezzo di questo prodotto è escluso IVA al 20%.",
            annualPurchaseDiscount: "Cogli l'offerta di sconto del 30% sugli acquisti annuali!",
            customerTables: "Tabelle dei clienti",
            formIntegration: "Integrazione di modulo",
            automationIntegration: "Integrazione di automazione",
            remainingAutomationTask: "Rimanenti attività di automazione",
            createUserError: "Si è verificato un errore durante la creazione dell'utente",
            sendTemplateMessage: "Invia messaggio modello",
            startChatWithDifferentChannel: "Avvia chat con un canale diverso",
            whatsappChatStarter: "Avvio chat WhatsApp",
            pressEnterToJoin: "Premi Invio per unirti alla chat",
            pressEnterToStartChat: "Premi Invio per avviare la chat",
            cannotSendMessage: "Non puoi inviare messaggi a questa persona",
            cannotSendSessionMessage: "Non puoi inviare messaggi di sessione a questa persona",
            conversationNotInYourDepartments: "Questa conversazione non appartiene a nessuno dei tuoi dipartimenti",
            customizeImage: "Se vuoi personalizzare l'immagine",
            clickToUpload: "Clicca qui per caricare un'immagine",
            uploadNote: "Di seguito sono riportati i formati di file e le rispettive dimensioni accettate per il caricamento",
            imageSize: "L'immagine non può essere caricata perché supera i 2 MB",
            videoSize: "Il video non può essere caricato perché supera i 20 MB",
            documentSize: "Il documento non può essere caricato perché supera i 2 MB",
            uploading: "Caricamento immagine in corso, attendere prego...",
            uploadSuccess: "Immagine caricata con successo",
            note: "Nota",
            gridView: "Vista di tabella",
            completedTasks: "Compiti completati",
            system: "Sistema",
            destroyedBy: "Distrutto da",
            brand: "Marca",
            channelCreatedSuccess: "Canale creato con successo",
            channelCreatedError: "Impossibile creare il canale",
            plans: {
                types: {
                    supsis: "Pacchetti Rappresentanti",
                    chatbot: "Chatbot",
                    automation: "Automazione",
                    customer_tables: "Tabella Clienti",
                    mail: "Email",
                    tasks: "Compiti",
                    form: "Modulo",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    artificial_intelligence: "Intelligenza Artificiale",
                    webhook: "Webhook",
                    telegram: "Telegram",
                    webphone: "Web Phone"
                }
            },
            vipCustomerDescription: "Contrassegnare questa persona come cliente VIP la porta in cima alla coda e garantisce che riceva un servizio prioritario.",
            switchOn: "Acceso",
            switchOff: "Spento",
            ownerDescription: "Questa funzione indica il proprietario di una chat. Indipendentemente dallo stato del proprietario (online o offline), le chat vengono sempre assegnate al proprietario. Le chat di proprietà possono essere visualizzate solo dal rispettivo proprietario e non possono essere risposte dal chatbot.",
            permissionError: "Non hai il permesso di eseguire questa azione!",
            copySuccess: "Contenuto copiato con successo!",
            unowned: "Senza proprietario",
            add: "Aggiungi",
            copy: "Copia",
            cancel: "Annulla",
            edit: "Modifica",
            update: "Aggiornare",
            search: "Avviare la ricerca",
            save: "Salva",
            jsonPreview: "ANTEPRIMA JSON",
            enterNewValue: "Inserisci un nuovo valore",
            updatePreferredLanguage: "Aggiorna lingua preferita",
            updateTags: "Aggiorna tag",
            updateEmail: "Aggiorna email",
            enterNewEmail: "Inserisci una nuova email",
            deleteConfirmation: "Conferma eliminazione",
            confirmDelete: "Sei sicuro di voler eliminare questa funzione?",
            yesDelete: "Sì, elimina",
            vipCustomer: "★ Cliente VIP",
            takeControlFromChatbot: "Prendi il controllo dal chatbot",
            enterJoin: "Puoi entrare nella conversazione premendo il tasto Invio",
            watchChat: "Guarda la conversazione",
            untitledAutomation: "👉 Automatizzazione di clic sul profilo senza titolo",
            event: "Evento",
            chatbotSettings: "Impostazioni di routing del chatbot",
            chatbotScenarioNotFound: "Scenario del chatbot non trovato",
            noChatbotScenario: "Nessuno scenario di chatbot trovato nel sistema.",
            scenarioNotFound: "Scenario non trovato",
            descNotAvailable: "Descrizione non disponibile",
            lastRegulation: "Ultima regolamentazione",
            taskCreator: "Creatore del compito",
            noPermission: "Non hai il permesso di creare attività.",
            notAppointed: "Non nominato",
            changeStage: "Cambiare fase",
            selectedCandidates: "1 candidato selezionato",
            coverPhotoRemove: "Rimuovere la foto di copertura",
            coverPhotoSet: "Imposta come foto di copertura",
            autoTransfer: "Trasferisci automaticamente i tuoi contatti a Zoho",
            autoTransferDescription: "I contatti che arrivano a questo canale vengono trasferiti automaticamente al modulo contatti di Zoho CRM. Quelli trasferiti a Zoho attivano i widget di Zoho.",
            zohoChannelRequiredTitle: "Canale Zoho CRM necessario",
            zohoChannelRequiredContent: "Non hai un canale Zoho CRM. Clicca qui per aggiungerne uno immediatamente.",
            okText: "Aggiungi canale Zoho CRM",
            cancelText: "Annulla",
            forceQueueForNoOwnerContacts: "Costringere i contatti senza proprietario ad attendere in coda",
            forceQueueDescription: "Solo i contatti posseduti vengono assegnati automaticamente, costringendo i contatti senza proprietario ad attendere in coda.",
            showNoOwnerContactsToAdmins: "Mostra i contatti senza proprietario solo agli amministratori",
            showNoOwnerContactsDescription: "I contatti senza proprietario sono visibili solo agli amministratori.",
            autoAssignOwner: "Assegnazione automatica del proprietario del contatto",
            autoAssignOwnerDescription: "Quando la chat viene assegnata automaticamente a un rappresentante, viene anche assegnata come proprietario.",
            creator: "Creatore",
            hideShow: "Nascondi / Mostra",
            url: "URL",
            cannedMessages: "Messaggi predefiniti",
            templateMessages: "Messaggi di modello",
            chatbots: "Chatbot",
            noCannedMessages: "Nessun messaggio predefinito trovato",
            filterToFindMore: "Puoi trovare più messaggi predefiniti modificando i tuoi filtri.",
            runPrompt: "Esegui Prompt",
            noLeadsFound: "Nessun lead trovato per questa persona",
            deals: "Offerte",
            noDealsFound: "Nessuna offerta trovata per questa persona",
            loadingDeals: "Caricamento delle offerte",
            zohoCRM: "Zoho CRM",
            viewContact: "Visualizza contatto",
            noNotesAdded: "Nessuna nota aggiunta ancora",
            attachments: "Allegati",
            addNewNote: "Aggiungi nuova nota",
            savingg: "Salvataggio...",
            warningFillFields: "Si prega di compilare i campi titolo e contenuto.",
            successNoteAdded: "Nota aggiunta con successo.",
            errorAddingNote: "Si è verificato un errore durante l'aggiunta della nota.",
            noteTitle: "Titolo della nota",
            noteContent: "Contenuto della nota",
            selectPreferredAgent: "Seleziona l'agente preferito che desideri assegnare al visitatore.",
            postOperations: "Operazioni di pubblicazione",
            loadingPostOperations: "Caricamento delle operazioni di pubblicazione",
            noPostOperations: "Nessuna operazione di pubblicazione trovata per questa persona",
            postOperationDetails: "Dettagli delle operazioni di pubblicazione",
            noMediaDocuments: "Nessun media o documento disponibile per questa persona.",
            selectionLimitError: "Puoi selezionare un massimo di 30 elementi.",
            showNote: "Mostra nota a tutti",
            hideNote: "Nascondi nota",
            updateNote: "Aggiorna nota",
            addUserNote: "Aggiungi una nota sull'utente",
            privateNote: "Nota privata",
            metaReferrals: "Riferimenti Meta",
            noMetaReferrals: "Nessuna interazione pubblicitaria Meta trovata.",
            searchPrompt: "Cerca qualcosa.",
            noRecentResults: "Nessun risultato recente trovato.",
            contactInfo: "Informazioni di contatto",
            noPropertiesAdded: "Nessuna proprietà aggiunta ancora.",
            propertyAddedUpdated: "Proprietà aggiunta/aggiornata con successo.",
            propertyError: "Si è verificato un errore durante l'aggiunta/aggiornamento della proprietà.",
            propertyDeleted: "Proprietà eliminata con successo.",
            propertyDeleteError: "Si è verificato un errore durante l'eliminazione della proprietà.",
            zohoSynchronization: "Sincronizzazione Zoho",
            zohoSyncConfirmation: "Vuoi apportare modifiche alla persona in Zoho?",
            hideOtherInfo: "Nascondi altre informazioni",
            showOtherInfo: "Mostra altre informazioni",
            whatsappChatStart: "Avvia chat WhatsApp",
            ownership: "Proprietà del cliente",
            countryAndLanguage: "Paese, Lingua",
            calendarEvent: "Evento del calendario",
            contact: "Contatto",
            user: "Utente",
            customerOwnership: "Proprietà del cliente",
            ownerless: "Senza proprietario",
            preferredDepartment: "Dipartimento preferito",
            flowluTransfer: "Trasferisci a Flowlu",
            mergeSuccess: "Operazione di fusione completata con successo.",
            visitorOwnershipWarning: "Questo visitatore è di proprietà di un altro utente.",
            newAutomation: "Nuova automazione",
            automations: "Automazioni",
            createProfileAutomation: "Crea automazione profilo",
            profileButtonClicked: "Pulsante profilo cliccato",
            profileButtonDescription: "Questa automazione verrà attivata quando viene cliccato un pulsante profilo.",
            automationName: "Nome dell'automazione",
            create: "Crea",
            dayRange: "Intervallo di giorni",
            hourRange: "Intervallo di ore",
            last24Hours: "Ultime 24 ore",
            today: "Oggi",
            yesterday: "Ieri",
            thisWeek: "Questa settimana",
            lastWeek: "Settimana scorsa",
            last7Days: "Ultimi 7 giorni",
            last30Days: "Ultimi 30 giorni",
            thisMonth: "Questo mese",
            lastMonth: "Mese scorso",
            startDateTime: "Data e ora di inizio",
            endDateTime: "Data e ora di fine",
            complaint: "Reclamo",
            opens: "Aperture",
            clicks: "Clic",
            mockData: "(Dati di prova)",
            preferredRepresentative: "Seleziona un agente preferito",
            forwardToDepartment: "Invia a dipartimento",
            toMobileAgents: "Ai agenti mobili",
            noMediaAndDocuments: "Questo utente non ha media o documenti",
            reportBug: "Segnala un errore",
            waitingForReply: "In attesa di risposta",
            memorySize: "Dimensione della memoria",
            usedMemory: "Memoria utilizzata",
            availableMemory: "Memoria disponibile",
            memoryLimit: "Limite della memoria",
            memoryLimitPrice: "Prezzo per la memoria aggiuntiva",
            telegramBotIsReachable: "Il servizio di bot di Telegram ha un errore",
            telegramBotIsHealthy: "Il servizio di bot di Telegram è sano",
            telegramBotIsUnhealthy: "Il servizio di bot di Telegram ha un errore",
            pieView: "Vista a torta",
            chartView: "Vista grafico",
            tableView: "Vista tabella",
            lastUpdate: "ultimo aggiornamento",
            task: "task",
            filterBy: "Per filtro",
            watchAllLive: "Guarda tutte le dirette",
            sessionsUnique: "Sessioni (utenti unici)",
            sessionsAll: "Sessioni (tutti gli utenti)",
            moreFeaturesDesc: "Più funzioni, più integrazioni, più agenti! Agisci subito per gestire meglio il tuo team e far crescere la tua attività al massimo del suo potenziale!",
            metaLeadForms: "Meta Lead Forms",
            metaLeadsConnectedSucs: "Meta Leads connessi con successo",
            failedToConnectMetaLeads: "Connessione fallita a Meta Leads",
            forbiddenChannel: "Canale vietato",
            forbiddenChannelDesc: "Non sei autorizzato a visualizzare questo canale",
            firstContact: "Primo contatto",
            needsAnalysis: "Analisi dei bisogni",
            offerSent: "Offerta inviata",
            offerReview: "Revisione dell'offerta",
            decisionPhase: "Fase decisionale",
            personDeleted: "Persona eliminata",
            metaLeadsIntegration: "Meta Leads Integration",
            phoneNumberIsInvalid: "Numero di telefono non valido",
            addAnItem: "Aggiungi un elemento",
            saveItem: "Salva elemento",
            customItem: "Elemento personalizzato",
            backgroundPhoto: "Immagine di sfondo",
            whenYouActivateFeature: "Quando si attiva questa funzione, essa non apparirà nella pagina di prenotazione",
            logo: "Logo",
            noLogo: "Nessun logo",
            addTeamMember: "Aggiungi un membro del team",
            timezone: "Fuso orario",
            selectDayys: "Seleziona giorno/i",
            selectStartHour: "Selezionare l'ora di inizio",
            selectEndHour: "Selezionare l'ora di fine",
            moveLeft: "Sposta a destra",
            moveRight: "Sposta a sinistra",
            reply: "Risposta",
            replyToAll: "Rispondi a tutti",
            deleteThreadMessage: "Messaggio di cancellazione della discussione",
            totalEmailsBounced: "Totale email rimbalzate",
            totalEmailsComplained: "Totale email di cui ci si lamenta",
            untilNowTotalEmailOpens: "Totale aperture di email finora",
            untilNowTotalEmailLinkClicks: "Totale clic sul link dell'email fino a quel momento",
            uniqueClicks: "Clic unici",
            untilNowTotalUniqueEmail: "Totale di clic unici sul link dell'email (per destinatario)",
            emailCampaignTimeline: "Timeline della campagna e-mail",
            receivedBroadcasts: "Trasmissioni ricevute",
            groupDeletedSuccessfully: "Gruppo eliminato con successo",
            verify: "Verifica",
            done: "Fatto",
            pleaseSelectAnEmailAddress: "Selezionare un indirizzo e-mail",
            goBack: "Torna indietro",
            show: "Mostra",
            vueEmailEditor: "Vue Email Editor (Demo)",
            saveDesign: "Salva design",
            exportHTML: "Esportazione HTML",
            saveAsEmailCustomerGroup: "Salva come gruppo di clienti e-mail",
            saveAsWhatsappCustomerGroup: "Salva come gruppo di clienti Whatsapp",
            deleteModalFormDesc: "Se si elimina questo modulo, tutti i dati del modulo saranno eliminati in modo permanente. Siete sicuri di voler continuare?",
            todo: "Cose da fare",
            inProgress: "In corso",
            approval: "Approvazione",
            transactionType: "Tipo di transazione",
            previousBalance: "Saldo precedente",
            nextBalance: "Saldo successivo",
            amount: "Importo",
            wpIntegrationChannelRequired: "Canale di integrazione Whatsapp Web richiesto",
            wpIntegrationChannelRequiredDesc: "L'integrazione Chatbot + Whatsapp Web richiede un canale Whatsapp Web. Creare un nuovo canale",
            wabaIntegrationChannelRequired: "Canale di integrazione Whatsapp Business richiesto",
            wabaIntegrationChannelRequiredDesc: "L'integrazione Chatbot + Whatsapp Business API richiede il canale web Whatsapp. Creare un nuovo canale",
            instaIntegrationChannelRequired: "Canale di integrazione Instagram richiesto",
            instaIntegrationChannelRequiredDesc: "L'integrazione Chatbot + Instagram richiede un canale Instagram. Si prega di creare un nuovo canale",
            createWpChannel: "Crea canale web Whatsapp",
            createWabaChannel: "Crea canale API Whatsapp Business",
            createInstaChannel: "Crea canale Instagram",
            failedToDeleteGroup: "Errore nell'eliminazione di un gruppo",
            failedToDeleteGroups: "Errore nell'eliminazione dei gruppi",
            failedToFetchGroupContacts: "Impossibile recuperare i contatti del gruppo",
            mailAddressDeletedSuccessfully: "Indirizzo di posta eliminato con successo",
            defaultMailAddressChangedSuccessfully: "L'indirizzo di posta predefinito è stato modificato con successo",
            mailAddressAlreadyRegistered: "L'indirizzo di posta non può essere già registrato o vuoto",
            pleaseVerifyByClicking: "Si prega di verificare cliccando sul link inviato al proprio indirizzo e-mail",
            signSucsRegistered: "Firma registrata con successo",
            myContacts: "I miei contatti",
            unanswered: "Mancato",
            emailBroadcasts: "Trasmissioni e-mail",
            monthlyLimit: "Limite mensile",
            totalShipments: "Totale spedizioni",
            shippingStatus: "Stato della spedizione",
            lastAction: "Ultima azione",
            receiver: "Ricevitore",
            delivered: "Consegnato",
            opened: "Aperto",
            clicked: "Cliccato",
            bounced: "È tornato",
            clickedLinks: "Link cliccati",
            reason: "Motivo",
            timer: "Timer",
            implemented: "Implementato?",
            module: "Modulo",
            excelDownload: "Download di Excel",
            serviceFeatures: "Caratteristiche del servizio",
            mailAddressDeletedSucs: "Indirizzo di posta cancellato con successo",
            inputSearchText: "Inserire il testo di ricerca",
            createRecord: "Crea record",
            separatorCharacter: "Carattere separatore",
            exampleResultPreview: "Anteprima del risultato",
            importRecords: "Importazione di record",
            equals: "Uguale",
            notEquals: "Non uguale",
            beginsWith: "Inizia con",
            endsWith: "Finisce con",
            greaterThan: "Maggiore",
            lessThan: "Meno di",
            before: "Prima",
            after: "Dopo",
            is: "O",
            isNot: "Non",
            empty: "Vuoto",
            notEmpty: "Non vuoto",
            isOneOff: "Una volta",
            field: "Campo",
            records: "Record",
            addIntegration: "Aggiungi integrazione",
            chatbotScenarioReleased: "Scenario chatbot rilasciato",
            chatbotScenarioHasBeenCancelled: "Scenario chatbot annullato",
            titleAndDesc: "Titolo e descrizione",
            templateAndMailSelection: "Modello e selezione della posta",
            peopleToSend: "Persone a cui inviare",
            submissionPlans: "Piano di invio",
            summary: "Riepilogo",
            broadcastTitle: "Titolo della trasmissione",
            sentByEmail: "Email inviata",
            emailTemplate: "Modello di e-mail",
            onlyPeopleWithEmail: "Solo le persone con un indirizzo e-mail sono valide per l'invio",
            sendNow: "Invia ora",
            plan: "Piano",
            senderEmail: "Email del mittente",
            totalBuyer: "Acquirente totale",
            estimatedDuration: "Durata stimata",
            person: "Persona",
            shippingIsNowComplete: "La spedizione è completata!",
            back: "Indietro",
            customerName: "Nome del cliente",
            customerEmail: "Email del cliente",
            customValue: "Valore personalizzato",
            selectMailTemplate: "È necessario selezionare un modello di posta",
            youMustSelectSendingMailAddress: "È necessario selezionare l'indirizzo di posta elettronica di invio",
            youMustSelectCustomerGroupSend: "È necessario selezionare il gruppo di clienti a cui inviare",
            createBroadcast: "Creare una trasmissione",
            broadcastDetails: "Dettagli della trasmissione",
            youCanCheckYourEmailStatus: "Puoi controllare lo stato delle tue e-mail aggiornando il tuo piano. Puoi controllare lo stato delle tue e-mail aggiornando il tuo piano.",
            sentDetails: "Dettagli dell'invio",
            total: "Totale",
            totalEmailsProcessed: "Totale email elaborate",
            totalEmailsDelivered: "Totale email inviate",
            toAvailableAgents: "Per gli agenti disponibili",
            toAvailableDepartments: "Per i reparti disponibili",
            toWithAgentAndDepartment: "Con agente e reparto",
            toMobilAgents: "Agli agenti mobili",
            toPreferredAgents: "Agli agenti preferiti",
            searchAgent: "Agente di ricerca",
            searchDepartment: "Reparto di ricerca",
            searchMobileAgent: "Agente mobile di ricerca",
            searchAgentOrDepartment: "Agente o reparto di ricerca",
            searchPreferredAgent: "Cerca l'agente preferito",
            noAgentsAvailableToForward: "Nessun agente disponibile per l'inoltro",
            noDepartmentsAvailableToForward: "Nessun reparto disponibile per l'inoltro",
            checkChannelVisibilityTitle: "Controlla le impostazioni di visibilità del canale",
            checkChannelVisibilityDescription: "Se non riesci a vedere alcuni reparti, controlla le impostazioni di visibilità del canale",
            goToChannelSettings: "Vai alle impostazioni del canale",
            noMobileAgentsAvailableToForward: "Nessun agente mobile disponibile per l'inoltro",
            noPreferredAgentsAvailableToForward: "Nessun agente preferito disponibile per l'inoltro",
            ifYouSendThisConversationToTheQueue: "Se si invia questa conversazione alla coda, l'utente viene rimosso dalla chat e la conversazione viene messa in coda. Se l'assegnazione automatica della chat è abilitata, la conversazione verrà assegnata a un agente appropriato e potrà essere ritrasferita all'utente",
            ifAutomaticChatAssignmentIsDisabled: "Se l'assegnazione automatica della chat è disabilitata, la chiamata rimarrà in coda. Il personale autorizzato può prendere la chiamata dalla coda",
            sendQueue: "Invia alla coda",
            agentName: "Nome agente",
            departmentName: "Nome del reparto",
            toQueue: "Coda",
            web: "Web",
            mobile: "Mobile",
            noGrouping: "Nessun raggruppamento",
            groupByThis: "Raggruppa per questo",
            selectGroupingCriteria: "Seleziona criteri di raggruppamento",
            activeUsers: "Utenti attivi",
            passiveUsers: "Utenti passivi",
            noPlatform: "Nessuna piattaforma specificata",
            noRole: "Ruolo non specificato",
            noDepartment: "Nessun dipartimento specificato",
            noLanguage: "Nessuna lingua specificata",
            group2: "Gruppo",
            groupedByStatus: "Raggruppati per stato",
            grouping: "Raggruppamento",
            activeSubjects: "Soggetti attivi",
            passiveSubjects: "Soggetti passivi",
            groupSubjects: "Soggetti del gruppo",
            showAll: "Mostra tutti",
            onlyActive: "Solo attivi",
            onlyPassive: "Solo i passivi",
            selectTimezone: "Selezionare il fuso orario",
            userFilter: "Filtro utente",
            confidenceScore: "Punteggio di fiducia",
            chatbotLanguage: "Lingua del chatbot",
            botScenerio: "Scenario bot",
            selectTemplate: "Seleziona modello",
            importFromReadyTemplates: "Importa da modelli pronti",
            classification: "Classificazione",
            addClassification: "Aggiungi classificazione",
            expressionClassified: "Espressione da classificare",
            zohoModuleName: "Nome del modulo Zoho",
            selectModule: "Seleziona modulo",
            standardFields: "Campi standard",
            selectStandardField: "Seleziona campo standard",
            customFields: "Campi personalizzati",
            selectCustomFields: "Seleziona campo personalizzato",
            aiFunction: "Funzione di intelligenza artificiale",
            aiFunctionDesc: "Gestione della funzione di intelligenza artificiale per eseguire azioni basate sugli input dell'utente",
            functionName: "Nome della funzione",
            functionDesc: "Descrizione della funzione",
            addParameter: "Aggiungi parametro",
            chooseAiStory: "Scegli una storia di IA",
            chatbotAiPromptDesc: "L'intelligenza artificiale apprende e determina il comportamento da tenere ricevendo istruzioni su un compito o un problema specifico grazie alla funzione 'prompt'",
            enterPrompt: "Inserire il prompt",
            aiParameterTunings: "Regolazione dei parametri dell'intelligenza artificiale",
            aiParameterTuningsDesc: "È possibile regolare i parametri dell'IA per renderla più reattiva e precisa. Questi parametri sono usati per controllare il comportamento dell'IA e il modo in cui risponde agli input dell'utente.",
            temperatura: "Temperatura",
            temperatureDesc: "La temperatura di campionamento da utilizzare, compresa tra 0 e 2. Valori più alti, come 0,8, renderanno l'output più casuale, mentre valori più bassi, come 0,2, lo renderanno più mirato e deterministico.",
            topDesc: "In alternativa al campionamento per temperatura, il cosiddetto campionamento kernel, il modello considera i risultati dei token con la massa di probabilità top_p. Quindi 0,1 significa che vengono considerati solo i token con la massa di probabilità superiore al 10%. Di solito si consiglia di cambiare questo o la temperatura, ma non entrambi.",
            toolChoices: "Opzioni dello strumento",
            noneDesc: "Nessuno significa che il modello non richiamerà alcuno strumento e genererà invece un messaggio.",
            autoDesc: "La modalità automatica è il valore predefinito e significa che il modello può scegliere se generare un messaggio o invocare uno o più agenti.",
            requiredDesc: "La modalità richiesta è che il modello deve chiamare uno o più agenti prima di rispondere all'utente.",
            createArticles: "Crea articolo",
            createArticlesDesc: "Crea articoli per aiutare gli utenti a trovare risposte alle loro domande",
            articlesTitle: "Titolo dell'articolo",
            articlesContent: "Contenuto dell'articolo",
            createFaq: "Creare una domanda frequente (FAQ)",
            createFaqDesc: "Crea una nuova FAQ per il tuo chatbot. Questo aiuterà il chatbot a rispondere alle domande dell'utente",
            question: "Domanda",
            saveAndClose: "Salva e chiudi",
            contentPreview: "Anteprima del contenuto",
            upgradePackageTitle: "Aggiornate il vostro pacchetto ed evitate i limiti",
            upgradePackageDescription: "Più funzioni, più integrazioni, più agenti! Agite subito per gestire meglio il vostro team e massimizzare il vostro potenziale commerciale!",
            upgradePackage: "Aggiornamento",
            deleteSelected: "Eliminare i file selezionati",
            newFolder: "Nuova cartella",
            newFile: "Nuovo file",
            noFilesFound: "Non sono stati trovati file in questa cartella",
            uploadFile: "Carica file",
            enterFolderName: "Inserire il nome della cartella",
            folderName: "Nome cartella",
            dropFileHere: "Lascia i file qui",
            createFolder: "Crea cartella",
            fileUploadingError: "Si è verificato un errore durante il caricamento di un file",
            fileUploadingSucs: "Cartella creata con successo",
            folderNameNotEmpty: "Il nome della cartella non può essere vuoto",
            deleteFolder: "Elimina cartella",
            sureDeleteFolder: "Sei sicuro di voler eliminare questa cartella e tutti i file in essa contenuti?",
            deletionSucs: "Cancellazione riuscita",
            deleteFile: "Elimina file",
            sureDeleteFile: "Siete sicuri di voler eliminare questo file?",
            deletionError: "Si è verificato un errore durante il processo di cancellazione",
            selectFile: "Seleziona file",
            moreThanOneSelect: "È possibile selezionare più di un file",
            selectAnFile: "Selezionare un file",
            removeZohoLinkbulkSms: "SMS di massa",
            sendBulkSmsCustomers: "Invia SMS di massa ai tuoi clienti",
            writeYourMessage: "Scrivi qui il tuo messaggio",
            sendSms: "Invia SMS",
            sendSmsYourCustomers: "Invia SMS ai tuoi clienti",
            manageChannelDetail: "Gestisci informazioni sul canale",
            details: "Dettagli",
            teamGramChannels: "Canali TeamGram",
            newTeamGramIntegration: "Nuova integrazione di TeamGram",
            teamGramIntegration: "Integrazione TeamGram",
            notMoreThanOneTeamGramChannels: "Non è possibile creare più di un canale TeamGram",
            teamGramDetail: "Dettaglio TeamGram",
            manageYourTeamGramIntegration: "Gestisci la tua integrazione TeamGram",
            trendyolChannels: "Canali Trendyol",
            trendyolStoreIntegration: "Integrazione del negozio Trendyol",
            trenyolStoreConnection: "Connetti il tuo negozio Trendyol",
            deleteTrendyolIntegration: "Elimina l'integrazione Trendyol",
            sureDeleteTrendyolIntegration: "Siete sicuri di voler eliminare l'integrazione Trendyol? Questa azione è irreversibile",
            trendyolStoreChannel: "Canale del negozio Trendyol",
            deleteTrendyolChannel: "Cancellare il canale Trendyol",
            channelUpdatedSucs: "Canale aggiornato con successo",
            failedUpdateChannel: "Aggiornamento del canale non riuscito",
            trendyolStoreIntegrationDetail: "Dettaglio integrazione negozio Trendyol",
            configureTrendyolStoreIntegrationDetail: "Configura la tua integrazione con il negozio Trendyol",
            trenyolStoreProductQuestManage: "Trendyol Store - Gestione delle richieste di prodotto",
            trendyolStoreDesc: "È possibile utilizzare le seguenti impostazioni per gestire le richieste di informazioni sui prodotti del negozio Trendyol",
            zohoCrmChannels: "Canali di Zoho CRM",
            zohoPersonalChannel: "Canali personali Zoho",
            connectZoho: "Connettiti a Zoho CRM",
            updateChannelDesc5: "Aggiornamento del canale Zoho CRM",
            zohoCrmIntegration: "Integrazione di Zoho CRM",
            sureDeleteZohoChannel: "Sei sicuro di voler eliminare il canale Zoho CRM?",
            createNotMoreThanOneZohoChannels: "Non è possibile creare più di un canale Zoho",
            removeZohoLink: "Rimuovere il collegamento Zoho",
            connectToZoho: "Connettersi a Zoho",
            chatClosed: "Chat chiusa",
            scoreChat: "Conversazione conclusa",
            createdTicket: "Biglietto creato",
            updatedTicket: "Biglietto aggiornato",
            newUserCreated: "Nuovo utente creato",
            updateUser: "Utente aggiornato",
            deleteUsers: "Utente cancellato",
            changeStatusRepresent: "Lo stato del rappresentante è cambiato",
            incomingMessage: "Messaggio in arrivo",
            outgoingMessage: "Messaggio in uscita",
            createdNewTicket: "Nuovo biglietto creato",
            bitrix24Channels: "Canali Bitrix24",
            sureDeleteBitrixChannel: "Sei sicuro di voler cancellare il canale Bitrix24?",
            bitrix24Integrations: "Integrazione Bitrix24",
            notCreateMoreThenOneChannel: "Non è possibile creare più di un canale Ideasoft",
            connectToBitrix24: "Connetti a Bitrix24",
            connectToBitrix24Api: "Connetti a Bitrix24 Api",
            updateChannel: "Canale di aggiornamento",
            updateChannelDesc: "Aggiorna il canale Api di Bitrix24",
            yourBitrix24Domain: "Il vostro nome di dominio Bitrix24",
            bitrix24ConnectedSucs: "Bitrix24 connesso con successo",
            failedToConnectBitrix24: "Connessione fallita a Bitrix24",
            channelCreatedSuccessfully: "Canale creato con successo",
            failedToCreateChannel: "Canale non creato",
            holidayPlusChannels: "Canali Holiday+",
            newHolidayPlusIntegration: "Nuova integrazione Holiday+",
            holidayPlusIntegrations: "Integrazione Holiday+",
            notCreateMoreThanOneHolidayChannel: "Non è possibile creare più di un canale Holiday+",
            holidayPlusDetail: "Dettaglio Holiday+",
            manageHolidayPlusIntegration: "Gestisci l'integrazione Holiday+",
            ideasoftChannels: "Canali Ideasoft",
            connectToIdeasoft: "Connettiti a Ideasoft",
            connectToIdeasoftApi: "Connettersi a Ideasoft api",
            updateChannelDesc2: "Aggiornamento del canale Whatsapp business api",
            ideasoftIntegration: "Integrazione Ideasoft",
            sureDeleteIdeasoftChannel: "Sei sicuro di voler eliminare il canale Ideasoft?",
            moreThanOneChannelError: "Non è possibile creare più di un canale Ideasoft",
            websiteAddress: "Indirizzo del sito web",
            ideasoftConnectedSucs: "Ideasoft si è connesso con successo",
            failedToConnectIdeasoft: "Connessione fallita a Ideasoft",
            redirectURLcopiedToClipboard: "URL di reindirizzamento copiato negli appunti",
            openAIChannels: "Canali openAI",
            newOpenAiChannel: "Nuovo canale OpenAI",
            createNewChannelOpenAi: "Crea un nuovo canale per OpenAI",
            updateChannelDesc3: "Aggiornamento del canale Whatsapp business api",
            openAiIntegration: "Integrazione OpenAI",
            sureDeleteOpenAiChannel: "Sei sicuro di voler eliminare il canale OpenAI?",
            createMoreThenOneOpenAiChannel: "Non è possibile creare più di un canale OpenAI",
            postaCellChannels: "Canali PostaCell",
            newPostaCellChannel: "Nuovi canali PostaCell",
            createNewPostaCellChannel: "Crea un nuovo canale per il provider di sms PostaCell",
            updateChannelDesc4: "Aggiornamento del canale Whatsapp business api",
            accessControl: "Controllo degli accessi",
            leads: "Conducenti",
            ensureFacebookAccount: "Assicurarsi che abbia un account e una pagina Facebook",
            ensureAdAccount: "Assicurarsi che abbia un account pubblicitario",
            page: "Pagina",
            leadCount: "Conteggio dei lead",
            showLeads: "Mostra lead",
            syncLeeds: "Sincronizza Leeds",
            wpStartChat: "Lanciatore di chat Whatsapp",
            archivedIn: "Archiviato?",
            makeSelect: "Effettua selezione",
            newLead: "Nuovo Leed",
            initalContact: "Primo contatto",
            needsAssessnment: "Analisi dei bisogni",
            proposalSent: "Offerta inviata",
            proposalReview: "Revisione della proposta",
            negotiation: "Contrattazione",
            decisionStage: "Fase decisionale",
            closure: "Chiusura",
            followUp: "Follow",
            campagin: "Campagna",
            adSet: "Ad Set",
            ad: "Annuncio",
            inArchived: "Archiviato",
            deletedSelectedPerson: "Elimina le persone selezionate",
            sureDelSelectedPerson: "Sei sicuro di voler cancellare le persone selezionate?",
            deletePerson: "Cancellare una persona",
            sureDeletePerson: "Sei sicuro di voler cancellare la persona?",
            phoneNumberNotAvailable: "Numero di telefono non disponibile",
            statusSucsUpdated: "Stato aggiornato con successo",
            statusUpdatedFailed: "Si è verificato un errore durante l'aggiornamento dello stato",
            archivedContact: "Contatto archiviato",
            sureWantArchivePerson: "Sei sicuro di voler archiviare questa persona?",
            personArchived: "Persona archiviata",
            personArchivedHead: "Operazione di archiviazione non riuscita",
            metaLeadChannels: "Meta Lead Channels",
            wpStartSpeech: "Avvio discorso Whatsapp",
            pleaseSelectStartChat: "Selezionare il canale su cui si desidera avviare la chat:",
            phoneNumber: "Numero di telefono",
            phoneNumberDesc: "Codice paese con solo numeri senza spazi",
            channelDesc: "Su quale canale si desidera avviare la chat",
            pleaseSelectStartChatOn: "Selezionare il canale su cui si desidera avviare la chat",
            notAuthorisedChannel: "Non sei autorizzato ad accedere a questo canale",
            phoneNumberError: "Numero di telefono non corretto",
            chatStartError: "Si è verificato un errore nell'avvio della chat. Riprovare",
            noRecordFailed: "Nessun record trovato",
            metaLeadsChannel: "Canale Meta Leads",
            mlChannelDetails: "Dettagli del canale Meta Leads",
            manageMlChannel: "Gestisci i tuoi Meta Leads",
            deleteMetaLeadsChannelInfo: "Sei sicuro di voler eliminare il canale Meta Leads?",
            contactPage: "Pagina dei Contatti",
            addRouted: "Aggiungi instradato",
            otherEmailProviders: "Altri provider di posta elettronica",
            visitorScreenNaming: "Nomi delle schermate dei visitatori",
            enterCatalogTitle: "Inserire il titolo del catalogo...",
            passwordUpdate: "Aggiornare la password",
            showCenterScreen: "Visualizzazione al centro dello schermo",
            skipNow: "Salta ora",
            confirm: "Confermare",
            newTable: "Nuova tabella",
            actions: "Transazioni",
            integrationsTrendyol: "Collega il tuo negozio Trendyol e rispondi automaticamente alle domande dei tuoi clienti.",
            integrationsHoliday: "Integra Holiday+ per fornire hotel e camere tramite chatbot!",
            integrationsTeamgram: "Trasferisci i tuoi clienti da Supsis a Teamgram per semplificare la gestione dei clienti!",
            integrationsTicimax: "Invia un messaggio automatico ai membri segmentati di Ticimax.",
            integrationsBitrix24: "Attiva l'API Bitrix24 per un'esperienza chatbot migliorata per i tuoi clienti.",
            integrationsIdeasoft: "Attiva l'API Ideasoft per un'esperienza chatbot migliorata per i tuoi clienti.",
            integrationsOpenAI: "Attivare i servizi OpenAI, Risposta dell'IA del Chatbot, Assistente IA CoPilot, Base di conoscenza dell'IA del Chatbot.",
            integrationsSMSPostacell: "Attiva l'invio di SMS tramite il fornitore di SMS PostaCELL.",
            integrationsMetaLeads: "Gestisci i tuoi contatti Meta tramite Supsis. Collega i contatti ai ticket, al chatbot o al supporto live.",
            integrationsZoho: "Integrate i vostri processi aziendali in Zoho CRM con Supsis.",
            forward: "in avanti",
            packUpRequired: "Aggiornamento del pacchetto richiesto",
            upgradePack: "Pacchetto di aggiornamento",
            supsisMobilApp: "APP MOBILE SUPSIS",
            supsisMobilAppDesc: "App per IOS e Android sul mercato!",
            sendEmail: "Invia e-mail",
            jumpToMessage: "Clicca per andare al messaggio",
            doesntMatter: "Non importa",
            events: "Calendario eventi",
            reservations: "Prenotazioni",
            designer: "Design",
            targetContacts: "Contatti di destinazione",
            scheduler: "Scheduler",
            planAndTask: "Piano e compiti",
            insights: "Approfondimenti",
            createRole: "Crea ruolo",
            createSubject: "Creare il soggetto",
            createUser: "Crea utente",
            blockManuel: "Blocco Manuel",
            showHide: "mostra/nascondi",
            contactSearch: "Ricerca contatti",
            favorite: "preferiti",
            downloadAllData: "scaricare tutti i dati",
            downloadThePage: "Scarica la pagina",
            choosePoints: "scegli punti",
            createdAt: "Creato a",
            action: "azione",
            searchChannel: "Ricerca Canali",
            activeChannels: "Canali attivi",
            deleteChannels: "Canali eliminati",
            selectChannel: "Seleziona Canale",
            channelFilter: "Filtro canale",
            noConversationDesc: "Qui puoi vedere le chat attive e le chat assegnate a te.",
            forMe: "Per me",
            unAssigned: "Non assegnato",
            agentDetails: "Dettagli dell'agente",
            contactProperties: "Proprietà di contatto",
            goToProfile: "Vai al profilo",
            addNote: "Aggiungi nota",
            noPreferredAgent: "Nessun agente preferito ancora",
            toPrefer: "Preferire",
            inChat: "Nella chat",
            watching: "Guardando",
            chatsTitle: "Chat",
            dealyTimeMaxValueError: "Il tempo di ritardo può essere al massimo 15",
            dealyTimeTypeError: "Il valore del tempo di ritardo deve essere un numero",
            passedTimeHm: "{hour} Ore {min} Minuti",
            passedTimeMs: "{min} Minuti {sec} secondi",
            passedTimeSc: "{sec} Secondi",
            translateMessage: "Il tuo messaggio è stato tradotto dall'intelligenza artificiale.",
            toneChanged: "Il tono del messaggio è stato cambiato in {tone}",
            aiResponseAdded: "Risposta AI aggiunta al messaggio",
            messageLonger: "Messaggio reso più lungo",
            grammarFixed: "Grammatica corretta",
            aiTranslate: "Traduzione",
            other: "Altro",
            yourLanguage: "La tua lingua",
            contactLanguage: "lingua del cliente",
            myLanguage: "La mia lingua",
            forwardToChatbot: "Inoltra al Chatbot",
            friendly: "Amichevole",
            confident: "Sicuro",
            straightForward: "Diretto",
            casual: "Casuale",
            professional: "Professionale",
            longSentence: "Frase Lunga",
            changeTone: "Cambia Tonalità",
            fixGrammar: "Correggi Grammatica",
            aiResponse: "Risposta AI",
            templateButtonNote: "Per vietare il contatto, fare attenzione a utilizzare i seguenti testi sul pulsante di divieto. Indipendentemente dalle lettere maiuscole o minuscole",
            templateButtonTags: "#Invia messaggio# | #Annulla iscrizione# | #Vieta# | #Blocca#",
            dashboard: "Dashboard",
            adminReports: "Admin Reports",
            calendarModule: "Modulo calendario",
            taskModule: "Modulo di gestione delle attività",
            maxUrlButtonMessage: "Puoi aggiungere un massimo di 2 pulsanti URL.",
            noPreferredDepartment: "Nessun dipartimento preferito",
            searchForDepartment: "Cerca dipartimento",
            departmentAssignedToTheVisitor: "Seleziona il dipartimento che desideri assegnare al visitatore.",
            assignPreferredDepartment: "Assegna il dipartimento preferito",
            smsChannel: "Canale SMS: ",
            whatsappv2Channel: "Canale Whatsapp V2: ",
            whatsappv1Channel: "Canale Whatsapp V1: ",
            wBChannel: "Canale Whatsapp Business: ",
            messengerChannel: "Canale Messenger: ",
            instagramChannel: "Canale Instagram: ",
            allPlatforms: "Tutte le piattaforme",
            cbStartMessage: "Messaggio di avvio del chatbot",
            cbStartMessageDesc: "Il primo messaggio inserito dall'utente viene elaborato automaticamente dal chatbot e indirizzato all'indirizzo rilevante.",
            messengerUserProfile: "Profilo utente di Messenger",
            instagramUserProfile: "Profilo utente Instagram",
            noEventFound: "Nessun evento trovato",
            visitorMails: "Mail dei visitatori",
            visitorActions: "Azioni dei visitatori",
            notVerified: "Non verificato",
            visitorEvents: "Eventi dei visitatori",
            assignedTasks: "Compiti assegnati",
            mails: "Mail",
            prefferedAgents: "Agenti preferiti",
            createEvent: "Crea evento",
            blockManagement: "Gestione del blocco",
            deleteUser: "Elimina utente",
            blocked: "Bloccato",
            profiles: "Profili",
            similiarProfiles: "Profili simili trovati",
            ReplyAsAPm: "Rispondi come messaggio privato e chiudi",
            replyAsAComment: "Rispondi come commento e chiudi",
            messengerAddDesc: "Fai clic sul pulsante Connetti qui sotto e accedi al tuo account Facebook.",
            instaAddPrivacyCheckDesc: "Ho letto e accetto la {Privacy} e i {Terms and Conditions}",
            instaAddDesc5: "Fai clic sul pulsante Connetti qui sotto e accedi al tuo account Facebook.",
            instaAddDesc4: "Registrati come sviluppatore Facebook",
            instaAddDesc3: "Assicurati che il commutatore <b>'Consenti l'accesso ai messaggi'</b> sia attivato",
            instaAddDesc2: "Assicurati che il tuo account professionale Instagram sia collegato alla tua pagina Facebook",
            instaAddDesc1: "Assicurati che il tuo account Instagram sia un account professionale Instagram (account aziendale).",
            selectedDepartment: "Dipartimento selezionato",
            departmentForwardEnable: "Regola di inoltro del dipartimento abilitata",
            departmentForwardRule: "Regola di inoltro del dipartimento",
            departmentForwardDesc: "Seleziona a quale dipartimento inoltrare le chat in arrivo al canale.",
            channelName: "Nome del canale",
            forwardToLiveAgents: "👉 Inoltra agli agenti in diretta",
            manageIgChannel: "Gestisci il tuo canale Instagram",
            igDetail: "Dettaglio Instagram",
            manageVisibilityDesc: "Gestisci chi può vedere questo canale",
            selectAnIgAccount: "Seleziona un account Instagram",
            connectToInsta: "Collegati a Instagram",
            connectToMetaLeads: "Connetti a Meta Leads",
            deleteInstaChannelInfo: "Sei sicuro di voler eliminare il canale Instagram?",
            instagramChannels: "Canali Instagram",
            suspendedDescription: "Il tuo account è stato sospeso a causa di fatture non pagate.",
            onlyChatbot: "Solo Chatbot",
            onlyAgents: "Solo Agenti",
            checkboxWarning: "Questo campo deve essere obbligatoriamente selezionato",
            sendingAllow: "Invio",
            receiving: "Ricezione",
            platform: "Piattaforma",
            banModalTitle: "Finestra modale di divieto visitatori",
            selectDepartmentDesc: "Seleziona i dipartimenti di cui vuoi modificare la visibilità",
            selectAgentDesc: "Seleziona gli agenti di cui vuoi modificare la visibilità",
            selectDepartment: "Seleziona Dipartimento",
            selectAgent: "Seleziona Agente",
            visibleDepartments: "Dipartimenti visibili",
            visibleAgents: "Agenti visibili",
            visibilityInfoCont: "Tutti gli agenti e i dipartimenti possono vedere questo canale",
            editDepartmentVisibility: "Modifica permessi dipartimento",
            editAgentVisibility: "Modifica permessi agente",
            typeSTToSearch: "Digita qualcosa per cercare gli utenti",
            exportToCSV: "Esporta in CSV",
            clear: "Cancella",
            usedSessionCount: "Numero di sessioni utilizzate",
            maxSessionCount: "Numero massimo di sessioni",
            leftSessionCount: "Numero di sessioni rimanenti",
            planManagement: "Gestione del piano",
            maxAutomationTask: "Numero massimo di attività di automazione",
            teamChat: "Chat di squadra",
            templateNameIsNotValid: "Il nome del modello non è valido",
            relatedAdvertisement: "Pubblicità correlata",
            whatsappNumber: "Numero di Whatsapp",
            integrationsWhatsappV1: "È necessario un piano WhatsApp per una comunicazione senza problemi tra Supsis e WhatsApp.",
            integrationsWhatsappV2: "Puoi facilmente condividere le informazioni della chat tra Supsis e WhatsApp.",
            integrationsWhatsappBusiness: "Puoi trasmettere rapidamente e comodamente le informazioni della chat tra Supsis e WhatsApp.",
            selectDays: "Seleziona giorni",
            addTime: "Aggiungi ora",
            instagramContactList: "Lista contatti Instagram",
            archiveAllRated: "Recupera tutte le conversazioni con qualsiasi valutazione.",
            allChannels: "Tutti i canali",
            comment: "commento",
            news: "cosa c'è di nuovo",
            speechTermination: "Terminazione del discorso",
            noSystemMessage: "Nessun messaggio di sistema",
            supsisCustomerService: "Supsis Servizio Clienti,",
            supsisClickExperience: "Clicca per provare l'esperienza",
            customerPage: "Vai alla pagina cliente",
            buttonTitle: "Titolo del pulsante",
            buttonType: "Tipo di pulsante",
            buttonSendMessage: "Invia messaggio",
            buttonGoToBlock: "Vai al blocco",
            buttonOpenUrl: "Apri URL",
            buttonPhoneCall: "Chiamata telefonica",
            buttonOpenMoment: "Apri Momento",
            buttonCloseChat: "Chiudi chat",
            buttonTransferChat: "Trasferisci chat",
            buttonCreateTicket: "Crea ticket",
            you: "Tu",
            and: "e",
            deleteVisitor: "Elimina visitatore",
            dndBlocked: "Blocco DND",
            tokenCopied: "Token copiato",
            apiIntegration: "Integrazione API",
            generateToken: "Genera token",
            copyToken: "Copia token",
            labels: "Etichette",
            noData: "Nessun dato",
            color: "Colore",
            titleColor: "Colore del titolo",
            secondTitleColor: "Colore del secondo titolo",
            tag_name_indicator: "Nome dell'etichetta",
            sendMessage: "Invia messaggio",
            removeFromG: "Rimuovi dal gruppo",
            delChannel: "Sei sicuro di voler eliminare questo canale?",
            new_name: "Nuovo nome",
            set_group_info: "Modifica informazioni di gruppo",
            shortcut_desc_num: "Passa da una conversazione all'altra con cifre numeriche",
            copilot_desc_num: "Ti consente di aprire Copilot nella schermata della chat",
            typing_w_chat: "sta scrivendo...",
            edit_group_info: "Modifica informazioni del gruppo",
            notif_sound: "Attiva i suoni delle notifiche",
            notif_mute: "Silenzia le notifiche",
            leave: "Lasciare",
            group: "Gruppo",
            updateTag: "Aggiorna Tag",
            ordered_desc: "Assegna le chat ai rappresentanti in ordine.",
            random_desc: "Assegna le chat ai rappresentanti in modo casuale.",
            Rrobin_desc: "Assegna le chat ai rappresentanti in modo round robin. (Priorità ai rappresentanti meno occupati)",
            RrobinRev_desc: "Assegna le chat ai rappresentanti in modo round robin inverso. (Priorità ai rappresentanti più occupati)",
            algo_desc: "Seleziona l'algoritmo per l'assegnazione automatica delle chat",
            algorithm: "Algoritmo",
            os_browser: "Sistema operativo e browser",
            addTag: "Aggiungi tag",
            tags: "Tag",
            searchRepresentative: "Ricerca rappresentante",
            voting: "Votazione",
            chatWidget: "Widget chat",
            webhooks: "Webhooks",
            selectHooks: "Seleziona hooks",
            planRequired: "{integratable} Piano Obbligatorio.",
            allIntegrations: "Tutte le integrazioni",
            disableAgentSystemMessages: "Disabilita i messaggi di sistema dell'agente",
            disableAgentSystemMessagesDesc: "Nascondi messaggi di sistema dell'agente.",
            disableAutoTranslate: "Disabilita la traduzione automatica",
            disableAutoTranslateDesc: "Traduce automaticamente i messaggi da diverse lingue. In questo modo puoi comunicare più facilmente con i tuoi clienti.",
            shouldAddMethod: "È necessario compilare il campo Metodo di pagamento e indirizzo di fatturazione!\nNessun denaro verrà prelevato dal tuo conto.\nAlla fine del mese, verrà creata una fattura in base all'importo dell'utilizzo.",
            approveSelection: "Approva selezione",
            trialDaysEndSelectPlan: "Conferma la selezione del piano",
            trialDaysEndSelectPlanDesc: "La tua versione di prova è terminata. Devi confermare selezionando il piano qui sotto.",
            infinitePlay: "Riproduzione infinita",
            hideBubbleOnMobile: "Nascondi la bolla sul cellulare",
            deleteSystemLanguage: "dal sistema {code} si asciuga la lingua",
            assignedChat: "Chat assegnata",
            check: "Controllo",
            systemStatus: "Stato del sistema",
            chatAssignedToUser: "Chat assegnata a {user}",
            inactiveThresholdTime: "Tempo limite inattivo (minuti)",
            tippyInactiveThresholdTime: "Se non viene inviato alcun messaggio entro il tempo stabilito, la conversazione è considerata passiva, inserire il valore (minuti). Minimo 1 minuto e massimo 120 minuti.",
            inactiveTerminateTime: "Tempo limite di inattività (minuti)",
            tippyInactiveTerminateTime: "Se non viene inviato alcun messaggio entro il tempo stabilito, la conversazione viene terminata, inserire il valore (minuti). Minimo 1 minuto e massimo 120 minuti.",
            removePendingMessage: "Rimuovi messaggio in sospeso",
            disconnected: "Disconnesso",
            visitorWriteEmptyChatTippy: "Il visitatore può scrivere senza che l'agente sia connesso.",
            visitorWriteEmptyChat: "Il visitatore può scrivere senza che l'agente sia connesso.",
            visitorConnectionEventSystemMessageEnabled: "Il visitatore è entrato e ha abilitato i messaggi di sistema del visitatore.",
            visitorConnectionEventSystemMessageEnabledTippy: "Il visitatore è entrato e ha abilitato i messaggi di sistema del visitatore.",
            openBubble: "Apri bolla",
            changeLogo: "Cambia logo",
            changePhoto: "Cambia foto",
            addPhoto: "Aggiungi una foto",
            seePhoto: "Guarda la foto",
            deletePhoto: "Eliminare la foto",
            askQuestion: "Fai una domanda",
            locationPermsNeeded: "Per utilizzare la funzione di condivisione della posizione, è necessario abilitare i permessi di posizione.",
            useMyLocation: "Usa la mia posizione",
            acceptingChat: "Accettazione chat",
            notAcceptingChat: "Non accettazione chat",
            websiteChatWidgetIntegration: "Integrazione del widget di chat del sito web",
            loggedOut: "Disconnesso",
            listStatuses: "Stati della lista",
            hideInactiveAgents: "Nascondi agenti inattivi",
            hideMinorValues: "Nascondi valori minori",
            agentActivities: "Attività dell'agente",
            newHASHContent: "Nuovo contenuto HASH",
            hash: "HASH",
            languageRemovalQuestion: "dal sistema {code} Stai per cancellare la tua lingua!",
            blockBy: "Rappresentante",
            hashText: "Biglietto",
            exampleHash: "tracciamento dell'ordine",
            notValidHash: "Non deve contenere spazi",
            videoCallEnabledDesc: "Attiva per abilitare la funzione di videochiamata",
            videoCallEnabled: "Videochiamata",
            audioCallDesc: "Attiva per abilitare la funzione di chiamata audio",
            audioCallEnabled: "Funzione di ricerca vocale",
            assignPreferredAgent: "Assegna agente preferito",
            representativeAssignedToTheVisitor: "Seleziona l'agente preferito che desideri assegnare al visitatore.",
            agentFileSendEnabledDesc: "Consente ai delegati di inviare file",
            agentFileSendEnabled: "I delegati possono inviare file",
            visitorFileSendEnabledDesc: "Consente ai visitatori di inviare file",
            visitorFileSendEnabled: "I visitatori possono inviare file",
            visitorAutoLogin: "Accesso automatico del visitatore",
            visitorAutoLoginDesc: "Il visitatore viene automaticamente connesso al sistema",
            agentVoiceRecordEnabledDesc: "I rappresentanti possono abilitare la funzione di registrazione vocale",
            agentVoiceRecordEnabled: "I rappresentanti possono registrare la voce",
            visitorVoiceRecordEnabledDesc: "I visitatori possono abilitare la funzione di registrazione vocale",
            visitorVoiceRecordEnabled: "I visitatori possono registrare la voce",
            startVideoCall: "Videochiamata",
            startAudioCall: "Chiamata audio",
            visitorGDPRDeleteEnabledDesc: "I visitatori possono eliminare tutte le informazioni",
            visitorGDPRDeleteEnabled: "I visitatori possono eliminare tutte le informazioni",
            visitorLocationEnabled: "I visitatori possono condividere la posizione",
            visitorLocationEnabledDesc: "I visitatori possono condividere la posizione",
            customerLocationEnabled: "I rappresentanti possono condividere la posizione",
            customerAutoMergeEnabled: "Unisce automaticamente le stesse persone",
            customerAutoMergeEnabledDesc: "Questa funzione effettua automaticamente l'unione dei dati relativi alle stesse persone in modo efficace. Ciò assicura che gli utenti con profili simili siano rappresentati in modo più coerente e ordinato nei set di dati.",
            chatAiCopilot: "Assistente chat AI",
            chatAiCopilotDesc: "Rispondi automaticamente alle domande dei tuoi clienti utilizzando l'Assistente chat AI",
            customerLocationEnabledDesc: "I rappresentanti possono condividere la posizione",
            thoesNotOwners: "Mantieni i non proprietari in coda",
            thoesNotOwnersDesc: "Si attiva questa funzione per mantenere in coda le persone che non sono proprietarie della conversazione",
            hideContactInfo: "Nascondi le informazioni di contatto",
            hideContactInfoDesc: "Quando si attiva questa funzione, i numeri e le e-mail dei clienti saranno nascosti agli agenti",
            triggerAlreadyExists: "Il trigger esiste già",
            ticketStatusForm: "Titolo dello stato del ticket",
            statusFormTitle: "Titolo",
            allStatus: "Tutti gli stati",
            triggers: "Trigger",
            trigger: "Trigger",
            noTrigger: "Nessun trigger",
            triggerSkipLoginForm: "Modulo di accesso",
            triggerSkipLoginFormTrue: "Mostra modulo di accesso",
            triggerSkipLoginFormFalse: "Salta il modulo di accesso e passa direttamente al messaggio",
            noContent: "Nessun contenuto",
            toCreate: " per creare",
            clickTheButton: "Clicca il pulsante",
            triggerContent: " per creare un trigger. I trigger sono utilizzati per inviare messaggi automatici ai visitatori in base alle condizioni impostate.",
            triggerDrag: "Trascina e rilascia i trigger per riordinarli.",
            triggerNewCondition: "Nuova condizione",
            triggerNoConditionDescription1: "Sulla pagina del visitatore è attivo solo uno dei trigger con le stesse condizioni.",
            triggerNoConditionDescription2: "Per visualizzare un trigger come attivo, è necessario modificare le condizioni degli altri trigger.",
            triggerShowAndHide: "Mostra/nascondi trigger",
            countryLanguage: "Paese/Lingua",
            addTrigger: "Aggiungi trigger",
            yesPlease: "Sì grazie!",
            noThanks: "No grazie.",
            firstAnswer: "Prima risposta",
            secondAnswer: "Seconda risposta",
            noTitle: "senza titolo",
            sumChat_MediaFile: "Media e documenti",
            importantWarning: "AVVERTENZA IMPORTANTE!",
            images: "Immagini",
            URLS: "Collegamenti",
            files: "File",
            warning: "Attenzione!",
            noCondition: "Nessuna condizione",
            showTriggers: "Mostra trigger",
            showThisTrigger: "Mostra questo trigger",
            hideTriggers: "Nascondi trigger",
            hideThisTrigger: "Nascondi questo trigger",
            updateTrigger: "Aggiorna trigger",
            conditions: "Condizioni",
            messageDurationPerRow: "Durata del messaggio (per riga)",
            dayTime: "Orario di lavoro",
            weekDay: "Giorno della settimana",
            spendTimePage: "Tempo trascorso sulla pagina",
            spendTimeSite: "Tempo trascorso sul sito",
            pageUrl: "URL della pagina",
            pageTitle: "Titolo della pagina",
            equal: "Uguale",
            not_equal: "Non uguale",
            less_than: "Minore di",
            greater_than: "Maggiore di",
            less_than_or_equal: "Minore o uguale",
            greater_than_or_equal: "Maggiore o uguale",
            visitorName: "Nome del visitatore",
            seconds10: "10 secondo",
            seconds30: "30 secondo",
            minute1: "1 minuto",
            minutes5: "5 minuto",
            minutes10: "10 minuto",
            minutes30: "30 minuto",
            hour1: "1 ora",
            hours2: "2 ora",
            hours4: "4 ora",
            hours8: "8 ora",
            hours12: "12 ora",
            hours24: "24 ora",
            maxCondition: "Massimo 5 condizioni",
            doYouWishToDeleteTrigger: "Vuoi eliminare il trigger?",
            contains: "Contiene",
            not_contains: "Non contiene",
            chatLanguage: "Lingua della chat",
            translating: "Traduzione",
            liveSupportStartingWait: "Live support starting, please wait...",
            noConnection: "No connection",
            buyWhatsapp: "Buy Whatsapp",
            integrations: "Integrations",
            refundInvoiceSure: "Sei sicuro di voler rimborsare questa fattura?",
            invoiceMarkedAsPaidSuccess: "Invoice marked as paid successfully.",
            invoiceMarkedAsPaidError: "Invoice marked as paid error.",
            deleteConfirm: "Questo {object} Vuoi davvero eliminare?",
            markPaidConfirm: "Sei sicuro di voler contrassegnare questa fattura come pagata?",
            startChatDesc: "Inizia una chat con i visitatori",
            addLink: "Aggiungi link",
            selectStep: "Seleziona passo: ",
            addGOTO: "Aggiungi GOTO",
            sendFastLink: "Invia link di accesso senza password",
            or: "o",
            allTags: "Tutti i tag",
            showDetail: "Mostra dettagli",
            hideDetail: "Nascondi dettagli",
            weLlSendPhone: "Invieremo un SMS",
            weLlSendEmail: "Invieremo un'e-mail",
            linkSentToPhone: "Link inviato al tuo telefono",
            offerlinkSendToPhone: "Invieremo un SMS con il link per scaricare l'applicazione.",
            offerlinkSendToMail: "Invieremo un'e-mail con il link per scaricare l'applicazione.",
            theEmail: "L'email",
            differentEmail: "diverso dall'email di registrazione",
            linkSentToMailBox: "Link inviato alla tua casella di posta",
            errorOccurred: "Si è verificato un errore !",
            clickStoreIcon: "Fai clic sull'icona del tuo negozio",
            meetWithSupsis: "Incontra Supsis",
            downloadMobileApps: "Scarica le app mobili",
            getApps: "Ottieni le app",
            info: "Informazioni",
            conversationHistory: "Cronologia della conversazione",
            planInfoHeader: "Informazioni sul piano",
            planInformation: "il tuo piano {selectedPlan} Piano ({detailMaxAgentCount} Rappresentante) ({freeAgent} agente libero)",
            creditAvailable: "Il tuo credito agente disponibile sul tuo piano: ",
            upDownGradePlan: "Se desideri eseguire l'upgrade/downgrade del tuo piano, per favore",
            click: "clicca",
            all: "Tutti",
            allDepartments: "Tutti i dipartimenti",
            preferredLanguage: "Lingua preferita",
            kmkAutoDepartmentBind: "KMK Auto Department Bind",
            kmkAutoDepartmentBindDesc: "KMK Auto Department Bind",
            visitorEmailUpdated: "Email del visitatore aggiornata",
            visitorEmailIsNotValid: "L'email del visitatore non è valida",
            visitorNameUpdated: "Nome del visitatore aggiornato",
            clickToEdit: "Clicca per modificare",
            addEmail: "+ Aggiungi e-mail",
            addFullname: "+ Aggiungi nome completo",
            partner: "Partner",
            isIntegrated: "Integrato",
            agentCount: "Conteggio agente",
            autoStartChat: "Chat di avvio automatico",
            bubbleColor: "Colore della bolla",
            openFolder: "Apri cartella",
            preDefined: "Predefinito",
            customIcon: "Icona personalizzata",
            theme: "Tema",
            themeSettings: "Impostazioni del tema",
            chatThemeSettings: "Impostazioni del tema della chat",
            bubbleSettings: "Impostazioni della bolla",
            inputHeightOfBubble: "Altezza della bolla",
            inputPixelsOfChatBubble: "Pixel della bolla di chat",
            modalTitleIsMarginAsPixelInfo: "Distanza della bolla della chat dai bordi :  ",
            inputPxOfXaxis: "Posizione orizzontale",
            inputPxOfYaxis: "Posizione verticale",
            inputPxOfMobileXaxis: "(Mobile) Posizione orizzontale",
            inputPxOfMobileYaxis: "(Mobile) Posizione verticale",
            animations: "Animazioni",
            preferredAnimation: "Animazione preferita",
            selectAnAnimation: "Seleziona un'animazione",
            inputOfBubbleMessage: "Aggiungi contenuto a enormi bolle di chat.\n{contentOfChatBubble}",
            showChatBubbleOnlyLoggedUserToolTip: "Impostazione per nascondere il fumetto della chat in base allo stato di accesso. Se è disattivato, verrà mostrato a tutti i visitatori.",
            showChatBubbleOnlyLoggedUser: "Mostra la bolla solo agli utenti che hanno effettuato l'accesso. (ideasoft)",
            helloDoUNeedHelp: "Ciao, posso aiutarti!",
            bubbleIcon: "Icona della bolla",
            overrideMargins: "Override Margins",
            autoHideBubble: "Nascondi automaticamente la bolla",
            vtippyAutoHideBubble: "Nasconde automaticamente la bolla dopo 5 secondi.",
            hideBubble: "Nascondi la bolla",
            vtippyHideBubble: "Nasconde la bolla.",
            overrideMobileMargin: "Override Mobile Margin",
            vtippyMobileMargin: "Sovrascrive il valore del margine per mobile.",
            vtippyHideBubbleOnMobile: "Il fumetto della chat è nascosto agli utenti mobili.",
            isFabsActive: "Mostra popup",
            isAlwaysActive: "Il menu è sempre aperto",
            isAlwaysActiveDesc: "Vuoi che il menu della chat rimanga sempre aperto nella visualizzazione web?",
            bubbleOpenableMenu: "Menu a discesa della bolla della chat",
            vtippyIsFabsActive: "Impostazione per mostrare/nascondere i menu a comparsa",
            vtippyIsFabsAsIcon: "È l'impostazione della visualizzazione delle icone nel menu a discesa.",
            vtippyTranslateButton: "Traduce la lingua selezionata in altre lingue.",
            vtippyTranslateClearButton: "Pulisce la traduzione.",
            vtippySelectnotification: "Seleziona la notifica",
            vtippyVoiceLevel: "Impostazione del livello di volume",
            vtippyStartVoice: "Avvia la notifica vocale",
            vtippyInfiniteNotification: "Impostazione per riprodurre la notifica vocale in modo continuo. (Se è disattivato, verrà riprodotto solo una volta.)",
            vtippyNewVisitorNotification: "Impostazione per la notifica vocale dei nuovi visitatori.",
            vtippyNewChatNotification: "Impostazione per la notifica vocale dei nuovi chat.",
            vtippyNewConversationNotification: "Impostazione per la notifica vocale delle nuove conversazioni.",
            vtippyNewMessageNotification: "Impostazione per la notifica vocale dei nuovi messaggi.",
            vtippyPrivateMessageNotification: "Impostazione per la notifica vocale dei messaggi privati.",
            isFabsAsIcon: "Mostra icone",
            setMarginAsPixel: "Imposta margini come pixel",
            returnDefaultMargins: "Ripristina i margini predefiniti",
            closePreviewColors: "Chiudi anteprima colori",
            previewColors: "Anteprima colori",
            videoCalls: "Chiamate video",
            filterLost: "Filtro perso",
            vtipyCustomLogin: "Se è attivato, il sistema di accesso personalizzato verrà utilizzato per l'accesso. (Se è disattivato, il sistema di accesso predefinito verrà utilizzato per l'accesso.)",
            vtipyLoginlessChat: "Se è attivato, il sistema di accesso personalizzato verrà utilizzato per l'accesso. (Se è disattivato, il sistema di accesso predefinito verrà utilizzato per l'accesso.)",
            loginlessChat: "Chat senza accesso",
            imageUrl: "URL dell'immagine",
            replied: "Risposto",
            solved: "Risolto",
            openImage: "Apri immagine",
            writeFeedback: "Scrivi un feedback",
            feedbackFailed: "Invio del feedback non riuscito.",
            feedbackSuccessful: "Feedback inviato con successo.",
            sendFeedback: "Invia feedback",
            errorReport: "Segnala un errore",
            sendErrorFeedBack: "Invia feedback di errore",
            successImgUpload: "Immagine caricata con successo",
            successImgDelete: "Immagine eliminata con successo.",
            errorImgUpload: "Errore durante il caricamento dell'immagine",
            errorImgDelete: "Si è verificato un errore durante l'eliminazione dell'immagine",
            chatBotEndStatics: "Statistiche di fine chatbot",
            videoCallDist: "Distanza della chiamata video",
            deleteSite: "\" {siteName} \" Eliminare il sito?",
            deleteThisSite: "Elimina questo sito",
            departmentInfo: "Informazioni sul dipartimento",
            infoAboutDepartment: "Informazioni sul dipartimento",
            deleteDepartmentQuestion: "Eliminare il dipartimento?",
            departmentDeleted: "Dipartimento eliminato",
            departmentTitle: "Titolo del dipartimento",
            updateDepartmentForm: "Modulo di aggiornamento del dipartimento",
            updateCompleted: "Aggiornamento completato",
            CatalogUpdatedSuccessfully: "Catalogo aggiornato con successo",
            integrateSupsiswithIntegratable: "Supsis e {integratable} Trasmetti facilmente le informazioni sulla chat tra",
            installationOK: "Caricato",
            newDepartmentForm: "Nuovo modulo di registrazione del dipartimento",
            newDepartment: "Nuovo dipartimento",
            departmentSaved: "Dipartimento salvato",
            selectAll: "Seleziona tutto",
            collapseAll: "Comprimi tutto",
            expandAll: "Espandi tutto",
            addUsersToDepartment: "Aggiungi utenti al dipartimento",
            removeFromDepartment: "Rimuovi dal dipartimento",
            moveToDepartment: "Sposta in altro dipartimento",
            noUsersInDepartment: "Nessun utente in questo dipartimento",
            selectAtLeastOneUser: "Seleziona almeno un utente",
            departmentUsersUpdated: "Utenti aggiornati",
            copyToDepartment: "Aggiungi anche al dipartimento",
            userAlreadyInDepartment: "L'utente è già in questo dipartimento",
            removeUserFromDepartmentConfirm: "Sei sicuro di voler rimuovere questo utente dal dipartimento?",
            bulkUpdateProgress: "Aggiornamento massivo",
            usersUpdated: "aggiornato",
            moveToAllDepartments: "Sposta in tutti i dipartimenti",
            copyToAllDepartments: "Aggiungi anche a tutti i dipartimenti",
            deselectAll: "Deseleziona tutto",
            sameDepartment: "C'è un dipartimento con lo stesso nome",
            sameValue: "C'è un valore con lo stesso nome!",
            departments: "Dipartimenti",
            department: "Dipartimento",
            announcements: "Annunci",
            announcement: "Annuncio",
            newAnnouncement: "Nuovo annuncio",
            announcementInfo: "Informazioni sull'annuncio",
            infoAboutAnnouncement: "Informazioni sull'annuncio",
            deleteAnnouncementQuestion: "Eliminare l'annuncio?",
            announcementDeleted: "Annuncio eliminato",
            announcementTitle: "Titolo dell'annuncio",
            updateAnnouncementForm: "Modulo di aggiornamento dell'annuncio",
            newAnnouncementForm: "Nuovo modulo di registrazione dell'annuncio",
            announcementSaved: "Annuncio salvato",
            chatTimingSettings: "Impostazioni di temporizzazione della chat",
            assetOversize: "La dimensione del file deve essere inferiore a 10 MB",
            assetOversizeMB: "La dimensione del file che desideri inviare non deve superare i {mb} MB.",
            assetOversizeWithExt: "La dimensione del file deve essere inferiore a 10 MB. ({ext})",
            messageDeleted: "Messaggio eliminato",
            filterVideoCall: "Filtra le chiamate video",
            filterLostChat: "Filtra le chat perse",
            filterClosedByAgent: "Filtra le chat chiuse dall'agente",
            notificationText: "Testo della notifica ",
            notificationTitle: "Titolo della notifica",
            deniedText: "Le tue notifiche sono chiuse, devi attivarle per non perdere i tuoi clienti.",
            deniedTitle: "Per favore, attiva le notifiche",
            deniedHeader: "Notifiche disattivate",
            showNotificationGuide: "Clicca per vedere i dettagli",
            howToEnableNotification: "Come posso abilitare le notifiche",
            notificationOK: "OK",
            notificationUnderstood: "Compreso!",
            notificationCancel: "Annulla",
            howToEnableNotificationInstruction1: "Fare clic sull'icona del lucchetto nella barra degli indirizzi del browser",
            howToEnableNotificationInstruction2: "Se Notifiche è disabilitato nella sezione Autorizzazioni, abilitalo",
            howToEnableNotificationInstruction3: "Se \"Notifiche\" è disabilitato nella sezione \"Autorizzazioni\", abilitarlo",
            howToEnableNotificationInstruction4: "Se \"Notifiche\" è disabilitato nella sezione \"Autorizzazioni\", abilitarlo",
            checkPaymentMethod: "Controlla il metodo di pagamento",
            pushNotificationEnabled: "Notifiche push abilitate",
            pushNotificationDenied: "Notifiche push negate",
            suspendedMessage: "Il tuo account è stato sospeso",
            enableNotification: "Abilita notifiche",
            languageSettings: "Impostazioni della lingua",
            problemsSound: "Se non senti il suono, controlla le impostazioni del tuo browser. (Se il problema persiste, contatta il tuo amministratore.)",
            betweenRepresentative: "Tra rappresentante",
            desktopNotifications: "Notifiche desktop",
            notificationDisable: "Notifiche disabilitate",
            notificationEnabled: "Notifiche abilitate",
            newMessageAlert: "Nuovo messaggio",
            newConversationAlert: "Nuova conversazione",
            chatBot: "Chatbot",
            ticketResponse: "Risposta al ticket: ",
            archived: "Archiviato",
            chatbotChatCount: "CHATBOT",
            closeChat: "Chiudi chat",
            formStep: "Passaggio del modulo",
            menuStep: "Passaggio del menu",
            contentStep: "Passaggio del contenuto",
            menuTitle: "Titolo del menu",
            messageContent: "Contenuto del messaggio",
            goToLive: "Vai in diretta",
            prevStep: "Passaggio precedente",
            button: "Pulsante",
            addImage: "Immagine",
            addText: "Testo",
            stepTitle: "Titolo del passaggio",
            addTicket: "Ticket",
            formDescription: "Domanda",
            addInput: "Domanda",
            addRandomText: "Testo casuale",
            changeTitle: "Cambia titolo",
            changeVisitorTitle: "Cambia indirizzo visitatore",
            catalog: "Catalogo",
            openTheCatalog: "Apri il catalogo",
            catalogNotOpen: "Il catalogo non è aperto. Per aprire il catalogo, vai alla sezione Impostazioni e attiva il catalogo.",
            showCatalogCategories: "Mostra categorie",
            showChatBot: "Mostra chatbot",
            openCatalog: "Apri catalogo",
            unreadMessages: "Messaggi non letti",
            personalFirstMsg: "Primo messaggio personale",
            personalRating: "Valutazione personale",
            soundSettings: "Impostazioni audio",
            newPrivateMessage: "Nuovo messaggio privato",
            addNewGroup: "Creare un nuovo gruppo",
            newMessage: "Nuovo messaggio",
            newConversation: "Nuova conversazione",
            newVisitor: "Nuovo visitatore",
            chatPosition: "Posizione della chat",
            bottomLeftCorner: "angolo in basso a sinistra",
            leftDocked: "lasciato ancorato",
            bottomRightCorner: "nell'angolo in basso a destra",
            rightDocked: "agganciato a destra",
            chatPositionSelect: "Seleziona la posizione della chat",
            teamChatGroup: "Messaggi di gruppo",
            teamChatDepartment: "Messaggi del dipartimento",
            teamChatTeam: "Messaggi di squadra",
            teamChatDm: "Messaggi DM",
            bottomLeft: "In basso a sinistra",
            left: "Sinistra",
            bottomRight: "In basso a destra",
            right: "Destra",
            mailorname: "Email o nome",
            breaksByTime: "Interruzioni per tempo",
            clPlaceholder: "Scrivi un messaggio",
            fieldName: "Nome",
            value: "Valore",
            addSetting: "Aggiungi impostazione",
            globalSettings: "Impostazioni globali",
            target: "Target",
            duration: "Durata",
            arrivalCount: "Conteggio di arrivo",
            bootMaxLife: "Durata massima di avvio",
            startLoadTest: "Avvia test di carico",
            noClusterInstanceFound: "Nessuna istanza cluster trovata",
            stopLoadTest: "Ferma il test di carico",
            integrationDesc: "Descrizione dell'integrazione",
            integrationDemoCode: "Codice demo di integrazione",
            integrationWindow: "Finestra di integrazione",
            notIntegrated: "Non integrato",
            help: "Aiuto",
            notIntegratedDesc: "Non hai ancora integrato il tuo sito web. Per integrare il tuo sito web, vai alla sezione Impostazioni e segui le istruzioni.",
            backToLogin: "Torna al login",
            passwordlessLoginUnsuccessful: "Il login senza password non è riuscito. Per favore, riprova.",
            passwordlessLogin: "Login senza password",
            loginWithEmail: "Accedi con e-mail",
            loginWithPassword: "Accedi con password",
            enteringPasswordless: "Stai entrando nel tuo account senza password",
            toMainPath: "Vai al percorso principale",
            userRoleChanged: "Il ruolo dell'utente è stato modificato",
            passwordChangeSuccess: "La password è stata modificata con successo",
            feedback: "Feedback",
            showFeedbackHistory: "Mostra cronologia dei feedback",
            newSelfServiceSite: "Nuovo sito di self-service",
            subdomain: "Sottodominio",
            rootUserEmail: "Email",
            rootUserName: "Nome",
            newVersion: "Nuova versione",
            closeLiveSupport: "Chiudi supporto live",
            newVersionShort: "Nuova versione",
            bannedWordRestrict: "Restrizione parole vietate",
            ticketShow: "Consentire ai clienti di creare ticket",
            ticketShowDesc: "Attivare l'opzione di creazione ticket nel menu della chat",
            autoLoadIframe: "Iframe di caricamento automatico",
            autoLoadIframeDesc: "Carica automaticamente l'iframe sul tuo sito web",
            bannedWordRestrictDesc: "Se abilitato, i messaggi contenenti parole vietate non verranno inviati",
            agentDown: "Agente inattivo",
            delayChat: "Ritardo chat",
            tableSettingTippy: "Impostazioni tabella",
            tableSettings: "Impostazioni tabella",
            tableSettingsInfo: "Seleziona le colonne che desideri visualizzare nella tabella. Le impostazioni verranno salvate automaticamente.",
            privateParametry: "Parametri utente personalizzati",
            systemOperetor: "Informazioni di sistema",
            cityAndDistrict: "Città/Paese",
            general: "Generale",
            availability: "Disponibilità",
            home: "Home",
            successful: "Riuscito",
            forgetPasswordSent: "Ti abbiamo inviato un'e-mail per reimpostare la password.",
            saturday: "Sabato",
            friday: "Venerdì",
            thursday: "Giovedi",
            wednesday: "Mercoledì",
            tuesday: "Martedì",
            monday: "Lunedì",
            sunday: "Domenica",
            download: "Scarica",
            calendarPassedTimeHour: "{hour} ora {name}",
            calendarPassedTime: "{hour} ora {min} dk {name}",
            calendarPassedTimeMinSec: "{min} dk {sec} sn {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} ora {min} dk {sec} sn {name}",
            workScheduleOneDay: "{name} Dell'utente {sDate} Calendario del lavoro giornaliero",
            workSchedule: "{name} Il tuo nome utente {sDate} - {eDate} Tra orario di lavoro",
            noRating: "Nessuna valutazione",
            rateDist: "Distribuzione delle valutazioni",
            distConversation: "Distribuzione della conversazione",
            distributionConversa: "Distribuzione della conversazione",
            distChatbotAgent: "Chatbot & Agente",
            distAgent: "Agente",
            distFugitive: "Discorso mancato e discorso ricevuto",
            distLive: "Live Cha",
            distChatbot: "Chatbot",
            distComplex: "Complesso",
            distHandled: "Gestito",
            distMissed: "Mancato",
            distWeb: "Web",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "Totale chat Whatsapp",
            statsByTime: "Statistiche per tempo",
            selectRep: "Seleziona rappresentante",
            allRepresentatives: "Tutti i rappresentanti",
            avgRating: "Distribuzione punti ({point}) ({count} valutazione)",
            avgFirstMessageTime: "Tempo medio del primo messaggio ",
            totalBreakTime: "Tempo totale di pausa",
            totalBreakNum: "Numero totale di pause",
            averageConTime: "Tempo medio di conversazione",
            multiWpReportTitle: "Conteggio conversazioni multiple Whatsapp",
            multiWpReport: "Numero di chat multiple di WhatsApp",
            multiWpReportExplanation: "Puoi vedere la quantità di chat dei tuoi canali  Whatsapp.",
            longestConTime: "Tempo di conversazione più lungo",
            shortestConTime: "Tempo di conversazione più breve",
            refresh: "Ricarica",
            waitingReply: "In attesa di risposta",
            organizationName: "Nome dell'organizzazione",
            companySlogan: "Nome lungo dell'organizzazione",
            messageSentErr: "Errore nell'invio del messaggio",
            messageSent: "Messaggio inviato",
            openPrivateChat: "Apri chat privata",
            escKey: "Premi Esc per chiudere",
            archiveChatKey: "Premi Ctrl + E per archiviare la chat",
            chatCopilot: "Attiva Chat CoPilot",
            privateChat: "Chat privata",
            multiModeAlertDesc: "Se abilitato, i rappresentanti possono gestire più chat contemporaneamente. Se disabilitato, i rappresentanti possono gestire solo una chat alla volta.",
            useHereText: "Usa qui",
            brandVisibility: "Visibilità del marchio",
            focusInput: " Inserisci il tuo messaggio qui",
            send: "Invia",
            notYet: "Non ancora",
            sending: "Invio",
            onlyRepresentative: "Solo rappresentante",
            yourMessage: "Il tuo messaggio",
            liveFabListDescription: "Live Chat",
            messengerIntegrationDesc: "Chatta con i tuoi clienti tramite la pagina Facebook, invia messaggi automatici con il chatbot.",
            checkDepartmentToAgent: "Controlla il Dipartimento per l'Agente Online",
            ifAllOfflineStory: "Storia per Indirizzare se Tutti Offline",
            AssignMessagesToAgents: "Assegna Tutti i Messaggi agli Agenti",
            firstChatbotAndAssign: "Prima risponde il Chatbot e poi viene assegnato a un agente",
            hybridAssign: "Il sistema controlla il dipartimento per vedere se c'è un agente online, e se non c'è un agente online, lo assegna al chatbot.",
            ticketFabListDescription: "Ticket",
            whatsappFabListDescription: "Whatsapp",
            phoneFabListDescription: "Telefono",
            emailFabListDescription: "E-mail",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "YouTube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "a questa zona {channelLink} Puoi mettere il link del tuo canale.",
            typeYourAccountLink: "a questa zona {accountLink} Puoi mettere il link del tuo canale.",
            typeYourMessage: "Il tuo messaggio",
            typeYourMessageMail: "Il messaggio inserito in questo campo verrà inviato dal Cliente come primo messaggio all'indirizzo e-mail sopra indicato.",
            typeYourMessageDesc: "Il messaggio inserito in questo campo verrà inviato dal Cliente come primo messaggio all'indirizzo e-mail sopra indicato.",
            sendNumber: "Numero di telefono a cui inviare il messaggio: {path}",
            callNumber: "Numero di telefono che il tuo cliente può chiamare: {phoneNumber}",
            numberIsNotCorrect: "Numero mancante inserito!!",
            emailIsNotCorrect: "E-mail non corretta!",
            selectFab: "Scegli un favoloso",
            notValid: "È possibile inserire solo lettere (carattere singolo). Le lettere e,d,f,z,a,x,c,v,w,t,n non sono valide",
            forMacUsers: " Gli utenti Mac possono usare il tasto Control(⌃)",
            basePriceValue: "Base Fiyat",
            basePriceDiscount: "Sconto",
            basePriceCurrency: "Valuta",
            customerDBEnabled: "Selezione del database: utilizzare il server del database del cliente",
            customerDBDisabled: "Selezione del database: utilizzare il server del database Supsis",
            mongoConnectionString: "Collegamento Mongo",
            whatsappBasePriceValue: "Prezzo base Whatsapp",
            whatsappPlusBasePriceValue: "Prezzo base Whatsapp Plus",
            instagramBasePriceValue: "Prezzo base Instagram",
            instagramPlusBasePriceValue: "Prezzo base di Instagram Plus",
            clientAddress: "Indirizzo del cliente",
            customerClientAddress: "Cliente Cliente Indirizzo",
            apiAddress: "Indirizzo API",
            socketAddress: "Indirizzo Socket",
            backendAddress: "Indirizzo Backend",
            panelLogoUrl: "URL del logo del pannello",
            panelCustomCssUrl: "URL CSS personalizzato del pannello",
            customerLogoUrl: "URL del logo del cliente",
            customerCssUrl: "URL CSS personalizzato del cliente",
            siteAlias: "Alias del sito",
            language: "Lingua",
            features: "Caratteristiche",
            interactionPopularity: "Popolarità dell'interazione",
            interactionCount: "Numero di interazioni",
            uniqueUserCount: "Numero di utenti unici",
            allUserPercentage: "(%) Percentuale di tutti gli utenti",
            represantativeSettings: "Impostazioni rappresentative",
            documentTitle: "Modulo documento supsis",
            supsisDocument: "Documento Supsis",
            ApiDoc: "Documentazione API",
            chatBalloonTehemeSettings: "Impostazioni del tema della bolla di chat",
            customLoginFormSettingsTitle: "Impostazioni del modulo di accesso personalizzato",
            addNewField: "Aggiungi nuovo campo",
            editField: "Modifica campo",
            typeHere: "Scrivi qui",
            pco: "TOC",
            perPage: "/ pagina",
            perPageInFilter: "Pezzo",
            noUserInfoFound: "Nessuna informazione utente trovata",
            startFilter: "Filtro di avvio",
            CHAT: "CHAT",
            showMyChats: "Mostra le mie chat",
            showOnlineAgents: "Mostra agenti online",
            showWaitingChats: "Mostra chat in attesa",
            addNewStatus: "Aggiungi nuovo stato",
            newTitleContent: "Nuovo titolo",
            roleName: "Nome del ruolo",
            error: "Errore",
            contentType: "Tipo di contenuto",
            contentTitle: "Titolo del contenuto",
            newSiteForm: "Nuovo modulo di registrazione del sito",
            updateSiteForm: "Modulo di registrazione del sito di aggiornamento",
            newBannedWordForm: "Nuovo modulo di registrazione delle parole vietate",
            updateBannedWordForm: "Modulo di registrazione delle parole vietate di aggiornamento",
            newWelcomeMessageForm: "Nuovo modulo di registrazione del messaggio di benvenuto",
            updateWelcomeMessageForm: "Modulo di registrazione del messaggio di benvenuto di aggiornamento",
            newDefaultContentForm: "Nuovo modulo di registrazione del contenuto predefinito",
            updateDefaultContentForm: "Modulo di registrazione del contenuto predefinito di aggiornamento",
            newSubjectForm: "Nuovo modulo di registrazione dell'argomento",
            updateSubjectForm: "Modulo di registrazione dell'argomento di aggiornamento",
            showIntro: "Mostra introduzione",
            showChatColorMeaning: "Mostra significato del colore della chat",
            options: "Opzioni",
            resetPassword: "Resetta la password",
            audioLevel: "Livello audio",
            privateChatNotificationSound: "Suono di notifica della chat privata",
            continue: "Continua",
            newRoleForm: "Nuovo modulo di registrazione del ruolo",
            updateRoleForm: "Modulo di registrazione del ruolo di aggiornamento",
            newUserForm: "Nuovo modulo di registrazione utente",
            updateUserForm: "Modulo di registrazione utente di aggiornamento",
            changeOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            tooltipOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            newOSRForm: "Nuovo modulo di registrazione del messaggio offline",
            newOSRMessages: "Nuovo messaggio offline",
            newOsrMessageTitle: "Titolo del messaggio offline",
            updateOSRForm: "Modulo di registrazione del messaggio offline di aggiornamento",
            osrTitle: "Titolo",
            osrTitleDescription: "Il titolo del modulo di supporto offline",
            osrContent: "Contenuto",
            osrContentDescription: "Il contenuto del modulo di supporto offline",
            hello: "Ciao",
            date: "Data",
            startDate: "Data di inizio",
            finish: "Fine",
            start: "Inizio",
            endDate: "Data di fine",
            representative: "Rappresentante",
            representative_: "Rappresentante",
            star: "Stella",
            filter: "Filtro",
            reset: "Reset",
            dailyChatList: "Elenco chat giornaliero",
            dailyChatDuration: "Durata della chat giornaliera",
            chatDuration: "Durata della chat",
            dailyChatGraph: "Grafico chat giornaliero",
            ok: "Ok",
            chatCount: "Numero di chat",
            shortest: "Il più breve",
            longest: "Il più lungo",
            average: "Media",
            count: "Contare",
            averagePoint: "Punto medio",
            pointDist: "Distribuzione dei punti",
            point: "Punto",
            filters: "Filtri",
            totalCustomer: "Totale clienti",
            avResponseTime: "Tempo di risposta medio",
            breakDuration: "Durata della pausa",
            breakCount: "Numero di pause",
            active: "Attivo",
            passive: "Passivo",
            userForm: "Modulo utente",
            startChat: "Inizia chat",
            sender: "Mittente",
            profile: "Profilo",
            name: "Nome",
            number: "Numero",
            username: "Nome utente",
            updateUserName: "Aggiorna nome utente",
            email: "E-mail",
            password: "Parola d'ordine",
            oldPassword: "Vecchia password",
            newPassword: "Nuova password",
            passwordAtLeast: "Password (almeno {num} caratteri)",
            passwordRepeat: "Ripeti la password",
            changePassword: "Cambia la password",
            status: "Stato",
            enableState: "Abilita stato",
            douYouWishToDeleteUser: "Vuoi davvero eliminare l'utente?",
            douYouWishToDeleteAnnouncement: "Vuoi davvero eliminare l'annuncio?",
            userDeleted: "Utente eliminato",
            userSaved: "Utente salvato",
            oldPasswordError: "La vecchia password non è corretta",
            chooseAnOption: "Scegli un'opzione",
            userVolumeUpdated: "Volume utente aggiornato",
            addNewMenu: "Aggiungi nuovo menu",
            addNewContent: "Aggiungi nuovo contenuto",
            pleaseTitleEnter: "Inserisci il titolo",
            like: "Piace",
            disLike: "Non mi piace",
            users: "Utenti",
            visitor: "Visitatore",
            allContacts: "Tutti i contatti",
            allUsers: "Tutti gli utenti",
            allSites: "Tutti i siti",
            newUser: "Nuovo utente",
            noNewUser: "Non ci sono ancora nuovi utenti",
            noNewAdminUser: "Non ci sono ancora nuovi utenti amministratori",
            noNewAnnouncement: "Non ci sono ancora nuovi annunci",
            noRoleFound: "Nessun ruolo trovato",
            noBannedWordFound: "Nessuna parola vietata trovata",
            noWelcomeMessageFound: "Nessun messaggio di benvenuto trovato",
            noSubjectFound: "Nessun argomento trovato",
            noVisitorFound: "Nessun visitatore trovato",
            noContactFound: "Nessun contatto trovato",
            sendResponse: "Invia risposta",
            delete: "Elimina",
            duplicate: "Duplicare",
            makeDefault: "Rendi predefinito",
            checkMore: "Controlla di più",
            useReadyTemplates: "Usa modelli pronti",
            useAITemplates: "Usa modelli AI",
            noRePresentativeFound: "Nessun rappresentante trovato",
            noLiveSupportFound: "Nessun supporto live trovato",
            noLiveSupportFoundWithDepartment: " Nessun supporto live trovato con questo dipartimento",
            noBannedVisitorFound: "Nessun visitatore vietato trovato",
            removeBanDescription: "Vuoi davvero rimuovere il divieto?",
            editThisItem: "Modifica questo elemento",
            removeThisItem: "Rimuovi questo elemento",
            role: "Ruolo",
            newRolePlaceHolder: "Inserisci il nome del ruolo",
            autoChatAssignLimit: "Limite di assegnazione chat automatica",
            chatAssignInfo: "-1 = Predefinito di sistema, 0 = Nessuna assegnazione, >0 = Assegnazione tanto quanto il valore dato.",
            relatedDepartments: "Dipartimenti correlati",
            subjectInfo: "Seleziona i dipartimenti correlati per questo argomento",
            archive: "Archivio",
            offlineSupportRequests: "Richieste di supporto offline",
            offlineModeMessage: "Messaggio non in linea",
            offlineMode: "Modalità offline",
            first: "Primo",
            last: "Ultimo",
            query: "Query",
            clean: "Pulito",
            loading: "Caricamento",
            loadMore: "Carica altro",
            noMessage: "Nessun messaggio",
            selectChat: "Seleziona chat",
            noMessageInChat: "Nessun messaggio in chat",
            noMediaToShow: "Nessun contenuto multimediale da mostrare",
            firstSeen: "Prima Visione",
            userInfo: "Informazioni sull'utente",
            userProfile: "Profilo",
            addCalendarEvent: "Evento +",
            chatId: "ID chat",
            visitorId: "ID visitatore",
            visitingPage: "Pagina visitata",
            osAndBrowser: "Sistema operativo e browser",
            customerClientVersion: "Versione cliente",
            visitorFeedback: "Feedback del cliente",
            notes: "Note",
            nameSurname: "Nome cognome",
            chats: "Chat",
            bannedVisitors: "Visitatori vietati",
            country: "Nazione",
            city: "Città",
            cityDistrict: "Quartiere cittadino",
            browser: "Browser",
            os: "Sistema operativo",
            ipAddress: "Indirizzo IP",
            connectionDate: "Data di connessione",
            transaction: "Transazione",
            banRemoved: "Divieto rimosso",
            bannedWords: "Parole vietate",
            newBannedWord: "Nuova parola vietata",
            noBannedWord: "Nessuna parola vietata",
            bannedWordForm: "Modulo parola vietata",
            word: "Parola",
            bannedWordAndWordGroup: "Parola/frase vietata",
            doYouWishToDeleteBannedWord: "Vuoi davvero eliminare questa parola vietata?",
            doYouWishToOfflineSupportRequest: "Vuoi eliminare questo messaggio?",
            bannedWordSaved: "Parola vietata salvata",
            deletedSuccessfully: "Eliminato con successo",
            deleteErrorMsg: "Errore durante l'eliminazione",
            socketError: "Problema di connessione presa. Perfavore ricarica la pagina e riprova.",
            socketConnecting: "Connessione al server...",
            offlineModeDescription: "Il sistema è in modalità offline. I visitatori non possono inviare messaggi.",
            offlineModeSettingsDescription: "Se la modalità offline è attiva, i visitatori non possono inviare messaggi. Se la modalità offline è disattivata, i visitatori possono inviare messaggi.",
            offlineModeUser: "Modalità offline",
            adminCannotConnectSocket: "L'amministratore non può connettersi al socket. Controlla la connessione.",
            liveSupport: "Supporto dal vivo",
            siteVisitors: "Visitatori del sito",
            visitors: "Visitatori",
            thoseConnectedToLiveSupport: "Coloro che sono connessi al supporto dal vivo",
            visitorHistory: "Cronologia del visitatore",
            visitorHistoryDescription: "Puoi visualizzare e scaricare la cronologia delle chat dei visitatori.",
            privateMessage: "Messaggio privato",
            addRepresentative: "Aggiungi rappresentante",
            forwardRepresentative: "Inoltra rappresentante",
            keyboardShortcuts: "Tasti di scelta rapida",
            chatColorMeanings: "Significati dei colori della chat",
            connLostCheckInternet: "Connessione persa. Controlla la tua connessione a Internet.",
            wishToEndThisChat: "Vuoi davvero terminare questa chat?",
            defaultContents: "Contenuti predefiniti",
            contents: "Contenuti",
            newDefaultContent: "Nuovo contenuto predefinito",
            newCTRLContent: "Nuovo contenuto CTRL",
            newALTContent: "Nuovo contenuto ALT",
            newTABContent: "Nuovo contenuto TAB",
            shortcutChar: "Carattere di scelta rapida",
            pickOne: "Scegli uno",
            writeSomething: "Digita un carattere (a-z|0-9)",
            letterSequence: "Sequenza di lettere",
            exampleText: "Esempio: calcio -> calcio",
            anyChar: "Qualsiasi carattere",
            shorcutKey: "tasto di scelta rapida",
            content: "Contenuto",
            shortcutName: "Nome di scelta rapida",
            type: "Tipo",
            shortcut: "Scelta rapida",
            deleteContentQuestion: "Vuoi davvero eliminare questo contenuto?",
            defaultContentDeleted: "Contenuto predefinito eliminato",
            defaultContentSaved: "Contenuto predefinito salvato",
            defaultContentForm: "Modulo contenuto predefinito",
            titleContentForm: "Intestazione del contenuto pronta",
            contentMoved: "Contenuto spostato",
            cannotMoveFullParent: "Non puoi spostare un elemento completo sotto un altro elemento completo.",
            yourEmail: "La tua email",
            yourName: "Il tuo nome e cognome",
            lostPassword: "Hai perso la password?",
            login: "Accesso",
            forgotPassword: "Password dimenticata",
            multipleSession: "Sessione multipla",
            notAuthorizedToDisplayPage: "Non sei autorizzato a visualizzare questa pagina.",
            permissions: "Permessi",
            newPermission: "Nuovo permesso",
            permissionForm: "Modulo di autorizzazione",
            displayTitle: "Titolo visualizzato",
            key: "Chiave",
            keyToUseInSystem: "Chiave da utilizzare nel sistema",
            deletePermissionQuestion: "Vuoi davvero eliminare questo permesso?",
            permissionDeleted: "Permesso eliminato",
            permissionSaved: "Permesso salvato",
            newRole: "Nuovo ruolo",
            selectARole: "Seleziona un ruolo",
            yes: "Sì",
            no: "No",
            fullAuth: "Autorizzazione completa",
            roleDeleted: "Ruolo eliminato",
            sameRole: "C'è un ruolo con lo stesso nome.",
            roleForm: "Modulo ruolo",
            roles: "Ruoli",
            settings: "Impostazioni",
            selectTopic: "Seleziona un argomento",
            autoCallTransfer: "Trasferimento automatico della chiamata",
            customerTyping: "Digitazione del cliente",
            typing: "Digitazione",
            agentTyping: "Digitazione dell'agente",
            disconnectTime: "Tempo per terminare la conversazione (sec)",
            tippyDissconnectTime: "Imposta il numero di secondi dopo i quali la sintesi vocale viene disattivata.",
            queueNumberVisibleFeature: "Funzionalità di visualizzazione del numero di coda",
            privateChatEnabled: "Chat privata abilitata",
            delayedTalkTime: "Tempo di conversazione ritardato (sec)",
            employeeAverageChatCount: "Numero medio di chat per dipendente",
            customerDownTimeWhenRepExit: "Tempo di inattività del cliente quando l'agente esce (sec)",
            autoAssignLimit: "Limite di assegnazione automatica",
            wasted: "Perdere tempo (sec)",
            settingsSaved: "Impostazioni salvate",
            settingsCannotSaved: "Impostazioni non possono essere salvate",
            noAuthorization: "Nessuna autorizzazione",
            warningBadInput: "Si consiglia di inserire un numero compreso tra 0 e 70.",
            warningBadInputMarginY: "Avviso sull'inserimento del margine verticale ⚠️",
            warningBadInputMarginX: "Avviso sull'inserimento del margine orizzontale ⚠️",
            warningBadInputBubbleSize: "Avviso sull'immissione delle dimensioni del fumetto ⚠️",
            settingFormWrong: "I dati inseriti non sono corretti, controlla e riprova.",
            delayTime: "Tempo di ritardo",
            sites: "Siti",
            newSite: "Nuovo sito",
            noSiteYet: "Non hai ancora creato un sito.",
            siteAddress: "Indirizzo del sito",
            turnBack: "Torna indietro",
            customerRepLimit: "Limite cliente / rappresentante",
            siteSaved: "Sito salvato.",
            siteSaveError: "Si è verificato un errore durante il salvataggio del sito.",
            subjects: "Argomenti",
            newSubject: "Nuovo argomento",
            noSubject: "Non hai ancora creato un argomento.",
            subject: "Soggetto",
            subjectTitle: "Titolo dell'argomento",
            infoAboutSubject: "Informazioni sull'argomento",
            deleteSubjectQuestion: "Vuoi davvero eliminare questo argomento?",
            subjectDeleted: "Argomento eliminato",
            subjectSaved: "Argomento salvato",
            osrFromMessageSaved: "OSR da messaggio salvato",
            welcomeMessages: "Messaggi di benvenuto",
            newWelcomeMessages: "Nuovo messaggio di benvenuto",
            noWelcomeMessage: "Non hai ancora creato un messaggio di benvenuto.",
            welcomeMessageContent: "Contenuto del messaggio di benvenuto",
            makeChoice: "Fai una scelta",
            welcomeMessage: "Messaggio di benvenuto",
            repLoggedIn: "Il rappresentante ha effettuato l'accesso",
            loginMessage: "Messaggio di disconnessione",
            message: "Messaggio",
            messageTitle: "Titolo del messaggio",
            deleteWelcomeMessageQuestion: "Vuoi davvero eliminare questo messaggio di benvenuto?",
            welcomeMessageDeleted: "Messaggio di benvenuto eliminato",
            welcomeMessageSaved: "Messaggio di benvenuto salvato",
            welcomeMessageForm: "Modulo messaggio di benvenuto",
            noRep: "Nessun rappresentante",
            addChat: "Aggiungi chat",
            forwardChat: "Inoltra chat",
            ago: "fa",
            repName: "Nome rappresentante",
            lastOnline: "Ultimo online",
            lastStatusChange: "Ultima modifica dello stato",
            activeChat: "Chat attiva",
            userMaxCapacity: "Capacità massima dell'utente",
            noActiveChat: "Nessuna chat attiva",
            watch: "Guarda",
            join: "Unisciti",
            open: "Aperto",
            directMessage: "Messaggio diretto",
            block: "Blocca",
            transactions: "Transazioni",
            informations: "Informazioni",
            visitStart: "Inizio visita",
            fullName: "Nome completo",
            waitChatTime: "Tempo di attesa della chat",
            blockUserConfirm: "Vuoi davvero bloccare questo utente?",
            messaging: "Messaggistica",
            hideChat: "Nascondi chat",
            block_: "Blocca",
            privateMessage_: "Messaggio privato",
            assignRep: "Assegna rappresentante",
            joinChat: "Unisciti alla chat",
            forwardRep: "Inoltra rappresentante",
            leaveChat: "Lascia la chat",
            endChat: "Termina la chat",
            translatedTextDescription: "Amazon ha tradotto {from} -> {to} di questo messaggio.",
            autoTranslate: "Traduzione automatica",
            translateThisMessage: "Traduci questo messaggio",
            autoTranslateDetectedDesc: "Il visitatore parla {visitorLanguage}. Fare clic qui per abilitare la traduzione automatica",
            on: "Acceso",
            off: "Spento",
            prevChats: "Chat precedenti",
            noShortCut: "Nessuna scorciatoia",
            leaveChartConfirm: "Vuoi davvero lasciare questa chat?",
            endChatConfirm: "Vuoi davvero terminare questa chat?",
            chatBar: "Barra della chat",
            endConversation: "Termina la conversazione",
            onlyOneRep: "Solo un rappresentante",
            chatList: "Elenco chat",
            unreadTitle: "Non letto",
            visitorLeftTitle: "Visitatore lasciato",
            activeChatTitle: "Chat attiva",
            autoAssignedTitle: "Assegnato automaticamente",
            watchModeTitle: "Modalità di guardia",
            lostChat: "Chat persa",
            repLostConn: "Connessione persa",
            chatWidthDelay: "Larghezza della chat",
            repChatWidthDelay: "Se la larghezza della chat è impostata su 0, la larghezza della chat sarà la larghezza del contenitore della chat.",
            unreadMsg: "Se ci sono messaggi non letti, l'arco sarà rosso.",
            visitorLeftChat: "Se il visitatore lascia la chat, l'arco sarà rosso.",
            activeChatMsg: "Se la chat è attiva, l'arco sarà verde.",
            autoAssignMsg: "Se la chat è assegnata automaticamente, l'arco sarà blu.",
            watchModeMsg: "Se la modalità di guardia è attiva, l'arco sarà blu.",
            online: "Online",
            beRightBack: "Torno subito",
            away: "Assente",
            busy: "Occupato",
            offline: "Offline",
            logout: "Disconnettersi",
            forWindows: "Per Windows",
            forMac: "Per Mac",
            nextChatFromActive: "Passa alla chat successiva dall'attiva",
            previousChatFromActive: "Passa alla chat precedente dall'attiva",
            hideActiveChat: "Nascondi chat attiva",
            closeActiveChat: "Chiudi chat attiva",
            firsthiddenChat: "Connettiti alla conversazione del cliente che ha atteso di più",
            firstChatWaiting: "Connettiti alla prima conversazione in attesa",
            previousOpenedChat: "Connettiti alla conversazione del cliente che hai aperto per primo",
            hashHintMessage: "Con il tasto # puoi inviare un messaggio veloce (esempio: #ciao)",
            pmHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @nome)",
            vtippyTicketNotification: "Nuovo ticket",
            newTicketSound: "Suono nuovo ticket",
            vtippyDepartmentNotification: "Impostazioni di notifica per i messaggi dalla conversazione del dipartimento",
            vtippyGroupNotification: "Impostazioni di notifica per i messaggi dai gruppi creati",
            vtippyAnnouncemenNotification: "Impostazioni di notifica per i nuovi annunci",
            languageSelection: "Selezione della lingua",
            shortcutHintMessage: "Con il tasto / puoi inviare un messaggio veloce (esempio: /ciao) ",
            switchBetweenConversations: "Passa tra le conversazioni",
            atNameHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @nome)",
            dndHintMessage: "Non disturbare",
            pasteFile: "Incolla file",
            atEmailHintMessage: "Con il tasto @ puoi inviare un messaggio veloce (esempio: @email)",
            pastePlainText: "Incolla testo semplice",
            pressAndTalk: "Premi e parla",
            historyDetails: "Dettagli cronologia",
            chat: "Chat",
            chatNotFound: "Chat non trovata",
            dataNotFound: "Dati non trovati",
            visitorInfo: "Informazioni sul visitatore",
            timeSpent: "Tempo trascorso",
            noActiveVisitors: "Nessun visitatore attivo",
            select: "Seleziona",
            fullname: "Nome completo",
            text: "Testo",
            numeric: "Numerico",
            phone: "Telefono",
            optionsPlaceholder: "Opzioni separate da virgola",
            selectField: "Seleziona campo",
            fullnameField: "Nome completo",
            textField: "Testo",
            labelField: "Etichetta",
            numericField: "Numerico",
            phoneField: "Telefono",
            departmentField: "Dipartimento",
            emailField: "Email",
            visible: "Visibile",
            required: "Richiesto",
            label: "Etichetta",
            totalConnected: "Totale connessi",
            missedChat: "Chat perse",
            workTime: "Tempo di lavoro",
            closedChatCount: "Numero di chat chiuse",
            activeConvo: "Conversazioni attive",
            notAnswered: "Non risposto",
            delayedConvo: "Conversazioni ritardate",
            leavingRep: "Rappresentante che lascia",
            staffRate: "Valutazione dello staff",
            customLoginAlert: "Accedi con il tuo account",
            atLeastOneLanguage: "Seleziona almeno una lingua",
            requiredField: "Questo campo è obbligatorio.",
            notRequiredField: "Questo campo non è obbligatorio.",
            visibleField: "Questo campo è visibile nel form.",
            notVisibleField: "Questo campo non è visibile nel form.",
            connectServer: "Connessione al server...",
            disconnectServer: "Disconnessione dal server...",
            liveChatOff: "Live chat disattivata",
            visitorScreen: "Schermo del visitatore",
            viewOnTheSite: "Visualizza sul sito",
            viewOnTheSiteTippy: "Visualizza sul sito",
            showHint: "Mostra suggerimento",
            dontShowHint: "Non mostrare suggerimento",
            liveChatOn: "Live chat attivata",
            nightModeOff: "Modalità notturna disattivata",
            nightModeOn: "Modalità notturna attivata",
            deleteField: "Elimina campo",
            arrow_upward: "Sposta su",
            arrow_downward: "Sposta giù",
            doubleClickEdit: "Doppio click per modificare",
            newCatalogCategory: "Nuova categoria di catalogo",
            childCreate: "Crea figlio",
            updateCatalogCategoryFrom: "Aggiorna categoria di catalogo",
            newCatalogCategoryFrom: "Nuova categoria di catalogo",
            catalogMenu: "Menu catalogo",
            catalogContent: "Contenuto catalogo",
            catalogCategoryName: "Nome categoria catalogo",
            newCatalogContentFrom: "Nuovo contenuto catalogo",
            catalogContentName: "Nome contenuto catalogo",
            catalogCategorySaved: "Categoria di catalogo salvata.",
            catalogCategoryDeleted: "Categoria di catalogo eliminata.",
            catalogCategoryRate: "Valutazione categoria catalogo",
            catalogContentFeature: "Caratteristica contenuto catalogo",
            vtipyAudioLevel: "Utilizzato per disattivare o riattivare i suoni di notifica.",
            vtipyOrganizationName: "Nome dell'organizzazione.",
            vtipyBrandVisibility: "Seleziona se vuoi che il tuo marchio sia visibile o meno.",
            vtipyBrandVisibilityForced: "Seleziona se vuoi che il tuo marchio sia visibile o meno.",
            vtipyClientDefault: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyCustomerClientDefault: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyVisitorPreferredLang: "Seleziona la lingua predefinita per la pagina del cliente.",
            vtipyCustomerClientLanguageDetect: "Seleziona se vuoi che la lingua del cliente venga rilevata automaticamente.",
            vtipySelectTopic: "Seleziona l'argomento che vuoi che i tuoi clienti vedano quando aprono la pagina del cliente.",
            vtipyAutoCallTransfer: "Seleziona se vuoi che le chiamate vengano trasferite automaticamente.",
            vtipyCustomerTyping: "Mostra quando il cliente sta scrivendo.",
            vtipyAgentTyping: "Mostra quando l'agente sta scrivendo.",
            vtipyQueueNumberVisibleFeature: "Seleziona se vuoi che il numero di coda sia visibile o meno quando il cliente apre la pagina del cliente.",
            vtipyPrivateChatEnabled: "Seleziona se vuoi che il chat privata sia abilitata o meno.",
            vtipyDelayedTalkTime: "Se nessun agente è connesso alla conversazione durante questo periodo, verrà etichettata come \"Parola ritardata\".",
            vtipyOfflineMode: "Seleziona se vuoi che la modalità offline sia abilitata o meno.",
            vtipyAutoAssignLimit: "Seleziona il numero massimo di conversazioni che un agente può gestire.",
            vtipyCustomerDownTimeWhenRepExit: "Seleziona il tempo di inattività del cliente quando l'agente esce.",
            tippyDisconnectTime: "Seleziona il tempo di disconnessione.",
            changeSettings: "Cambia impostazioni",
            totalBg: "chat totali",
            activeBg: "chat attive",
            watchBg: "GUARDARE",
            waitingBg: "chat in sospeso",
            lateBg: "conversazioni di passaggio",
            freeBg: "GRATUITO",
            maxCapacityBg: "CAPACITÀ MASSIMA",
            addNewSettings: "Aggiungi nuove impostazioni",
            darkMode: "Modalità scura",
            clientDefault: "Lingua predefinita del cliente",
            customerClientDefault: "Lingua predefinita del cliente",
            customerClientLanguageDetect: "Rilevamento automatico della lingua del cliente",
            visitorPreferredLang: "Lingua preferita del visitatore",
            preferredThemeColor: "Colore del tema preferito",
            detail: "Dettaglio",
            langSetting: "Impostazione della lingua",
            supportUs: "Supportaci su Patreon",
            changeLang: "Cambia lingua",
            fontSizeSetting: "Impostazione della dimensione del carattere",
            changeLangDesc: "lingua dell'applicazione {code} come impostazioni.",
            trLang: "Turco",
            enLang: "Inglese",
            fieldRequired: "{field} il campo è obbligatiorio.",
            selectALanguage: "Scegli una lingua",
            selectATheme: "Scegli un tema",
            responseForm: "Modulo di risposta",
            clientRequestInfo: "Informazioni sulla richiesta del cliente",
            createdDate: "Data di creazione",
            descMessage: "Messaggio descrittivo",
            new: "Nuovo",
            lastLoginPlatform: "Ultima piattaforma di accesso",
            requiredFieldField: "il campo è obbligatiorio.",
            catalogCategoryMenu: "Menu categoria catalogo",
            catalogCategoryLeaf: "Foglia categoria catalogo",
            selectAllPermission: "Seleziona tutti i permessi",
            catalogCategories: "Categorie di catalogo",
            copiedClipboard: "Copiato negli appunti",
            organizationLogo: "Logo dell'organizzazione",
            changePlan: "Cambia piano",
            close: "Chiudi",
            vtipyUploadLogo: "Puoi caricare il logo dell'organizzazione. Il logo verrà visualizzato nella parte superiore della pagina del cliente.",
            tagName: "Nome del tag",
            tagDescription: "Descrizione del tag",
            tagColor: "Colore del tag",
            userInformations: "informazioni utente",
            incomingChat: "Chat in arrivo",
            support: "Supporto",
            team: "Impostato",
            groups: "Gruppi",
            newConversationStarted: "Nuova conversazione iniziata",
            allHistoryLoaded: "Tutta la cronologia caricata",
            chatCreator: "Creatore di chat",
            enterGroupTitle: "Inserisci il titolo del gruppo",
            requiredTitle: "Non puoi lasciare vuoto il campo del titolo",
            requiredChannel: "Il nome del canale non può essere vuoto",
            next: "Confermare",
            selectPeople: "Seleziona Persone",
            textLimitAlertMessage: "Il limite di caratteri in WhatsApp è di 19 caratteri e oltre questo limite non verrà visualizzato. Tuttavia, sul Web, i testi che superano il limite di 19 caratteri vengono automaticamente spostati nella riga successiva e visualizzati.",
            artificialIntelligence: "Artificial Intelligence",
            channelSettings: "Channel Settings",
            apiKeyMode: "API Key Mode",
            byokTitle: "Use My Own API Key (BYOK)",
            byokDesc: "Usa la chiave API del tuo account OpenRouter",
            supsisKeyTitle: "Let Supsis AI Provide API Key",
            supsisKeyDesc: "Use API key provided by Supsis",
            openrouterApiKey: "Chiave API OpenRouter",
            openrouterApiKeyHint: "Puoi ottenere la chiave API dalla dashboard OpenRouter.",
            noChannels: "No channels yet",
            createFirstChannel: "Click 'Add Channel' to create your first channel.",
            createChannel: "Crea canale",
            providerInfo: "Provider Info",
            channels: "Channels",
            channelUpdatedSuccessfully: "Canale aggiornato con successo",
            channelDeletedSuccessfully: "Canale eliminato con successo",
            failedToSaveChannel: "Impossibile salvare il canale",
            failedToDeleteChannel: "Impossibile eliminare il canale",
            apiKeyRequired: "API key is required",
            deleteChannelConfirm: "Sei sicuro di voler eliminare questo canale?",
            copiedToClipboard: "Copiato negli appunti",
            showMore: "Show More",
            showLess: "Show Less",
            socialMedia: "Social Media",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "E-Commerce",
            utilities: "Utilities",
            advertising: "Advertising",
            groupBy: "Group By",
            dropdown: "Selezionabile",
            selectRepresentativeChatbot: "Seleziona rappresentante/chatbot",
            selectDomain: "Seleziona dominio",
            salesOrders: "Sales Orders",
            noSalesOrdersFound: "No sales orders found for this person",
            loadingSalesOrders: "Loading sales orders",
            contacts: "Contacts",
            noContactsFound: "No contacts found for this phone number",
            loadingContacts: "Loading contacts",
            startsWith: "Inizia con",
            isOneOf: "One of",
            between: "Between",
            chatbotScenarioHasBeenCanceled: "Chatbot Scenario has been canceled",
            aiClassificationTextMode: "Classificazione testo",
            aiClassificationImageMode: "Classificazione immagine",
            aiClassificationImageUrlLabel: "Immagine da classificare (URL)",
            aiClassificationImageUrlPlaceholder: "Inserisci un indirizzo immagine nel formato https://...",
            temperature: "Temperature",
            updateChannelDesc6: "Aggiorna canale API Whatsapp Business",
            newWabaChannel: "New Whatsapp Business Channel",
            newWabaChannelDesc: "Crea un nuovo canale per l'API Whatsapp Business",
            deleteFiles: "Elimina file",
            sureDeleteMultipleFiles: "Sei sicuro di voler eliminare i file selezionati?",
            cancelSelection: "Annulla selezione",
            bulkSms: "SMS massivi",
            questions: "Questions",
            notAuthorizedChannel: "Non sei autorizzato ad accedere a questo canale.",
            integrationsYouTubeComments: "Gestisci i commenti YouTube da un unico pannello e interagisci con i tuoi clienti.",
            integrationsGoogleBusinessReviews: "Gestisci le recensioni Google Business da un unico pannello e interagisci con i tuoi clienti.",
            integrationsGooglePlayReviews: "Gestisci le recensioni delle app Google Play Store da un unico pannello e interagisci con i tuoi utenti.",
            integrationsAppStoreReviews: "Gestisci le recensioni delle app App Store da un unico pannello e interagisci con i tuoi utenti.",
            integrationsGoogleDrive: "Gestisci i tuoi file Google Drive in Supsis e condividili nelle conversazioni.",
            integrationsPage: {
                compare: "Confronta",
                dead: "Dead",
                whatsappV2Web: "WhatsApp V2 (Web)",
                whatsappV3QR: "WhatsApp V3 (QR Code)",
                whatsappBusinessAPI: "WhatsApp Business API",
                whatsappBusinessAPIv2: "WhatsApp Business API v2",
                instagram: "Instagram",
                instagramV2: "Instagram V2",
                instagramV2Desc: "Connessione diretta con Instagram Login. Nessun account Facebook richiesto.",
                messenger: "Messenger",
                linkedin: "LinkedIn",
                telegramQR: "Telegram (QR Code)",
                telegramBotFather: "Telegram (Bot Father)",
                youtubeComments: "Commenti YouTube",
                googleBusinessReviews: "Recensioni Google Business",
                googlePlayReviews: "Recensioni Google Play",
                appStoreReviews: "Recensioni App Store",
                googleDrive: "Google Drive",
                webTabs: "Schede Web",
                webTabsDesc: "Apri applicazioni esterne in Supsis aggiungendo schede personalizzate al menu laterale",
                webApps: "Web Apps",
                webAppsDesc: "Carica e gestisci le tue applicazioni web",
                mail: "Mail",
                smsPostacell: "SMS - Postacell",
                zohoCRM: "Zoho CRM",
                teamgram: "Teamgram",
                ideasoft: "Ideasoft",
                ticimax: "Ticimax",
                ticimaxV2: "Ticimax-V2",
                ticimaxV2Desc: "Gestisci il tuo negozio Ticimax e rispondi ai clienti in tempo reale tramite Supsis.",
                tsoft: "T-SOFT",
                tsoftDesc: "Gestisci ordini e spedizioni T-SOFT facilmente con SUPSIS AI.",
                ikas: "IKAS",
                ikasDesc: "Gestisci ordini e spedizioni Ikas facilmente con SUPSIS AI.",
                cacheManager: "Cache Manager",
                cacheManagerDesc: "Gestione della cache per la condivisione dati tra automazione e chatbot",
                openai: "OpenAI",
                slack: "Slack",
                pushover: "Pushover",
                metaLeads: "Meta Leads",
                voice: "Voce",
                webphoneRedsantral: "Webphone (Red Central)",
                webphoneRedsantralDesc: "Integrazione sistema telefonico web",
                webphoneTelnyx: "Webphone (Telnyx)",
                webphoneTelnyxDesc: "Integrazione Telnyx per chiamate globali",
                webphoneNetgsm: "Webphone (NetGSM)",
                webphoneNetgsmDesc: "Integrazione telefonica web con centralino NetGSM",
                aiVoiceAgent: "AI Voice Agent",
                aiVoiceAgentDesc: "Gestisci i tuoi telefoni con l'assistente vocale IA. Puoi anche integrare l'assistente vocale nel tuo sito web.",
                artificialIntelligenceFallback: "Intelligenza artificiale",
                openRouter: "OpenRouter",
                openRouterDesc: "Accesso a tutti i modelli LLM tramite una singola API",
                openAIDesc: "Modelli GPT-4, GPT-4o e ChatGPT",
                googleAIStudio: "Google AI Studio",
                googleAIStudioDesc: "Modelli Gemini",
                anthropic: "Anthropic",
                anthropicDesc: "Modelli Claude 3.5 Sonnet e Claude",
                mistral: "Mistral",
                mistralDesc: "Mistral Large e altri modelli",
                microsoftAzure: "Microsoft Azure",
                microsoftAzureDesc: "Servizi Azure OpenAI",
                amazonBedrock: "Amazon Bedrock",
                amazonBedrockDesc: "Piattaforma AWS LLM",
                cohere: "Cohere",
                cohereDesc: "Modelli Command R+ e NLP",
                xai: "xAI",
                xaiDesc: "Modelli Grok",
                deepInfra: "DeepInfra",
                deepInfraDesc: "Infrastruttura di inferenza LLM",
                together: "Together",
                togetherDesc: "Servizi LLM open source",
                fireworks: "Fireworks",
                fireworksDesc: "Inferenza LLM veloce",
                siliconFlow: "SiliconFlow",
                siliconFlowDesc: "Piattaforma modelli IA",
                parasail: "Parasail",
                parasailDesc: "Servizio API LLM",
                nebius: "Nebius",
                nebiusDesc: "Infrastruttura cloud IA",
                alibabaCloud: "Alibaba Cloud",
                alibabaCloudDesc: "Modelli Qwen",
                xiaomi: "Xiaomi",
                xiaomiDesc: "Modelli MiLM",
                sambaNova: "SambaNova",
                sambaNovaDesc: "Hardware e software IA",
                moonshotAI: "Moonshot AI",
                moonshotAIDesc: "Modelli Kimi",
                minimax: "Minimax",
                minimaxDesc: "Modelli Abab",
                nvidia: "NVIDIA",
                nvidiaDesc: "Modelli NVIDIA NIM",
                whatsappComparisonTitle: "Confronto soluzioni WhatsApp",
            },
            trendyol: "Trendyol",
            addUserToRole: "Add user to role",
            moveToRole: "Sposta in ruolo",
            noUsersInRole: "No users in this role",
            removeUserFromRole: "Remove user from role",
            removeUserFromRoleConfirm: " Are you sure you want to remove this user from the role?",
            selectNewRole: "Seleziona nuovo ruolo",
            selectRole: "Seleziona ruolo",
            roleUsersUpdated: "Utenti aggiornati",
            userNotFound: "User not found",
            unnamed: "Unnamed",
            favorites: "Favorites",
            whatsappv3Channel: "Canale Whatsapp V3: ",
            linkedinChannel: "Linkedin Channel: ",
            telegramChannel: "Telegram Channel: ",
            linkedinUserProfile: "Linkedin User Profile",
            telegramUserProfile: "Telegram User Profile",
            createTask: "Crea attività",
            integrationsInstagram: "Gestisci i messaggi Instagram da un unico pannello, comunica con i clienti senza interruzioni sui social.",
            integrationsLinkedin: "Gestisci messaggi e commenti LinkedIn, interagisci rapidamente con i clienti grazie alle risposte automatiche.",
            integrationsTelegram: "Gestisci il canale Telegram da una sola piattaforma, controlla facilmente tutti i messaggi.",
            integrationsWebchat: "Aumenta le conversioni con chatbot attivo 24/7 sul tuo sito, risposte alle FAQ e follow-up dei lead.",
            conversation: "Team Chat",
            deleteThread: "Sei sicuro di voler eliminare tutte le email? Questa operazione non può essere annullata.",
            deleteMail: "Sei sicuro di voler eliminare l'email? Questa operazione non può essere annullata.",
            showHeaderImage: "Show Company Logo and Name",
            cardInfos: "Card Infos",
            saveSystemCardInfo: "La tua carta viene salvata nel nostro sistema e il pagamento viene addebitato automaticamente alla scadenza.",
            cardNumber: "Card Number",
            cardType: "Card Type",
            skt: "ED",
            cvv: "CVV",
            saveCard: "Save Card",
            cardNameSurname: "Card Holder's Name and Surname",
            confidentialityAgreementCheck: "I Accept the Confidentiality Agreement",
            confidentialityAgreement: "Confidentiality Agreement",
            sameTag: "There is a tag with this name!",
            mail: "Mails",
            billingAddress: "Billing Address",
            addNewAddress: "Add New Address",
            adressTitle: "Address Title",
            address: "Address",
            contactUs: "Contact Us",
            Aufgabe: "Attività",
            FromName: "Nome del Mittente",
            ImportFromReadyTemplates: "Importa da modelli pronti",
            KeepUsingFeatures: "Per continuare a usare le funzionalità",
            anWarteschlange: "Coda",
            aprobado: "Approvato",
            campaign: "Campaign",
            cantProceedPayment: "Cause of we couldn't proceed payment",
            chatbotTickets: "Ticket chatbot",
            completado: "Completato",
            configureTrendyolStoreStoreIntegrationDetail: "Configura l'integrazione del tuo negozio Trendyol",
            connectZohoZoho: "Connetti a Zoho CRM",
            createMoreThanOneOpenAiChannel: "Non puoi creare più di un canale OpenAI",
            deleteModalModalFormDesc: "Se elimini questo modulo, tutti i dati del modulo verranno eliminati definitivamente. Sei sicuro di voler continuare?",
            deleteZohoLinkbulkSms: "SMS massivi",
            failToDeleteGroup: "Errore nell'eliminazione del gruppo",
            failToDeleteGroups: "Errore nell'eliminazione dei gruppi",
            failToFetchGroupContacts: "Errore nel recupero dei contatti del gruppo",
            featureIsNotAvailable: "La funzionalità non è disponibile.",
            ifYouSendThisConversationToTheQue: "Se invii questa conversazione in coda, verrai rimosso dalla chat e la conversazione andrà in coda. Se l'assegnazione automatica è attiva, la conversazione verrà assegnata a un agente e potrà essere ritrasferita a te.",
            initialContact: "First Contact",
            manageYourYourTeamGramIntegration: "Gestisci la tua integrazione TeamGram",
            needsAssessment: "Needs Assessment",
            notCreateMoreThanOneChannel: "Non puoi creare più di un canale Ideasoft",
            offlineTickets: "Ticket offline",
            payNow: "PAGA ORA",
            saveAsAsEmailCustomerGroup: "Salva come gruppo clienti email",
            saveAsAsWhatsAppCustomerGroup: "Salva come gruppo clienti WhatsApp",
            saving: "Salvataggio...",
            sendBulkBulkSmsCustomers: "Invia SMS di massa ai tuoi clienti",
            supprimerZohoLinkbulkSms: "SMS massivi",
            sureDeleteDeleteZohoChannel: "Sei sicuro di voler eliminare il canale Zoho CRM?",
            suspendedPlan: " le funzionalità sono sospese",
            ticketSettings: "Impostazioni ticket",
            trendyolStoreConnection: "Connetti il tuo negozio Trendyol",
            usageLimitExceeded: "Limite di utilizzo superato",
            utoForwardToOwnerForce: "Inoltro automatico al proprietario (anche con chatbot attivo)",
            visitorScreenLabel: "Etichetta schermata visitatore"
        },
        telegram: {
            typeInTelegramToken: "Inserisci il token di Telegram",
            token: "Token",
            telegram: "Telegram",
            telegramTokenTitle: "Token di Telegram",
            telegramAlertForm: "Modulo di avviso di Telegram",
            telegramAlertTitle: "Titolo dell'avviso di Telegram",
            telegramAlertText: "Testo dell'avviso di Telegram"
        },
        wp: {
            sendingStatus: "In invio",
            sent: "Inviato",
            allErrors: "Tutti gli errori",
            inProcess: "In elaborazione",
            sendingStatuses: "Stati di invio",
            downloadCSV: "Scarica CSV",
            errorMessage: "Messaggio di errore",
            noNumbersAdded: "Nessun numero aggiunto",
            downloadDetails: "Scarica dettagli",
            broadcastFound: "{count} trasmissione/i trovata/e",
            resendForFailedNumbersTooltip: "Avvia reinvio per i restanti",
            date: "Data",
            walletBalanceInsufficient: "Saldo del portafoglio insufficiente.",
            broadcastCreatedSuccess: "Trasmissione creata con successo.",
            broadcastCreateFailed: "Impossibile creare la trasmissione.",
            resendTitlePrefix: "Reinvia ({count} destinatari): ",
            duplicateTitlePrefix: "Duplicato: ",
            broadcastClonedSuccess: "Trasmissione clonata con successo.",
            broadcastCloneFailed: "Impossibile clonare la trasmissione.",
            broadcastCancelRequestSent: "Richiesta di annullamento inviata. Attendere...",
            broadcastCancelledSuccess: "Trasmissione annullata con successo.",
            downloadError: "Errore durante il download!",
            progressTooltipFormat: "{percent}% ({sent} inviati/{total} contatti)",
            successRatioTooltipFormat: "Totale inviati = {total} \n Messaggi riusciti = {success} \n Messaggi falliti = {failed}",
            notAvailable: "N/D",
            fieldRequired: "Il campo {field} è obbligatorio.",
            defaultBroadcastMessageText: "Ciao {{name}}, grazie per averci scelto.",
            sendAgain: "Invia di nuovo",
            shippingDetails: "Dettagli di spedizione",
            importContactsFromFile: "Importa contatti da File",
            whatsapp: "Whatsapp",
            chatStartingWait: "Avvio della chat, attendere prego...",
            chatStarted: "Chat avviata",
            chatNotStarted: "Chat non avviata",
            contactSelected: "Contatto selezionato",
            startChatWithAnyNo: "Avvia una chat con qualsiasi numero",
            toLittleChar: "Inserisci almeno 3 caratteri",
            typeInANumberDesc: "Digita un numero di telefono per avviare una chat",
            wpPlusAndLicenceRequired: "Piano Whatsapp Plus e licenza richiesti.",
            wpPlusAndLicenceRequiredDesc: "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            agreement: "Accordo",
            purchase: "Acquista",
            activating: "Attivazione",
            authenticating: "Autenticazione",
            ready: "Pronto",
            activationTitle: "Abilitare l'integrazione di Whatsapp su Supsis:",
            wpIntegrationInstruction1: "Apri Whatsapp sul tuo telefono e vai su Impostazioni.",
            wpIntegrationInstruction2: "Selezionare Menu o Impostazioni e fare clic su Dispositivi connessi. ",
            wpIntegrationInstruction3: "Punta il telefono su questa schermata per scansionare il codice",
            qrGeneratingWait: "Generazione del codice QR in corso, attendere...",
            pleaseContinueToWaitUntilCompleted: "Dopo che il codice QR è stato verificato, passerà automaticamente al campo completato. Attendere prego...",
            authenticatingWait: "Accesso, attendere prego...",
            enableFeature: "Abilita funzionalità",
            unsubscribeWpInetgration: "Annulla l'abbonamento all'integrazione di Whatsapp",
            unsubscribeIGIntegration: "Annulla l'abbonamento all'integrazione di Instagram",
            wpBack: "Torna a Whatsapp",
            terminatelWpInetgration: "Quando fai clic sul pulsante Annulla abbonamento, il tuo abbonamento verrà annullato e non potrai utilizzare il servizio Whatsapp.",
            cancelWpInetgration: "Vuoi annullare l'abbonamento all'integrazione di Whatsapp?",
            terminatelIGIntegration: "Quando fai clic sul pulsante Annulla abbonamento, il tuo abbonamento verrà annullato e non potrai utilizzare il servizio Instagram.",
            cancelIGIntgeration: "Vuoi annullare l'abbonamento all'integrazione di Instagram?",
            startChatWp: "Avvia chat su Whatsapp",
            readAndAgree: "Ho letto e accetto l'accordo",
            subscribe: "Abbonati",
            subscribed: "Abbonato",
            toEnableWpDescription: "Per abilitare l'integrazione di Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            waitForWpActivationDescription: "Attendere che il servizio Whatsapp venga attivato. Questo processo può richiedere fino a 24 ore. Riceverai una notifica quando il servizio verrà attivato.",
            greatWpActivatedDescription: "Grande! Il servizio Whatsapp è stato attivato. Puoi iniziare a utilizzare il servizio.",
            unsubscribe: "Annulla abbonamento",
            planDetails: "Dettagli del piano",
            sendReceiveMessage: "Invia & Ricevi Messaggio ",
            sendReceiveImage: "Invia & Ricevi Immagine",
            sendReceiveAudio: "Invia & Ricevi Audio ",
            sendReceiveGif: "Invia & Ricevi Gif ",
            startChat: "Supsis Avvia Chat",
            supsisFunctionality: "Funzionalità Supsis",
            onePhoneMultiAgent: "Un telefono, più agenti",
            basicIntegration: "Integrazione di base",
            purchaseHeader: "Acquistare Integrazione Supsis-Whatsapp",
            wpServices: "Servizi Whatsapp",
            wpServicesIntegrationCompleted: "Integrazione dei servizi Whatsapp completata",
            purchasePaymentDescription: "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            wpIntegrationFeatures: "Funzionalità di integrazione di Whatsapp",
            saveChanges: "Salva modifiche",
            contactList: "Elenco dei contatti",
            broadcast: {
                broadcast: "Trasmissione",
                detail: "Dettaglio",
                customer: "Cliente",
                phoneNumbers: "Numeri di telefono",
                showMore: "Mostra di più",
                showLess: "Mostra meno",
                groupName: "Nome del gruppo",
                messages: "Messaggi",
                status: "Stato",
                usageCost: "Costo di utilizzo",
                sendingTime: "Tempo di invio",
                progress: "Progresso",
                groupDetail: "Dettaglio del gruppo",
                messagesPerContact: "Messaggi per contatto",
                successRatio: "Rapporto di successo",
                message: "Messaggio"
            },
            messages: "Messaggi",
            broadcastRequests: "Richieste di trasmissione",
            customerGroups: "Gruppi di clienti",
            messageTemplates: "Modelli di messaggi",
            plans: "Piani",
            wpIntegrationRequired: "Integrazione di Whatsapp richiesta",
            wpRequiredIntegrationDescription: "Per utilizzare il servizio Whatsapp, è necessario disporre di un piano Whatsapp Plus e di una licenza.",
            integrateWp: "Integra Whatsapp",
            active: "Attivo",
            archived: "Archiviato",
            createBroadcastMessage: "Crea un messaggio di trasmissione",
            title: "Titolo",
            description: "Descrizione",
            createdAt: "Creato a",
            numbers: "Numeri",
            actions: "Azioni",
            action: "Azione",
            createCustomerGroup: "Crea un gruppo di clienti",
            search: "Ricerca",
            name: "Nome",
            contacts: "Contatti",
            noContactFound: "Nessun contatto trovato",
            broadcastTitle: "Titolo della trasmissione",
            recipients: "Destinatari",
            selectRecipients: "Seleziona i destinatari",
            writeYourMessage: "Scrivi il tuo messaggio",
            schedule: "Programma",
            scheduleNowOrLater: "Programma ora o più tardi",
            summary: "Sommario",
            cancel: "Annulla",
            send: "Invia",
            sending: "Invio",
            deleteCustomerGroup: "Sei sicuro di voler eliminare questo gruppo di clienti? {name}",
            customerGroupDeleting: "Eliminazione del gruppo di clienti in corso",
            customerGroupDeletingSuccess: "Gruppo di clienti eliminato con successo",
            customerGroupDeletingError: "Errore durante l'eliminazione del gruppo di clienti",
            wpPlusRequired: "Richiesto Whatsapp Plus",
            broadcastMessageArchived: "Messaggio di trasmissione archiviato",
            broadcastMessageNotArchived: "Il gruppo di messaggi broadcast non è stato archiviato",
            groupNameSearch: "Inserisci il nome del gruppo cliente",
            groupNameDesc: "Il nome del gruppo cliente identifica i tuoi gruppi di clienti",
            save: "Salva",
            number: "NUMERO",
            addColumn: "Aggiungi colonna",
            addColumnDesc: "Aggiungi una colonna alla tabella",
            addNewContact: "Aggiungi nuovo contatto",
            addNewContactDesc: "Aggiungi una persona alla tabella",
            importFile: "Importa da file",
            importFileDesc: "Importa i contatti da un file Excel o CSV",
            contactAdded: "Contatto aggiunto",
            updateCustomerGroup: "Aggiornamento gruppo cliente in corso...",
            updateCustomerGroupSuccess: "Gruppo cliente aggiornato con successo",
            sendBroadcastMessage: "Invia messaggio broadcast",
            columnName: "Nome colonna",
            columnType: "Tipo colonna",
            defaultValue: "Valore predefinito",
            setDefaultValue: "Imposta il valore predefinito per i contatti esistenti",
            age: "Età",
            location: "Posizione",
            gender: "Genere",
            selectContactFile: "Seleziona il file dei contatti",
            selectContactCsvOrExcel: "Seleziona un file CSV o Excel",
            importConfiguration: "Importa la tua configurazione",
            customizeFile: "Personalizza il file dei contatti aggiunti",
            sendMessageTo: "A chi desideri inviare il messaggio?",
            allContact: "Tutti i contatti",
            messageTypes: "Tipi di messaggio",
            whenSendMessage: "Quando desideri inviare il messaggio?",
            instantlyRightNow: "Immediatamente, adesso",
            completed: "Completato",
            scheduleFuture: "Pianifica per una data futura",
            messageDesc: "Il tuo messaggio sarà inviato istantaneamente a tutti i destinatari",
            messageSendAt: "Il tuo messaggio sarà inviato a tutti i destinatari in questa data: ",
            estimatedPrice: "Prezzo stimato",
            estimatedTime: "Tempo stimato",
            now: "Adesso",
            tenMinute: "10 minuti",
            cancelled: "Annullato",
            failed: "Fallito",
            running: "In esecuzione",
            queued: "In coda",
            scheduled: "Pianificato",
            noNumberAdded: "Nessun numero aggiunto",
            csvOrExcelFile: "File CSV o Excel",
            broadcastMessagesToContactFile: "Invia messaggi broadcast alla lista contatti",
            broadcastMessageTemplates: "Modelli di messaggi broadcast",
            messageFlow: "Flusso del messaggio",
            textMessageSupport: "Supporto messaggi di testo",
            imageMessageSupport: "Supporto messaggi con immagini",
            spamPreventions: "Prevenzione dello spam",
            includesAllBasicPlans: "Include tutte le funzionalità del pacchetto WhatsApp",
            chatbotIntegration: "Integrazione con chatbot",
            messageToNewNumbers: "Invio messaggi ai nuovi numeri",
            broadcastMessageToEveryone: "Invio messaggi broadcast a tutti",
            personalizedBroadcastMessage: "Messaggi broadcast personalizzati",
            customerGroupSegmentation: "Segmentazione del gruppo cliente",
            scheduleBroadcastMessage: "Pianificazione messaggi broadcast",
            locationMessageSupport: "Supporto messaggi di posizione",
            advancedSpamPreventions: "Prevenzione avanzata dello spam",
            whatsappPlans: "Piani WhatsApp",
            selectBestPlan: "Seleziona il piano migliore per te",
            comingSoon: "Disponibile a breve...",
            selectFile: "Seleziona un file",
            created: "Creato",
            message: "Messaggio",
            uploadFromComputer: "Carica da computer",
            cancelIGIntegration: "Vuoi annullare l'integrazione Instagram?"
        },
        ig: {
            instagram: "Instagram"
        },
        ticket: {
            trendyolQandA: "Domande e Risposte Trendyol",
            instagramComments: "Commenti Instagram",
            messengerComments: "Commenti Messenger",
            trendyolComments: "Commenti Trendyol",
            facebookComments: "Commenti di Facebook",
            ticketSelection: "Ticket Selezionato",
            bulkClose: "Chiusura di Massa",
            igComment: "Commento Instagram",
            igMentioned: "Menzioni su Instagram",
            incomingReqChatbot: "Richieste in arrivo con Chatbot",
            incomingReqWebForm: "Richieste da modulo web",
            incomingReqAutomation: "Richieste dall'automazione",
            thisPersonEmailAnswered: "Questa persona vuole una risposta via e-mail",
            thisPersonWpAnswered: "Questa persona è in attesa di una risposta via WhatsApp",
            clickStartWpChat: "Fare clic per avviare una chat WhatsApp",
            requestProgress: "Stato di avanzamento della richiesta",
            requestMessage: "Messaggio di richiesta",
            clickAddMailAddress: "Clicca per aggiungere un indirizzo e-mail",
            sendReplyCloseTicket: "Invia risposta e chiudi il biglietto",
            closeTicket: "Chiudi biglietto",
            selectEmailSender: "Seleziona il mittente dell'e-mail",
            withEmailWillNotRecievice: "Non sarà possibile ricevere risposte all'e-mail quando si invia con questo indirizzo e-mail!",
            deleteCommentAndClose: "Cancella e chiudi il commento",
            sendReplyAndClose: "Invia risposta e chiudi",
            startChatWp: "Avvia chat WhatsApp",
            sureWantToDeleteTicket: "Sei sicuro di voler eliminare un biglietto?",
            bulkDeleteConfirmation: "Conferma di cancellazione in blocco",
            selectedTicketSucsDelete: "I biglietti selezionati sono stati eliminati con successo",
            thereErrorDeletingTicket: "Si è verificato un errore durante l'eliminazione dei biglietti",
            deleteConfirm: "Conferma l'eliminazione",
            sureDeleteTicket: "Sei sicuro di voler cancellare questo biglietto?",
            ticketSucsDelete: "Biglietto eliminato con successo",
            represantiveSucsAppoint: "L'agente è stato nominato con successo",
            ticketClosedSucs: "Biglietto chiuso con successo",
            ticketCloureFailed: "Chiusura del biglietto non riuscita.",
            unprocessed: "Non elaborato",
            pleaseSelectValidStatus: "Selezionare uno stato valido",
            ticketStatusBeenUpdatd: "Lo stato del biglietto è stato aggiornato",
            doYouWantCloseTicket: "Vuoi chiudere il biglietto?",
            ticketWillMarkedClosed: "Il biglietto sarà contrassegnato come chiuso e archiviato",
            errorUpdatingTicketFailed: "Si è verificato un errore durante l'aggiornamento dello stato del biglietto",
            igCommentDeleteIgPost: "Il commento Instagram è stato eliminato dal vostro post IG",
            igCommentHideChange: "Lo stato di nascondimento dei commenti di Instagram è stato modificato",
            pleaseChooseRepresent: "Selezionare un rappresentante",
            selectedTicketSucsDelegated: "I biglietti selezionati sono stati delegati con successo",
            errorOccuredDuringDelegation: "Si è verificato un errore durante il processo di delega",
            bulkTicketClosing: "Chiusura di un biglietto in blocco",
            sureWantCloseTicket: "Sei sicuro di voler chiudere il ticket?",
            selectedTicketSucsClosed: "I ticket selezionati sono stati chiusi con successo",
            thereErrorClosingTicket: "Si è verificato un errore durante la chiusura dei ticket",
            changeFilterTicketPage: "Modifica dei filtri della pagina Biglietti",
            nameOfFilter: "Nome del filtro",
            filterValue: "Valore del filtro",
            deletesSelectedTickets: "Cancella i biglietti selezionati",
            idTicketBeDelete: "Gli id dei biglietti da eliminare (id dei biglietti selezionati o tutti gli id dei biglietti elencati)",
            assignsAgentSelectedTickets: "Assegna un rappresentante ai biglietti selezionati",
            idTicketBeAssigned: "ID dei biglietti da assegnare. (ID dei biglietti selezionati o ID di tutti i biglietti elencati)",
            idAgentAssigned: "ID del rappresentante da assegnare",
            changesStatusSelectedTicket: "Cambia lo stato dei biglietti selezionati",
            idTicketWhoseStatus: "ID dei biglietti di cui cambiare lo stato. (ID dei biglietti selezionati o ID di tutti i biglietti elencati)",
            newStatus: "Nuovo Stato",
            selectedTicketsSucsUpdated: "Lo stato dei biglietti selezionati è stato aggiornato con successo.",
            errorWhileChangingStatus: "Si è verificato un errore durante la modifica dello stato dei biglietti.",
            thisPageVoiceAssistant: "C'è un assistente vocale in questa pagina",
            hello: "Ciao!",
            voiceAssistantContent: " Sapevi che c'è un <strong>Assistente AI</strong> che può aiutarti in questa pagina? Puoi provare a usare l'assistente con i seguenti metodi:",
            commandHoldingDownTheKey: "puoi tenere premuto il tasto combinato e dare comandi parlando.",
            topRightContent: "In alto a destra",
            clickOnTheIcon: "clicca sull'icona per avviare l'assistente.",
            sampleVoiceCommands: "Esempi di comandi vocali:",
            showMyTickets: "Mostra i miei biglietti",
            showMeZeynepsOpenTicket: "Mostra i biglietti aperti di Zeynep oggi",
            deleteTicketsScreen: "Cancella i biglietti sullo schermo",
            assigntLastTicketAli: "Assegna l'ultimo biglietto ad Ali",
            changeStatusAllTicket: "Cambia lo stato di tutti i biglietti in done",
            setStatusTicketsScreen: "Imposta lo stato dei biglietti sullo schermo su .......",
            assigntUserTicketScreen: "Assegna i biglietti sullo schermo all'utente .....",
            assigntFirstTicket: "Assegna il primo biglietto a me",
            showIgTickets: "Mostra i biglietti instagram del mese scorso",
            makeChoice: "Effettua una selezione",
            makeAssignment: "Assegnazione",
            tickets: "Biglietti",
            instagramTickets: "Biglietti Instagram",
            facebookTickets: "Biglietti Facebook",
            trendyolTickets: "Biglietti Trendyol",
            automationTickets: "Biglietti di automazione",
            supsisFormTickets: "Supsis Form Tickets",
            columnSettings: "Impostazioni della colonna",
            ticketField: "Area biglietti",
            contactPropertyFields: "Raggiungere le aree di proprietà",
            ticketFilterList: {
                archivedRequests: "Richieste archiviate",
                comingFromFacebook: "In arrivo da Facebook",
                comingFromInstagram: "Provenienti da Instagram",
                unassignedOpenRequests: "Richieste aperte non assegnate",
                openRequests: "Richieste aperte",
                requestsOpenedThisWeek: "Richieste aperte questa settimana",
                specialList: "Elenco speciale",
                creationDate: "Data di creazione",
                supsisFromTheForm: "Supsis dal modulo",
                fromTrendyol: "Da Trendyol",
                comesWithAutomation: "Viene dall'automazione",
                label: "Etichetta",
                status: "Stato",
                subject: "Oggetto",
                email: "Email",
                name: "Nome",
                phone: "Telefono",
                type: "Tipo",
                assignedUser: "Utente assegnato"
            },
            appointingRepresentative: "Nomina un rappresentante",
            ticketTagFilter: "Filtro Tag Ticket",
            ticketEmails: "Lista Indirizzi Email di Reindirizzamento Ticket",
            save: "Salva",
            delete: "Elimina",
            transactions: "Transazioni",
            noEmailTicketNotifications: "Nessuna notifica via email per il reindirizzamento dei ticket trovata",
            emailIsNotValid: "Indirizzo email non valido",
            emailNotificationDeleted: "Notifica via email per il reindirizzamento dei ticket eliminata",
            emailNotificationDeleteError: "Impossibile eliminare la notifica via email per il reindirizzamento dei ticket",
            tagFilterRequired: "È necessario specificare un filtro di tag per i ticket. Puoi utilizzare il carattere jolly '*' per tutti i ticket!",
            emailsRequired: "È necessario specificare almeno un indirizzo email per il reindirizzamento dei ticket",
            emailNotificationCreated: "Creata notifica via email per il reindirizzamento dei ticket",
            emailNotificationCreateError: "Impossibile creare la notifica via email per il reindirizzamento dei ticket",
            ticketForwarding: "Reindirizzamento Email dei Ticket",
            ticketTagFilterDesc: "Utilizza i tag dei ticket utilizzati nel design del chatbot per filtrare i ticket. Puoi inserire un tag diverso e premere Invio per aggiungerlo. Seleziona '*' per tutti i ticket.",
            ticketEmailsDesc: "Elenco degli indirizzi email a cui reindirizzare i ticket. Puoi selezionare gli indirizzi email dei rappresentanti del sistema o aggiungere indirizzi email esterni.",
            ticketList: "Regole di Reindirizzamento dei Ticket",
            ticketTagFilterPlaceHolder: "Filtro ticket, seleziona '*' per tutti",
            ticketEmailsPlaceHolder: "Elenco indirizzi email di reindirizzamento",
            chatbotTickets: "Chatbot Tickets",
            offlineTickets: "Offline Tickets",
            ticketSettings: "Ticket Settings",
            assignFirstTicket: "Assign the first ticket to me.",
            assignLastTicketAli: "Assign the last ticket to Ali.",
            assignUserTicketScreen: "Assign the tickets on the screen to the user .....",
            placeholders: "Placeholders",
            ticketStatusBeenUpdated: "Lo stato del ticket è stato aggiornato."
        },
        theme: {
            headerColor1: "Colore Intestazione (Sinistra)",
            headerColor1A: "Colore/Trasparenza dell'Intestazione",
            headerColor2: "Colore Intestazione (Destra)",
            headerColor2A: "Colore/Trasparenza dell'Intestazione 2",
            backgroundColor: "Colore di Sfondo (Sinistra)",
            backgroundColorA: "Colore/Trasparenza di Sfondo 1",
            backgroundColor2: "Colore di Sfondo (Destra)",
            backgroundColor2A: "Colore/Trasparenza di Sfondo 2",
            opacity: "Trasparenza",
            textColor: "Colore Testo Generale",
            errorTheme: "Colore Errore",
            bubbleBackground: "Colore Sfondo Bubble (Agente)",
            bubbleVisitorBackground: "Colore Sfondo Bubble (Visitatore)",
            bubbleBackgroundA: "Trasparenza Bubble (Agente)",
            bubbleVisitorBackgroundA: "Trasparenza Bubble (Visitatore)",
            bubbleText: "Colore Testo Bubble (Agente)",
            bubbleVisitorText: "Colore Testo Bubble (Visitatore)",
            textFormColor: "Colore Testo Form",
            selectCustom: "Seleziona Tema Personalizzato",
            font: "Carattere",
            headerColorSecond: "Colore Superiore Intestazione",
            headerColorFirst: "Colore Inferiore Intestazione",
            backgroundColorFirst: "Colore Superiore Sfondo",
            formColor: "Colore Testo Form",
            buttonColor: "Colore Pulsante",
            backgroundColorSecond: "Colore Inferiore Sfondo",
            chatBotButtonText: "Colore del carattere del chatbot",
            chatBotButtonColor: "Colore pulsante chatbot"
        },
        billing: {
            paymentId: "ID pagamento",
            billType: "Tipo fattura",
            invoiceAmount: "Importo fattura",
            invoiceDate: "Data fattura",
            invalidBill: "Fattura non valida",
            invalidBillNotPossible: "Questa fattura non è stata creata, quindi non può essere contrassegnata come non valida.",
            myInvoices: "Le mie fatture",
            allInvoices: "Tutte le fatture",
            manualInvoices: "Fatture manuali",
            endOfPeriodInvoices: "Fatture di periodo",
            purchaseInvoices: "Fatture di acquisto",
            paidInvoices: "Fatture pagate",
            unpaidInvoices: "Fatture non pagate",
            walletDeposit: "Deposito portafoglio",
            updateBillingInfo: "Aggiorna informazioni sulla fattura",
            notFoundSavedBillingAddress: "Nessuna indirizzo fattura memorizzato",
            notFoundSavedCard: "Nessuna carta di credito memorizzata",
            cardInfoIsStoredSecurelyByIyzico: "Le informazioni della carta sono memorizzate in modo sicuro da Iyzico",
            paymentMethodAndInvoiceAddress: "Metodo di pagamento e indirizzo fattura",
            unpaidInvoiceBannerMessage: "Hai una fattura non pagata. Si prega di pagare la fattura per evitare l'interruzione del servizio.",
            unpaidInvoiceBannerMessageWithDate: "Hai una fattura non pagata. Se non paghi entro il {date}, il tuo account verrà sospeso.",
            unpaidInvoiceBannerSuspendedMessage:
                "Il tuo account è stato sospeso per fatture non pagate. Completa il pagamento per ripristinare il servizio.",
            clickToPay: "Vai alla pagina di pagamento",
            packageDescriptions: {
                whatsapp: "Integra il tuo account WhatsApp normale per rispondere ai clienti su tutti i canali.",
                whatsappBusiness: "Integra il tuo account WhatsApp Business per rispondere ai clienti su tutti i canali.",
                supsis: "Con più rappresentanti, puoi rispondere ai tuoi clienti in modo più rapido ed efficace.",
                chatbot: "L'integrazione del chatbot ti consente di offrire assistenza ai clienti 24/7.",
                instagram: "Integra il tuo account Instagram per rispondere ai clienti su tutti i canali.",
                telegram: "Integra il tuo account Telegram per rispondere ai clienti su tutti i canali.",
                custom: "Scegli uno dei nostri piani personalizzati per ottenere soluzioni su misura per la tua azienda.",
                messenger: "Integra il tuo account Messenger per rispondere ai clienti su tutti i canali.",
                trendyol: "Integra il tuo account Trendyol per rispondere rapidamente alle domande dei clienti.",
                metaLead: "Integra il tuo account Meta Lead per gestire i lead direttamente dal pannello di controllo.",
                customerTables: "Crea tabelle dinamiche per gestire le informazioni dei clienti, gli ordini e molto altro.",
                form: "Crea moduli per raccogliere informazioni dai clienti e analizzare i dati.",
                automation: "Configura automazioni per ottimizzare i processi aziendali e migliorare il servizio.",
                mail: "L'integrazione della posta elettronica ti consente di inviare e ricevere email dai clienti.",
                tasks: "Crea attività per pianificare e gestire i tuoi processi di lavoro.",
                artificialIntelligence: "L'integrazione dell'intelligenza artificiale ti aiuta a rispondere ai clienti in modo più rapido ed efficace.",
                webhook: "Integra le tue applicazioni con Supsis utilizzando i webhook.",
                default: "Esplora i nostri pacchetti per maggiori dettagli."
            },
            autoRenew: "Rinnovo automatico",
            purchased: "Acquistato",
            currentPlans: "I miei piani",
            individual: "Individuo",
            expirationDate: "Scad",
            editCardInformation: "Modifica informazioni carta",
            billingContactInfo: "Informazioni sul contatto di fatturazione aggiornate con successo",
            defaultRootEmail: "Predefinito: Email di base",
            invoiceEmailAddress: "Indirizzo e-mail di fatturazione",
            invoiceSettings: "Impostazioni della fattura",
            updateChannelDesc6: "Aggiornamento del canale Whatsapp business api",
            newWabaChannel: "Nuovo canale Whatsapp Business",
            newWabaChannelDesc: "Crea un nuovo canale per Whatsapp business api",
            popular: "Popolare",
            selectedPlan: "Piano selezionato",
            editPlan: "Modifica piano",
            removePlan: "Rimuovi piano",
            showPlan: "Mostra piano",
            hiddenPlan: "Piano nascosto",
            contactSales: "Contatto vendite",
            showLess: "Mostra meno",
            more: "Di più",
            selectTransactionType: "Tipo di transazione",
            walletLogs: "Registri del portafoglio",
            addBalance: "Aggiungi saldo",
            availableBalance: "Saldo disponibile",
            walletTransactions: "Transazioni del portafoglio",
            autoReload: "Ricarica automatica",
            transactionTypes: "Tipi di transazione:",
            transactionTypesHint: "(Clic per selezione singola, Ctrl+clic per selezione multipla)",
            importantInfo: "Informazioni importanti",
            walletImportantPoint1: "Se il pagamento non può essere addebitato dalla tua carta, il sistema si disattiverà automaticamente; devi attivarlo tu stesso.",
            walletImportantPoint2: "Solo 1 ricarica ogni 10 minuti. Mantieni il saldo target alto per un uso intensivo.",
            walletImportantPoint3: "Puoi abilitare più notifiche dalle Impostazioni notifiche.",
            walletImportantPoint3Before: "Puoi abilitare più notifiche da ",
            walletImportantPoint3After: ".",
            walletImportantPoint4: "Puoi visualizzare le ricariche automatiche nella scheda \"Transazioni del portafoglio\".",
            walletImportantPoint5: "Non c'è limite al numero o all'importo delle ricariche; assicurati di inserire le impostazioni corrette.",
            autoBalanceReload: "Ricarica automatica del saldo",
            autoBalanceReloadDesc: "Ricarica automaticamente il saldo quando il saldo del portafoglio scende sotto la soglia che imposti.",
            autoReloadToggle: "Ricarica automatica",
            autoReloadToggleDesc: "Puoi abilitare/disabilitare questa funzione",
            disabledDueToFailure: "Disabilitato a causa di un errore",
            thresholdValue: "Valore soglia (TL)",
            thresholdValueDesc: "La ricarica automatica viene eseguita quando il saldo scende sotto questo valore",
            reloadMode: "Modalità di ricarica",
            reloadModeDesc: "Cosa deve succedere quando il saldo scende sotto la soglia?",
            addFixedAmount: "Aggiungi importo fisso",
            fixBalance: "Fissa saldo",
            modeAddDesc: "Quando il saldo scende sotto la soglia, viene aggiunto l'importo specificato. Es.: Soglia 50 TL, Saldo 30 TL → 200 TL aggiunti → Saldo 230 TL.",
            modeFixedDesc: "Quando il saldo scende sotto la soglia, viene completato all'importo specificato. Es.: Soglia 50 TL, Saldo 30 TL → 170 TL aggiunti → Saldo 200 TL.",
            amountToAdd: "Importo da aggiungere (TL)",
            targetBalance: "Saldo target (TL)",
            amountToAddDesc: "Questo importo verrà aggiunto quando il saldo scenderà sotto la soglia",
            targetBalanceDesc: "Il saldo verrà completato a questo importo quando scenderà sotto la soglia (deve essere maggiore della soglia)",
            panelNotifications: "Notifiche del pannello",
            panelNotificationsDesc: "In quali casi desideri ricevere notifiche?",
            notifyOnRecharge: "Notifica ricarica riuscita",
            notifyOnFailure: "Notifica errore",
            notifyOnDisabled: "Notifica disabilitazione",
            emailNotifications: "Notifiche email",
            emailNotificationsDesc: "Chi deve ricevere le notifiche email (opzionale)",
            emailPlaceholder: "Inserisci indirizzi email (separare con virgola)",
            emailHint: "Se lasciato vuoto, l'email verrà inviata solo al proprietario del sito",
            lastTrigger: "Ultimo trigger:",
            neverTriggered: "Non ancora attivato",
            failedAttempt: "Tentativo fallito:",
            saveSettings: "Salva impostazioni",
            tabAll: "Tutti",
            tabAiUsage: "Uso AI",
            tabVoiceAgent: "Voice Agent",
            tabAutomation: "Automazione",
            balanceAddedSuccess: "{price}TL è stato aggiunto al tuo account WhatsApp",
            balanceAddFailed: "Impossibile aggiungere saldo al tuo account.",
            autoRebalanceLoadError: "Impossibile caricare le impostazioni di ricarica automatica",
            thresholdMinError: "Il valore soglia deve essere 0 o maggiore",
            targetBalanceMinError: "Il saldo target deve essere maggiore di 0",
            targetBalanceThresholdError: "Il saldo target deve essere maggiore della soglia",
            autoRebalanceSaveSuccess: "Impostazioni di ricarica automatica salvate con successo",
            settingsSaveFailed: "Impossibile salvare le impostazioni",
            testFailed: "Test fallito",
            creditCardRequiredForAutoReload: "Devi prima aggiungere le informazioni della carta di credito per la ricarica automatica",
            notificationSettings: "Impostazioni notifiche",
            appsumoPack: "Pacchetto Appsumo",
            updatePlan: "Aggiorna piano",
            createPlan: "Crea piano",
            freePack: "Pacchetto gratuito",
            instantFee: "Verrà addebitato un costo immediato",
            planSequence: "Sequenza di piani",
            areYouSoreRefundInvoice: "È sicuro di voler elaborare un rimborso per questa fattura?",
            copied: "Copiato",
            copiedToClipboard: "Contenuto copiato negli appunti.",
            copyFailed: "Operazione di copia non riuscita.",
            invoiceGenerated: "Fattura generata",
            invoiceNotGenerated: "Fattura non generata",
            notAvailable: "N/D",
            estimated: "Stimato",
            dueDate: "Data di scadenza",
            markAsPaid: "Segna come pagato",
            refundPayment: "Elabora rimborso",
            editInvoice: "Modifica fattura",
            deleteInvoice: "Elimina fattura",
            adminGroup: "Admin",
            billTypeNone: "Nessuno",
            billTypeManual: "Manuale",
            billTypeMonthly3: "3 mesi",
            billTypeMonthly6: "6 mesi",
            billTypeAnnual: "Annuale",
            billTypeAnnual2: "2 anni",
            billTypeEducation: "Formazione",
            billTypeConsultancy: "Consulenza",
            billTypeInstallation: "Installazione",
            billTypeOther: "Altro",
            paymentNotPossible: "Pagamento non possibile",
            saveCardFirst: "Salvare prima la carta di credito per effettuare un pagamento.",
            requiredCodes: "Numero di codici richiesti",
            subHeading: "Sottointestazione",
            featureKey: "Chiave caratteristica",
            customerKey: "Chiave cliente",
            monthlyPrice: "Prezzo mensile",
            monthlyNonDiscounted: "Prezzo mensile non scontato (visualizzazione non funzionale)",
            twoYearDiscount: "Sconto di 2 anni",
            yearDiscount: "Sconto annuale",
            sixMonthDiscount: "6 mesi",
            threeMonthDiscount: "3 mesi",
            features: "Proprietà",
            sessionCount: "Conteggio delle sessioni",
            subType: "Tipo di abbonamento",
            skipTrialVersion: "Salta la versione di prova",
            skipTrialVersionDesc: "È possibile saltare la versione di prova e continuare selezionando il pacchetto appropriato per la propria attività. Se si salta la versione di prova, questa azione non può essere annullata.",
            skipStep: "Salta questo passaggio",
            switchToPay: "Passa a pagare",
            forward: "Avanti",
            pleaseFillInCard: "Inserire i dati della carta!",
            fillInTheBillingAddress: "Inserisci i dati dell'indirizzo di fatturazione!",
            cardNumberWrong: "Il numero della carta è sbagliato!",
            pleaseConfirmTheUser: "Si prega di confermare l'accordo con l'utente",
            pleaseCheckYourCard: "Controlla la tua carta e i tuoi dati.",
            sito: "Sito",
            period: "Periodo",
            billStatus: "Stato della fattura",
            totalPrice: "Prezzo totale + IVA",
            depotMoneyWallet: "Deposito nel portafoglio",
            threeMonthly: "3 mesi",
            sixMonthly: "6 mesi",
            twoYearly: "2 anni",
            forever: "Per sempre",
            extraPackage: "Pacchetto extra",
            teamPackage: "Pacchetti di squadra",
            adventPackage: "Pacchetti vantaggiosi",
            cupponError: "Il codice del buono è errato o scaduto",
            enterYourCard: "Inserire la carta di credito",
            invalidCard: "Carta di credito non valida, pagamento non ricevuto",
            calculateThis: "Calcola per:",
            adventageousPackage: "Vantaggiosi sconti sui pacchetti!",
            cupponApplied: "Coupon applicato con successo",
            subStart: "Abbonamento avviato",
            subSuccessStart: "L'abbonamento è stato avviato con successo",
            success: "Successo",
            succesDesc: "Abbonamento creato con successo",
            successDesc: "La funzione è stata attivata con successo.",
            maxNumber: "Numero massimo di rappresentanti che possono intervenire",
            currentAmountDetails: "Dettagli sull'importo corrente",
            endOfMonthForecastDetails: "Dettagli della previsione di fine mese",
            totalAmount: "Importo totale",
            vatAmount: "Importo IVA (20%)",
            totalAmountIncludingVAT: "Importo totale IVA inclusa",
            hideDetails: "Nascondi dettagli",
            createInvoice: "Crea fattura",
            reimbursementMade: "Rimborso effettuato",
            invalidInvoice: "Fattura non valida",
            balanceTopUp: "Ricarica saldo WhatsApp",
            paidSuccesfully: "La fattura è stata pagata con successo",
            paymentFailed: "Il processo di pagamento della fattura non è riuscito",
            areYouSurePaid: "Sei sicuro di voler contrassegnare questa fattura come pagata?",
            invoiceMarkedPaid: "La fattura è stata contrassegnata come pagata",
            invoiceMarkedFailed: "Si è verificato un errore e non è stato possibile contrassegnare la fattura come pagata",
            areYouSureRefundInvoice: "Sei sicuro di voler elaborare un rimborso per questa fattura?",
            youMustFillInEmpty: "È necessario riempire tutti gli spazi vuoti",
            createdNewInvoice: "La nuova fattura è stata creata con successo",
            createdNewInvoiceFailed: "Si è verificato un errore durante la creazione della fattura",
            invoiceUpdated: "L'importo della fattura è stato aggiornato con successo...",
            invoiceUpdatedFailed: "Si è verificato un problema durante l'aggiornamento della fattura",
            plans: "Piani",
            companyName: "Nome della società",
            company: "Azienda",
            person: "Persona",
            invoiceAddressInfo: "Informazioni sull'indirizzo della fattura",
            idNo: "ID turco",
            taxOffice: "Ufficio delle imposte",
            taxNumber: "Numero di imposta",
            packageCanNotDownSupsis: "Il pacchetto non può essere declassato. Rimuovere o disattivare alcuni agenti per eseguire il downgrade del pacchetto.",
            packageCanNotDownWp: "Il vostro pacchetto non può essere declassato. Eliminate alcuni dei vostri canali Whatsapp per declassare il vostro pacchetto.",
            packageCanNotDownWPBussiness: "Il tuo pacchetto non può essere declassato. Si prega di eliminare alcuni dei canali Whatsapp Business per declassare lo stato del pacchetto.",
            chooseYourPlan: "Scegli il tuo piano.",
            numberOfRepresentatives: "Numero di rappresentanti",
            numberOfChannels: "Numero di canali",
            wpNumberOfChannels: "Numero di canali Whatsapp",
            igNumberOfChannels: "Numero di canali Instagram",
            msNumberOfChannels: "Numero di canali Messenger",
            cancelIt: "Annulla",
            activePlan: "Piano attivo",
            activate: "Attiva",
            noTransition: "Nessuna transizione",
            daysLater: "giorni dopo",
            payBack: "Rimborso",
            paid: "Pagato",
            unPaid: "Non pagato",
            editPrice: "Modifica prezzo",
            payNow: "paga ora",
            youAreCurrentlyOnTrial: "Sei attualmente in prova. Puoi saltare la prova per vedere i pacchetti esclusivi.",
            youAreCurrentlyLimited: "Sei attualmente limitato dal sistema perché i tuoi pacchetti non soddisfano le condizioni.",
            youHaveOneRepresentative: "Hai un rappresentante.",
            deactivateOrDeleteYourPiece: "Disattiva o elimina il tuo rappresentante Piece o acquista un rappresentante.",
            youHaveOneWhatsappQRChannel: "Hai un canale Whatsapp QR.",
            deleteYourWhatsAppQR: "Elimina il tuo canale Whatsapp QR o acquista un canale.",
            youHaveAWhatsappBusiness: "Hai un canale Whatsapp Business.",
            deleteYourWhatsapp: "Elimina il tuo canale Whatsapp Business o acquista un canale.",
            youHaveAnInstagram: "Hai un canale Instagram.",
            deleteYourInstagram: "Elimina il tuo canale Instagram o acquista un canale.",
            youHaveAMessenger: "Hai un canale Messenger.",
            deleteYourMessenger: "Elimina il tuo canale Messenger o acquista un canale.",
            additionalPackages: "Pacchetti aggiuntivi.",
            availablePackages: "Pacchetti disponibili",
            buyNow: "Acquista ora",
            invoiceInformation: "Informazioni sulla fattura",
            invoiceAddress: "Indirizzo della fattura",
            invoiceType: "Tipo di fattura",
            review: "Recensione",
            viewDetails: "Visualizza dettagli",
            addNewAddress: "Aggiungi nuovo indirizzo",
            enterYourBillingAddress: "Inserisci il tuo indirizzo di fatturazione",
            selectPlan: "Seleziona piano",
            paymentStatus: "Stato pagamento",
            amount: "Importo",
            invoiceID: "ID Fattura",
            expected: "Previsto...",
            currentAmount: "Importo attuale",
            monthlyEstimatedAmount: "Importo mensile stimato",
            creationDate: "Data di creazione",
            invoiceStatus: "Stato della fattura",
            invoicePeriod: "Periodo di fatturazione",
            newPaymentMethod: "Nuovo metodo di pagamento",
            channelCount: "Numero di canali",
            remainingTime: "Tempo rimanente",
            chatbotLimit: "Limite chatbot",
            free: "Gratuito",
            maxChatbotSession: "Sessioni massime del chatbot",
            buyIt: "Acquista",
            renewalDate: "Data di rinnovo",
            monthly: "Mensile",
            yearly: "Annuale",
            packagePeriod: "Periodo del pacchetto",
            packageType: "Tipo di pacchetto",
            packageManagement: "Gestione pacchetti",
            invoiceManagement: "Gestione delle fatture",
            futureInvoice: "Fattura futura",
            pastInvoices: "Fatture passate",
            creditCard: "Carta di credito",
            invoice: "Fattura",
            mustBeUpgradePlanForChatBot: "Per attivare la funzione di Chatbot, è necessario passare al piano Pro!",
            cardInfo: "Informazioni sulla carta",
            billingDetails: "Dettagli di fatturazione",
            addCardIyzico: "Non hai una carta registrata. Per poter pagare le tue tariffe mensili, è necessario aggiungere una carta. Il sistema di pagamento è fornito da iyzico.",
            billingPlanSettings: "Fattura e pagamento",
            paymentMethod: "Metodo di pagamento",
            billingDate: "Data di fatturazione",
            isPaid: "È stato pagato?",
            markPaid: "Contrassegna come pagato",
            paymentDate: "Data di pagamento",
            pay: "Paga Fattura",
            newInvoice: "Nuova Fattura",
            updateBilling: "Modifica Indirizzo di Fatturazione",
            updateCard: "Cambia Carta di Credito",
            paymentBilling: "Metodo di pagamento e indirizzo di fatturazione",
            price: "Importo Fattura",
            billingAddress: "Indirizzo di Fatturazione",
            billingCity: "Città di Fatturazione",
            billingCountry: "Paese di Fatturazione",
            contactName: "Nome del contatto per la fatturazione",
            expireMonth: "Mese di Scadenza",
            expireYear: "Anno di Scadenza",
            expireDate: "Data di Scadenza",
            cardNumber: "Numero di Carta",
            cardHolderName: "Nome del Titolare della Carta",
            cardAlias: "Alias della Carta",
            identityNumber: "Numero di Identificazione/Fiscale",
            name: "Nome",
            surname: "Cognome",
            email: "Email",
            addCard: "Aggiungi Carta",
            update: "Aggiorna",
            cancel: "Annulla",
            save: "Salva",
            saving: "Salvataggio in corso",
            noInvoiceFound: "Nessuna fattura trovata",
            year: "Anno",
            updating: "Aggiornamento in corso",
            newInvoiceForm: "Nuovo Modulo di Creazione Fattura",
            error: "Errore",
            transactions: "Transazioni",
            paymentMethodAdded: "Metodo di pagamento aggiunto con successo",
            paymentMethodAddError: "Impossibile aggiungere il metodo di pagamento, si è verificato un errore",
            creditCardChanged: "La tua carta di credito è stata cambiata",
            errorOccurred: "Si è verificato un errore, riprova.",
            billingDetailUpdated: "Le tue informazioni di fatturazione sono state aggiornate",
            invoiceCreated: "La fattura è stata creata con successo",
            paymentSuccess: "La tua fattura è stata pagata con successo, grazie",
            paymentFail: "Si è verificato un errore durante il pagamento della fattura, riprova più tardi.",
            startWith: "Carta {binNumber} che inizia con {cardFamily}",
            billingAddressChanged: "Le informazioni sull'indirizzo di fatturazione sono state aggiornate",
            hidePlan: "Nascondi Piano",
            informationShopping: "Le tue informazioni di pagamento, di fatturazione e di carta di credito sono controllate da Shopify.",
            trialTimeInformation: "Restano {dayCount} giorni al termine della versione di prova. Se non inserisci un metodo di pagamento entro questo periodo, il sistema passerà automaticamente al piano GRATUITO.",
            trialTimeInformationShort: "{dayCount} giorni rimanenti",
            currentPlanLabel: "Piano attuale: Piano {planName} ({agentCount} Agenti)",
            changeCancelPlan: "Cambia/Annulla Piano",
            oneAgent: "Agente",
            agent: "Agente",
            yourCurrentPlan: "Il tuo Piano Attuale",
            month: "Mese",
            billedMonthToMonth: "(Fatturazione mensile)",
            selectAgentCount: "Seleziona il Numero di Agenti",
            selectFreePlan: "Seleziona il Piano Gratuito",
            planDetails: "Dettagli del Piano",
            multiAgent: "(Multi-agente)",
            selectProPlan: "Seleziona il Piano Pro",
            foreverFree: "Sempre Gratis",
            websiteIntegration: "Integrazione del Sito Web",
            websiteIntegrationUnlimited: "Integrazione del Sito Web",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Chiamata Video",
            multiAgentUpTo: "Multi-agente (fino a {agentCount} Agenti)",
            audioCallUnlimited: "Chiamata Audio",
            screenSharingUnlimited: "Condivisione Schermo",
            fileTransferUnlimited: "Trasferimento File",
            autoChatAssignerUnlimited: "Assegnazione Chat Automatica",
            multiLanguageTranslationUnlimited: "Traduzione Multilingue Automatica",
            detailedReporting: "Report Dettagliati",
            days30TrialsAvailable: "Versione di Prova di 30 Giorni",
            limitedArchiveLookupLastMo: "Ricerca Archivio Limitata (Ultimi {monthCount} mesi)",
            fullCustomizationUnlimited: "Personalizzazione Completa",
            planUpdated: "Il tuo piano è stato aggiornato con successo.",
            planUpdating: "Aggiornamento del piano in corso...",
            planUpdatingDescription: "Attendere durante l'aggiornamento!",
            done: "Fatto",
            freePlanUpdated: "Il tuo piano è stato aggiornato al Piano Gratuito. (Numero massimo di Agenti: 1)",
            proPlanUpdated: "Il tuo piano è stato aggiornato al Piano Pro. (Numero massimo di Agenti: {proPlanUpdated})",
            canNotDwnGrade: "Il tuo piano non può essere ridotto da {agentCountFirst} a {valNewPlnToUppr} {agentCountSecond}! I crediti degli Agenti sono in uso.",
            deleteWarning: "È necessario eliminare {valDif} Agenti.",
            warnMessage: "Il piano selezionato deve essere diverso dal piano attuale",
            add: "Aggiungi",
            cancelYourPlan: "Annulla il Tuo Piano",
            upgradeYourPlan: "Passa a un Piano Superiore",
            downgradeYourPlan: "Riduci il Tuo Piano",
            agree: "ACCETTA",
            disagree: "ANNULLA",
            invoices: "Fatture",
            priceIntervals: "Intervallo di Prezzo",
            selectSiteAlias: "Inserisci o Seleziona il Nome del Sito",
            selectPriceInterval: "Inserisci o Seleziona l'Intervallo di Prezzo",
            isRefunded: "Rimborsato",
            invoiceId: "ID Fattura",
            siteId: "ID Sito",
            createdDate: "Data di Creazione",
            failCount: "Numero di Tentativi di Pagamento Falliti",
            failDate: "Data di Pagamento Non Effettuato",
            Dashboard: "Dashboard",
            Agents: "Agenti",
            Integration: "Integrazione",
            Settings: "Impostazioni",
            Contacts: "Contatti",
            Domain: "Dominio",
            lastActivity: "Ultima Attività",
            basePrice: "Prezzo Base",
            packagePrice: "Prezzo Pacchetto",
            whatsappPrice: "Prezzo WhatsApp",
            realtimeVisitorCount: "Numero di Visitatori in Tempo Reale",
            suspend: "Sospendi",
            partner: "Partner",
            plan: "Piano",
            trialDay: "Giorno di Prova",
            mobile: "Mobile",
            webSite: "Sito Web",
            websiteOrigins: "Origini del Sito Web",
            ownerName: "Nome del Proprietario",
            ownerEmailAddress: "Indirizzo Email del Proprietario",
            discount: "Sconto",
            daysLeft: "Giorni Rimanenti",
            newTrialPopUp: "Quanti giorni dovrebbe durare la nuova prova gratuita?",
            newWpPricePopUp: "Quanto dovrebbe essere il nuovo prezzo di WhatsApp?",
            newIGPricePopUp: "Quanto dovrebbe essere il nuovo prezzo di Instagram?",
            newBasePricePopUp: "Quanto dovrebbe essere il nuovo prezzo di base di Supsis?",
            siteInfoUpdated: "Informazioni sul Sito Aggiornate",
            siteInfoNotUpdated: "Informazioni sul Sito Non Aggiornate",
            siteInfoNotUpdatedErr: "Errore durante l'aggiornamento delle informazioni sul sito.",
            yourNameSurname: "Your Name and Surname",
            yearDisccount: "Annual Discount",
            site: "Site",
            depositMoneyWallet: "Deposita denaro nel portafoglio",
            couponError: "Codice coupon errato o scaduto.",
            paidSuccessfully: "Fattura pagata con successo.",
            incorrect: "Incorrect",
            firstPreferredCard: "Set as Primary Card",
            primary: "Primary",
            billingHistory: "Invoice History",
            compony: "Company",
            cuponApplied: "Coupon erfolgreich angewendet",
            deleteYourWhatsApp: "Elimina il canale WhatsApp Business o acquista un canale.",
            packageCanotDownSupsis: "Il tuo pacchetto non può essere declassato. Rimuovi o disattiva alcuni agenti per effettuare il downgrade.",
            packageCanotDownWPBussiness: "Il tuo pacchetto non può essere declassato. Elimina alcuni canali WhatsApp Business per effettuare il downgrade.",
            packageCanotDownWp: "Il tuo pacchetto non può essere declassato. Elimina alcuni canali WhatsApp per effettuare il downgrade.",
            planes: "Piani",
            youHaveAWhatsAppBusiness: "Hai un canale WhatsApp Business.",
            youHaveOneWhatsAppQRChannel: "Hai un canale WhatsApp QR."
        },
        tour: {
            representativeTab: "Rappresentante Tabella",
            stats: "PANNELLO DI STATISTICHE",
            chats: "PANNELLO CHAT",
            settings: "IMPOSTAZIONI",
            status: "STATO",
            prevStep: "Passo Precedente",
            nextStep: "Passo Successivo",
            finish: "Fine",
            skip: "Salta",
            skip2: "Conosco già il sistema, non mostrare di nuovo",
            startTour: "Inizia Tour",
            firstTimeIntro: "Ho notato che è la tua prima volta nel sistema. Sei d'accordo se avvio un breve tour introduttivo?",
            hi: "Ciao",
            welcomeTo: "Benvenuto in Supsis Live Support",
            statsPanel: "È una barra di stato che mostra il numero di chat in attesa, totali e attive in tempo reale.",
            sidebarMenu: "Menu",
            sidebarMenuContent: "Puoi navigare tra le pagine da qui.",
            representativePrivateMessage: "Pannello Messaggi Privati Rappresentante",
            representativePrivateMessageContent: "Puoi visualizzare i messaggi privati tra i rappresentanti da qui.",
            helpMenu: "Menu di Aiuto",
            helpMenuContent: "Puoi accedere alle informazioni di aiuto sul sistema da qui.",
            settingsMenu: "Menu Impostazioni",
            settingsMenuContent: "Puoi impostare la lingua, la modalità notturna e il ridimensionamento dello schermo da qui.",
            startChat: "Inizia chat",
            profileMenu: "Menu Profilo",
            profileMenuContent: "Puoi modificare la tua disponibilità e le impostazioni del rappresentante da qui.",
            visitorsTab: "Visitatori",
            visitorsTabContent: "Puoi visualizzare i visitatori da qui.",
            visitorTabHistory: "Cronologia Visitatori",
            visitorTabHistoryContent: "Puoi visualizzare la cronologia dei visitatori da qui.",
            representativ_eTab: "Rappresentanti",
            representativeTabContent: "Puoi visualizzare i rappresentanti da qui.",
            liveSupport: "Supporto Live",
            liveSupportContent: "Puoi visualizzare il numero di clienti nel supporto live da qui.",
            siteVisitors: "Visitatori del Sito",
            siteVisitorsContent: "Puoi visualizzare il numero di visitatori del sito da qui.",
            tableSettings: "Impostazioni Tabella",
            tableSettingsContent: "Puoi mostrare o nascondere le colonne nella tabella da qui.",
            watchModeButton: "Pulsante Modalità Osservatore",
            watchModeContent: "Puoi partecipare come osservatore e vedere solo i messaggi inviati.",
            popoverInfo: "Dettagli Visitatore",
            popoverInfoContent: "Fornisce informazioni sul visitatore.",
            popoverButton: "Impostazioni Avanzate Chat",
            popoverButtonContent: "Puoi aprire la chat, inviare messaggi privati al rappresentante o bloccare il visitatore.",
            openChat: "Pulsante Apri Chat",
            openChatContent: "Puoi aprire la chat da qui.",
            pagination: "Menu di Paginazione",
            paginationContent: "Puoi aumentare il numero di pagine da qui.",
            chatwindow: {
                chatWindowSettingsButtons: "PULSANTI IMPOSTAZIONI FINESTRA DI CHAT",
                chatWindowActionButtons: "PULSANTI AZIONE GENERALE FINESTRA DI CHAT",
                chatPanelActions: "AZIONI PANNELLO DI CHAT",
                otherPanels: "ALTRI PANNELLI",
                settingsButton: "Puoi bloccare la chat, instradarla, inviare messaggi privati e assegnare un rappresentante.",
                chatColorButton: "Puoi scoprire il significato dei colori delle bolle di chat da qui.",
                keyboardShortcutButton: "Puoi trovare le scorciatoie per le funzioni utili durante la scrittura.",
                hideButton: "Riduce la chat attiva in basso e rimane aperta sullo sfondo.",
                closeButton: "Termina la chat attiva e esci dalla conversazione.",
                ellipsisButton: "Qui troverai altre opzioni come invio di messaggi privati, blocco del visitatore o assegnazione di un rappresentante.",
                userInfoWidget: "Fornisce informazioni dettagliate sul visitatore.",
                preparedContentWidget: "Qui troverai modelli di contenuto predefiniti. Puoi aggiungerli rapidamente premendo o utilizzando la sequenza di tasti corrispondente nell'area di scrittura della chat.",
                chatHistoryWidget: "Se il visitatore ha una cronologia di chat precedenti, verrà elencata qui. Puoi consultare le conversazioni passate da qui.",
                chatBarButton: "Puoi bloccare la chat attiva, inviare messaggi privati al rappresentante e uscire dalla chat."
            },
            selectColumnsToDisplay: "Seleziona colonne da visualizzare",
            selectAll: "Seleziona tutto",
            deselectAll: "Deselect All",
            resetToDefault: "Reset to Default",
            settingsSaved: "Settings saved",
            changeLang: "Can change system language",
            changeStatus: "Can change your availability status",
            changeTheme: "Can switch dark and light theme",
            closeChat: "Close Chat",
            contentStep: "Content Step",
            formStep: "Form Step",
            goToLive: "Connect Representative",
            logout: "Can logout system from here",
            menuStep: "Menu Step",
            menuTitle: "Menu Title",
            messageContent: "Contenuto messaggio",
            ticket: "Ticket"
        },
        adminUser: {
            newAdminUserForm: "Nuovo Modulo Utente Admin",
            updateAdminUserForm: "Modulo di aggiornamento utente admin",
            adminUsers: "Utenti Admin",
            newAdminUser: "Nuovo Utente Admin",
            noAdminUser: "Nessun Utente Admin",
            adminUserName: "Nome Utente Admin"
        },
        report: {
            channel: "Canale",
            channelType: "Tipo di canale",
            contactCount: "Numero di contatti",
            tag: "Etichetta",
            owner: "Proprietario",
            email: "Email",
            language: "Lingua",
            approvalCount: "Numero di approvazioni",
            adTitle: "Titolo dell'annuncio",
            sourceType: "Tipo di sorgente",
            contactDistributions: "Distribuzioni dei contatti",
            mostUsedTag: "Tag più utilizzato",
            leastUsedTag: "Tag meno utilizzato",
            timeDistribution: "Distribuzione dei contatti per tempo",
            channelDistribution: "Distribuzione dei contatti per canale",
            tagDistribution: "Distribuzione dei contatti per tag",
            platformDistribution: "Distribuzione dei contatti per piattaforma",
            ownerDistribution: "Distribuzione dei contatti per proprietario",
            languageDistribution: "Distribuzione dei contatti per lingua",
            adsDistribution: "Distribuzione dei contatti per annunci",
            contactPropertyDistribution: "Distribuzione dei contatti per proprietà di contatto",
            totalPersonCount: "Numero totale dei contatti",
            averagePersonCount: "Media dei contatti",
            personCount: "Numero di contatti",
            person: "Contatto",
            mostEffectiveAd: "Annuncio più efficace",
            leastEffectiveAd: "Annuncio meno efficace",
            mostUsedChannel: "Canale più utilizzato",
            leastUsedChannel: "Canale meno utilizzato",
            columnChart: "Grafico a colonne",
            pieChart: "Grafico a torta",
            mostUsed: "Più utilizzato",
            leastUsed: "Meno utilizzato",
            mostUsedLanguage: "Lingua più utilizzata",
            leastUsedLanguage: "Lingua meno utilizzata",
            mostAssigned: "Più assegnato",
            leastAssigned: "Meno assegnato",
            mostUsedPlatform: "Piattaforma più utilizzata",
            leastUsedPlatform: "Piattaforma meno utilizzata",
            commentAnalysis: "Analisi dei commenti",
            whatsappChannelDistribution: "Distribuzione delle chat per canali WhatsApp",
            instagramChannelDistribution: "Distribuzione delle chat per canali Instagram",
            messengerChannelDistribution: "Distribuzione delle chat per canali Messenger",
            trendyolChannelDistribution: "Distribuzione delle chat per canali Trendyol",
            metaLeadsChannelDistribution: "Distribuzione delle chat per canali Meta Leads",
            chatDistributionByTelegramChannels: "Distribuzione delle chat per canali Telegram",
            chatDistributionByLinkedinChannels: "Distribuzione delle chat per canali Linkedin",
            channelTimeseries: "Timeline dei canali",
            channelPies2: "Distribuzione dei canali",
            date: "Data",
            incomingMessages: "Messaggi in arrivo",
            outgoingMessages: "Messaggi in uscita",
            customerCount: "Conteggio clienti",
            mailCount: "Conteggio posta",
            answered: "Rispondere",
            unanswered: "Senza risposta",
            selectaChannel: "selezionare un canale",
            sentMails: "Correos enviados",
            sentMailCount: "Número de correos enviados",
            eventCount: "Numero di eventi",
            ticketDistribution: "Distribuzione dei biglietti",
            selectWorkflow: "Selezionare il flusso di lavoro",
            distributionOfTasks: "Distribuzione delle attività",
            mostMissioned: "La maggior parte delle missioni",
            leastTask: "Compiti minimi",
            totalNumberTasks: "Numero totale di compiti",
            erorFetchingTask: "Errore nella ricezione dei dati dell'attività:",
            pipelinePhase: "Fase della pipeline",
            status: "Stato",
            numberOfTasks: "Numero di task",
            insufficientData: "Dati non sufficienti",
            hourly: "(Orario)",
            hourlyAverage: "Media oraria",
            hourlyMax: "Massimo orario",
            hourlyMin: "Minimo orario",
            totalAmount: "Importo Totale",
            averageAmount: "Importo Medio",
            minAmount: "Importo Minimo",
            maxAmount: "Importo Massimo",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Serie temporali dei canali",
            channelPies: "Torte dei canali",
            pieView: "Grafico a torta",
            topVisitorCountry: "Paese con più visitatori",
            websiteTrafficByCountry: "Traffico del sito web per Paese",
            visitorCount: "Numero di visitatori",
            websiteVisitorTraffic: "Traffico visitatori del sito web",
            websiteTraffic: "Traffico del sito web",
            author: "Autore",
            topWorstComments: "Commenti Peggiori",
            topBestComments: "Commenti Migliori",
            topComments: "Commenti Migliori",
            noComment: "Nessun commento ancora",
            minWaitingTime: "Tempo di attesa minimo",
            maxWaitingTime: "Tempo di attesa massimo",
            averageWaitTime: "Tempo di attesa medio",
            waitTime: "Tempo di attesa (secondi)",
            agentWaitDurationTitle: "Grafico della durata di attesa dell'agente",
            incomingMessage: "Messaggio(i) in arrivo",
            outgoingMessage: "Messaggio(i) in uscita",
            totalSpent: "Totale speso",
            avgSpent: "Media spesa",
            totalPayment: "Pagamento totale",
            walletStatus: "Stato del portafoglio",
            walletBalanceStatus: "Stato del saldo del portafoglio",
            messageTraffic: "Traffico di messaggi",
            breakCount: "Conteggio delle pause",
            agentBreakTime: "Conteggi delle pause dell'agente ☕",
            agentStatusHour: "Ora dello stato dell'agente",
            agentWorkTimeCalendar: "Calendario del tempo di lavoro dell'agente",
            agentActivity: "Attività dell'agente",
            noEnoughtData: "Dati non sufficienti",
            averageFirstResponse: "Tempo medio di prima risposta",
            slowestResponser: "Più lento a rispondere",
            fastestResponder: "Più veloce a rispondere",
            firstAnswerTimeSec: "Tempo del primo messaggio (in secondi)",
            firstAnswerByAgent: "Tempo del primo messaggio da parte dell'agente",
            averageSolutionTime: "Tempo medio di soluzione",
            slowestSolver: "Risoluzione più lenta",
            fastestSolver: "Risoluzione più veloce",
            averageChat: "Chat media",
            leastChatReceiver: "Ricevitore di chat meno attivo",
            mostChatRecipients: "Il maggior numero di destinatari della chat",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Meno ticket assegnati",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Tempo di risoluzione (min)",
            resolveTimeByUser: "Tempo di risoluzione della chat per l'utente (in minuti)",
            chatResolveTimeByAgent: "Tempo di risoluzione della chat per gli agenti",
            chatDistByHandleType: "Distribuzione chat per handler",
            chatDistByHandDesc: "Quanti chat sono state gestite da agenti, chatbot e ibridi?",
            chatCountsByHandleType: "Numero di chat per tipo di gestione",
            missed: "Perso",
            chatDistByAnsDesc: "Quante chat sono state risposte o perse?",
            chatCountsByAns: "Conteggio chat per risposta",
            chatCountByPlatform: "Conteggio chat per piattaforma",
            chatDistByPDesc: "Quanti chat sono arrivate su quale piattaforma?",
            chatDistByPlatform: "Distribuzione della chat per piattaforma",
            ticketCountByUser: "Conteggio dei biglietti da parte degli agenti",
            ticketCountByStatus: "Conteggio dei ticket per stato di risposta",
            user: "Utente",
            saveAsImage: "Salva come immagine",
            fullScreen: "Schermo intero",
            download: "Scarica",
            tableView: "Vista tabella",
            chartView: "Vista grafico",
            chatDistByUsers: "Distribuzione delle chat per utenti",
            chatCountsByUsers: "Conteggio delle chat per utenti",
            minDuration: "Durata minima",
            maxDuration: "Durata massima",
            totalDurationByAgent: "Durata totale della sessione per agente",
            averageDurationByAgent: "Durata media della sessione per agente",
            totalDurationByCB: "Durata totale della sessione per chatbot",
            averageDurationByCB: "Durata media della sessione per chatbot",
            viewUnitAs: "Visualizza unità come",
            hybrid: "Ibrido",
            handledBy: "Gestito da",
            sessionDurationOverall: "Durata complessiva della sessione",
            allChannels: "Tutti i Canali",
            sessionsDurationOverall: "Durata complessiva delle sessioni",
            sessionsOverall: "Sessioni complessive",
            sessionsOverallDesc: "Total chat session count in the selected period",
            ratingOverallDesc: "Distribution of customer satisfaction scores",
            sessionDurationOverallDesc: "Average and total session durations",
            totalSessionCountDesc: "Total number of sessions in the selected period",
            averageSessionCountDesc: "Average session count per time unit",
            maxSessionCountDesc: "Highest session count in a single time unit",
            minSessionCountDesc: "Lowest session count in a single time unit",
            totalSessionDurationDesc: "Sum of all session durations",
            averageSessionDurationDesc: "Average duration per session",
            totalDurationByCBDesc: "Total duration handled by chatbot",
            averageDurationByCBDesc: "Average chatbot session duration",
            totalDurationByAgentDesc: "Total duration handled by agents",
            averageDurationByAgentDesc: "Average agent session duration",
            maxDurationDesc: "Longest session in the selected period",
            minDurationDesc: "Shortest session in the selected period",
            totalRatingCountDesc: "Total number of ratings received",
            averageRatingDesc: "Average score of all ratings",
            weightedAverageRatingDesc: "Weighted average based on score distribution",
            chatDistByUsersDesc: "Chat session distribution by agent",
            chatDistByAnsDesc: "Ratio of answered vs missed sessions",
            chatDistByPlatformDesc: "Chat sessions by platform source",
            chatDistByHandleTypeDesc: "Session distribution between chatbot and live agent",
            resolveTimeByUserDesc: "Average resolve time per agent",
            firstAnswerByAgentDesc: "Average first response time per agent",
            agentWaitDurationDesc: "Customer wait time for agent response",
            topCommentsDesc: "Best and worst customer feedback comments",
            websiteTrafficDesc: "Website visitor traffic over time",
            websiteTrafficByCountryDesc: "Website visitor distribution by country",
            channelBreakdownDesc: "Session counts and distribution by channel",
            wabaMessageTrafficDesc: "WhatsApp message traffic (incoming/outgoing)",
            walletStatusDesc: "Balance transactions and wallet status",
            calendarEventsDesc: "Calendar event count time series",
            reservationEventsDesc: "Reservation event count time series",
            mailInboxDesc: "Incoming email count time series",
            mailSendDesc: "Sent email count time series",
            ticketTimeSeriesDesc: "Support ticket time series",
            ticketByStatusDesc: "Support ticket distribution by status",
            ticketByUserDesc: "Support ticket distribution by agent",
            taskOverallDesc: "Task status and pipeline stage distribution",
            contactTimeDistDesc: "Contact distribution over time",
            contactChannelDistDesc: "Contact distribution by channel",
            contactTagDistDesc: "Contact distribution by tag",
            contactPlatformDistDesc: "Contact distribution by platform",
            contactOwnerDistDesc: "Contact distribution by agent",
            contactLanguageDistDesc: "Contact distribution by language",
            contactAdDistDesc: "Contact distribution by advertisement",
            contactPropertyDistDesc: "Contact distribution by contact properties",
            agentActivitiesDesc: "Daily agent activity summary",
            agentPerformanceDesc: "Agent performance metrics",
            agentWorktimeDesc: "Agent work and break durations",
            breakCountDesc: "Break count and duration distribution",
            calendarEvents: "Eventi del calendario",
            reservationEvents: "Eventi di prenotazione",
            incomingMails: "Mail in arrivo",
            incomingMailCount: "Conteggio delle mail in arrivo",
            reservation: "Prenotazione",
            event: "Evento",
            reservationEventCount: "Numero di eventi di prenotazione",
            channelBreakdown: "Ripartizione dei canali",
            websiteAnalysis: "Analisi del sito web",
            customerSatisfaction: "Soddisfazione del cliente",
            teamBreakAnalysis: "Analisi delle pause del team",
            dailyAgentActivity: "Attività quotidiana dell'agente",
            agentPerformance: "Prestazioni dell'agente",
            chatDistributions: "Distribuzione delle chat",
            users: "Utenti",
            segmentTimeseries: "Serie temporale del segmento",
            segmentsOverall: "Segmenti Complessivi",
            unmatchRatio: "Rapporto di non corrispondenza",
            totalMatchCount: "Conteggio totale delle corrispondenze",
            totalUnmatchCount: "Conteggio totale delle non corrispondenze",
            matchRatio: "Rapporto di corrispondenza",
            matched: "Abbinato",
            trainingOverall: "Formazione Complessiva",
            trainingStatusTimeseries: "Serie temporale dello stato di formazione",
            duration: "Durata",
            totalSessionDuration: "Durata totale della sessione",
            averageSessionDuration: "Durata media della sessione",
            second: "secondo",
            minute: "minuto",
            hour: "ora",
            aggregateAs: "Aggrega come",
            chatbotSessionDurationOverall: "Durata complessiva della sessione del chatbot",
            ratingTimeSeries: "Serie temporale delle valutazioni",
            chatCountTimeseries: "Serie temporale del numero di chat",
            notRated: "Non valutato",
            totalRatingCount: "Numero totale di valutazioni",
            averageRating: "Valutazione media",
            weightedAverageRating: "Valutazione media ponderata",
            rate: "Valuta",
            ratingOverall: "Valutazioni dei clienti in generale",
            session: "Sessione",
            total: "Totale",
            average: "Media",
            max: "Massimo",
            min: "Minimo",
            sessionCount: "Conteggio sessioni",
            uniqueUsers: "Utenti Unici",
            viewAs: "Visualizza come:",
            overall: "Complessivo",
            detailReport: "Rapporto Dettagliato",
            dailyReports: "Rapporti Giornalieri",
            pointBasedReports: "Rapporti Basati su Punti",
            personDateBasedPointReport: "Rapporto Punti Basato su Persona e Data",
            personDateBasedReport: "Rapporto Basato su Persona e Data",
            personBasedReport: "Rapporto Basato su Persona",
            personAndDateBasedGraph: "Grafico Basato su Persona e Data",
            noReport: "Nessun Rapporto",
            reports: "Rapporti",
            totalBar: "Barra Totale",
            ticketCount: "Ticket Count",
            adNameDistribution: "Distribuzione contatti per nome annuncio",
            adsetDistribution: "Distribuzione contatti per nome set di annunci",
            campaignDistribution: "Distribuzione contatti per nome campagna",
            selectChannel: "Seleziona un canale",
            leastTasked: "Meno attività assegnate",
            errorFetchingTask: "Errore durante il recupero dei dati dell'attività:",
            dailyAverage: "Media giornaliera",
            dailyMax: "Massimo giornaliero",
            dalyMin: "Minimo giornaliero",
            topBestWorstComments: "Migliori/peggiori commenti"
        },
        announcements: {
            menu: "Annunci",
            newAnnouncementForm: "Nuovo Modulo di Annuncio",
            updateAnnouncementForm: "Modulo di aggiornamento annuncio"
        },
        stats: {
            total: "Totale: È il numero di conversazioni attive nel sistema.",
            active: "Attive: È il numero di conversazioni attive che ti appartengono.",
            waiting: "In attesa: È il numero di nuove conversazioni in attesa di assegnazione di un rappresentante.",
            late: "In ritardo: È il numero di nuove conversazioni in attesa di assegnazione di un rappresentante dopo un certo periodo di tempo.",
            free: "Libere: È il numero di conversazioni in attesa di assegnazione di un nuovo rappresentante dopo che il precedente ha terminato.",
            pco: "[Tasso di occupazione del personale]: È il tasso di occupazione delle conversazioni totali che i rappresentanti online possono gestire nel sistema.",
            maxCapacity: "Capacità massima: È il numero massimo di conversazioni che il sistema può gestire senza mettere in attesa.",
            chatbot: "Chatbot: È il numero di conversazioni attive gestite dal chatbot."
        },
        time: {
            lastYear: "L'anno Scorso",
            thisYear: "Quest'anno",
            last3Months: "Ultimi 3 Mesi",
            last7: "Ultimi 7 Giorni",
            today: "Oggi",
            yesterday: "Ieri",
            lastWeek: "Settimana scorsa",
            currentWeek: "Questa settimana",
            currentMonth: "Questo mese",
            lastMonth: "Mese scorso",
            last30Day: "Ultimi 30 giorni",
            allTime: "Sempre",
            custom: "Periodo personalizzato"
        },
        fastWizard: {
            generalColors: "Colori generali",
            tellUsMore: "Forniscici ulteriori informazioni per personalizzare la tua esperienza",
            moreInfo: "Impostazioni generali",
            display: "Impostazioni del tema",
            availability: "Orari di disponibilità degli operatori",
            preview: "Anteprima",
            installCode: "Installazione",
            previous: "Passaggio precedente",
            setupSupsisLiveChat: "Configurazione rapida di SUPSIS LIVE Chat",
            continue: "Passaggio successivo",
            completeInitialize: "Completa l'inizializzazione rapida",
            completedMessage: "Configurazione rapida di SUPSIS Live Chat completata con successo.",
            websiteIntegration: "Indirizzo del tuo sito web per l'integrazione di SUPSIS Live",
            customizeLiveChat: "Personalizza la chat dal vivo",
            createBrandedExperience: "Crea un'esperienza di chat personalizzata per i visitatori.",
            chatColor: "Colore della chat",
            chooseChatColor: "Scegli un colore.",
            chatBubble: "Bolla di chat",
            selectBubble: "Seleziona una bolla di chat",
            chatBubbleColor: "Colore della bolla di chat",
            selectChatBubbleColor: "Seleziona il colore della bolla di chat",
            customSelection: "Selezione personalizzata:",
            onlineSupportVisitorTime: "In quali fasce orarie fornisci assistenza ai visitatori?",
            channelAvailability: "Disponibilità del canale",
            availability724: "Servizio continuativo 24/7",
            basedOnTeam: "In base agli orari di lavoro degli operatori",
            basedOnTeamExplanation: "La chat sarà disponibile online quando ci sarà almeno 1 operatore online. Se non ci sono operatori online, apparirà come offline",
            customHours: "Orari di lavoro personalizzati",
            customHoursExplanation: "Imposta i tuoi orari di lavoro",
            customHoursTimezone: "Fuso orario:",
            customHoursFrom: "Da:",
            customHoursTo: "A:",
            customHoursAddHours: "+ Aggiungi ora",
            previewDesktop: "Desktop",
            previewIpad: "Tablet",
            installationAndInstructions: "Installazione e istruzioni",
            installationTrackingCode: "Carica il codice di monitoraggio sul tuo sito web",
            installationTrackingCodePlease: "Incolla il codice sottostante subito prima della chiusura del tag {bodyTag} su qualsiasi pagina in cui desideri attivare SUPSIS Live Chat.",
            installationInstructionsJavascript: "Incolla il codice di integrazione fornito sopra all'interno del tag {bodyTag}, subito prima della chiusura.",
            installationInstructionsShopify1: "1. Accedi al pannello di controllo di Shopify",
            installationInstructionsCopy: "Copia",
            installationInstructionsCoppyMessage: "Le istruzioni di integrazione sono state copiate negli appunti",
            installationInstructionsShopify2: "2. Vai a Online Store > Temi > Azioni, seleziona Current Theme > Modifica codice > theme.liquid",
            installationInstructionsShopify3: "3. Incolla il codice di integrazione fornito sopra subito prima del tag {bodyTag} alla fine dello script theme.liquid.",
            installationInstructionsIdeaSoft1: "1. Accedi al pannello di amministrazione di IdeaSoft",
            installationInstructionsIdeaSoft2: "2. Vai su Impostazioni > SEO > Servizi per i motori di ricerca",
            installationInstructionsIdeaSoft3: "3. Seleziona l'opzione \"Convalida del sito tramite tag meta\".",
            installationInstructionsIdeaSoft4: "4. Incolla il codice di integrazione fornito sopra nella casella aperta e salva.",
            installationInstructionsIdeaSoft5: "5. Vai su Impostazioni > Ottimizzazioni > \"Cancella cache\". L'integrazione è completata.",
            installationInstructionsWordPress1: "1. Accedi al pannello di amministrazione di WordPress",
            installationInstructionsWordPress2: "2. Vai su Aspetto > Editor di Temi",
            installationInstructionsWordPress3: "3. Trova e seleziona il file del piè di pagina (footer.php) nella sezione File del tema (a destra)",
            installationInstructionsWordPress4: "4. Incolla il codice di integrazione fornito sopra prima del tag {bodyTag} nella parte inferiore del file.",
            installationInstructionsWordPress5: "5. Clicca su Aggiorna file per salvare le modifiche",
            installationInstructionsOpenCart1: "1. Accedi al pannello di amministrazione di OpenCart",
            installationInstructionsOpenCart2: "2. Vai su Design > Editor di Temi",
            installationInstructionsOpenCart3: "3. Seleziona la cartella 'common' e apri il file 'header.twig'",
            installationInstructionsOpenCart4: "4. Incolla il codice di integrazione fornito sopra prima del tag {headTag} nella parte superiore del file.",
            installationInstructionsOpenCart5: "5. Clicca su Salva",
            installationInstructionsTicimax1: "1. Accedi al pannello di amministrazione di Ticimax",
            installationInstructionsTicimax2: "2. Vai su Design > Impostazioni di design > Header/Footer Design",
            installationInstructionsTicimax3: "3. Fai clic sul pulsante 'Sorgente' nel design del logo.",
            installationInstructionsTicimax4: "4. Incolla il codice di integrazione fornito sopra sotto il codice HTML.",
            installationInstructionsEticaretteyim1: "1. Accedi al pannello di amministrazione di Eticaretteyim",
            installationInstructionsEticaretteyim2: "2. Vai su Moduli > Genera HTML > Dai un nome a SUPSIS e copia il codice.",
            installationInstructions: "Istruzioni",
            installationVerify: "Verifica l'installazione di SUPSIS sul tuo sito web",
            installationVerifyChecking: "Verifica in corso",
            installationVerifyCheck: "Verifica",
            installationVerifyCheckingStatus: "Controllo dello stato di integrazione di SUPSIS Live su {website} in corso",
            installationCheckingStatusMessageYes: "SUPSIS LIVE è integrato con successo su {website}.",
            installationCheckingStatusMessageNo: "SUPSIS non è attualmente integrato con il sito web {website}. Puoi completare il processo di integrazione ora o in seguito.",
            vtippyPreferredLanguage: "Lingua preferita:",
            chatAvailability: "Chat Availability"
        },
        akinon: {
            typeOrSelectSKU: "Inserisci o seleziona l'SKU",
            akinonUserId: "ID utente Akinon",
            userEmail: "Email utente",
            userEmailDesc: "Inserisci o seleziona l'email dell'utente...",
            send: "Invia",
            selectCity: "Seleziona città",
            city: "Città",
            selectState: "Seleziona stato",
            state: "Stato",
            useMap: "Usa mappa",
            chooseAddress: "Seleziona indirizzo",
            selectCountry: "Seleziona Paese",
            country: "Paese",
            productIdDesc: "Inserisci o seleziona l'ID del prodotto...",
            productId: "ID prodotto",
            userIdDesc: "Inserisci l'ID utente Akinon...",
            productSKU: "SKU prodotto",
            latitudeDesc: "Inserisci o seleziona la latitudine della posizione di destinazione...",
            longitudeDesc: "Inserisci o seleziona la longitudine della posizione di destinazione...",
            orderNumber: "Numero d'ordine",
            orderDesc: "Inserisci il numero d'ordine...",
            longitude: "Longitudine",
            latitude: "Latitudine"
        },
        probel: {
            branchCode: "Codice filiale",
            branchCodeDesc: "Inserisci o seleziona il codice filiale...",
            hospitalBranchCode: "Codice del reparto ospedaliero",
            hospitalBranchCodeDesc: "Inserisci o seleziona il codice del reparto ospedaliero...",
            clinicCode: "Codice clinica",
            clinicCodeDesc: "Inserisci o seleziona il codice della clinica...",
            date: "Data appuntamento",
            dateDesc: "Inserisci o seleziona la data dell'appuntamento...",
            patientToken: "Token del paziente",
            patientTokenDesc: "Inserisci o seleziona il token del paziente...",
            appointmentId: "ID appuntamento",
            appointmentIdDesc: "Inserisci o seleziona l'ID dell'appuntamento...",
            identityType: "Tipo di documento d'identità",
            identityNumber: "Numero documento d'identità",
            name: "Nome del paziente",
            surname: "Cognome del paziente",
            gender: "Genere del paziente",
            birthDay: "Data di nascita del paziente",
            phoneNumber: "Numero di telefono del paziente",
            identityTypeDesc: "Inserisci o seleziona il tipo di documento d'identità...",
            identityNumberDesc: "Inserisci o seleziona il numero del documento d'identità...",
            nameDesc: "Inserisci o seleziona il nome del paziente...",
            surnameDesc: "Inserisci o seleziona il cognome del paziente...",
            genderDesc: "Inserisci o seleziona il genere del paziente...",
            birthDayDesc: "Inserisci o seleziona la data di nascita del paziente...",
            phoneNumberDesc: "Inserisci o seleziona il numero di telefono del paziente..."
        },
        headBar: {
            source: "Fonte",
            label: "Etichetta",
            completed: "Completato?",
            email: "Email",
            phone: "Telefono",
            name: "Nome",
            date: "Data",
            subject: "Oggetto",
            situation: "Situazione",
            representative: "Rappresentante",
            transactions: "Transazioni",
            channel: "Canale di contatto",
            Email: "E-mail"
        },
        login: {
            loginTitle1: "Benvenuti alla",
            loginTitle2: "Supsis AI",
            email: "Indirizzo Email",
            emailPlaceholder: "Inserisci il tuo indirizzo email.",
            emailError: "Inserisci un indirizzo email valido",
            password: "Password",
            passwordLogin: "Accesso senza password",
            passwordAndLogin: "Accedi con password",
            passwordNew: "Resetta la mia password",
            loginAnd: "Oppure",
            passwordPlaceholder: "Inserisci la tua password.",
            loginMemory: "Ricorda questo dispositivo",
            passwordForget: "Ho dimenticato la password",
            passwordNewAgain: "Nuova password",
            passwordNewAgainTwo: "Conferma nuova password",
            passwordNewAgainPlaceholder: "Inserisci la tua nuova password.",
            passwordNewAgainPlaceholderTwo: "Conferma la tua nuova password.",
            login: "Accedi",
            loginFooter: "Oppure accedi tramite email",
            emailLogin: "Accedi tramite email",
            welcomeTitle: "Benvenuto",
            welcomeMorning: "Buongiorno",
            welcomeAfternoon: "Buon pomeriggio",
            welcomeEvening: "Buonasera",
            welcomeNight: "Buonanotte"
        },
        settings: {
            ipWhitelist: "Elenco accessi IP",
            loadMore: "Carica di più...",
            socialMedia: "Social Media",
            web: "Web",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "E-commerce",
            utilities: "Utilità",
            advertising: "Pubblicità",
            detectIpAddress: "Rileva Il Mio Indirizzo IP",
            addWighteListAddress: "Aggiungi indirizzo IP alla whitelist",
            accessControlSubTitles: "l Controllo Accessi fornisce un ulteriore livello di sicurezza che consente solo agli IP autorizzati di accedere al sistema",
            companyInformation: "Informazioni sull'azienda",
            ipAddress: "Il mio indirizzo IP",
            whiteList: "Elenco IP sicuro",
            whiteListAdd: "Aggiungi IP sicuro",
            whiteListDeletedSuccessfully: "Lista blanca eliminata correttamente",
            whiteListDeletedFailed: "Lista blanca non eliminata",
            whiteListAddedSuccessfully: "Lista blanca aggiunta correttamente",
            whiteListAddedFailed: "Lista blanca non aggiunta",
            deleteWhiteListTitle: "Sei sicuro di voler eliminare questa lista bianca?",
            talkSettings: "Impostazioni vocali",
            talkSubtitles: "Gestione delle impostazioni vocali",
            changeSettings: "Modifica delle impostazioni per l'assegnazione automatica delle chat",
            dateAndTime: "Data e ora",
            actor: "Attore",
            event: "Evento",
            accessControl: "Controllo degli accessi",
            rulesGroup: "Regole",
            organizationLongName: "Nome lungo dell'organizzazione",
            visitorNewDesc: "È possibile utilizzare la nuova versione del tema del visitatore",
            transactionType: "Tipo di transazione",
            priorBalance: "Saldo precedente",
            nextBalance: "Saldo successivo",
            amount: "Importo",
            phoneNumber: "Numero di telefono",
            profileInfoRemoved: "Informazioni sul profilo rimosse",
            newValueUpdated: "Nuovo valore aggiornato",
            ballanceToTransferred: "Saldo da trasferire",
            availableBalance: "Saldo disponibile",
            balanceReceived: "Saldo ricevuto",
            totalBalance: "Saldo totale",
            paymentCard: "Carta di pagamento",
            wpPhoneNumber: "Numero di telefono Whatsapp",
            wpSendingMessage: "Primo messaggio Whatsapp inviato",
            auditlogs: "Registri di controllo",
            myaccount: "Il mio account",
            notifications: "Notifiche",
            company: "Azienda",
            features: "Caratteristiche",
            general: "Generale",
            chat: "Chat",
            wallet: "portafoglio",
            timings: "Impostazioni di orario",
            language: "Lingua",
            "bubble-settings": "Impostazioni del palloncino di chat",
            "bubble-actions": "Funzionalità del palloncino di chat",
            "theme-settings": "Impostazioni del tema di chat",
            visitorLoginForm: "Modulo di accesso visitatori",
            visitorAttribute: "Informazioni sul profilo del visitatore",
            timing_settings: "Impostazioni di orario",
            auto_assign: "Auto Assign",
            availability: "Orari di disponibilità dell'operatore",
            "website-integration": "Integrazione del sito web",
            General: "Generale",
            Chat: "Chat",
            Timings: "Impostazioni di orario",
            Integration: "Integrazione",
            developer: "Sviluppatore",
            integration: "Integrazione",
            visitorNew: "Passaggio al nuovo design visitatori",
            companySubtitles: "Gestisci le informazioni generali dell'azienda.",
            featuresSubtitles: "Gestisci le funzionalità intelligenti di Supsis.",
            languageSubtitles: "Impostare la lingua e il fuso orario preferiti dalla vostra azienda.",
            bubbleSettings: "Impostazioni del palloncino di chat",
            bubbleSettingsSubtitles: "Gestisci le impostazioni del palloncino di chat.",
            bubbleActionsSubtitles: "Espandi le funzionalità del palloncino di chat. Puoi condividere con i visitatori le informazioni relative a WhatsApp, email e telefono della tua azienda.",
            chatThemeSettingsSubtitles: "Gestisci le impostazioni del tema di chat.",
            visitorLoginFormSubtitles: "Gestisci le impostazioni del modulo di accesso visitatori.",
            chatTimingSettingsSubtitles: "Impostazioni di durata della chat: controlli e opzioni di durata della conversazione.",
            webSiteIntegrationSubtitles: "Aggiungi un palloncino di chat al tuo sito web.",
            apiAccessTitle: "Accesso API",
            apiAccessSubtitles: "Puoi accedere al tuo codice token da qui.",
            youTubeActionForm: "Aggiungi il tuo canale YouTube",
            linkedinActionForm: "Aggiungi il tuo account Linkedin",
            telegramActionForm: "Aggiungi un account Telegram",
            facebookActionForm: "Aggiungi la tua pagina Facebook",
            tiwitterActionForm: "Aggiungi il tuo account Twitter",
            instagramActionForm: "Aggiungi il tuo account Instagram",
            liveSupportDescription: "Apri una chat in diretta con i tuoi clienti",
            ticketDescription: "Apri una chat in diretta con i tuoi clienti",
            whatsappDescription: "Permetti ai tuoi clienti di contattarti tramite WhatsApp",
            phoneDescription: "Permetti ai tuoi clienti di contattarti telefonicamente",
            emailDescription: "Permetti ai tuoi clienti di contattarti via email",
            facebookDescription: "Permetti ai tuoi clienti di contattarti tramite Facebook",
            twitterDescription: "Permetti ai tuoi clienti di contattarti tramite Twitter",
            instagramDescription: "Permetti ai tuoi clienti di contattarti tramite Instagram",
            youtubeDescription: "Permetti ai tuoi clienti di contattarti tramite YouTube",
            linkedinDescription: "Consenti ai tuoi clienti di raggiungerti con LinkedIn",
            telegramDescription: "Consenti ai tuoi clienti di raggiungere le dimensioni con Telegram",
            whatsappModalTitle: "Modulo di azione di WhatsApp",
            whatsappModalDescription: "Compila il seguente modulo per collegare il tuo account WhatsApp.",
            phoneModalTitle: "Modulo di azione telefonica",
            phoneModalDescription: "Compila il seguente modulo per collegare il tuo numero di telefono.",
            emailModalTitle: "Modulo di azione email",
            emailModalDescription: "Compila il seguente modulo per collegare il tuo account email.",
            facebookModalTitle: "Modulo di azione di Facebook",
            facebookModalDescription: "Compila il seguente modulo per collegare il tuo account Facebook.",
            twitterModalTitle: "Modulo di azione di Twitter",
            twitterModalDescription: "Compila il seguente modulo per collegare il tuo account Twitter.",
            instagramModalTitle: "Modulo di azione di Instagram",
            instagramModalDescription: "Compila il seguente modulo per collegare il tuo account Instagram.",
            youtubeModalTitle: "Modulo di azione di YouTube",
            youtubeModalDescription: "Compila il seguente modulo per collegare il tuo account YouTube.",
            linkedinModalTitle: "Modulo di transazione LinkeIn",
            linkedinModalDescription: "Compila il modulo sottostante per collegare il tuo account LinkedIn.",
            telegramModalTitle: "Modulo di transazione Telegram",
            telegramModalDescription: "Inserisci il link del tuo profilo Telegram nel modulo sottostante per collegare il tuo account Telegram",
            instagramAlertTitle: "Integrazione Instagram richiesta",
            instagramAlertDesc: "Spiacente, la pagina che hai visitato verrà attivata quando integri il tuo Instagram.",
            instagramActivateText: "Andiamo, integriamo Instagram",
            remove: "Rimuovi",
            edit: "Modifica",
            connected: "Collegato",
            add: "Aggiungi",
            themeDescription: "Impostazioni del tema di chat.",
            fontDescription: "Impostazioni del carattere di chat.",
            emailTitle: "Inserisci il tuo indirizzo email",
            emailMessage: "Messaggio di invio email iniziale",
            isFabsAsIcon: "Mostra icone di menu.",
            chatBubbleTextSetting: "Impostazione del testo della bolla di chat",
            textOnChatBubble: "Puoi regolare le impostazioni del testo che appariranno nel fumetto della chat.",
            textToAppearOnChatBubble: "Testo da visualizzare nel fumetto della chat",
            newVisitorProfileInformation: "Nuove informazioni sul profilo del visitatore",
            newVisitorProfileInformationDescription: "Aggiunge nuovo valore alle informazioni del profilo del visitatore",
            create: "Creare",
            newAdd: "Aggiungere nuova",
            toInform: "Informare",
            toInformDescription: "Puoi abbinare i valori che aggiungi in questa pagina con il modulo di accesso del visitatore.",
            showVisitor: "Mostra visitatore",
            label: "Biglietto",
            text: "Scrivere",
            email: "E-mail",
            phone: "Telefono",
            number: "Numero",
            url: "URL",
            date: "Tempo",
            dropdown: "selezionabile",
            languageTimeZone: "Lingua e regione",
            timeZoneTitle: "Regione e fuso orario",
            timeZoneDescription: "Impostazioni di regione e fuso orario",
            balanceToTransferred: "Balance to be transferred",
            ballanceToTransfer: "Solde à transférer"
        },
        sessions: {
            mySessions: "Le mie sessioni",
            mySessionsDesc: "Visualizza e gestisci le tue sessioni attive collegate al tuo account.",
            allSessions: "Tutte le sessioni",
            sessionManagement: "Gestione sessioni",
            allSessionsDesc: "Visualizza e gestisci tutte le sessioni attive nel sistema.",
            noActiveSessions: "Nessuna sessione attiva trovata",
            currentSession: "Sessione corrente",
            lastAccess: "Ultimo accesso",
            createdAt: "Creato",
            revoke: "Revoca",
            revokeConfirm: "Sei sicuro di voler revocare questa sessione?",
            revokeAllConfirm: "Sei sicuro di voler revocare tutte le altre sessioni?",
            revokeSuccess: "Sessione revocata con successo",
            revokeAllSuccess: "Tutte le sessioni revocate con successo",
            revokeFailed: "Impossibile revocare la sessione",
            revokeAllOther: "Revoca tutte le altre sessioni",
            unknownLocation: "Posizione sconosciuta",
            unknownDevice: "Dispositivo sconosciuto",
            filterByUser: "Filtra per utente",
            mobile: "Mobile",
            supsisMobileApp: "App mobile Supsis",
            httpClient: "Client HTTP",
            unknown: "Sconosciuto",
            ios: "iOS",
            android: "Android"
        },
        contactModuleRules: {
            title: "Regole del Modulo Contatti",
            description: "Definire azioni automatiche alla creazione di una scheda cliente o all'apertura di una chat",
            active: "Attivo",
            passive: "Passivo",
            when: "Quando:",
            conditions: "Condizioni:",
            actions: "Azioni:",
            elseTitle: "Altrimenti (quando nessuna regola corrisponde)",
            noActionsDefined: "Nessuna azione definita",
            addNewRule: "Aggiungi Nuova Regola",
            rulesDisabled: "Regole del Modulo Contatti Disabilitate",
            enableHint: "Attiva l'interruttore sopra per abilitare le azioni automatiche",
            rulesEnabledSuccess: "Regole del modulo contatti abilitate",
            rulesDisabledSuccess: "Regole del modulo contatti disabilitate",
            ruleEnabledSuccess: "Regola abilitata",
            ruleDisabledSuccess: "Regola disabilitata",
            ruleUpdateError: "Errore durante l'aggiornamento della regola",
            orderUpdatedSuccess: "Ordine delle regole aggiornato",
            orderUpdateError: "Errore durante l'aggiornamento dell'ordine",
            ruleNameTemplate: "Regola {n}",
            ruleSavedSuccess: "Regola salvata",
            ruleSaveError: "Errore durante il salvataggio della regola",
            deleteRuleTitle: "Elimina Regola",
            deleteRuleConfirm: "Sei sicuro di voler eliminare la regola \"{name}\"?",
            delete: "Elimina",
            ruleDeletedSuccess: "Regola eliminata",
            ruleDeleteError: "Errore durante l'eliminazione della regola",
            elseActionsSavedSuccess: "Azioni Altrimenti salvate",
            actionsSaveError: "Errore durante il salvataggio delle azioni",
            whenContactCreated: "Quando viene creata la scheda cliente",
            whenChatOpened: "Quando viene aperta la chat",
            noCondition: "Nessuna condizione",
            and: "e",
            or: "o",
            AND: "E",
            OR: "O",
            fieldNotSelected: "Campo non selezionato",
            noAction: "Nessuna azione",
            doNothing: "Non fare nulla",
            assignToOwnerless: "non assegnato",
            assignOwnerlessAction: "Assegna come <strong>{ownerless}</strong>",
            assignTo: "assegna a",
            assignToUser: "Assegna a <strong>{name}</strong>",
            unknown: "Sconosciuto",
            leastContact: "Meno conversazioni",
            roundRobin: "Round robin",
            today: "oggi",
            last7Days: "ultimi 7 giorni",
            last30Days: "ultimi 30 giorni",
            channelAccessUsers: "utenti con accesso al canale",
            usersCount: "{n} utenti",
            allUsers: "tutti gli utenti",
            random: "Casuale",
            algorithmic: "Algoritmico",
            addTagNotSelected: "Aggiungi etichetta (non selezionata)",
            tagsLabel: "etichette",
            tagLabel: "etichetta",
            addDepartmentNotSelected: "Aggiungi reparto (non selezionato)",
            addDepartmentTo: "reparto",
            applyToConversation: "(applica anche alla conversazione)",
            updatePropertyNotSelected: "Aggiorna proprietà (non selezionata)",
            changeOwner: "Cambia Proprietario",
            addTag: "Aggiungi Etichetta",
            addDepartment: "Aggiungi Reparto",
            updateProperty: "Aggiorna Proprietà",
            yes: "Sì",
            no: "No",
            fields: {
                fullname: "Nome",
                email: "Email",
                phone: "Telefono",
                whatsappNumber: "WhatsApp",
                whatsappCountry: "Paese WhatsApp",
                platform: "Piattaforma",
                ownerExists: "Proprietario",
                ownerIsOnline: "Proprietario online",
                ownerStatus: "Stato proprietario",
                uptime: "Età (min)",
                tags: "Etichette",
                channel: "Canale",
                preferredDepartment: "Reparto",
                hour: "Ora",
                day: "Giorno",
                conversationStatus: "Stato chat",
                conversationSubject: "Reparto chat"
            },
            operators: {
                equals: "uguale",
                not_equals: "diverso",
                contains: "contiene",
                not_contains: "non contiene",
                gt: "maggiore di",
                gte: "≥",
                lt: "minore di",
                lte: "≤",
                in: "contiene",
                not_in: "non contiene",
                exists: "esiste",
                not_exists: "non esiste"
            },
            ruleEditor: {
                editTitle: "Modifica Regola",
                createTitle: "Crea Nuova Regola",
                stepWhen: "Quando?",
                stepConditions: "Condizioni",
                stepActions: "Azioni",
                whenQuestion: "Quando deve essere eseguita la regola?",
                ruleName: "Nome Regola",
                ruleNamePlaceholder: "Inserisci un nome per la regola",
                contactCreatedTitle: "Quando viene creata la scheda cliente",
                contactCreatedDesc: "Si esegue alla creazione di un nuovo record cliente",
                chatOpenedTitle: "Quando viene aperta la chat",
                chatOpenedDesc: "Si esegue quando il cliente avvia una nuova conversazione",
                conditionsQuestion: "Quali condizioni devono essere soddisfatte?",
                actionsQuestion: "Quali azioni devono essere eseguite?",
                back: "Indietro",
                cancel: "Annulla",
                next: "Avanti",
                save: "Salva",
                newRule: "Nuova Regola"
            },
            elseEditor: {
                title: "Modifica Azioni Altrimenti",
                description: "Definire azioni predefinite quando nessuna regola corrisponde"
            },
            ruleTester: {
                title: "Testa Regola",
                description: "Puoi testare quanti contatti corrisponderanno alla tua regola",
                selectRule: "Seleziona Regola",
                selectRulePlaceholder: "Seleziona la regola da testare",
                test: "Testa",
                ruleInfo: "Informazioni Regola",
                conditionCount: "Numero condizioni:",
                actionCount: "Numero azioni:",
                ruleNotFound: "Regola non trovata",
                testComingSoon: "Funzione di test in arrivo.",
                testError: "Errore durante il test"
            },
            filterBuilder: {
                noConditions: "Nessuna condizione aggiunta",
                addFirstCondition: "Aggiungi Prima Condizione",
                groupTitle: "Gruppo {n}",
                deleteGroup: "Elimina Gruppo",
                if: "Se",
                selectField: "seleziona campo",
                operator: "operatore",
                select: "seleziona",
                selectValue: "seleziona valore",
                enterValue: "inserisci valore",
                addCondition: "Aggiungi condizione",
                addFilterGroup: "Aggiungi Gruppo Filtri",
                andOption: "e",
                orOption: "o",
                fieldLabels: {
                    fullname: "Nome contatto",
                    email: "Email contatto",
                    phone: "Telefono contatto",
                    whatsappNumber: "Numero WhatsApp",
                    whatsappCountry: "Paese WhatsApp",
                    platform: "Piattaforma contatto",
                    ownerExists: "Il contatto ha un proprietario",
                    ownerIsOnline: "Proprietario online",
                    ownerStatus: "Stato proprietario",
                    uptime: "Età contatto (min)",
                    tags: "Etichette contatto",
                    channel: "Canale contatto",
                    preferredDepartment: "Reparto preferito",
                    hour: "Ora attuale",
                    day: "Giorno attuale",
                    conversationStatus: "Stato conversazione",
                    conversationSubject: "Reparto conversazione"
                },
                operators: {
                    equals: "uguale",
                    not_equals: "diverso",
                    contains: "contiene",
                    not_contains: "non contiene",
                    gt: "maggiore di",
                    gte: "maggiore o uguale",
                    lt: "minore di",
                    lte: "minore o uguale",
                    between: "tra",
                    exists: "esiste",
                    not_exists: "non esiste",
                    in: "contiene",
                    not_in: "non contiene"
                }
            },
            actionsEditor: {
                noActions: "Nessuna azione aggiunta",
                addFirstAction: "Aggiungi Prima Azione",
                actionNumber: "Azione {n}",
                actionType: "Tipo Azione",
                addAction: "Aggiungi Azione"
            },
            changeOwnerConfig: {
                method: "Metodo di Assegnazione",
                static: "Statico",
                algorithmic: "Algoritmico",
                random: "Casuale",
                userSelect: "Selezione Utente",
                assignOwnerless: "Assegna come non assegnato",
                selectUser: "Seleziona utente",
                userList: "Lista Utenti",
                channelAccessUsers: "Tutti gli utenti con accesso al canale",
                selectUsers: "Seleziona utenti",
                algorithm: "Algoritmo",
                leastContact: "Meno Conversazioni",
                roundRobin: "Round Robin",
                dateRange: "Intervallo Date",
                today: "Oggi",
                last7Days: "Ultimi 7 Giorni",
                last30Days: "Ultimi 30 Giorni",
                onlyOnline: "Includi solo utenti online"
            },
            addTagConfig: {
                tagsToAdd: "Etichette da Aggiungere",
                selectTag: "Seleziona etichetta",
                selectedTagsHint: "Le etichette selezionate saranno aggiunte al contatto"
            },
            addDepartmentConfig: {
                departmentSelect: "Selezione Reparto",
                selectDepartment: "Seleziona reparto",
                departmentHint: "Il reparto selezionato sarà aggiunto alla lista reparti del contatto",
                applyToConversation: "Applica anche alla conversazione",
                applyToConversationHint: "Se abilitato, il reparto della conversazione aperta sarà impostato"
            },
            upsertContactPropertyConfig: {
                propertySelect: "Selezione Proprietà",
                selectProperty: "Seleziona proprietà",
                propertyHint: "Proprietà da aggiornare o creare",
                value: "Valore",
                valuePlaceholder: "Inserisci valore proprietà",
                valueHint: "Questo valore sarà assegnato alla proprietà"
            }
        },
        taskModuleRules: {
            title: "Regole del Modulo Attività",
            description: "Definire azioni automatiche alla creazione, aggiornamento di un'attività o aggiunta di un commento",
            settingsTitle: "Regole del Modulo Attività",
            settingsDescription: "Definire regole attività automatiche per ogni flusso di lavoro",
            selectWorkflow: "Seleziona flusso di lavoro",
            selectWorkflowPlaceholder: "Seleziona flusso di lavoro",
            selectWorkflowHint: "Seleziona un flusso di lavoro per modificare le regole del modulo attività",
            active: "Attivo",
            passive: "Passivo",
            when: "Quando:",
            conditions: "Condizioni:",
            actions: "Azioni:",
            elseTitle: "Altrimenti (quando nessuna regola corrisponde)",
            noActionsDefined: "Nessuna azione definita",
            addNewRule: "Aggiungi Nuova Regola",
            rulesDisabled: "Regole del Modulo Attività Disabilitate",
            enableHint: "Attiva l'interruttore sopra per abilitare le azioni automatiche",
            rulesEnabledSuccess: "Regole del modulo attività abilitate",
            rulesDisabledSuccess: "Regole del modulo attività disabilitate",
            ruleEnabledSuccess: "Regola abilitata",
            ruleDisabledSuccess: "Regola disabilitata",
            ruleUpdateError: "Errore durante l'operazione",
            orderUpdatedSuccess: "Ordine delle regole aggiornato",
            orderUpdateError: "Errore durante l'aggiornamento dell'ordine",
            ruleNameTemplate: "Regola {n}",
            ruleSavedSuccess: "Regola salvata",
            ruleSaveError: "Errore durante il salvataggio della regola",
            deleteRuleTitle: "Elimina Regola",
            deleteRuleConfirm: "Sei sicuro di voler eliminare la regola \"{name}\"?",
            delete: "Elimina",
            ruleDeletedSuccess: "Regola eliminata",
            ruleDeleteError: "Errore durante l'eliminazione della regola",
            elseActionsSavedSuccess: "Azioni Altrimenti salvate",
            actionsSaveError: "Errore durante il salvataggio delle azioni",
            noCondition: "Nessuna condizione",
            and: "e",
            or: "o",
            AND: "E",
            OR: "O",
            fieldNotSelected: "Campo non selezionato",
            noAction: "Nessuna azione",
            chainBadge: "Concatenazione",
            chainBadgeTooltip: "Questa regola può attivare altre regole",
            automationOffBadge: "Automazione disattivata",
            automationOffTooltip: "Non segnalato a Supsis Automations",
            yes: "Sì",
            no: "No",
            unknown: "Sconosciuto",
            cancel: "Annulla"
        },
        userInfoWidget: {
            zohoInfo: "Informazioni Zoho",
            messageSearch: "Cerca messaggio",
            userInformation: "Informazioni utente",
            fullName: "Nome e cognome",
            newValue: "Nuovo valore",
            newProfileInfo: "Nuove informazioni sul profilo",
            affiliatedRepresentatives: "Rappresentanti",
            preferredAgents: "Agente(i) preferito(i)",
            labels: "Etichette",
            agentNotes: "Note dell'agente",
            newNote: "Nuova Nota",
            note: "Nota",
            available: "nota disponibile.",
            systemInformation: "Informazioni di sistema",
            speechID: "ID vocale",
            customerVersion: "Versione cliente",
            IPAddress: "Indirizzo IP",
            pageVisited: "Pagina visitata",
            systemAndBrowser: "Sistema operativo e browser",
            countryAndLanguage: "Paese e lingua",
            clickToEdit: "Modifica Fare clic all'interno del post",
            adsYouAreInterestedIn: "Annunci di tuo interesse",
            detail: "Dettaglio",
            adsTitle: "Titolo",
            adUrl: "URL dell'annuncio",
            sourceID: "ID fonte",
            resourceType: "Tipo di risorsa",
            adsBody: "Contenuto",
            adsCreateDate: "Data di creazione",
            adsUpdateDate: "Data di aggiornamento"
        },
        newWizartV2: {
            generalSettings: "impostazioni generali",
            themeSettings: "Impostazioni tema",
            representativeWorkingHours: "Orario di lavoro rappresentativo",
            preview: "anteprima",
            setup: "Impostare",
            formStepTitle: "Forniscici maggiori informazioni in modo che possiamo personalizzare la tua esperienza",
            supsisEntergation: "Dove userai Supsis sul tuo sito web? :",
            goToNextStep: "Fai il prossimo passo",
            readytemplate: "Usa modello di colore pronto",
            customSettings: "Impostazioni personalizzate",
            customerMessageView: "Messaggio del cliente Visualizza",
            backcgroundColor: "Colore di sfondo",
            textColor: "Colore del carattere",
            agentMessageView: "Vista messaggio agente",
            workingHours: "Con quali intervalli di tempo fornisci servizi ai tuoi visitatori?",
            continuousService: "Servizio continuo",
            continuousServiceDescription: "La bolla della chat è sempre attiva. Anche se non sei nel sistema.",
            vote: "Fate la vostra scelta",
            representativeWorking: "Nell'orario di lavoro del rappresentante",
            representativeWorkingDescription: "La chat appare online quando almeno 1 agente è online. Se non è presente un rappresentante online, verrà visualizzato come offline.",
            computer: "Computer",
            tablet: "Tavoletta",
            uploadTrackingCodeToYourWebsite: "Carica il codice di monitoraggio sul tuo sito web",
            password: "Imposta nuova password"
        },
        whatsappChannel: {
            whatsappTitleV1: "Canali Whatsapp V1 (QR)",
            whatsappTitleV2: "Canali Whatsapp V2 (QR)",
            channelName: "Nome Canale",
            phoneNumber: "Numero di Telefono",
            forwardToChatbot: "Inoltra al Chatbot",
            forwardingChatbotOrLiveAgent: "Inoltro (Chatbot o Agente Live)",
            addChannel: "Aggiungi Canale",
            newWhatsappChannel: "Nuovo Canale WhatsApp",
            newWhatsappChannelDescription: "Crea un nuovo canale WhatsApp scansionando il codice QR",
            editWhatsappChannel: "Modifica Canale WhatsApp",
            editWhatsappChannelDescription: "Modifica canale WhatsApp",
            whatsappChannel: "Canale WhatsApp",
            deleteWhatsappChannelDescription: "Sei sicuro di voler eliminare questo canale?",
            whatsappIntegration: "Integrazione WhatsApp",
            deleteChannel: "Elimina Canale",
            restartChannel: "Riavvia Canale",
            wantRestartChannel: "Vuoi riavviare il canale?",
            deleteSMSChannelDescription: "Sei sicuro di voler eliminare il canale SMS?",
            smsChannel: "Canale SMS",
            maxChannelCount: "Non puoi creare più di un canale SMS!",
            smsModalText: "La nostra integrazione con le moderne soluzioni di comunicazione ti dà l'opportunità di inviare SMS in modo semplice ed efficace. Elimina i confini nella comunicazione, connettiti direttamente con i tuoi clienti!",
            smsModalBtn: "Fare clic per aprire il canale SMS...",
            postaCellDetail: "Dettagli canale PostaCell",
            phoneNummer: "Numero di telefono"
        },
        noPermission: "Non hai il permesso di eseguire questa operazione.",
        mail_integration_detail: {
            title: "Dettagli della posta",
            integration: "Integrazione",
            sender: "Email del mittente",
            signature: "Firma",
            inbox: "Posta in arrivo",
            medias: "Media",
            visibility: "Visibilità",
            settings_group: "Impostazioni",
            contacts: "Contatti"
        },
        whatsapp_business_api: {
            userVisibility: "Visibilità utente",
            userVisibilityDesc: "I canali a cui gli utenti possono accedere dipendono dal loro ruolo e dalle impostazioni di visibilità del canale. Gli utenti con il ruolo di amministratore completo o di root possono vedere tutti i canali. Se le impostazioni di visibilità di un canale sono vuote, il canale è pubblico. Tuttavia, se il canale è definito per utenti o reparti specifici, solo gli utenti o i membri del reparto possono vedere il canale.",
            searchTemplate: "Modello di ricerca...",
            forwardToChatbot: "Inoltro al Chatbot",
            forwarding: "Inoltro (Chatbot o Live Agent)",
            forwardLiveAgents: "Inoltro all'assistenza live",
            forwardingToDepartment: "Inoltro al reparto",
            selectDepartment: "Selezionare il reparto",
            createWbChannel: "Per creare un canale Whatsapp Business, è necessario acquistare un pacchetto Whatsapp Business. È possibile accedere immediatamente ai pacchetti a prezzi accessibili",
            wbCreateChannelMax: "Hai raggiunto il limite di creazione di canali Whatsapp Business. Massimo",
            wbContinue: "È possibile creare un canale Whatsapp Business. Per continuare, aggiornare il pacchetto o eliminare alcuni dei canali Whatsapp Business",
            chatInitiatorTemplate: "Modello di iniziatore di chat",
            selectChatInitiatorTemplate: "Selezionare il modello di iniziatore di chat",
            dailyUsageReport: "Rapporto di utilizzo giornaliero",
            metaInsightsTitle: "Meta Insights",
            metaInsightsSubtitle: "Visualizza le statistiche WhatsApp Business API",
            metaInsightsDateRange: "Intervallo di date",
            metaInsightsDateStart: "Inizio",
            metaInsightsDateEnd: "Fine",
            metaInsightsGranularity: "Granularità",
            metaInsightsGranularityDay: "Giornaliero",
            metaInsightsGranularityMonth: "Mensile",
            metaInsightsGranularityHalfHour: "Mezz'ora",
            metaInsightsRefresh: "Aggiorna",
            metaInsightsTabMessaging: "Analytics messaggistica",
            metaInsightsTabConversation: "Analytics conversazioni",
            metaInsightsTabPricing: "Analytics prezzi",
            metaInsightsTabTemplate: "Analytics modelli",
            metaInsightsTabTemplateGroup: "Analytics gruppi modelli",
            metaInsightsErrorMessaging: "Impossibile caricare i dati di analytics messaggistica",
            metaInsightsErrorConversation: "Impossibile caricare i dati di analytics conversazioni",
            metaInsightsErrorPricing: "Impossibile caricare i dati di analytics prezzi",
            metaInsightsErrorTemplate: "Impossibile caricare i dati di analytics modelli",
            metaInsightsErrorTemplateGroup: "Impossibile caricare i dati di analytics gruppi modelli",
            metaInsightsViewChart: "Vista grafico",
            metaInsightsViewTable: "Vista tabella",
            metaInsightsDownloadExcel: "Scarica Excel",
            metaInsightsTotalSent: "Totale inviati",
            metaInsightsTotalDelivered: "Totale consegnati",
            metaInsightsDeliveryRate: "Tasso di consegna",
            metaInsightsUnitMessage: "messaggi",
            metaInsightsMessageStats: "Statistiche messaggi",
            metaInsightsSent: "Inviati",
            metaInsightsDelivered: "Consegnati",
            metaInsightsDateColumn: "Data",
            metaInsightsCountryBreakdown: "Ripartizione per paese",
            metaInsightsNoData: "Nessun dato trovato. Controlla l'intervallo di date.",
            metaInsightsPieChart: "Grafico a torta",
            metaInsightsTotalConversations: "Totale conversazioni",
            metaInsightsTotalCost: "Costo totale",
            metaInsightsAvgCost: "Costo medio",
            metaInsightsUnitConversation: "conversazioni",
            metaInsightsCostPerConversation: "$/conversazione",
            metaInsightsCategoryBreakdown: "Ripartizione per categoria",
            metaInsightsConversationStats: "Statistiche conversazioni",
            metaInsightsCategoryDistribution: "Distribuzione per categoria",
            metaInsightsConversationCount: "Numero di conversazioni",
            metaInsightsCost: "Costo",
            metaInsightsCategory: "Categoria",
            metaInsightsType: "Tipo",
            metaInsightsConversationCategoryAuth: "Autenticazione",
            metaInsightsConversationCategoryMarketing: "Marketing",
            metaInsightsConversationCategoryService: "Servizio",
            metaInsightsConversationCategoryUtility: "Utility",
            metaInsightsConversationCategoryOther: "Altro",
            metaInsightsConversationDistribution: "Distribuzione conversazioni",
            metaInsightsTotalVolume: "Volume totale",
            metaInsightsAvgUnitCost: "Costo unitario medio",
            metaInsightsCostPerMessage: "$/messaggio",
            metaInsightsPricingCategoryBreakdown: "Ripartizione per categoria di prezzo",
            metaInsightsPricingTypeBreakdown: "Ripartizione per tipo di prezzo",
            metaInsightsPricingStats: "Statistiche prezzi",
            metaInsightsCostDistribution: "Distribuzione costi",
            metaInsightsCountry: "Paese",
            metaInsightsVolume: "Volume",
            metaInsightsTier: "Livello",
            metaInsightsPricingCategoryAuth: "Autenticazione",
            metaInsightsPricingCategoryAuthInternational: "Autenticazione internazionale",
            metaInsightsPricingCategoryMarketing: "Marketing",
            metaInsightsPricingCategoryService: "Servizio",
            metaInsightsPricingCategoryUtility: "Utility",
            metaInsightsPricingCategoryReferral: "Conversione referral",
            metaInsightsPricingTypeRegular: "Regolare",
            metaInsightsPricingTypeFreeCustomerService: "Servizio clienti gratuito",
            metaInsightsPricingTypeFreeEntryPoint: "Punto di ingresso gratuito",
            metaInsightsTemplateAboutTitle: "Informazioni su analytics modelli",
            metaInsightsTemplateAboutDesc: "È necessario selezionare i modelli per l'analytics. È possibile selezionare fino a 10 modelli. I dati sono restituiti con granularità giornaliera e si può accedere a 90 giorni di storico.",
            metaInsightsTemplateSelectLabel: "Seleziona modelli (max 10)",
            metaInsightsTemplateSelectPlaceholder: "Seleziona modelli...",
            metaInsightsFetchData: "Recupera dati",
            metaInsightsTotalRead: "Totale letti",
            metaInsightsReadRate: "Tasso di lettura",
            metaInsightsRead: "Letti",
            metaInsightsTemplatePerformance: "Prestazioni modelli",
            metaInsightsCostInfo: "Informazioni sui costi",
            metaInsightsTotalSpent: "Totale speso",
            metaInsightsCostPerDelivered: "Costo per consegna",
            metaInsightsClickInfo: "Informazioni sui clic",
            metaInsightsClickInfoDesc: "I clic sui pulsanti URL e Quick Reply sono disponibili solo per i modelli nelle categorie MARKETING e UTILITY.",
            metaInsightsTemplateNoData: "Nessun dato di analytics modelli. Puoi recuperare i dati selezionando gli ID dei modelli.",
            metaInsightsTemplateId: "ID modello",
            metaInsightsTemplateGroupAboutTitle: "Informazioni su analytics gruppi modelli",
            metaInsightsTemplateGroupAboutDesc: "È necessario inserire gli ID dei gruppi di modelli creati in Meta per l'analytics. È possibile inserire fino a 10 gruppi. I dati sono restituiti con granularità giornaliera e si può accedere a 90 giorni di storico.",
            metaInsightsTemplateGroupIdsLabel: "ID gruppi modelli (separati da virgola, max 10)",
            metaInsightsTemplateGroupIdsPlaceholder: "Es.: 1044106240855852, 1044106240855853",
            metaInsightsTemplateGroupPerformance: "Prestazioni gruppi modelli",
            metaInsightsGroupBreakdownTitle: "Prestazioni per gruppo",
            metaInsightsGroupLabel: "Gruppo",
            metaInsightsTemplateGroupNoData: "Nessun dato di analytics gruppi modelli. Puoi recuperare i dati inserendo gli ID dei gruppi di modelli.",
            metaInsightsGroupId: "ID gruppo",
            capiStatus: "Stato CAPI",
            capiActive: "Attivo",
            capiPassive: "Inattivo",
            capiConnectionMethod: "Metodo di connessione",
            capiConnectThroughMeta: "Connetti tramite Meta",
            capiWithDatasetAndToken: "Con dataset e token",
            capiOauthInfoDesc: "È necessario riautorizzare per connettersi tramite Meta. Questo non modifica il canale esistente, aggiunge solo permessi aggiuntivi.",
            capiConnecting: "Connessione in corso...",
            capiConnectWithMeta: "Connetti con Meta",
            capiDatasetSelection: "Selezione dataset",
            capiSelectDataset: "Seleziona un dataset",
            capiCreating: "Creazione in corso...",
            capiCreateNewDataset: "Crea nuovo dataset",
            capiDatasetId: "ID dataset",
            capiEnterDatasetId: "Inserisci l'ID del dataset",
            capiAccessToken: "Token di accesso",
            capiEnterAccessToken: "Inserisci il token di accesso",
            capiTesting: "Test in corso...",
            capiTestConnection: "Testa connessione",
            capiConnectionSuccess: "Connessione riuscita",
            capiConnectionFailed: "Connessione fallita",
            capiAutoEventSend: "Invio automatico eventi",
            capiEventInitiateCheckout: "Chat avviata",
            capiEventInitiateCheckoutDesc: "Quando viene creata una nuova conversazione",
            capiEventPurchase: "Acquisto",
            capiEventPurchaseDesc: "Quando l'acquisto è completato",
            capiEventAppointmentBooked: "Appuntamento prenotato",
            capiEventAppointmentBookedDesc: "Quando viene prenotato un appuntamento",
            capiEventAddToCart: "Aggiunto al carrello",
            capiEventAddToCartDesc: "Quando un prodotto viene aggiunto al carrello",
            capiEventViewContent: "Contenuto visualizzato",
            capiEventViewContentDesc: "Quando una pagina o prodotto viene visualizzato",
            capiEventOrderCreated: "Ordine creato",
            capiEventOrderCreatedDesc: "Quando l'ordine viene creato con successo",
            capiEventOrderShipped: "Ordine spedito",
            capiEventOrderShippedDesc: "Quando l'ordine viene spedito",
            capiMetaConnectionSuccess: "Connessione Meta riuscita",
            capiMetaConnectionFailed: "Connessione Meta fallita",
            capiDatasetsLoadError: "Impossibile caricare i dataset",
            capiDatasetCreated: "Nuovo dataset creato",
            capiDatasetCreateError: "Impossibile creare il dataset",
            capiConnectionTestSuccess: "Connessione CAPI riuscita!",
            capiConnectionTestFailed: "Connessione CAPI fallita",
            capiConnectionTestError: "Impossibile eseguire il test di connessione",
            wabaMovementsTitle: "Attività Webhook",
            wabaMovementsSubtitle: "Monitora le attività del canale WhatsApp Business API",
            wabaMovementsTotalActivity: "attività totali",
            wabaMovementsEmailNotifications: "Notifiche email",
            wabaMovementsActive: "Attivo",
            wabaMovementsOff: "Disattivo",
            wabaMovementsEmailSettingTitle: "Ricevi le notifiche dell'account via email",
            wabaMovementsEmailSettingDesc: "Invia notifiche email per le attività webhook",
            wabaMovementsEmailListHeader: "Indirizzi email a cui inviare le notifiche",
            wabaMovementsEmailPlaceholder: "Inserisci l'indirizzo email",
            wabaMovementsNoEmailsYet: "Nessun indirizzo email aggiunto ancora",
            wabaMovementsActivityLoadError: "Errore durante il caricamento dei log attività",
            wabaMovementsNotificationsOn: "Notifiche email attivate",
            wabaMovementsNotificationsOff: "Notifiche email disattivate",
            wabaMovementsUpdateError: "Errore durante l'aggiornamento",
            wabaMovementsEmailAlreadyAdded: "Questo indirizzo email è già presente",
            wabaMovementsEmailAdded: "Indirizzo email aggiunto",
            wabaMovementsEmailAddError: "Errore durante l'aggiunta dell'email",
            wabaMovementsEmailRemoved: "Indirizzo email rimosso",
            wabaMovementsEmailRemoveError: "Errore durante la rimozione dell'email",
            freeChat: "Chat gratuita",
            paidChat: "Chat a pagamento",
            templateMessage: "Messaggio modello",
            outgoingSession: "Sessione in uscita",
            incomingSession: "Sessione in arrivo",
            totalCost: "Costo totale",
            allOptNumbers: "Tutti i numeri opt-in",
            startChat: "Inizio chat",
            lastMessageDate: "Data ultimo messaggio",
            sureDeleteTemplate: "Sei sicuro di voler cancellare questo modello?",
            manageWhoChannelChat: "Gestisci chi può vedere queste chat di canale",
            profileImageDesc: "Questo sarà uno screenshot WhatsApp della tua attività.",
            businessDescription: "Descrizione dell'azienda.",
            descOfWork: "Descrizione della tua attività in poche parole (massimo 512 caratteri).",
            accountStatus: "Stato del conto.",
            dockerStatus: "Stato di Docker.",
            phoneQuality: "Qualità del telefono.",
            customersOrDay: "CustomersDay.",
            messagingLimit: "Limite di messaggistica.",
            canSendMessage: "Il messaggio può essere inviato.",
            officialDetails: "Dettagli ufficiali.",
            officialDetailsDesc: "Questi indirizzi saranno sempre mostrati nella sezione del profilo agli utenti che chattano con voi su WhatsApp. Dopo averli modificati, li invieremo a WhatsApp per l'approvazione.",
            addressLine: "Indirizzo.",
            stateIfApplic: "Stato (se applicabile).",
            zipCodeOrPostCode: "Codice postale.",
            selectCountry: "Seleziona Paese.",
            selectBussVertical: "Selezionare l'area commerciale.",
            saveInfo: "Salva informazioni.",
            active: "Attivo.",
            banned: "Vietato.",
            low: "Basso.",
            medium: "Medio.",
            high: "Alto.",
            connected: "Connesso.",
            disConnected: "Disconnesso.",
            flagged: "Flagged.",
            pending: "In attesa.",
            restricted: "Limitato.",
            unknown: "Sconosciuto.",
            available: "Disponibile.",
            limited: "Limitato.",
            blocked: "Bloccato.",
            loadingProfile: "Caricamento informazioni profilo...",
            businessProfileTitle: "Profilo aziendale",
            lastUpdate: "Ultimo aggiornamento:",
            updateFromMeta: "Aggiorna da Meta",
            waitSeconds: "Attendere {n}s",
            wabaInfoTitle: "Informazioni account WhatsApp Business",
            phoneInfo: "Informazioni telefono",
            verifiedNameLabel: "Nome verificato:",
            phoneNumberLabel: "Numero di telefono:",
            codeVerificationLabel: "Verifica codice:",
            platformSettings: "Impostazioni piattaforma",
            platformTypeLabel: "Tipo di piattaforma:",
            throughputLevelLabel: "Livello di throughput:",
            twoFaPinLabel: "PIN 2FA:",
            enabled: "Abilitato",
            disabled: "Disabilitato",
            dailyLimit: "Limite giornaliero",
            messageSending: "Invio messaggi",
            businessInfoTitle: "Informazioni aziendali",
            profilePhoto: "Foto profilo",
            change: "Modifica",
            profilePhotoNote: "JPG o PNG (max 5MB, consigliato: 640x640px)",
            aboutText: "Testo Informazioni",
            aboutPlaceholder: "Scrivi una breve descrizione della tua attività...",
            aboutHint: "Breve descrizione visibile sul tuo profilo WhatsApp (max 139 caratteri)",
            businessDescriptionLabel: "Descrizione azienda",
            businessDescriptionPlaceholder: "Scrivi la descrizione dettagliata della tua attività...",
            descriptionHint: "Descrizione dettagliata della tua attività",
            contactEmail: "Email di contatto",
            emailPlaceholder: "esempio@azienda.com",
            businessAddress: "Indirizzo azienda",
            addressPlaceholder: "Indirizzo completo",
            website1: "Sito web 1",
            website2: "Sito web 2",
            website1Placeholder: "https://www.azienda.com",
            website2Placeholder: "https://www.facebook.com/azienda",
            businessCategory: "Categoria azienda",
            selectBusinessCategory: "Seleziona categoria azienda",
            categoryHint: "Seleziona il settore di attività",
            revertChanges: "Annulla modifiche",
            updateButton: "Aggiorna",
            accountModeLabel: "Modalità account:",
            na: "N/D",
            verticalOther: "Altro",
            verticalAuto: "Automotive",
            verticalBeauty: "Bellezza, spa e salon",
            verticalApparel: "Abbigliamento e moda",
            verticalEdu: "Istruzione",
            verticalEntertain: "Intrattenimento",
            verticalEventPlan: "Pianificazione eventi e servizi",
            verticalFinance: "Finanza e banche",
            verticalGrocery: "Alimentari e generi alimentari",
            verticalGovt: "Servizio pubblico",
            verticalHotel: "Hotel e alloggio",
            verticalHealth: "Medico e salute",
            verticalNonprofit: "Non profit",
            verticalProfServices: "Servizi professionali",
            verticalRetail: "Shopping e retail",
            verticalTravel: "Viaggi e trasporti",
            verticalRestaurant: "Ristorante",
            verticalAlcohol: "Alcol",
            verticalOnlineGambling: "Gioco d'azzardo online",
            verticalPhysicalGambling: "Gioco d'azzardo fisico",
            verticalOtcDrugs: "Farmaci da banco",
            verticalMatrimonyService: "Servizio matrimoniale",
            success: "Successo.",
            successDesc: "Le informazioni del profilo sono state aggiornate con successo.",
            wabaOverview: "Panoramica della salute WABA.",
            manageChannelDetail: "Gestisci le informazioni del tuo canale.",
            wpBussChannelDetail: "Dettaglio canale Whatsapp Business.",
            manageWpBussChannel: "Gestisci il tuo canale Whatsapp business.",
            channelName: "Nome del canale.",
            phoneNumberE164: "Numero di telefono",
            phoneNumberE164Place: "Numero di telefono es: 908501234455",
            channelUpdatedSucs: "Canale aggiornato con successo.",
            failedUpdateChannel: "Canale non aggiornato.",
            title: "Canali Whatsapp Business API",
            integration: "Integrazione",
            detail: "Dettaglio",
            visibility: "Visibilità",
            templates: "Tutti i Messaggi Modello",
            settings_group: "Impostazioni",
            template_message_group: "Messaggi Modello",
            chat_initiator_template: "Modello di inizio chat",
            contacts: "Contatti",
            numbers: "Numeri",
            all_contacts: "Tutti i contatti",
            new_template: "Crea nuovo Modello",
            broadcast_group: "Trasmissione",
            broadcast_requests: "Richieste di Trasmissione",
            customer_groups: "Gruppi Clienti",
            businessChannelDetail: "Dettagli del canale Whatsapp Business",
            wallet: "Wallet",
            postacellMessage: "Invia SMS",
            postacellAllMessage: "Invia SMS di massa",
            message_group: "Messaggio",
            createNewTemplate: "Crea nuovo messaggio modello",
            templateName: "Nome del modello",
            templateNameDesc: "Dai un nome al tuo modello di messaggio.",
            templateInfo: "Informazioni sul modello",
            viewTemplates: "Visualizza modelli",
            templateListTitle: "Modelli di messaggi",
            templateListShownTotal: "{shown} modelli mostrati (totale: {total})",
            templateListCreateButton: "Crea modello",
            templateListSearchPlaceholder: "Cerca modelli...",
            templateListAllCategories: "Tutte le categorie",
            templateListAllStatus: "Tutti gli stati",
            templateListStatusApproved: "Approvato",
            templateListStatusPending: "In revisione",
            templateListStatusRejected: "Rifiutato",
            templateListRefresh: "Aggiorna",
            templateListTotalTemplates: "Totale {count} modelli",
            templateListCopied: "Copiato!",
            templateListCopy: "Copia",
            templateListIdLabel: "ID:",
            templateListPreview: "Anteprima",
            templateListEdit: "Modifica",
            templateListDelete: "Elimina",
            templateListPreviewTitle: "Anteprima modello",
            templateListNameLabel: "Nome:",
            templateListCategoryLabel: "Categoria:",
            templateListLanguageLabel: "Lingua:",
            templateListStatusLabel: "Stato:",
            templateListReasonLabel: "Motivo:",
            templateListRecommendationLabel: "Raccomandazione:",
            templateListColumnName: "NOME MODELLO",
            templateListColumnCategory: "CATEGORIA",
            templateListColumnStatus: "STATO",
            templateListColumnLastEdited: "ULTIMA MODIFICA",
            templateListStatusActive: "Attivo",
            templateListStatusInReview: "In revisione",
            templateListStatusRejected: "Rifiutato",
            templateListStatusFailed: "Fallito",
            templateListQualityHigh: "Alta qualità",
            templateListQualityMedium: "Qualità media",
            templateListQualityLow: "Bassa qualità",
            templateListDeleteConfirmTitle: "Elimina modello",
            templateListDeleteConfirmContent: "Sei sicuro di voler eliminare \"{{name}}\"?",
            templateListDeleteConfirmOk: "Elimina",
            templateListDeleteConfirmCancel: "Annulla",
            templateListCopyIdError: "Errore durante la copia dell'ID",
            templateListDeletedSuccess: "{{name}} eliminato con successo.",
            templateListDeleteFailed: "Impossibile eliminare il modello.",
            templateNameRules: "Il nome del modello può includere solo lettere minuscole, numeri e trattini bassi.",
            category: "Categoria",
            categoryDesc: "Seleziona il tipo di modello che desideri creare",
            categoryUtility: "Utilità",
            categoryUtilityDesc: "Invia informazioni di utilità come aggiornamenti dell'account, aggiornamenti degli ordini, avvisi e altro.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc: "Invia offerte promozionali, offerte di prodotti e altro per aumentare la consapevolezza e l'interazione.",
            categoryAuth: "Autenticazione",
            categoryAuthDesc: "Invia codici per consentire ai tuoi clienti di accedere ai loro account.",
            optional: "Opzionale",
            languageDesc: "Seleziona la lingua in cui verrà inviato il tuo messaggio di modello",
            header: "Intestazione",
            headerRules: "Aggiungi un'intestazione di 60 caratteri al tuo messaggio. Nell'intestazione è supportata solo una variabile.",
            headerOptionMedia: "Media",
            headerOptionText: "Testo",
            none: "Nessuno",
            headerType: "Tipo di intestazione",
            headerText: "Testo dell'intestazione",
            body: "Corpo",
            bodyRules: "Inserisci il testo nella lingua che hai scelto per il tuo messaggio",
            addVariable: "Aggiungi variabile",
            variables: "Variabili",
            variable: "Variabile",
            defaultVariableName: "Nome variabile predefinito",
            defaultVariableToolTip: "La tua variabile appare nel template con questo nome. <br><br> Inoltre, questo valore viene inviato come predefinito in caso di altre situazioni.",
            selectATemplate: "Seleziona un modello di messaggio",
            variableSettings: "Impostazioni variabili",
            example: "Esempio",
            footer: "Piè di pagina",
            footerDesc: "Aggiungi un piè di pagina di 60 caratteri al tuo messaggio. Le variabili non sono supportate nel piè di pagina.",
            buttons: "Pulsanti",
            buttonType: "Tipo di pulsante",
            buttonTypeReply: "Rispondi",
            submit: "Salva",
            submitting: "Invio in corso",
            addButton: "Aggiungi pulsante",
            rejectWhatsapp: "Respinto da Whatsapp.",
            approvedWhatsapp: "Approvato da Whatsapp.",
            pendingWhatsapp: "In attesa di approvazione",
            daily_usages: "Utilizzi giornalieri",
            bussinesDesciption: "Descrizione attività",
            succesDesc: "Le informazioni del profilo sono state aggiornate con successo.",
            faieldUpdateChannel: "Impossibile aggiornare il canale",
            completeSetup: "Completa configurazione",
            completeSetupDescription:
                "Per completare la configurazione dell'API WhatsApp Business, fare clic sul pulsante qui sotto per accedere alla pagina di connessione.",
            connectWhatsAppBusinessAccount: "Connetti account WhatsApp Business",
            infoLabel: "Informazione",
            onboardingInfoDescription:
                "Il tuo account Facebook Business e il tuo numero WhatsApp devono essere pronti per la configurazione dell'API WhatsApp Business.",
            businessId: "ID azienda",
            phoneNumberId: "ID numero di telefono",
            wabaId: "ID WABA",
            verifiedNameLabel: "Nome verificato",
            userAccessibility: "Accessibilità utente",
            userAccessibilityDesc:
                "Le persone indicate sotto possono vedere contatti e chat in questo canale (nessun accesso se è impostata la proprietà). Questa impostazione viene utilizzata in: <ul><li><strong>Assegnazione automatica chat:</strong> i clienti in entrata vengono assegnati in base alla visibilità; le chat non vengono assegnate a chi non ha accesso</li><li><strong>Inoltro:</strong> inoltrare una chat o aggiungere un altro agente deve corrispondere a queste impostazioni; l'inoltro non è consentito agli utenti non autorizzati</li><li><strong>Elenchi contatti/clienti:</strong> gli elenchi visualizzati dipendono da questa impostazione</li><li><strong>Proprietà:</strong> è possibile assegnare un cliente a un agente in questa impostazione</li></ul>",
            makePublicButton: "Rendi pubblico",
            channelOwners: "Proprietari del canale",
            channelOwnersDesc:
                "I proprietari del canale hanno il permesso di visualizzare tutte le conversazioni in questo canale. Possono leggere tutti i messaggi indipendentemente dalle impostazioni di visibilità.",
            editChannelOwners: "Modifica proprietari canale",
            selectChannelOwner: "Seleziona proprietario canale",
            selectChannelOwnerDesc: "Seleziona gli agenti che saranno proprietari di questo canale",
            makePublicConfirmTitle: "Sei sicuro di voler rendere pubblico questo canale?",
            makePublicConfirmContent: "Dopo questa azione, tutti gli agenti potranno vedere le conversazioni di questo canale.",
            makePublicConfirmOk: "Sì, rendi pubblico",
            makePublicSuccessMessage: "Il canale è stato reso pubblico",
            stepSetupTemplate: "Configura modello",
            stepEditTemplate: "Modifica modello",
            stepSubmitReview: "Invia per revisione",
            templateNameAndLanguage: "Nome e lingua del modello",
            editModeNoticeText: "In modalità modifica nome e lingua del modello non possono essere modificati. Solo categoria (se non approvato), componenti e time-to-live.",
            nameYourTemplate: "Assegna un nome al modello",
            enterTemplateNamePlaceholder: "Inserisci il nome del modello",
            selectLanguage: "Seleziona lingua",
            content: "Contenuto",
            footerOptional: "Piè di pagina • Opzionale",
            enterTextPlaceholder: "Inserisci testo",
            bodyLabel: "Corpo",
            bodyPlaceholder: "Inserisci il testo del corpo del messaggio",
            bold: "Grassetto",
            italic: "Corsivo",
            strikethrough: "Barrato",
            headerLabelRecommended: "Consigliato",
            headerLabelOptionalTextOnly: "Opzionale (solo testo)",
            headerLabelRequiredProduct: "Obbligatorio (prodotto)",
            headerLabelOptional: "Opzionale",
            headerNone: "Nessuno",
            headerTextOption: "Testo",
            headerDocument: "Documento",
            headerProduct: "Prodotto",
            productHeaderAutoSet: "L'intestazione prodotto viene impostata automaticamente con i modelli prodotto.",
            headerTextPlaceholder: "Aggiungi una breve riga di testo all'intestazione del messaggio",
            mediaHintNote: "Nota:",
            mediaHintIntro: "Formati e dimensioni file accettati:",
            mediaHintImage: "Immagine: JPEG, PNG (Max 5 MB)",
            mediaHintVideo: "Video: MP4 (Max 16 MB)",
            mediaHintDocument: "Documento: PDF (Max 100 MB)",
            productHeaderAutoInfo: "L'intestazione prodotto viene aggiunta automaticamente dal catalogo.",
            carouselContentDescription: "Crea due messaggi: prima il testo generale (corpo), poi le card carousel. Ogni card può avere corpo opzionale e pulsanti (almeno 1). Il corpo principale non può avere pulsanti.",
            contentDescriptionProduct: "Aggiungi il testo del corpo per il modello messaggio prodotto. L'intestazione viene aggiunta dal catalogo.",
            contentDescriptionLTO: "Aggiungi intestazione e corpo per il modello offerta a tempo limitato. Il piè di pagina non è supportato per questo tipo.",
            contentDescriptionCarousel: "Aggiungi corpo generale e card carousel. Ogni card ha intestazione, corpo opzionale e pulsanti.",
            contentDescriptionDefault: "Aggiungi intestazione, corpo e piè di pagina per il modello.",
            readyToSubmit: "Pronto per l'invio",
            submitReviewDescription: "Il modello sarà inviato per revisione Meta. Di solito richiede minuti, fino a 24 ore.",
            bodyContentAdded: "Contenuto del corpo aggiunto",
            buttonsAddedCount: "{count} pulsanti aggiunti",
            previous: "Precedente",
            discard: "Annulla",
            next: "Avanti",
            submitForReview: "Invia per revisione",
            updateTemplate: "Aggiorna modello",
            cannotProceed: "Impossibile procedere",
            noChangesReason: "Non sono state apportate modifiche al modello. Effettua almeno una modifica.",
            categoryCannotChangeWarning: "La categoria non può essere modificata per i modelli approvati.",
            setupYourTemplate: "Configura il tuo modello",
            setupDescription: "Scegli la categoria che descrive meglio il modello di messaggio. Poi il tipo di messaggio.",
            learnMoreCategories: "Maggiori informazioni sulle categorie.",
            marketing: "Marketing",
            utility: "Utility",
            authentication: "Autenticazione",
            categoryCannotChangeApproved: "La categoria non può essere modificata per i modelli approvati",
            categoryCannotEditApproved: "La categoria non può essere modificata per i modelli approvati. Solo componenti e time-to-live.",
            notSupported: "Non supportato",
            selectProductMessageType: "Seleziona il tipo di messaggio prodotto",
            selectOtpAutofillType: "Seleziona il tipo di compilazione automatica OTP",
            templatePreview: "Anteprima modello",
            previewAlt: "Anteprima",
            previewAltCallPermission: "Richiesta permesso chiamata",
            previewSampleCard: "Scheda di esempio",
            previewCardPreview: "Anteprima scheda",
            previewBodyMarketingDefault: "Ciao! Scopri i nostri prodotti freschi! Usa il codice HEALTH per il 10% di sconto.",
            previewBodyCarouselStep0: "Scopri i nostri prodotti in evidenza! Scorri per esplorare le offerte.",
            previewSpecialOffer: "Offerta speciale",
            previewEndsIn2Days: "Scade tra 2 giorni",
            previewExpiresLabel: "Scade: ",
            previewSeeAllOptions: "Vedi tutte le opzioni",
            previewBodyLto: "Da ora! Compra due, uno gratis nella nostra nuova collezione di saponi.",
            previewWinterSaleHeader: "I nostri saldi invernali sono attivi!",
            previewBodyCoupon: "Acquista fino a fine dicembre e usa il codice WINTER25 per il 25% di sconto!",
            previewViewBizCatalog: "Visualizza il catalogo di {BIZ_NAME} su WhatsApp",
            previewBrowseCatalogueDetails: "Sfoglia immagini e dettagli delle offerte.",
            previewBodyCatalogue: "Acquista i tuoi prodotti preferiti su WhatsApp! Sfoglia il catalogo.",
            previewBodyCatalogueSingle: "Scopri questo prodotto! Perfetto per le tue esigenze.",
            previewBodyCatalogueMulti: "Dimenticato qualcosa? Sembra che questi articoli siano rimasti nel carrello.",
            previewBodyCatalogueCarousel: "Scopri le ultime novità! Sfoglia il catalogo.",
            previewBodyUtility: "Ottime notizie! Il tuo ordine 23KFEJJ2312 è stato spedito! Controlla il link per il tracking.",
            previewBodyAuth: "123456 è il tuo codice di verifica. Per sicurezza, non condividerlo.",
            previewBodyPlaceholder: "Il testo del messaggio apparirà qui",
            previewBodyCarouselPlaceholder: "Il testo del messaggio carousel apparirà qui",
            previewButtonN: "Pulsante {n}",
            previewProductNDescription: "Descrizione prodotto {n}",
            previewTemplateGoodFor: "Questo modello è adatto a",
            previewTemplateAreasCustomise: "Aree del modello che puoi personalizzare",
            previewDescCatalogue: "Scoperta prodotti/servizi, vendite, offerte, marketing personalizzato",
            previewDescCoupon: "Invia codici promozionali con pulsante copia. Un solo pulsante copia codice.",
            previewDescCarousel: "Mostra più prodotti o servizi in vista scorrevole. Ogni scheda con immagine, descrizione e pulsanti.",
            previewDescMarketing: "Messaggi di benvenuto, promozioni, offerte, coupon, annunci",
            previewDescUtility: "Conferme ordini, aggiornamenti account, ricevute, promemoria",
            previewDescAuth: "Password monouso, recupero account, verifica",
            previewCustomisableCallPermission: "Intestazione, corpo, piè di pagina",
            previewCustomisableCoupon: "Intestazione (testo), corpo, pulsante (eccetto testo copia codice)",
            previewCustomisableCarousel: "Messaggio generale, schede carousel",
            previewCustomisableMarketing: "Media, intestazione, corpo, piè di pagina, pulsante",
            previewCustomisableUtility: "Intestazione, corpo, piè di pagina",
            previewCustomisableAuth: "Corpo",
            productMessage: "Messaggio prodotto",
            callUs: "Chiamaci",
            unsubscribe: "Annulla iscrizione",
            trackShipment: "Traccia spedizione",
            choosePreference: "Scegli preferenza",
            autoVerify: "Verifica automatica",
            yourTemplateNamePlaceholder: "nome_modello",
            templateNameLabel: "Nome modello",
            categoryLabel: "Categoria",
            languageLabel: "Lingua",
            templateCreatedSuccess: "Modello creato e inviato per revisione con successo!",
            templateUpdatedSuccess: "Modello aggiornato con successo!",
            mediaUploadedSuccess: "Media caricato con successo",
            mediaUploadFailedPrefix: "Caricamento media fallito: ",
            nameRequired: "Il nome del modello è obbligatorio",
            nameInvalidChars: "Sono consentite solo lettere minuscole, numeri e underscore",
            nameMaxLength: "Il nome del modello deve essere di 512 caratteri o meno",
            bodyRequired: "Il contenuto del corpo è obbligatorio",
            ltoRequiresOneButton: "L'offerta a tempo limitato richiede almeno un pulsante",
            ltoRequiresUrlButton: "L'offerta a tempo limitato richiede un pulsante URL",
            carouselRequiresOneCard: "Il modello carousel richiede almeno una card",
            cardMustHaveButton: "La card {index} deve avere almeno un pulsante",
            cardMustHaveHeaderMedia: "La card {index} deve avere un'immagine o video di intestazione",
            ltoUrlButtonCannotRemove: "L'offerta a tempo limitato richiede almeno un pulsante URL che non può essere rimosso",
            ltoRequiresOneButtonWarning: "L'offerta a tempo limitato richiede almeno un pulsante",
            copyCodeButtonRequired: "Il pulsante Copia codice è obbligatorio per i modelli coupon e non può essere rimosso",
            carouselCardMustHaveButton: "Ogni card del carousel deve avere almeno un pulsante",
            imageMaxSize: "L'immagine deve essere inferiore a 5 MB",
            videoMaxSize: "Il video deve essere inferiore a 16 MB",
            documentMaxSize: "Il documento deve essere inferiore a 100 MB",
            fileUploadFailed: "Caricamento file fallito",
            uploadFileLoading: "Caricamento file...",
            templateTypeDefault: "Predefinito",
            templateTypeDefaultDesc: "Invia messaggi con media e pulsanti personalizzati per coinvolgere i clienti.",
            templateTypeLimitedTimeOffer: "Offerta a tempo limitato",
            templateTypeLimitedTimeOfferDesc: "Crea urgenza con promozioni e codici offerta sensibili al tempo.",
            templateTypeCarousel: "Carousel",
            templateTypeCarouselDesc: "Invia un carousel di card con immagini e pulsanti per mostrare più prodotti o offerte.",
            templateTypeProductMessage: "Messaggio prodotto",
            templateTypeProductMessageDesc: "Invia messaggi che aumentano le vendite collegando il tuo catalogo prodotti.",
            templateTypeCallPermission: "Richiesta permesso chiamata",
            templateTypeCallPermissionDesc: "Chiedi ai clienti se puoi chiamarli su WhatsApp.",
            templateTypeCouponCode: "Codice coupon",
            templateTypeCouponCodeDesc: "Invia codici promozionali con pulsante copia per un facile riscatto.",
            templateTypeUtilityDefault: "Predefinito",
            templateTypeUtilityDefaultDesc: "Invia messaggi su un ordine o account esistente.",
            templateTypeOtp: "Codice monouso",
            templateTypeOtpDesc: "Invia codici per verificare una transazione o accesso.",
            catalogueSubtypeCatalogue: "Messaggio catalogo",
            catalogueSubtypeCatalogueDesc: "Mostra il catalogo completo con pulsante visualizza catalogo.",
            catalogueSubtypeMultiProduct: "Messaggio multi-prodotto",
            catalogueSubtypeMultiProductDesc: "Mostra fino a 30 prodotti del catalogo in un solo messaggio.",
            catalogueSubtypeSingleProduct: "Messaggio prodotto singolo",
            catalogueSubtypeSingleProductDesc: "Evidenzia un prodotto con dettagli e pulsante call-to-action.",
            catalogueSubtypeProductCardCarousel: "Carousel card prodotto",
            catalogueSubtypeProductCardCarouselDesc: "Mostra fino a 10 card prodotto in vista carousel.",
            catalogueSubtypeDisabledReason: "Attualmente non supportato. Questo tipo di modello richiede integrazione catalogo prodotti.",
            authSubtypeCopyCode: "Copia codice",
            authSubtypeCopyCodeDesc: "L'utente copia il codice manualmente (OTP standard).",
            authSubtypeOneTap: "One Tap",
            authSubtypeOneTapDesc: "Compilazione automatica codice con un tocco su dispositivi Android supportati.",
            authSubtypeZeroTap: "Zero Tap",
            authSubtypeZeroTapDesc: "Compilazione automatica codice senza interazione utente (richiede consenso).",
            viewCatalog: "Visualizza catalogo",
            viewProduct: "Visualizza prodotto",
            viewProducts: "Visualizza prodotti",
            view: "Visualizza",
            copyOfferCode: "Copia codice offerta",
            oneTapAutofill: "Compilazione automatica One Tap",
            zeroTapAutofill: "Compilazione automatica Zero Tap",
            shopNow: "Acquista ora",
            viewItems: "Visualizza articoli",
            autofill: "Compilazione automatica",
            messageTtlOptional: "Time-to-Live messaggio (TTL) • Opzionale",
            selectTtlPlaceholder: "Seleziona TTL o lascia predefinito",
            ttlDescMarketing: "Se non possiamo consegnare il messaggio di marketing, riproveremo per la durata specificata.",
            ttlDescUtility: "Imposta per quanto tempo consegneremo messaggi utility (conferme ordini, ecc.).",
            ttlDescAuthentication: "Definisci per quanto tempo i codici di autenticazione sono validi per la consegna.",
            ttlInfoMarketing: "Modelli marketing: da 12 ore a 30 giorni. Predefinito definito dal sistema.",
            ttlInfoUtility: "Modelli utility: da 30 secondi a 12 ore, o -1 per 30 giorni. Predefinito definito dal sistema.",
            ttlInfoAuthentication: "Modelli autenticazione: da 30 secondi a 15 minuti, o -1 per 30 giorni. Predefinito definito dal sistema.",
            ttlOption12Hours: "12 ore (43.200 secondi)",
            ttlOption1Day: "1 giorno (86.400 secondi)",
            ttlOption3Days: "3 giorni (259.200 secondi)",
            ttlOption7Days: "7 giorni (604.800 secondi)",
            ttlOption15Days: "15 giorni (1.296.000 secondi)",
            ttlOption30Days: "30 giorni (2.592.000 secondi)",
            ttlOption30Seconds: "30 secondi",
            ttlOption1Minute: "1 minuto (60 secondi)",
            ttlOption2Minutes: "2 minuti (120 secondi)",
            ttlOption3Minutes: "3 minuti (180 secondi)",
            ttlOption5Minutes: "5 minuti (300 secondi)",
            ttlOption10Minutes: "10 minuti (600 secondi)",
            ttlOption15Minutes: "15 minuti (900 secondi)",
            ttlOption30Minutes: "30 minuti (1.800 secondi)",
            ttlOption1Hour: "1 ora (3.600 secondi)",
            ttlOption2Hours: "2 ore (7.200 secondi)",
            ttlOption4Hours: "4 ore (14.400 secondi)",
            ttlOption6Hours: "6 ore (21.600 secondi)",
            ttlOption30DaysSpecial: "30 giorni (valore speciale: -1)",
            authSettings: "Impostazioni autenticazione",
            addSecurityRecommendation: "Aggiungi raccomandazione di sicurezza",
            securityRecommendationHint: "Aggiunge il messaggio \"Per la tua sicurezza, non condividere questo codice\".",
            authMessageTtlHint: "Limite di tempo per la consegna del messaggio (60-600 secondi). Lasciare vuoto per predefinito.",
            authTtlPlaceholder: "60-600",
            authCodeExpPlaceholder: "1-90",
            authPackagePlaceholder: "com.example.app",
            authSignatureHash: "Hash firma",
            messageTtlSecondsOptional: "TTL messaggio (secondi) • Opzionale",
            codeExpirationOptional: "Scadenza codice (minuti) • Opzionale",
            codeExpirationHint: "Per quanto tempo il codice OTP è valido. Mostrato nel piè di pagina.",
            zeroTapTerms: "Accetto i termini e condizioni Zero Tap",
            zeroTapTermsHint: "Richiesto per la compilazione automatica Zero Tap.",
            supportedAndroidAppsOptional: "App Android supportate • Opzionale",
            addApp: "Aggiungi app",
            limitedTimeOfferLabel: "Offerta a tempo limitato",
            ltoDescription: "Aggiungi testo che creerà urgenza. L'ora di scadenza sarà impostata all'invio.",
            ltoPlaceholder: "es. Offerta in scadenza!, Vendita lampo!",
            showExpirationTimer: "Mostra timer di scadenza",
            ltoExpirationHint: "Quando attivato, WhatsApp mostrerà un countdown in base all'invio.",
            carouselCards: "Card carousel",
            carouselCardsDescription: "Queste card appariranno come secondo messaggio dopo il corpo. Ogni card deve avere intestazione immagine/video e almeno un pulsante (fino a 2). Il corpo della card è opzionale e supporta variabili. Fino a 10 card.",
            carouselCardN: "Card {n}",
            carouselButtonsLabel: "Pulsanti * (almeno 1, fino a 2)",
            cardHeaderRequired: "Intestazione card",
            cardBodyOptional: "Corpo card • Opzionale",
            cardBodyPlaceholder: "Inserisci il testo del corpo della card (opzionale)",
            image: "Immagine",
            video: "Video",
            moveUp: "Sposta su",
            moveDown: "Sposta giù",
            remove: "Rimuovi",
            dragDropUpload: "Trascina e rilascia per caricare",
            orChooseFiles: "Oppure scegli file dal dispositivo",
            uploadingToMeta: "Caricamento su Meta...",
            uploadedSuccessfully: "Caricato con successo",
            addQuickReplyButton: "Aggiungi pulsante risposta rapida",
            addCtaButton: "Aggiungi pulsante CTA",
            urlButtonRequiredLto: "Il pulsante URL è obbligatorio per l'offerta a tempo limitato",
            copyCodeButtonFixed: "Il testo del pulsante copia codice non può essere personalizzato nei modelli coupon",
            copyCode: "Copia codice",
            fixed: "Fisso",
            buttonsHeading: "Pulsanti",
            buttonLabelAutoAdded: "Aggiunto automaticamente",
            buttonLabelRequiredCopyCode: "Obbligatorio (1 Copia codice + opzionale)",
            buttonLabelRequiredUrl: "Obbligatorio (1 URL + opzionale)",
            buttonLabelOptional: "Opzionale",
            buttonDescCatalogue: "Un pulsante prodotto viene aggiunto automaticamente. Puoi personalizzare il testo del pulsante.",
            buttonDescCallPermission: "Un pulsante permesso chiamata viene aggiunto automaticamente. Non è possibile aggiungere altri pulsanti.",
            buttonDescAuth: "Un pulsante autenticazione viene aggiunto automaticamente. Puoi personalizzare il testo del pulsante.",
            buttonDescCoupon: "Un pulsante Copia codice è obbligatorio e il suo testo non può essere personalizzato. Puoi aggiungere pulsanti Risposta rapida o CTA fino a 10 in totale.",
            buttonDescLto: "Le offerte a tempo limitato richiedono almeno un pulsante URL. Puoi aggiungere altri pulsanti CTA o Risposta rapida.",
            buttonDescDefault: "Aggiungi pulsanti Risposta rapida o CTA. Massimo 10 pulsanti in totale.",
            buttonPlaceholderText: "Testo del pulsante",
            buttonMax10Warning: "Massimo 10 pulsanti consentiti",
            buttonCopyCodeAutoAddedWarning: "Il pulsante Copia codice viene aggiunto automaticamente e non può essere aggiunto manualmente",
            exampleValuePlaceholder: "valore_esempio",
            copyCodeExamplePlaceholder: "SUMMER20",
            quickReply: "Risposta rapida",
            visitWebsite: "Visita sito web",
            callPhone: "Chiama",
            addCard: "Aggiungi card",
            addButton: "Aggiungi pulsante",
            reports: "Raporlar",
            dynamicUrlSampleNote: "Sample dynamic URL with variable (Note: Do not add the URL in your sample message body above)",
            bussinesDescription: "Business description",
            postacellMessagepostacellMessage: "Envoyer un SMS",
            selectBusinessVertical: "Seleziona settore di attività",
            stateIfApplicable: "State (if applicable)"
        },
        multi_whatsapp_api: {
            profile: "Profilo",
            integration: "Integrazione",
            detail: "Dettaglio",
            visibility: "Visibilità",
            templates: "Tutti i messaggi dei modelli",
            settings_group: "Setting",
            template_message_group: "Messaggi template",
            new_template: "Crea nuovo modello",
            broadcast_group: "Bulk Message",
            broadcast_requests: "Invio di messaggi in blocco",
            customer_groups: "Gruppi di clienti",
            chat_initiator_template: "Chat Initiator Template",
            contacts: "Contatti",
            numbers: "Numeri",
            all_contacts: "Tutti i contatti"
        },
        archive: {
            destroyedBy: {
                agent: "Agente",
                visitor: "Visitatore",
                system: "Sistema",
                chatbot: "Chatbot"
            }
        },
        upgradeMessages: {
            ticket: "Anche se sei offline, le tue richieste vengono registrate istantaneamente con l'intelligenza artificiale e il chatbot. Mantieni sempre i tuoi clienti soddisfatti!",
            tasks: "Gestisci facilmente le tue attività e i tuoi progetti. Collabora con il tuo team e consegna i progetti in tempo!",
            calendar: "Pianifica facilmente i tuoi appuntamenti e riunioni. Rimani sincronizzato con il tuo team e gestisci meglio il tuo tempo!",
            mail_integration: "Gestisci facilmente le tue e-mail. Rafforza la comunicazione con i tuoi clienti e migliora la collaborazione!",
            team_integration: "Comunica più velocemente ed efficacemente con il tuo team. Migliora la collaborazione e assicurati di consegnare i progetti in tempo!",
            webhook_integration: "Collega le tue applicazioni utilizzando l'integrazione Webhook e semplifica lo scambio di dati!",
            whatsapp_v2: "Migliora la comunicazione con i tuoi clienti tramite l'integrazione di WhatsApp per una comunicazione più rapida ed efficiente!",
            whatsapp: "Migliora la comunicazione con i tuoi clienti usando l'integrazione di WhatsApp per una comunicazione più rapida ed efficace!",
            whatsapp_business_api: "Sfrutta l'API WhatsApp Business per comunicare in modo più efficiente ed efficace con i tuoi clienti!",
            instagram: "Interagisci più efficacemente con i tuoi clienti utilizzando l'integrazione di Instagram!",
            messenger: "Comunica facilmente con i tuoi clienti tramite l'integrazione di Messenger!",
            sms_postacell: "Comunica rapidamente ed efficacemente con i tuoi clienti tramite l'integrazione SMS!",
            ready_contents: "I contenuti pronti ti aiutano a comunicare con i tuoi clienti più velocemente ed efficacemente.",
            automation: "Automatizza i tuoi flussi di lavoro per risparmiare tempo e gestire le attività in modo più efficiente!",
            form: "Usa il costruttore di moduli per semplificare le interazioni con i clienti, raccogliere informazioni preziose e migliorare la collaborazione!",
            customer_tables: "Crea tabelle personalizzate e gestisci le informazioni dei clienti in modo efficiente!",
            trendyol: "Migliora la comunicazione con i tuoi clienti tramite l'integrazione Trendyol per un'interazione senza problemi!",
            access_control: "Proteggi i tuoi dati e impedisci l'accesso non autorizzato con le funzionalità di controllo degli accessi!",
            upgrade: "Aggiorna il mio abbonamento",
            upgradeFeature: "Acquista pacchetto aggiuntivo",
            featureNotAvailable: "La funzione non è disponibile.",
            usageLimitExceeded: "Limite di utilizzo superato.",
            maxAgentCount: "Aggiorna il tuo piano per servire più clienti aggiungendo più agenti.",
            maxTriggerCount: "Aggiorna il tuo piano per generare più interazioni aggiungendo più trigger.",
            visitorStartChat: "Aggiorna il tuo piano per avviare chat con visitatori che non hanno ancora interagito.",
            voiceCalling: "Aggiorna il tuo piano per comunicare in modo più efficace con i clienti tramite chiamate vocali.",
            videoCalling: "Aggiorna il tuo piano per comunicare in modo più efficace con i clienti tramite videochiamate.",
            fileAndVoiceMessage: "Aggiorna il tuo piano per inviare file e messaggi vocali ai clienti.",
            autoTranslation: "Aggiorna il tuo piano per servire più clienti grazie alla traduzione automatica dei messaggi.",
            telegramEntegration: "Aggiorna il tuo piano per abilitare l'integrazione con Telegram.",
            chatCopilot: "Aggiorna il tuo piano per offrire un servizio migliore grazie all'assistente di chat basato sull'intelligenza artificiale.",
            calenderEntegration: "Aggiorna il tuo piano per sincronizzare il calendario con altre applicazioni.",
            mailEntegration: "Aggiorna il tuo piano per gestire meglio le email e migliorare la comunicazione con i clienti.",
            smsEntegration: "Aggiorna il tuo piano per raggiungere i clienti più rapidamente tramite l'integrazione SMS.",
            ticketSystem: "Aggiorna il tuo piano per gestire meglio le richieste dei clienti con il sistema di ticket.",
            taskManagementEntegration: "Aggiorna il tuo piano per ottimizzare il flusso di lavoro con l'integrazione della gestione delle attività.",
            webhookEntegration: "Aggiorna il tuo piano per sincronizzare le altre applicazioni tramite webhook.",
            readyContents: "Aggiorna il tuo piano per migliorare la comunicazione con i clienti grazie ai contenuti predefiniti.",
            automationEntegration: "Aggiorna il tuo piano per automatizzare ulteriormente il flusso di lavoro.",
            customerTablesEntegration: "Aggiorna il tuo piano per gestire meglio le informazioni dei clienti con le tabelle clienti.",
            formEntegration: "Aggiorna il tuo piano per gestire meglio le richieste dei clienti con i moduli.",
            maxFormLimit: "Aggiorna il tuo piano per creare più moduli e gestire meglio le richieste dei clienti.",
            maxFormFieldLimit: "Aggiorna il tuo piano per aggiungere più campi ai moduli e migliorare la gestione delle richieste.",
            maxCustomerTableCount: "Aggiorna il tuo piano per aggiungere più tabelle clienti.",
            maxCustomerTableFieldCount: "Aggiorna il tuo piano per aggiungere più campi nelle tabelle clienti.",
            maxCustomerTableViewCount: "Aggiorna il tuo piano per salvare più viste delle tabelle clienti.",
            maxCustomerTableRecordCount: "Aggiorna il tuo piano per aggiungere più record nelle tabelle clienti.",
            maxAutomationButton: "Aggiorna il tuo piano per aggiungere più blocchi di automazione.",
            automationTimerBase: "Aggiorna il tuo piano per utilizzare timer di automazione.",
            automationEventBase: "Aggiorna il tuo piano per utilizzare eventi di automazione.",
            automationWebhookBase: "Aggiorna il tuo piano per utilizzare webhook di automazione.",
            automationButtonBase: "Aggiorna il tuo piano per utilizzare pulsanti di automazione.",
            liveScore: "Aggiorna il tuo piano per attivare la funzione di monitoraggio in tempo reale.",
            multipleChatWindow: "Aggiorna il tuo piano per aprire più finestre di chat contemporaneamente.",
            maxTaskWorkflowLimit: "Aggiorna il tuo piano per aggiungere più flussi di attività.",
            maxTaskColumnLimit: "Aggiorna il tuo piano per aggiungere più colonne nelle attività.",
            maxTaskRowLimit: "Aggiorna il tuo piano per aggiungere più righe nelle attività.",
            maxDepartmentLimit: "Aggiorna il tuo piano per aggiungere più dipartimenti.",
            maxRoleLimit: "Aggiorna il tuo piano per aggiungere più ruoli.",
            maxReadyContentsLimit: "Aggiorna il tuo piano per aggiungere più contenuti predefiniti.",
            excelDownload: "Aggiorna il tuo piano per abilitare il download di file Excel.",
            customerGroup: "Aggiorna il tuo piano per utilizzare la funzione dei gruppi di clienti.",
            maxMailCount: "Aggiorna il tuo piano per inviare più email.",
            maxWhatsappChannel: "Aggiorna il tuo piano per aggiungere più canali WhatsApp.",
            maxBusinessWhatsappChannel: "Aggiorna il tuo piano per aggiungere più canali WhatsApp Business.",
            maxInstagramChannel: "Aggiorna il tuo piano per aggiungere più canali Instagram.",
            maxMessengerChannel: "Aggiorna il tuo piano per aggiungere più canali Messenger.",
            maxTelegramChannel: "Aggiorna il tuo piano per aggiungere più canali Telegram.",
            maxTrendyolChannel: "Aggiorna il tuo piano per aggiungere più canali Trendyol.",
            maxMetaLeadChannel: "Aggiorna il tuo piano per aggiungere più canali Meta Lead."
        },
        setupWizard: {
            finishModalVideos: "Video di Formazione",
            finishModalDoc: "Documentazione",
            finsihModalLiveSupport: "Supporto Live",
            completed: "Completato",
            completedWarning: "Fai clic sul pulsante per completare la configurazione e terminare la guida",
            supsisSetupGuide: "Guida Configurazione Supsis",
            supsisSetupGuideDescription: "Completa questi passaggi per utilizzare completamente Supsis.",
            goToSetup: "Vai alla Configurazione",
            completionPercentageDescription: "Stai utilizzando solo il % {percentage} delle funzionalità offerte da Supsis.",
            aiChatbot: {
                title: "Chatbot AI",
                content: "Rispondi ai messaggi in arrivo automaticamente, istantaneamente e intelligentemente con il Chatbot AI di Supsis.",
                steps: {
                    step1: {
                        title: "Crea Chatbot",
                        content: "Usa questo pulsante per creare un nuovo <b>scenario chatbot</b>. Puoi iniziare rapidamente selezionando uno dei modelli appositamente preparati per te, oppure progettare uno scenario completamente originale da zero per creare un chatbot che soddisfi completamente le tue esigenze aziendali."
                    },
                    step2: {
                        title: "Scenari Pronti all'Uso",
                        content: "Comprendi facilmente la logica di funzionamento di base del chatbot con i <b>modelli pronti all'uso</b> qui. Risparmia tempo personalizzando questi modelli secondo le tue esigenze e sviluppa soluzioni su misura. Puoi iniziare scegliendo uno qualsiasi dei modelli elencati di seguito, adatti a diversi casi d'uso."
                    },
                    step3: {
                        title: "Integrazioni Chatbot",
                        content: "Integra il tuo chatbot preparato con <b>piattaforme di social media popolari come WhatsApp, Instagram e Facebook</b>. In questo modo, puoi attivare il tuo chatbot direttamente sui canali che i tuoi clienti utilizzano, aumentando la tua accessibilità e i tassi di coinvolgimento."
                    },
                    step4: {
                        title: "Analisi Chatbot",
                        content: "Visualizza e analizza le <b>prestazioni del tuo chatbot con grafici e statistiche dettagliate</b>. Filtrando secondo periodi di tempo specifici o le piattaforme che hai integrato, puoi misurare l'efficacia del tuo chatbot, identificare aree di miglioramento e ottimizzare le tue strategie."
                    }
                }
            },
            aiAssistant: {
                title: "Assistente AI",
                content: "Attiva l'assistente digitale per aiutare il tuo team di supporto.",
                steps: {
                    step1: {
                        title: "Integrazione OpenAI",
                        content: "<p>Stabilisci un'<b>integrazione perfetta</b> tra OpenAI e Supsis AI per aumentare l'efficienza del tuo business. In questo modo, il tuo potente assistente AI verrà attivato e inizierà a ottimizzare i tuoi processi. Per completare l'integrazione, tutto quello che devi fare è inserire la tua chiave API OpenAI. <br> <br> <b>Per ottenere la tua chiave API OpenAI, <a href='https://platform.openai.com/account/api-keys' target='_blank'>clicca qui</a>.</b></p>"
                    }
                }
            },
            aiLiveSupport: {
                title: "Supporto Live AI",
                content: "Attiva il sistema di chat live alimentato dall'AI.",
                steps: {
                    step1: {
                        title: "Filtra Conversazioni",
                        content: "Gestisci facilmente <b>tutte le conversazioni dei clienti</b> da quest'area. Puoi dare priorità alle conversazioni filtrandole in diverse categorie come non lette, in sospeso, o quelle in corso con il chatbot, assicurandoti che nessuna richiesta venga trascurata."
                    },
                    step2: {
                        title: "Vista Più Dettagliata",
                        content: "Usa queste opzioni per esaminare le conversazioni dei clienti più in profondità. Puoi applicare <b>filtri più dettagliati</b> come conversazioni senza risposta di ieri o clienti specifici che ti hanno contattato, oppure creare i tuoi filtri personalizzati per personalizzare il tuo flusso di lavoro."
                    },
                    step3: {
                        title: "Schermata Supporto Live",
                        content: "Passa a questa vista per <b>gestire efficientemente tutte le tue conversazioni di supporto live da uno schermo centralizzato</b>. Visualizza tutti i messaggi, le risposte degli agenti, gli stati attuali e le informazioni sulla data per ogni conversazione in un unico posto, permettendoti di prendere decisioni rapide e accurate."
                    },
                    step4: {
                        title: "Pagina di Test",
                        content: "Accedi a questa sezione per testare le prestazioni e il funzionamento del tuo chatbot creato in tempo reale. Inviando messaggi come visitatore, puoi <b>osservare da vicino le risposte e i comportamenti del tuo chatbot</b>, permettendoti di apportare tutti i miglioramenti necessari prima di presentarlo agli utenti finali."
                    }
                }
            },
            aiAutomation: {
                title: "Automazione AI",
                content: "Automatizza i tuoi processi di supporto e risparmia tempo.",
                steps: {
                    step1: {
                        title: "Crea Nuova Automazione",
                        content: "Usa questo pulsante per creare una nuova automazione per semplificare i tuoi processi aziendali. Puoi progettare automazioni basate su eventi (ad es., quando arriva un nuovo messaggio), basate sul tempo (ad es., a un'ora specifica ogni mattina), o <b>basate su Webhook</b> per rendere i tuoi flussi di lavoro più intelligenti."
                    },
                    step2: {
                        title: "Categorie di Automazione",
                        content: "Quando hai molte automazioni, crea <b>categorie di automazione</b> da questa sezione per rendere la gestione più facile. La categorizzazione ti aiuta a mantenere le tue automazioni organizzate e a trovarle rapidamente quando necessario. Usa questo pulsante per creare una nuova categoria."
                    },
                    step3: {
                        title: "Attività Eseguite",
                        content: "Dopo aver creato e pubblicato le tue automazioni, puoi <b>tracciare istantaneamente quante attività le tue automazioni hanno eseguito</b> da questa sezione. Questo ti permette di osservare quanto sono attive le tue automazioni e quali processi influenzano."
                    },
                    step4: {
                        title: "Statistiche Automazione",
                        content: "Rivedi le <b>statistiche complete delle prestazioni</b> delle tue automazioni in questa sezione. Vedi quanto spesso ogni automazione viene eseguita, il numero di attività riuscite, il tasso di successo e eventuali tassi di errore per ottimizzare le tue strategie di automazione."
                    }
                }
            },
            aiDynamicCrm: {
                title: "CRM AI",
                content: "Analizza e gestisci le tue interazioni con i clienti con l'intelligenza artificiale.",
                steps: {
                    step1: {
                        title: "Filtra Visitatori",
                        content: "Filtra facilmente i <b>visitatori</b> nel tuo database clienti. Puoi cercare visitatori per nome, indirizzo email, numero di telefono, tag o campi profilo personalizzati. Puoi anche accedere a questa sezione per una visualizzazione e analisi più dettagliate."
                    },
                    step2: {
                        title: "Visualizza Visitatori",
                        content: "Tutti i tuoi visitatori sono elencati in questa tabella. <b>Fai doppio clic sulla riga pertinente per accedere a maggiori informazioni e intraprendere azioni su un visitatore</b>. Nella finestra aperta, puoi accedere alla cronologia delle comunicazioni del visitatore, alle note e ad altre informazioni dettagliate."
                    },
                    step3: {
                        title: "Blocco Manuale",
                        content: "Puoi <b>bloccare manualmente i visitatori</b> che mostrano comportamenti indesiderati o inappropriati. I visitatori bloccati vengono visualizzati in un elenco separato, e puoi rimuovere il blocco da questa sezione se necessario."
                    },
                    step4: {
                        title: "Tag",
                        content: "Rendi il tuo CRM più organizzato e gestibile <b>categorizzando i tuoi visitatori con i tag</b>. Per assegnare tag ai visitatori, devi prima creare i tuoi tag. Usa questo pulsante per creare un nuovo tag."
                    },
                    step5: {
                        title: "Campi Profilo",
                        content: "I <b>campi profilo</b> ti permettono di raccogliere informazioni aggiuntive sui tuoi visitatori e gestire queste informazioni in modo organizzato. In questo modo, puoi approfondire la tua segmentazione clienti, offrire servizi personalizzati e rendere le tue relazioni con i clienti più efficaci."
                    }
                }
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "Gestisci i tuoi messaggi di supporto collegando il tuo account WhatsApp Business.",
                steps: {
                    step1: {
                        title: "Integrazione WhatsApp Business",
                        content: "<p><b>Collega il tuo account WhatsApp Business a Supsis</b> e gestisci tutti i tuoi messaggi di supporto clienti da un unico pannello centrale. Con questa integrazione, puoi inviare messaggi istantanei tramite WhatsApp, fare annunci di massa, impostare risposte automatizzate e tracciare in modo completo le tue interazioni con i clienti.</p>"
                    }
                }
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "Gestisci i messaggi ricevuti tramite WhatsApp Web con Supsis AI.",
                steps: {
                    step1: {
                        title: "Integrazione WhatsApp Web",
                        content: "<p><b>Gestisci perfettamente tutti i messaggi ricevuti tramite WhatsApp Web con Supsis AI.</b> Con questa integrazione, puoi inviare messaggi istantanei tramite WhatsApp, creare messaggi di massa, impostare risposte automatizzate e tracciare facilmente le tue interazioni con i clienti. In questo modo rendi la tua comunicazione con i clienti più efficiente.</p>"
                    }
                }
            },
            instagram: {
                title: "Instagram",
                content: "Rispondi ai DM di Instagram tramite Supsis AI.",
                steps: {
                    step1: {
                        title: "Integrazione Instagram",
                        content: "<p><b>Centralizza la tua comunicazione con i clienti rispondendo direttamente ai DM di Instagram tramite Supsis AI.</b> Con questa integrazione, puoi inviare messaggi istantanei tramite Instagram, fare annunci di massa, impostare risposte automatizzate e tracciare in modo completo le tue interazioni con i clienti.</p>"
                    }
                }
            },
            facebook: {
                title: "Facebook",
                content: "Gestisci i messaggi dalla tua pagina Facebook in un unico pannello.",
                steps: {
                    step1: {
                        title: "Integrazione Facebook",
                        content: "<p><b>Gestisci efficacemente tutti i messaggi dalla tua pagina Facebook con Supsis AI.</b> Con questa integrazione, puoi inviare messaggi istantanei tramite Facebook Messenger, creare messaggi di massa, impostare risposte automatizzate e tracciare le tue interazioni con i clienti.</p>"
                    }
                }
            },
            telegram: {
                title: "Telegram",
                content: "Integra i messaggi Telegram con Supsis AI.",
                steps: {
                    step1: {
                        title: "Integrazione Telegram",
                        content: "<p><b>Integra i messaggi Telegram con Supsis AI</b> e gestisci la tua comunicazione con i clienti da un unico pannello. Con questa integrazione, puoi inviare messaggi istantanei tramite Telegram, creare messaggi di massa, impostare risposte automatizzate e tracciare senza sforzo tutte le tue interazioni con i clienti.</p>"
                    }
                }
            },
            mail: {
                title: "Email",
                content: "Integra le tue email di supporto nel sistema Supsis AI.",
                steps: {
                    step1: {
                        title: "Crea Nuova Email",
                        content: "<p>Usa questo pulsante per inviare una nuova email. <b>Compilando il contenuto dell'email, i destinatari e altre informazioni necessarie</b>, puoi inviare rapidamente le tue email personali o di massa.</p>"
                    },
                    step2: {
                        title: "Modelli Email",
                        content: "<p><b>Gestisci</b> i tuoi modelli email da questa sezione. Puoi modificare, eliminare o creare nuovi modelli. Utilizzando modelli prepreparati, puoi accelerare i tuoi processi di invio email e garantire una comunicazione coerente.</p>"
                    },
                    step3: {
                        title: "Invia Email di Massa",
                        content: "<p>Usa quest'area per <b>inviare email di massa</b> per raggiungere grandi pubblici. Compilando i campi richiesti, puoi facilmente inviare email di massa alla tua lista clienti o a gruppi specifici in Supsis.</p>"
                    },
                    step4: {
                        title: "Gestisci i Tuoi Gruppi Clienti",
                        content: "<p><b>Gestisci efficacemente</b> i tuoi gruppi clienti da questa sezione. Puoi modificare, eliminare o creare nuovi gruppi. Con questi gruppi, puoi organizzare campagne email mirate e personalizzare ancora di più la tua comunicazione.</p>"
                    }
                }
            },
            metaLead: {
                title: "Meta Lead",
                content: "Gestisci i moduli ricevuti dai tuoi annunci Facebook e Instagram.",
                steps: {
                    step1: {
                        title: "Integrazione Meta Lead",
                        content: "<p>Con l'<b>Integrazione Meta Lead</b>, gestisci i moduli di potenziali clienti ricevuti dai tuoi annunci Facebook e Instagram direttamente tramite Supsis. Grazie a questa integrazione, puoi tracciare i lead che ottieni dalle tue campagne pubblicitarie in modo più efficiente, accelerare la tua comunicazione con i potenziali clienti e aumentare i tuoi tassi di conversione.</p>"
                    }
                }
            },
            trendyol: {
                title: "Trendyol",
                content: "Gestisci i tuoi ordini Trendyol e i messaggi dei clienti.",
                steps: {
                    step1: {
                        title: "Integrazione Trendyol",
                        content: "<p>Grazie alle <b>Operazioni di Integrazione Trendyol</b>, gestisci centralmente i tuoi ordini ricevuti tramite Trendyol attraverso Supsis. Dopo aver completato questa integrazione, puoi rendere i tuoi processi di ordine più efficienti, facilitare la tua comunicazione con i clienti e ridurre il tuo carico di lavoro operativo.</p>"
                    }
                }
            },
            formSurvey: {
                title: "Sondaggi con Moduli",
                content: "Crea moduli per raccogliere feedback dai clienti.",
                steps: {
                    step1: {
                        title: "Crea Nuovo Modulo",
                        content: "<p>Usa questo pulsante per <b>creare un nuovo modulo o sondaggio</b> per raccogliere feedback dai tuoi clienti. Con i moduli che crei, puoi raccogliere feedback preziosi dai clienti e rendere la tua comunicazione più efficiente.</p>"
                    },
                    step2: {
                        title: "Gestisci i Tuoi Moduli",
                        content: "<p><b>Gestisci tutti i tuoi moduli efficacemente</b> da quest'area. Puoi modificare, archiviare, eliminare o creare nuovi moduli. Puoi anche tracciare le prestazioni dei tuoi moduli pubblicati, visualizzare i tassi di risposta e fare modifiche istantanee quando necessario. Con la gestione dei moduli, puoi raccogliere e analizzare il feedback dei clienti più efficacemente.</p>"
                    }
                }
            },
            processManagement: {
                title: "Gestione Processi",
                content: "Pianifica e gestisci i tuoi processi di supporto passo dopo passo.",
                steps: {
                    step1: {
                        title: "Gestisci i Tuoi Processi Aziendali",
                        content: "<p>Questa sezione ti permette di gestire efficacemente tutti i tuoi processi aziendali. <b>Puoi creare attività, assegnarle ai membri del tuo team e ottimizzare i tuoi flussi di lavoro.</b> In questo modo, puoi rendere i tuoi processi più efficienti, tracciare lo stato delle attività istantaneamente e aumentare le prestazioni del tuo team.</p>"
                    },
                    step2: {
                        title: "Elenca Attività",
                        content: "<p><b>Visualizza tutte le tue attività in una vista elenco</b> da questa sezione. Puoi filtrare, eliminare o creare nuove attività. Traccia facilmente il tuo carico di lavoro con una vista elenco completa.</p>"
                    },
                    step3: {
                        title: "Etichette Attività",
                        content: "<p><b>Crea etichette</b> per organizzare e gestire meglio le tue attività. Utilizzando queste etichette, puoi facilmente categorizzare le attività e accelerare i tuoi processi di ricerca. Puoi usare questo pulsante per creare etichette.</p>"
                    },
                    step4: {
                        title: "Archivia Attività",
                        content: "<p><b>Archivia le attività completate o inattive per mantenere il tuo spazio di lavoro organizzato</b>. Le attività archiviate sono elencate qui e possono essere facilmente ripristinate quando necessario.</p>"
                    },
                    step5: {
                        title: "Attività Completate",
                        content: "<p>Visualizza le tue <b>attività completate</b> da questa sezione. Puoi cambiare lo stato delle attività completate e archiviarle se desideri. In questo modo, puoi tenere un registro del tuo lavoro completato e analizzare le prestazioni passate.</p>"
                    }
                }
            },
            calendar: {
                title: "Calendario",
                content: "Gestisci il tuo calendario di riunioni e attività.",
                steps: {
                    step1: {
                        title: "Calendario",
                        content: "<p>Pianifica facilmente le tue riunioni quotidianamente con questo <b>calendario</b> interattivo. Puoi creare nuovi appuntamenti, aggiornare le riunioni esistenti tramite il calendario o cancellarle. Ottimizza la gestione dei tuoi appuntamenti e controlla efficacemente il tuo programma.</p>"
                    },
                    step2: {
                        title: "Sito Web di Prenotazione",
                        content: "<p>Permetti ai tuoi clienti di prenotare facilmente appuntamenti utilizzando il tuo <b>sito web di prenotazione</b>. I tuoi clienti possono fare prenotazioni, visualizzare, aggiornare o cancellare i loro appuntamenti esistenti tramite questo sito.</p>"
                    },
                    step3: {
                        title: "Visualizza il Tuo Sito Web",
                        content: "<p>Usa questo pulsante per visualizzare istantaneamente il sito web di prenotazione che hai creato. <b>Controlla la versione finale del tuo sito web</b> e sperimenta come i tuoi clienti vedranno le loro prenotazioni. Tutte le tue prenotazioni attive saranno elencate sul tuo sito web.</p>"
                    },
                    step4: {
                        title: "Crea Nuova Prenotazione",
                        content: "<p>Usa questo pulsante per <b>creare manualmente una nuova prenotazione</b>. Compilando tutte le informazioni necessarie, puoi aggiungere rapidamente l'appuntamento al tuo calendario e pianificare le tue riunioni con i clienti.</p>"
                    }
                }
            },
            websiteAnalysis: {
                title: "Analisi Sito Web",
                content: "Analizza il comportamento dei visitatori e ottieni insights.",
                steps: {
                    step1: {
                        title: "Visitatori Totali",
                        content: "<p>Visualizza il <b>numero totale di visitatori</b> del tuo sito web da quest'area. Questa metrica mostra il numero complessivo di visitatori unici del tuo sito entro un periodo di tempo specifico e ti aiuta a comprendere la portata totale del tuo sito.</p>"
                    },
                    step2: {
                        title: "Visitatori Medi",
                        content: "<p>Traccia il <b>numero medio giornaliero o periodico di visitatori</b> del tuo sito web qui. Questa metrica è un indicatore critico per valutare le prestazioni costanti del tuo sito nel tempo.</p>"
                    },
                    step3: {
                        title: "Visitatori Massimi",
                        content: "<p>Osserva i <b>momenti in cui il tuo sito web ha raggiunto il numero più alto di visitatori</b> con questa metrica. Mostra il numero più alto di visitatori del tuo sito entro un periodo di tempo specifico, aiutandoti a identificare i periodi di picco per campagne o contenuti.</p>"
                    },
                    step4: {
                        title: "Visitatori Minimi",
                        content: "<p>Traccia i <b>momenti in cui il tuo sito web ha ricevuto il minor numero di visitatori</b> con questa metrica. Mostra il numero più basso di visitatori del tuo sito entro un periodo di tempo specifico, aiutandoti a identificare i periodi di bassa performance e intraprendere le azioni necessarie.</p>"
                    }
                }
            },
            ticketSystem: {
                title: "Sistema Ticket di Supporto",
                content: "Organizza le richieste dei clienti con un sistema di ticket.",
                steps: {
                    step1: {
                        title: "Nuovo Stato",
                        content: "<p><b>Crea nuovi stati</b> per facilitare la gestione delle tue richieste di supporto. Ad esempio, definendo stati personalizzati come \"In Corso\", \"Risolto\", \"In Attesa\", puoi rendere il flusso delle richieste più trasparente.</p>"
                    },
                    step2: {
                        title: "Stati",
                        content: "<p><b>Visualizza gli stati attuali</b> per ogni richiesta di supporto aperta qui. Tracciando stati come \"Letto\", \"Risposto\", \"Annullato\", puoi facilmente vedere le fasi attuali delle richieste e abilitare una gestione efficace dei processi.</p>"
                    },
                    step3: {
                        title: "Modalità Visualizzazione",
                        content: "<p>Puoi passare tra <b>vista elenco o kanban</b> per gestire le tue richieste di supporto più efficacemente. Cambiando la modalità di visualizzazione, puoi tracciare visivamente gli stati delle richieste e scegliere il layout che meglio si adatta al tuo flusso di lavoro.</p>"
                    }
                }
            },
            dynamicTables: {
                title: "Tabelle Dinamiche",
                content: "Personalizza e gestisci i tuoi dati filtrandoli.",
                steps: {
                    step1: {
                        title: "Crea Categoria",
                        content: "<p><b>Organizza e gestisci meglio i tuoi dati categorizzando le tue tabelle</b>. Utilizzando il pulsante di creazione categoria, puoi definire nuove categorie, raggruppare le tue tabelle e accedere più rapidamente ai dati che stai cercando.</p>"
                    },
                    step2: {
                        title: "Crea Nuova Tabella",
                        content: "<p>Usa questo pulsante per <b>creare una nuova tabella dinamica su misura per le tue esigenze</b>. Compilando le informazioni richieste nella schermata di creazione tabella, puoi archiviare e gestire i tuoi dati in una struttura personalizzata.</p>"
                    },
                    step3: {
                        title: "Crea Tabella con AI",
                        content: "<p>Usa questo pulsante per <b>creare rapidamente nuove tabelle con il supporto dell'AI</b>. È sufficiente inserire le informazioni pertinenti per creare una tabella con l'AI; il sistema ti aiuterà a progettare tabelle efficienti con suggerimenti intelligenti.</p>"
                    }
                }
            },
            aiVoice: {
                title: "Agente Vocale AI",
                content: "Gestisci le conversazioni dei tuoi utenti con agenti vocali alimentati dall'AI.",
                steps: {
                    step1: {
                        title: "Integrazione Agente Vocale AI",
                        content: "<p><b>Integra il tuo agente vocale AI in Supsis</b> per automatizzare e migliorare i tuoi processi di comunicazione con i clienti. Dopo aver completato l'integrazione, puoi gestire le interazioni vocali più efficientemente e aumentare la soddisfazione del cliente.</p>"
                    }
                }
            }
        },
        common: {
            cancel: "Annulla",
            save: "Salva",
            yes: "Sì",
            no: "No",
            create: "Crea",
            delete: "Elimina",
            edit: "Modifica",
            add: "Aggiungi",
            back: "Indietro",
            active: "Attivo",
            inactive: "Inattivo"
        },
        youtubeChannel: {
            youtubeIntegration: "Integrazione YouTube",
            deleteYoutubeChannelInfo: "Sei sicuro di voler eliminare questo canale YouTube?",
            youtubeChannels: "Canali YouTube",
            title: "Commenti YouTube",
            channelName: "Nome del canale",
            channelDetail: "Dettagli del canale",
            channelDetailDesc: "Gestisci il tuo canale YouTube",
            youtubeChannel: "Canale YouTube",
            status: "Stato",
            active: "Attivo",
            inactive: "Inattivo",
            detail: "Dettaglio",
            visibility: "Visibilità",
            videos: "Video",
            comments: "Commenti",
            visibilitySettings: "Impostazioni di visibilità",
            visibilityDescription: "Imposta quali utenti e dipartimenti possono vedere questo canale",
            users: "Utenti",
            departments: "Dipartimenti",
            owners: "Proprietari",
            selectUsers: "Seleziona utenti",
            selectDepartments: "Seleziona dipartimenti",
            selectOwners: "Seleziona proprietari",
            deleteChannel: "Elimina canale",
            deleteChannelDescription: "Sei sicuro di voler eliminare questo canale YouTube?",
            channelUpdatedSuccess: "Canale aggiornato con successo",
            failedUpdateChannel: "Impossibile aggiornare il canale",
            connectedSuccess: "Account YouTube collegato con successo",
            failedToCreateChannel: "Impossibile creare il canale",
            requiredChannel: "Il nome del canale è obbligatorio",
            oauthTimeout: "Timeout autorizzazione",
            all: "Tutti",
            new: "Nuovo",
            replied: "Risposto",
            resolved: "Risolto",
            searchComments: "Cerca commenti",
            noCommentsFound: "Nessun commento trovato",
            replies: "replies",
            like: "Like",
            reply: "Reply",
            replyToComment: "Reply to Comment",
            writeYourReply: "Scrivi la tua risposta",
            pleaseEnterReply: "Inserisci una risposta",
            replySuccess: "Reply sent successfully",
            errorSendingReply: "Errore nell'invio della risposta",
            statusUpdated: "Stato aggiornato",
            errorUpdatingStatus: "Errore nell'aggiornamento dello stato",
            errorFetchingComments: "Errore nel recupero dei commenti",
            commentLiked: "Comment liked",
            errorLikingComment: "Errore nel mettere mi piace al commento",
            noVideosFound: "No videos found",
            errorFetchingVideos: "Errore nel recupero dei video",
            refresh: "Refresh",
            loadMore: "Load More",
            ensureYouTubeAccount: "Make sure you have a Google/YouTube account",
            ensureYouTubeChannel: "Make sure you have a YouTube channel",
            permissionDesc: "You need to allow Supsis to access your YouTube comments.",
            connectToYouTube: "Connect to YouTube",
            views: "views",
            likes: "likes",
            sync: "Sync",
            commentsSynced: "Comments synced",
            errorSyncingComments: "Errore nella sincronizzazione dei commenti",
            pending: "Pending",
            rejected: "Rejected",
            moderation: "Moderation",
            publish: "Publish",
            holdForReview: "Hold for Review",
            reject: "Reject",
            rejectAndBan: "Reject and Ban",
            moderationSuccess: "Moderation successful",
            errorModeration: "Moderazione fallita",
            videoDetail: "Video Detail",
            duration: "Duration",
            showMore: "Show more",
            showLess: "Show less",
            loadingVideo: "Loading video...",
            videoNotFound: "Video not found",
            goBack: "Go Back",
            errorLoadingVideo: "Errore nel caricamento del video",
            videosSynced: "Videos synced",
            errorSyncingVideos: "Errore nella sincronizzazione dei video",
            selectVideo: "Seleziona video",
            allVideos: "All Videos",
            selectCommentToPreview: "Seleziona un commento per l'anteprima",
            viewDetails: "View Details",
            published: "Published",
            heldForReview: "Held for Review"
        },
        googleBusiness: {
            title: "Google Business Reviews",
            channels: "Google Business Channels",
            channelName: "Nome canale",
            channelDetails: "Channel Details",
            connectToGoogleBusiness: "Connetti a Google Business",
            ensureGoogleAccount: "Make sure you have a Google account",
            ensureBusinessProfile: "Make sure you have a Google Business Profile account",
            permissionDesc: "You need to allow Supsis to access your Google Business reviews.",
            requiredChannel: "Channel name is required",
            failedToCreateChannel: "Impossibile creare il canale",
            connectedSuccess: "Google Business account connected successfully",
            oauthTimeout: "Autorizzazione scaduta",
            deleteChannelInfo: "Sei sicuro di voler eliminare questo canale Google Business?",
            deleteChannel: "Elimina canale",
            deleteChannelDescription: "Sei sicuro di voler eliminare questo canale Google Business?",
            detail: "Detail",
            visibility: "Visibility",
            locations: "Locations",
            reviews: "Reviews",
            accountInfo: "Account Information",
            accountName: "Account Name",
            accountId: "Account ID",
            status: "Status",
            enabled: "Enabled",
            disabled: "Disabled",
            save: "Salva",
            channelUpdated: "Canale aggiornato con successo",
            errorUpdatingChannel: "Errore nell'aggiornamento del canale",
            visibilityDescription: "Set which users and departments can see this channel",
            visibleToUsers: "Visible to Users",
            visibleToDepartments: "Visible to Departments",
            selectUsers: "Seleziona utenti",
            selectDepartments: "Seleziona dipartimenti",
            visibilityUpdated: "Impostazioni di visibilità aggiornate",
            errorUpdatingVisibility: "Errore nell'aggiornamento delle impostazioni di visibilità",
            sync: "Sync",
            refresh: "Refresh",
            locationsSynced: "Locations synced",
            errorSyncingLocations: "Errore nella sincronizzazione delle sedi",
            errorFetchingLocations: "Errore nel recupero delle sedi",
            noLocationsFound: "No locations found",
            selectLocation: "Seleziona sede",
            allLocations: "All Locations",
            allRatings: "All Ratings",
            all: "All",
            new: "New",
            replied: "Replied",
            resolved: "Resolved",
            noReviewsFound: "No reviews found",
            noComment: "No comment text",
            selectReviewToPreview: "Seleziona una recensione per l'anteprima",
            yourReply: "Your Reply",
            reply: "Reply",
            updateReply: "Update Reply",
            replyToReview: "Reply to Review",
            writeYourReply: "Scrivi la tua risposta",
            pleaseEnterReply: "Inserisci una risposta",
            replySuccess: "Reply sent successfully",
            errorSendingReply: "Errore nell'invio della risposta",
            statusUpdated: "Stato aggiornato",
            errorUpdatingStatus: "Errore nell'aggiornamento dello stato",
            errorFetchingReviews: "Error fetching reviews"
        },
        googlePlay: {
            title: "Google Play Reviews",
            channels: "Google Play Channels",
            channelName: "Nome canale",
            channelDetails: "Channel Details",
            connectToGooglePlay: "Connetti a Google Play",
            ensureGoogleAccount: "Make sure you have a Google account",
            ensurePlayConsole: "Make sure you have a Google Play Console account",
            permissionDesc: "You need to allow Supsis to access your Google Play reviews.",
            requiredChannel: "Channel name is required",
            failedToCreateChannel: "Impossibile creare il canale",
            connectedSuccess: "Google Play account connected successfully",
            oauthTimeout: "Autorizzazione scaduta",
            deleteChannelInfo: "Sei sicuro di voler eliminare questo canale Google Play?",
            deleteChannel: "Elimina canale",
            deleteChannelDescription: "Sei sicuro di voler eliminare questo canale Google Play?",
            detail: "Detail",
            visibility: "Visibility",
            apps: "Apps",
            reviews: "Reviews",
            status: "Status",
            enabled: "Enabled",
            disabled: "Disabled",
            save: "Salva",
            channelUpdated: "Canale aggiornato con successo",
            errorUpdatingChannel: "Errore nell'aggiornamento del canale",
            visibilityDescription: "Set which users and departments can see this channel",
            visibleToUsers: "Visible to Users",
            visibleToDepartments: "Visible to Departments",
            selectUsers: "Seleziona utenti",
            selectDepartments: "Seleziona dipartimenti",
            visibilityUpdated: "Impostazioni di visibilità aggiornate",
            errorUpdatingVisibility: "Errore nell'aggiornamento delle impostazioni di visibilità",
            addApp: "Add App",
            refresh: "Refresh",
            noAppsFound: "No apps found",
            packageName: "Package Name",
            appName: "App Name",
            appNamePlaceholder: "E.g: My App",
            iconUrl: "Icon URL",
            fillRequiredFields: "Compila i campi obbligatori",
            appAdded: "App aggiunta con successo",
            errorAddingApp: "Errore nell'aggiunta dell'app",
            syncReviews: "Sync Reviews",
            reviewsSynced: "Reviews synced",
            errorSyncingReviews: "Errore nella sincronizzazione delle recensioni",
            removeApp: "Remove App",
            removeAppConfirm: "Sei sicuro di voler rimuovere {name}? Anche tutte le recensioni correlate verranno eliminate.",
            appRemoved: "App removed",
            errorRemovingApp: "Errore nella rimozione dell'app",
            errorFetchingApps: "Errore nel recupero delle app",
            selectApp: "Seleziona app",
            allApps: "All Apps",
            allRatings: "All Ratings",
            all: "All",
            new: "New",
            replied: "Replied",
            resolved: "Resolved",
            noReviewsFound: "No reviews found",
            noComment: "No comment text",
            selectReviewToPreview: "Seleziona una recensione per l'anteprima",
            yourReply: "Your Reply",
            reply: "Reply",
            updateReply: "Update Reply",
            replyToReview: "Reply to Review",
            writeYourReply: "Scrivi la tua risposta (max 350 caratteri)",
            pleaseEnterReply: "Inserisci una risposta",
            replyTooLong: "Reply cannot exceed 350 characters",
            replySuccess: "Risposta inviata con successo",
            errorSendingReply: "Errore nell'invio della risposta",
            statusUpdated: "Stato aggiornato",
            errorUpdatingStatus: "Errore nell'aggiornamento dello stato",
            errorFetchingReviews: "Errore nel recupero delle recensioni",
            deviceInfo: "Informazioni dispositivo",
            device: "Dispositivo",
            appVersion: "Versione app",
            manufacturer: "Produttore"
        },
        googleDrive: {
            title: "Google Drive",
            googleDriveChannels: "Canali Google Drive",
            googleDriveIntegration: "Integrazione Google Drive",
            channelName: "Nome canale",
            channelInfo: "Info canale",
            channelSettings: "Impostazioni canale",
            connectedAccount: "Account connesso",
            storageQuota: "Quota di archiviazione",
            connectToGoogleDrive: "Connetti a Google Drive",
            ensureGoogleAccount: "Assicurati di avere un account Google",
            ensureGoogleDriveAccess: "Assicurati di avere accesso a Google Drive",
            permissionDesc: "Devi consentire a Supsis di accedere ai tuoi file Google Drive.",
            requiredChannel: "Il nome del canale è obbligatorio",
            failedToCreateChannel: "Impossibile creare il canale",
            connectedSuccess: "Account Google Drive connesso con successo",
            oauthTimeout: "Autorizzazione scaduta",
            deleteGoogleDriveChannelInfo: "Sei sicuro di voler eliminare questo canale Google Drive?",
            deleteChannel: "Elimina canale",
            deleteChannelDescription: "Sei sicuro di voler eliminare questo canale Google Drive?",
            driveExplorer: "Esplora drive",
            myDrive: "My Drive",
            sharedDrives: "Shared Drives",
            searchFiles: "Search files...",
            noSharedDrives: "No shared drives found",
            noFiles: "No files found",
            loadMore: "Load More",
            filesSelected: "files selected",
            downloadToSupsis: "Download to Supsis",
            fileDownloaded: "File downloaded successfully",
            errorLoadingFiles: "Errore nel caricamento dei file",
            errorLoadingDrives: "Errore nel caricamento dei drive",
            errorSearching: "Errore nella ricerca",
            errorDownloading: "Errore nel download del file",
            fileName: "File Name",
            fileSize: "Size",
            modifiedTime: "Modified Time",
            selectFile: "Seleziona file",
            selectFileFromGoogleDrive: "Seleziona file da Google Drive",
            selectChannel: "Seleziona canale",
            noChannelsAvailable: "Nessun canale Google Drive accessibile trovato",
            selectedFiles: "Selected Files",
            upload: "Upload",
            selectUploadMethod: "Seleziona metodo di caricamento:",
            uploadFromComputer: "Carica da computer",
            downloadingFiles: "Downloading files...",
            myChannel: "Mine",
            manageWhoCanAccess: "Gestisci chi può accedere a questo canale",
            download: "Download",
            openInNewTab: "Open in New Tab",
            openInGoogleDrive: "Apri in Google Drive",
            fileType: "File Type",
            owner: "Owner",
            previewNotAvailable: "Preview not available for this file type",
            byocTitle: "Use Your Own Google Cloud Credentials",
            byocDescription: "Per l'integrazione Google Drive è necessario creare le credenziali client OAuth dalla propria Google Cloud Console.",
            clientId: "OAuth Client ID",
            clientIdPlaceholder: "xxxxxxxx.apps.googleusercontent.com",
            clientIdRequired: "Client ID is required",
            clientSecret: "OAuth Client Secret",
            clientSecretPlaceholder: "GOCSPX-xxxxxxxxxx",
            clientSecretRequired: "Client Secret is required",
            redirectUriCopied: "Redirect URI copied",
            setupGuideTitle: "Setup Guide (click to expand)",
            setupStep1: "Go to Google Cloud Console and create a new project or select an existing one.",
            setupStep2: "Navigate to APIs & Services > Credentials section.",
            setupStep3: "Click \"+ CREATE CREDENTIALS\" > \"OAuth client ID\". Select \"Web application\" as the application type.",
            setupStep4: "Add the following URL to the Authorized redirect URIs section:",
            setupStep5: "Abilita \"Google Drive API\" da API e servizi > Libreria.",
            setupStep6: "Copy the Client ID and Client Secret values and paste them in the fields above."
        },
        appStore: {
            title: "App Store Reviews",
            channels: "App Store Channels",
            channelName: "Nome canale",
            channelDetails: "Channel Details",
            connectToAppStore: "Connect to App Store",
            credentials: "API Credentials",
            credentialsHelp: "Enter your App Store Connect API credentials. You can create an API key from",
            issuerId: "Issuer ID",
            issuerIdPlaceholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
            keyId: "Key ID",
            keyIdPlaceholder: "XXXXXXXXXX",
            privateKey: "Private Key (.p8 file content)",
            privateKeyPlaceholder: "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
            requiredField: "Questo campo è obbligatorio",
            validateCredentials: "Valida credenziali",
            credentialsValid: "Credenziali valide",
            credentialsInvalid: "Credenziali non valide",
            pleaseValidateFirst: "Valida prima le tue credenziali",
            failedToCreateChannel: "Creazione canale non riuscita",
            connectedSuccess: "Account App Store connesso con successo",
            deleteChannelInfo: "Sei sicuro di voler eliminare questo canale App Store?",
            deleteChannel: "Elimina canale",
            deleteChannelDescription: "Sei sicuro di voler eliminare questo canale App Store?",
            detail: "Dettaglio",
            visibility: "Visibilità",
            apps: "App",
            reviews: "Recensioni",
            status: "Stato",
            enabled: "Abilitato",
            disabled: "Disabilitato",
            save: "Salva",
            channelUpdated: "Canale aggiornato con successo",
            errorUpdatingChannel: "Errore durante l'aggiornamento del canale",
            visibilityDescription: "Imposta quali utenti e dipartimenti possono vedere questo canale",
            visibleToUsers: "Visibile agli utenti",
            visibleToDepartments: "Visibile ai dipartimenti",
            selectUsers: "Seleziona utenti",
            selectDepartments: "Seleziona dipartimenti",
            visibilityUpdated: "Impostazioni di visibilità aggiornate",
            errorUpdatingVisibility: "Errore durante l'aggiornamento delle impostazioni di visibilità",
            syncApps: "Sincronizza app",
            refresh: "Aggiorna",
            noAppsFound: "Nessuna app trovata",
            appsAutoFetch: "Le app vengono recuperate automaticamente da App Store Connect. Clicca su 'Sincronizza app' per aggiornare l'elenco.",
            appsSynced: "App sincronizzate con successo",
            errorSyncingApps: "Errore durante la sincronizzazione delle app",
            syncReviews: "Sincronizza recensioni",
            reviewsSynced: "Recensioni sincronizzate",
            errorSyncingReviews: "Errore durante la sincronizzazione delle recensioni",
            errorFetchingApps: "Errore durante il recupero delle app",
            selectApp: "Seleziona app",
            allApps: "Tutte le app",
            all: "Tutte",
            new: "Nuove",
            replied: "Risposte",
            resolved: "Risolte",
            noReviewsFound: "Nessuna recensione trovata",
            noComment: "Nessun testo del commento",
            anonymous: "Anonimo",
            selectReviewToPreview: "Seleziona una recensione da anteprima",
            yourReply: "La tua risposta",
            reply: "Risposta",
            edit: "Modifica",
            delete: "Elimina",
            editReply: "Modifica risposta",
            replyToReview: "Rispondi alla recensione",
            writeYourReply: "Scrivi la tua risposta",
            pleaseEnterReply: "Inserisci una risposta",
            replySuccess: "Risposta inviata con successo",
            errorSendingReply: "Errore durante l'invio della risposta",
            deleteResponse: "Elimina risposta",
            deleteResponseConfirm: "Sei sicuro di voler eliminare questa risposta?",
            responseDeleted: "Risposta eliminata con successo",
            errorDeletingResponse: "Errore durante l'eliminazione della risposta",
            statusUpdated: "Stato aggiornato",
            errorUpdatingStatus: "Errore durante l'aggiornamento dello stato",
            errorFetchingReviews: "Errore durante il recupero delle recensioni",
            territory: "Territorio",
            region: "Regione"
        },
        LinkedinContacts: "Contatti Linkedin",
        TelegramContacts: "Contatti Telegram",
        packages: {
            mostPopular: "PIÙ POPOLARE",
            currency: "₺",
            activePlan: "PIANO ATTIVO"
        },
        totalCost: {
            title: "COSTO SUPSIS",
            monthlyPayments: "Pagamenti mensili",
            currency: "₺",
            currencyMonthly: "₺ / Mese",
            oneTimePayments: "Pagamenti una tantum",
            oneTimeDiscount: "Sconto pacchetto annuale",
            currencyYearly: "₺ / Annuo",
            totalOneTimeCost: "Importo totale da pagare in un'unica soluzione",
            totalTax: "Imposta (18%)",
            referenceCode: "Hai un codice referente?",
            referencePlaceholder: "Inserisci il codice",
            codeButton: "Applica",
            monthlyCost: "Importo addebitato mensilmente dal tuo account?",
            oneTimeFullCost: "Importo una tantum tutto incluso?",
            payment: "Effettua il pagamento"
        },
        waba: {
            templateCreationFailed: "Creazione modello non riuscita",
            templateError_2388040: "Limite caratteri superato",
            templateErrorDesc_2388040: "Un campo del modello ha superato il limite massimo di caratteri consentito.",
            templateError_2388047: "Formato intestazione messaggio non corretto",
            templateErrorDesc_2388047: "L'intestazione del messaggio contiene una formattazione non valida.",
            templateError_2388072: "Formato corpo messaggio non corretto",
            templateErrorDesc_2388072: "Il corpo del messaggio contiene una formattazione non valida.",
            templateError_2388073: "Formato piè di pagina messaggio non corretto",
            templateErrorDesc_2388073: "Il piè di pagina del messaggio contiene una formattazione non valida.",
            templateError_2388293: "Rapporto parole/parametri supera il limite",
            templateErrorDesc_2388293: "Questo modello ha troppe variabili per la sua lunghezza. Riduci il numero di variabili o aumenta la lunghezza del messaggio.",
            templateError_2388299: "Parametri iniziali o finali non consentiti",
            templateErrorDesc_2388299: "Le variabili non possono essere all'inizio o alla fine del modello."
        },
        profile: {
            subtitle: "Gestisci le impostazioni dell'account e le sessioni"
        },
        integrations: {
            requiredField: "Questo campo è obbligatorio",
            existingChannels: "Canali esistenti",
            createNewChannel: "Crea nuovo canale",
            channelName: "Nome canale",
            createChannel: "Crea canale",
            channelCreated: "Canale creato con successo",
            channelCreateError: "Si è verificato un errore durante la creazione del canale",
            channelActivated: "Canale attivato",
            channelDeactivated: "Canale disattivato",
            channelUpdateError: "Si è verificato un errore durante l'aggiornamento del canale",
            deleteChannelConfirm: "Elimina canale",
            deleteChannelConfirmContent: "Sei sicuro di voler eliminare il canale {name}?",
            channelDeleted: "Canale eliminato con successo",
            channelDeleteError: "Si è verificato un errore durante l'eliminazione del canale",
            slackIntegration: "Integrazione Slack",
            slackDescription: "Invia messaggi al tuo workspace Slack tramite automazione e chatbot Supsis.",
            slackSetupTitle: "Passaggi di configurazione:",
            slackStep1: "Vai su api.slack.com/apps",
            slackStep2: "Seleziona la tua app Slack esistente o creane una nuova",
            slackStep3: "Clicca su 'Incoming Webhooks' nel menu a sinistra e attivalo",
            slackStep4: "Clicca su 'Aggiungi nuovo webhook allo spazio' e seleziona il canale a cui inviare i messaggi",
            slackCardDescription: "Invia messaggi ai tuoi canali Slack tramite automazione e chatbot",
            slackChannelNamePlaceholder: "Es.: Notifiche supporto",
            slackWebhookUrl: "URL webhook",
            slackWebhookUrlPlaceholder: "https://hooks.slack.com/services/...",
            slackWebhookUrlHelper: "Vai su App Slack > Incoming Webhooks > Aggiungi nuovo webhook allo spazio",
            slackWebhookUrlInvalid: "Inserisci un URL webhook Slack valido",
            slackDefaultChannel: "Canale predefinito (opzionale)",
            slackDefaultChannelPlaceholder: "#general",
            slackDefaultChannelHelper: "Se non specificato, verrà utilizzato il canale collegato al webhook",
            pushoverIntegration: "Integrazione Pushover",
            pushoverCardDescription: "Invia notifiche push ai tuoi dispositivi mobili tramite automazione e chatbot",
            pushoverDescription: "Invia notifiche push ai tuoi dispositivi mobili tramite automazione e chatbot Supsis. Puoi creare un account e ottenere Chiave utente e Token applicazione da pushover.net.",
            pushoverChannelNamePlaceholder: "Es.: Notifiche mobile",
            pushoverUserKey: "Chiave utente",
            pushoverUserKeyPlaceholder: "Chiave utente Pushover",
            pushoverUserKeyHelper: "Puoi ottenerla dalla pagina account del tuo profilo pushover.net",
            pushoverAppToken: "Token app",
            pushoverAppTokenPlaceholder: "Token applicazione Pushover",
            pushoverAppTokenHelper: "Puoi creare un'applicazione su pushover.net per ottenere il token"
        },
        addWebhook: "Aggiungi webhook",
        allIntegrations: "Tutte le integrazioni",
        editWebhook: "Modifica webhook",
        integrateYourCBwithChatGpt3: "Il chatbot può essere integrato con GPT-4. È richiesta la chiave API GPT-4.",
        integrateYourCBwithChatWidget: "Integra il tuo chatbot con il widget di chat.",
        integrateYourCBwithIntegratable: "Trasmetti facilmente le informazioni della chat tra ChatBot e {integratable}.",
        integrateYourCBwithWebHook: "Trasmetti facilmente le informazioni della chat tra ChatBot e i tuoi servizi web.",
        newWebhook: "Nuovo webhook",
        shouldAddMethod: "È necessario compilare il campo Metodo di pagamento e indirizzo di fatturazione!\nNessun importo verrà addebitato dal tuo account.\nAlla fine del mese verrà creata una fattura in base all'importo di utilizzo.",
        webhookPassword: "Password webhook",
        webhookTitle: "Nome webhook",
        webhookToken: "Token webhook",
        webhookUrl: "URL webhook",
        webhookUsername: "Nome utente webhook",
        task_reports: {
            title: "Rapporti Attività",
            date: "Data",
            workflow: "Flusso di Lavoro",
            select: "Seleziona",
            agent: "Agente",
            all: "Tutto",
            select_workflow_to_view_reports: "Seleziona un flusso di lavoro per visualizzare i rapporti.",
            created_task: "Attività Creata",
            updated_task: "Attività Aggiornata",
            assigned_tasks_by_personnel: "Attività Assegnate per Personale",
            assigned_task: "Attività Assegnata",
            no_assigned_task_found_in_date_range: "Nessuna attività assegnata trovata nell'intervallo di date selezionato.",
            updated_tasks: "Attività Aggiornate",
            task: "Attività",
            current_stage: "Fase Attuale",
            assigned: "Assegnato",
            update: "Aggiornamento",
            no_updated_task_found_in_date_range: "Nessuna attività aggiornata trovata nell'intervallo di date selezionato.",
            task_distribution_by_agent: "Distribuzione Attività per Agente",
            total: "Totale",
            no_assigned_task_found: "Nessuna attività assegnata trovata.",
            timeline: "Cronologia",
            unassigned_tasks: "Attività Non Assegnate",
            transition_process: "Processo di Transizione",
            no_active_task_found_for_agent: "Nessuna attività attiva trovata per questo agente.",
            select_agent_to_view_timeline: "Seleziona un agente per visualizzare la cronologia.",
            entry: "Entrata",
            exit: "Uscita",
            still_in_this_stage: "Ancora in questa fase",
            duration: "Durata",
            day: "giorno",
            hour: "ora",
            max_30_days_range_warning: "Puoi selezionare un intervallo di date fino a 30 giorni.",
            today: "Oggi",
            this_week: "Questa Settimana",
            this_month: "Questo Mese",
            last_month: "Il Mese Scorso",
            unknown: "Sconosciuto",
            unassigned: "Non assegnato",
            gantt: "Gantt",
            table: "Tabella"
        },
        customBlockErrors: {
            BLOCK_NOT_FOUND: "Blocco non trovato",
            BLOCK_NOT_APPROVED: "Questo blocco non è ancora stato approvato",
            BLOCK_ALREADY_IMPORTED: "Questo blocco è già stato importato",
            BLOCK_IMPORT_FAILED: "Importazione del blocco non riuscita"
        },
        developer: {
            webhookUrls: "URL Webhook",
            webhookUrlsDescription: "I messaggi in arrivo verranno inoltrati a questi URL.",
            webhookNamePlaceholder: "Nome (es. Il mio sistema)",
            webhookUrlPlaceholder: "https://...",
            addWebhook: "Aggiungi Webhook",
            webhookSaved: "URL Webhook salvati.",
            webhookSaveError: "Salvataggio non riuscito.",
            webhookValidationError: "Tutti i campi webhook devono essere compilati.",
            messagingApi: "API di Messaggistica",
            messagingApiDescription: "Invia messaggi tramite questo canale dai tuoi sistemi.",
            endpoint: "Endpoint",
            authentication: "Autenticazione",
            requestBody: "Corpo della richiesta (Esempi)",
            webhookPayload: "Payload Webhook (Messaggio in arrivo)",
            noToken: "Nessun token ancora generato.",
            tokenGenerateWarning: "Se clicchi su Genera token, il token attuale scadrà.",
            tokenGenerated: "Token generato con successo.",
            tokenGenerateError: "Impossibile generare il token.",
            copied: "Copiato.",
            sendMessageDesc: "Invia un messaggio al cliente specificato tramite questo canale.",
            fromParamsDesc: "from: api (predefinito) | user | chatbot. userId richiesto quando from=user. chatbot invia come chatbot.",
            userIdParamsDesc: "userId (User ObjectId) è obbligatorio. Il messaggio viene inviato a nome dell'utente specificato.",
            fromUserIdParamsDesc: "from (User ObjectId) è obbligatorio. Il messaggio viene inviato a nome dell'utente specificato.",
            contactIdParamsDesc: "È l'ID del visitatore. Puoi ottenerlo dal campo visitor.id nel payload del webhook.",
            webhookEventReceived: "Messaggio in arrivo",
            webhookEventSent: "Messaggio in uscita",
            yourWebhookUrl: "<il-tuo-url-webhook>",
            webhookPayloadDesc: "Una richiesta POST viene inviata ai tuoi URL webhook per ogni messaggio in arrivo.",
            webhookSentDesc: "Quando i messaggi inviati tramite API vengono elaborati, l'evento message.sent viene inviato al webhook. status: sent (delivered, failed saranno aggiunti in seguito).",
            curlExample: "Esempio cURL",
        }
    }
};

export default messagesIT;
